var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfPacedImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 270.2 361.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e4e5ee;\n      }\n\n      .cls-2 {\n        fill: #aba7c0;\n      }\n\n      .cls-3 {\n        fill: #8e899d;\n      }\n\n      .cls-4 {\n        fill: #cdb6bf;\n      }\n\n      .cls-5 {\n        fill: #9087a0;\n      }\n\n      .cls-6 {\n        fill: #7e7c8c;\n      }\n\n      .cls-7 {\n        fill: #bbd1de;\n      }\n\n      .cls-8 {\n        fill: #4ab2da;\n      }\n\n      .cls-9 {\n        fill: #a499b5;\n      }\n\n      .cls-10 {\n        fill: #8b869a;\n      }\n\n      .cls-11 {\n        fill: #3b2314;\n      }\n\n      .cls-12 {\n        fill: #c6a26e;\n      }\n\n      .cls-13 {\n        fill: #100d0e;\n      }\n\n      .cls-14 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-15 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-16 {\n        fill: #47415c;\n      }\n\n      .cls-17 {\n        fill: #a8a0bb;\n      }\n\n      .cls-18 {\n        fill: #a599b6;\n      }\n\n      .cls-19 {\n        fill: #5ec3b5;\n      }\n\n      .cls-20 {\n        fill: #53c8ed;\n      }\n\n      .cls-21 {\n        fill: #6fa8a7;\n      }\n\n      .cls-22 {\n        fill: #52c6ec;\n      }\n\n      .cls-23 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-24 {\n        fill: #44a2cd;\n      }\n\n      .cls-25 {\n        fill: #9e93ae;\n      }\n\n      .cls-26 {\n        fill: #897da0;\n      }\n\n      .cls-27 {\n        fill: #b6c5d6;\n      }\n\n      .cls-28 {\n        fill: #bacfdd;\n      }\n\n      .cls-29 {\n        fill: #9f8b78;\n      }\n\n      .cls-30 {\n        fill: #4d6b33;\n      }\n\n      .cls-31 {\n        fill: #4ba29d;\n      }\n\n      .cls-32 {\n        fill: #c0dde7;\n      }\n\n      .cls-33 {\n        fill: #44afbf;\n      }\n\n      .cls-34 {\n        fill: #988ea8;\n      }\n\n      .cls-35 {\n        fill: #898598;\n      }\n\n      .cls-36 {\n        fill: #8080ae;\n      }\n\n      .cls-37 {\n        fill: #bad0de;\n      }\n\n      .cls-38 {\n        fill: #b8c9d9;\n      }\n\n      .cls-39 {\n        fill: #3c8ebc;\n      }\n\n      .cls-40 {\n        fill: #afb1c8;\n      }\n\n      .cls-41 {\n        fill: #bde5f1;\n      }\n\n      .cls-42 {\n        fill: #51c3e9;\n      }\n\n      .cls-43 {\n        fill: #a297b3;\n      }\n\n      .cls-44 {\n        fill: #8c879b;\n      }\n\n      .cls-45 {\n        fill: #3fb7b5;\n      }\n\n      .cls-46 {\n        fill: #51c2e8;\n      }\n\n      .cls-47 {\n        fill: #efccab;\n      }\n\n      .cls-48 {\n        fill: #a69cb8;\n      }\n\n      .cls-49 {\n        fill: #fcd5a9;\n      }\n\n      .cls-50 {\n        fill: #8ac140;\n      }\n\n      .cls-51 {\n        fill: #183052;\n      }\n\n      .cls-52 {\n        fill: #a9a3bd;\n      }\n\n      .cls-53 {\n        fill: #30582a;\n      }\n\n      .cls-54 {\n        fill: #948da4;\n      }\n\n      .cls-55 {\n        fill: #968ea6;\n      }\n\n      .cls-56 {\n        fill: #827f90;\n      }\n\n      .cls-57 {\n        fill: #b4c1d3;\n      }\n\n      .cls-58 {\n        fill: #48acd6;\n      }\n\n      .cls-59 {\n        fill: #9f96b0;\n      }\n\n      .cls-60 {\n        fill: #f4835b;\n      }\n\n      .cls-61 {\n        fill: #877e95;\n      }\n\n      .cls-62 {\n        fill: #aaa5bf;\n      }\n\n      .cls-63 {\n        fill: #4bb4dc;\n      }\n\n      .cls-64 {\n        fill: #807d8e;\n      }\n\n      .cls-65 {\n        fill: #d0d2d3;\n      }\n\n      .cls-66 {\n        fill: #8c829a;\n      }\n\n      .cls-67 {\n        fill: #895c76;\n      }\n\n      .cls-68 {\n        fill: #bcd3e0;\n      }\n\n      .cls-69 {\n        fill: #8f859d;\n      }\n\n      .cls-70 {\n        fill: #b5c2d3;\n      }\n\n      .cls-71 {\n        fill: #4bb3db;\n      }\n\n      .cls-72 {\n        fill: #bbd6d1;\n      }\n\n      .cls-73 {\n        fill: #fff;\n      }\n\n      .cls-74 {\n        fill: #b6aab6;\n      }\n\n      .cls-75 {\n        fill: #49afd8;\n      }\n\n      .cls-76 {\n        fill: #868294;\n      }\n\n      .cls-77 {\n        fill: #6f5a42;\n      }\n\n      .cls-78 {\n        fill: #afb3c9;\n      }\n\n      .cls-79 {\n        fill: #858193;\n      }\n\n      .cls-80 {\n        fill: #b57997;\n      }\n\n      .cls-81 {\n        fill: #a084aa;\n      }\n\n      .cls-82 {\n        fill: #008c98;\n      }\n\n      .cls-83 {\n        fill: #429dc8;\n      }\n\n      .cls-84 {\n        fill: #b8cbda;\n      }\n\n      .cls-85 {\n        fill: #d9c5bd;\n      }\n\n      .cls-86 {\n        fill: #9b90ab;\n      }\n\n      .cls-87 {\n        fill: #52c5eb;\n      }\n\n      .cls-88 {\n        fill: #1c8568;\n      }\n\n      .cls-89 {\n        fill: #878395;\n      }\n\n      .cls-90 {\n        fill: #3d91be;\n      }\n\n      .cls-91 {\n        fill: #adadc5;\n      }\n\n      .cls-92 {\n        fill: #731d42;\n      }\n\n      .cls-93 {\n        fill: #4d706a;\n      }\n\n      .cls-94 {\n        fill: #f9d2a6;\n      }\n\n      .cls-95 {\n        fill: #52c6eb;\n      }\n\n      .cls-96 {\n        fill: #80788e;\n      }\n\n      .cls-97 {\n        fill: #837b91;\n      }\n\n      .cls-98 {\n        fill: #928ca2;\n      }\n\n      .cls-99 {\n        fill: #439fcb;\n      }\n\n      .cls-100 {\n        fill: #302f1f;\n      }\n\n      .cls-101 {\n        fill: #4cb6de;\n      }\n\n      .cls-102, .cls-103 {\n        fill: none;\n      }\n\n      .cls-104 {\n        fill: #9e94af;\n      }\n\n      .cls-105 {\n        fill: #e7efec;\n      }\n\n      .cls-106 {\n        fill: #d6b5d6;\n      }\n\n      .cls-107 {\n        fill: #aba9c2;\n      }\n\n      .cls-108 {\n        fill: #4db8df;\n      }\n\n      .cls-109 {\n        fill: #a9a4be;\n      }\n\n      .cls-110 {\n        fill: #d8effc;\n      }\n\n      .cls-111 {\n        fill: #f8ad87;\n      }\n\n      .cls-112 {\n        fill: #474748;\n      }\n\n      .cls-113 {\n        fill: #4dbae1;\n      }\n\n      .cls-114 {\n        fill: #848092;\n      }\n\n      .cls-115 {\n        fill: #8b8299;\n      }\n\n      .cls-116 {\n        fill: #bed9e4;\n      }\n\n      .cls-117 {\n        fill: #3f96c3;\n      }\n\n      .cls-118 {\n        fill: #295b70;\n      }\n\n      .cls-119 {\n        fill: #9d92ad;\n      }\n\n      .cls-120 {\n        fill: #47a9d3;\n      }\n\n      .cls-121 {\n        fill: #4fbde4;\n      }\n\n      .cls-122 {\n        fill: #348fc8;\n      }\n\n      .cls-123 {\n        fill: #4199c5;\n      }\n\n      .cls-124 {\n        fill: #988979;\n      }\n\n      .cls-125 {\n        fill: #998fa9;\n      }\n\n      .cls-126 {\n        fill: #4fbfe5;\n      }\n\n      .cls-127 {\n        fill: #46a7d1;\n      }\n\n      .cls-128 {\n        fill: #0f2339;\n      }\n\n      .cls-129 {\n        fill: #978da7;\n      }\n\n      .cls-130 {\n        fill: #51c4ea;\n      }\n\n      .cls-131 {\n        fill: #9c91ac;\n      }\n\n      .cls-132 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-133 {\n        fill: #9b92ab;\n      }\n\n      .cls-134 {\n        fill: #887f96;\n      }\n\n      .cls-135 {\n        fill: #b1598d;\n      }\n\n      .cls-136 {\n        fill: #938ca3;\n      }\n\n      .cls-137 {\n        fill: #45a4cf;\n      }\n\n      .cls-138 {\n        fill: #419ac6;\n      }\n\n      .cls-139 {\n        fill: #a79eba;\n      }\n\n      .cls-140 {\n        fill: #50c1e7;\n      }\n\n      .cls-141 {\n        fill: #ffecdc;\n      }\n\n      .cls-142 {\n        fill: #a398b4;\n      }\n\n      .cls-143 {\n        fill: #b0b4ca;\n      }\n\n      .cls-144 {\n        fill: #bbd2df;\n      }\n\n      .cls-145 {\n        fill: #8779b2;\n      }\n\n      .cls-146 {\n        fill: #8f899e;\n      }\n\n      .cls-147 {\n        fill: #231f20;\n      }\n\n      .cls-148 {\n        fill: #89be76;\n      }\n\n      .cls-149 {\n        fill: #57999d;\n      }\n\n      .cls-150 {\n        fill: #4ebbe2;\n      }\n\n      .cls-151, .cls-152 {\n        isolation: isolate;\n      }\n\n      .cls-153 {\n        fill: #888396;\n      }\n\n      .cls-154 {\n        fill: #e1e3d3;\n      }\n\n      .cls-155 {\n        fill: #46a8d2;\n      }\n\n      .cls-156 {\n        fill: #948aa4;\n      }\n\n      .cls-157 {\n        fill: #44a0cc;\n      }\n\n      .cls-158 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-159 {\n        fill: #adaec5;\n      }\n\n      .cls-160 {\n        fill: #827a90;\n      }\n\n      .cls-161 {\n        fill: #b9ccdb;\n      }\n\n      .cls-162 {\n        fill: #857c93;\n      }\n\n      .cls-163 {\n        fill: #b5c3d4;\n      }\n\n      .cls-164 {\n        fill: #7d748a;\n      }\n\n      .cls-165 {\n        fill: #4fbee5;\n      }\n\n      .cls-166 {\n        fill: #b4bfd1;\n      }\n\n      .cls-167 {\n        mix-blend-mode: darken;\n        opacity: .4;\n      }\n\n      .cls-168 {\n        fill: #8eb8b9;\n      }\n\n      .cls-169 {\n        fill: #aeb0c7;\n      }\n\n      .cls-170 {\n        fill: #b69b82;\n      }\n\n      .cls-171 {\n        fill: #9e95af;\n      }\n\n      .cls-172 {\n        fill: #f9c1a5;\n      }\n\n      .cls-173 {\n        fill: #3e93c1;\n      }\n\n      .cls-174 {\n        fill: #7b7388;\n      }\n\n      .cls-175 {\n        fill: #458a90;\n      }\n\n      .cls-176 {\n        fill: #fafbfd;\n      }\n\n      .cls-177 {\n        fill: #b3bccf;\n      }\n\n      .cls-178 {\n        fill: #bcd4e1;\n      }\n\n      .cls-179 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-180 {\n        fill: #acabc3;\n      }\n\n      .cls-181 {\n        fill: #8a8699;\n      }\n\n      .cls-182 {\n        fill: #64332f;\n      }\n\n      .cls-183 {\n        fill: #755b85;\n      }\n\n      .cls-184 {\n        fill: #937e65;\n      }\n\n      .cls-185 {\n        fill: #958ba5;\n      }\n\n      .cls-186 {\n        fill: #4bc5de;\n      }\n\n      .cls-187 {\n        fill: #439ec9;\n      }\n\n      .cls-188 {\n        fill: #d6beab;\n      }\n\n      .cls-189 {\n        fill: #95365b;\n      }\n\n      .cls-190 {\n        fill: #2b2b2b;\n      }\n\n      .cls-191 {\n        fill: #978fa7;\n      }\n\n      .cls-192 {\n        fill: #429bc7;\n      }\n\n      .cls-193 {\n        fill: #afb2c8;\n      }\n\n      .cls-194 {\n        fill: #576131;\n      }\n\n      .cls-195 {\n        fill: #968ca6;\n      }\n\n      .cls-196 {\n        fill: #57aec0;\n      }\n\n      .cls-197 {\n        fill: #9d94ae;\n      }\n\n      .cls-198 {\n        fill: #a399b4;\n      }\n\n      .cls-199 {\n        fill: #b2bace;\n      }\n\n      .cls-200 {\n        fill: #1e75b7;\n      }\n\n      .cls-201 {\n        fill: #b3bdd0;\n      }\n\n      .cls-202 {\n        fill: #817e8f;\n      }\n\n      .cls-203 {\n        fill: #957854;\n      }\n\n      .cls-204 {\n        fill: #b8a6d0;\n      }\n\n      .cls-205 {\n        fill: #118986;\n      }\n\n      .cls-206 {\n        fill: #9188a1;\n      }\n\n      .cls-207 {\n        fill: #7a9a86;\n      }\n\n      .cls-208 {\n        fill: #9a90aa;\n      }\n\n      .cls-209 {\n        fill: #e0d7d4;\n      }\n\n      .cls-210 {\n        fill: #bacedc;\n      }\n\n      .cls-211 {\n        fill: #49add7;\n      }\n\n      .cls-212 {\n        fill: #a9a2bd;\n      }\n\n      .cls-213 {\n        fill: #bdd6e2;\n      }\n\n      .cls-214 {\n        fill: #339676;\n      }\n\n      .cls-215 {\n        fill: #45a5d0;\n      }\n\n      .cls-216 {\n        fill: #6c141d;\n      }\n\n      .cls-217 {\n        fill: #3c8cbb;\n      }\n\n      .cls-218 {\n        fill: #bed8e4;\n      }\n\n      .cls-219 {\n        fill: #5a6a9b;\n      }\n\n      .cls-220 {\n        fill: #b8cad9;\n      }\n\n      .cls-221 {\n        fill: #b4c0d2;\n      }\n\n      .cls-222 {\n        fill: #9c93ac;\n      }\n\n      .cls-223 {\n        fill: #937d65;\n      }\n\n      .cls-224 {\n        fill: #aaa6c0;\n      }\n\n      .cls-225 {\n        fill: #7c7489;\n      }\n\n      .cls-226 {\n        fill: #adacc4;\n      }\n\n      .cls-227 {\n        fill: #888497;\n      }\n\n      .cls-228 {\n        fill: #a59ab6;\n      }\n\n      .cls-229 {\n        fill: #47aad4;\n      }\n\n      .cls-230 {\n        fill: #408faf;\n      }\n\n      .cls-231 {\n        fill: #b2b9ce;\n      }\n\n      .cls-232 {\n        fill: #d4b2c7;\n      }\n\n      .cls-233 {\n        fill: #9991a9;\n      }\n\n      .cls-234 {\n        fill: #4db9e0;\n      }\n\n      .cls-235 {\n        mix-blend-mode: overlay;\n      }\n\n      .cls-152 {\n        opacity: .4;\n      }\n\n      .cls-236 {\n        fill: #b1b8cd;\n      }\n\n      .cls-237 {\n        fill: #958ea5;\n      }\n\n      .cls-238 {\n        fill: #81798f;\n      }\n\n      .cls-239 {\n        fill: #4ab1d9;\n      }\n\n      .cls-240 {\n        fill: #4097c4;\n      }\n\n      .cls-241 {\n        fill: #76c0c3;\n      }\n\n      .cls-242 {\n        fill: #bdd7e3;\n      }\n\n      .cls-243 {\n        fill: #4cb5dd;\n      }\n\n      .cls-244 {\n        fill: #a096b1;\n      }\n\n      .cls-245 {\n        fill: #52c5ea;\n      }\n\n      .cls-246 {\n        fill: #9389a3;\n      }\n\n      .cls-247 {\n        fill: #a197b2;\n      }\n\n      .cls-248 {\n        fill: #a69bb7;\n      }\n\n      .cls-249 {\n        fill: #4cb7df;\n      }\n\n      .cls-250 {\n        fill: #f1c431;\n      }\n\n      .cls-251 {\n        fill: #7f768c;\n      }\n\n      .cls-252 {\n        fill: #876690;\n      }\n\n      .cls-253 {\n        fill: #3a88b7;\n      }\n\n      .cls-254 {\n        fill: #154d88;\n      }\n\n      .cls-255 {\n        fill: #847b92;\n      }\n\n      .cls-256 {\n        fill: #b7c8d8;\n      }\n\n      .cls-257 {\n        fill: #b7c7d7;\n      }\n\n      .cls-258 {\n        fill: #b1b6cb;\n      }\n\n      .cls-259 {\n        fill: #9289a2;\n      }\n\n      .cls-260 {\n        opacity: .1;\n      }\n\n      .cls-261 {\n        fill: #98cbcb;\n      }\n\n      .cls-262 {\n        fill: #b9cddc;\n      }\n\n      .cls-263 {\n        fill: #3b89b8;\n      }\n\n      .cls-264 {\n        fill: #5b0e15;\n      }\n\n      .cls-265 {\n        fill: #9ba549;\n      }\n\n      .cls-266 {\n        fill: #4ebce3;\n      }\n\n      .cls-267 {\n        fill: #5cc5f0;\n      }\n\n      .cls-268 {\n        fill: #acaac3;\n      }\n\n      .cls-269 {\n        fill: #949f93;\n      }\n\n      .cls-270 {\n        fill: #f0e4f0;\n      }\n\n      .cls-271 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-272 {\n        fill: #dd582e;\n      }\n\n      .cls-273 {\n        fill: #a097b1;\n      }\n\n      .cls-274 {\n        fill: #70151c;\n      }\n\n      .cls-275 {\n        fill: #cb99be;\n      }\n\n      .cls-276 {\n        fill: #a49ab5;\n      }\n\n      .cls-277 {\n        fill: #797186;\n      }\n\n      .cls-278 {\n        fill: #b6c6d6;\n      }\n\n      .cls-279 {\n        fill: #9890a8;\n      }\n\n      .cls-280 {\n        fill: #5f9ba6;\n      }\n\n      .cls-281 {\n        fill: #b1b7cc;\n      }\n\n      .cls-282 {\n        fill: #333d28;\n      }\n\n      .cls-283 {\n        fill: #8d889c;\n      }\n\n      .cls-284 {\n        fill: #3b8bb9;\n      }\n\n      .cls-285 {\n        fill: #908a9f;\n      }\n\n      .cls-286 {\n        fill: #53c7ec;\n      }\n\n      .cls-287 {\n        fill: #838091;\n      }\n\n      .cls-288 {\n        fill: #8b6e50;\n      }\n\n      .cls-289 {\n        fill: #50c9f1;\n      }\n\n      .cls-290 {\n        fill: #48abd5;\n      }\n\n      .cls-291 {\n        fill: #6da595;\n      }\n\n      .cls-292 {\n        fill: #7a7287;\n      }\n\n      .cls-293 {\n        fill: #54868b;\n      }\n\n      .cls-294 {\n        fill: #b8c5c0;\n      }\n\n      .cls-295 {\n        fill: #bedae5;\n      }\n\n      .cls-296 {\n        fill: #e7cd8b;\n      }\n\n      .cls-297 {\n        fill: #9c94ad;\n      }\n\n      .cls-298 {\n        fill: #b3bed0;\n      }\n\n      .cls-299 {\n        fill: #7f7d8d;\n      }\n\n      .cls-300 {\n        fill: #bfdbe6;\n      }\n\n      .cls-301 {\n        fill: #8a8198;\n      }\n\n      .cls-302 {\n        fill: #8f869e;\n      }\n\n      .cls-303 {\n        fill: #e9c1db;\n      }\n\n      .cls-103 {\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 5px;\n      }\n\n      .cls-304 {\n        fill: #3f95c2;\n      }\n\n      .cls-305 {\n        fill: #50c0e6;\n      }\n\n      .cls-306 {\n        fill: #bbb9dc;\n      }\n\n      .cls-307 {\n        fill: #815e37;\n      }\n\n      .cls-308 {\n        fill: #392548;\n      }\n\n      .cls-309 {\n        fill: #9f95b0;\n      }\n\n      .cls-310 {\n        fill: #801b1e;\n      }\n\n      .cls-311 {\n        fill: #918ba0;\n      }\n\n      .cls-312 {\n        fill: #898097;\n      }\n\n      .cls-313 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-314 {\n        fill: #e6e7e8;\n      }\n\n      .cls-315 {\n        fill: #b6c4d5;\n      }\n\n      .cls-316 {\n        fill: #8d839b;\n      }\n\n      .cls-317 {\n        fill: #757f45;\n      }\n\n      .cls-318 {\n        fill: #3d8fbd;\n      }\n\n      .cls-319 {\n        fill: #cdc5a2;\n      }\n\n      .cls-320 {\n        fill: #c0dee8;\n      }\n\n      .cls-321 {\n        fill: #9a91aa;\n      }\n\n      .cls-322 {\n        fill: #dd948e;\n      }\n\n      .cls-323 {\n        fill: #aeafc6;\n      }\n\n      .cls-324 {\n        fill: #bdca9b;\n      }\n\n      .cls-325 {\n        fill: #a79db9;\n      }\n\n      .cls-326 {\n        fill: #3e7485;\n      }\n\n      .cls-327 {\n        fill: #a59ab7;\n      }\n\n      .cls-328 {\n        fill: #a298b3;\n      }\n\n      .cls-329 {\n        opacity: .2;\n      }\n\n      .cls-330 {\n        fill: #b0b5cb;\n      }\n\n      .cls-331 {\n        fill: #8e849c;\n      }\n\n      .cls-332 {\n        fill: #3d5427;\n      }\n\n      .cls-333 {\n        fill: #bcd5e1;\n      }\n\n      .cls-334 {\n        fill: #a8a1bc;\n      }\n\n      .cls-335 {\n        fill: #bfdce7;\n      }\n\n      .cls-336 {\n        fill: #f8f4ed;\n      }\n\n      .cls-337 {\n        fill: #aba8c1;\n      }\n\n      .cls-338 {\n        fill: #a79fba;\n      }\n\n      .cls-339 {\n        fill: #45a3ce;\n      }\n\n      .cls-340 {\n        fill: #7e758b;\n      }\n\n      .cls-341 {\n        fill: #80778d;\n      }\n\n      .cls-342 {\n        fill: #867d94;\n      }\n\n      .cls-343 {\n        fill: #4ab0d8;\n      }\n\n      .cls-344 {\n        fill: #3e92bf;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 0.9,
    y: 4.8,
    width: 261,
    height: 349.7
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M158.4,205.6c0,0,0,.2,0,.2h0c0-.1,0-.2,0-.3h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "154.9 199.1 154.9 199 154.9 199 154.9 199.1 154.9 199.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M258.1,253.3c0-.2.2-.4.2-.6.2-.6,0-1.3.1-2,0-1,.8-1,1.2-1.6.6-1,.6-2,.5-3.1,0-.2,0-.5-.2-.6-.2-.3-.7-.4-1.1-.4-3.2,0-6.4.5-9.4,1.3-3,.9-6.6,1.6-7.9-2.2-.1-.4-.6-.9-1-1-.8-.2-1.7-.2-2.6-.2-.2,0-.5.1-.7.3-.9.8-2,1-2.9.3-.5-.4-1.1-.9-1.4-1.4-.4-.8-1-.8-1.6-.7-.1,0,0,.8-.1,1.3,0,0,0,.2,0,0-.4.2-.8.3-1.1.5-1.9,1.5-2.9,1.7-4.4,0-2-2.2-4.6-1.8-7-1.6-1.5.1-2.6-.6-3.9-.7-.6,0-1.1-.2-1.7-.3-.5-.1-1.2,0-1.4-.4-.5-.7-1.1-.7-1.8-.7-.1.4-.3.8-.4,1.2-.5-.5-.8-.8-1.2-1.1-.5-.4-1.3-.8-1.4-1.3-.2-1.4-1.1-1.6-2.2-1.8,0,1.7-.2,3.4-.2,5.1,0,.3.4.7.6,1-.7.3-.8.3-2.2-1.1,1-.9.9-1.7,0-2.7-.7-.7.3-2.3,1.3-2.3.2,0,.4,0,.5,0,.1-.2.2-.6.4-.7,1.2-.3,2.4-.1,3.4-1,.1-.1.8.2,1.1.4.2-.2.5-.7.8-.8,1.1-.2,2.2-.3,3.3-.4.1-.5.2-.9.4-1.4.4.3.6.5.9.6.4.2.9.6,1.2.5.3,0,.4-.7.7-1.3.2,0,.6,0,1,.2.5.2,2.5-.3,2.8-.8.1-.2,0-.8,0-.8-.8-.3-.9-1-1.2-1.7-.1-.3-.5-.7-.9-.7-1.6-.3-2.3-.8-2.2-3.1-1.1.1-2.7-.8-2.9-1.8-.2-.8-.8-1.1-1.5-.6-1.2.8-2.5.3-2.6-1.1,0-.4,0-.8.1-1.2-.9.4-1.6.7-2.4,1.1.7-1.8.6-2.2-.7-2.5-.9-.2-1.6-.6-2.5-.8-.8-.2-1.6-.3-2.4-.4-1.5-.2-3-.3-4.6-.5-.1,0-.3-.3-.4-.3-.5-.2-1-.5-1.5-.6-1.1-.2-1.4-.5-1.2-1.6,0-.6-.1-1.1-.2-1.7-.2,0-.4,0-.5,0-.2.5-.7.9-.7,1.4,0,.9-.5,1.2-1.2,1.3-.5,0-1,0-1.4-.1-1.4-.3-2.3.4-2.4,1.8,0,.3,0,.6,0,.9-1.4,0-.6-1.1-1-1.6-.3-.1-.7-.2-.9-.4-.3-.3-.5-.7-.9-1.3.4-.2.8-.4,1.3-.6,0-.2-.1-.4-.2-.5-1.4,1-2.7.6-3.8-.1-.7.9-1.3,1.8-1.9,2.6.4-3-2.3-1-3-2,.3-.6.6-1.2,1-1.9-.6-.1-1.2-.2-1.8-.3.2.8.4,1.4.6,2.3-.9-.2-1.4-.3-2-.5.5-.5.7-.9,1.1-1.3-.8-.3-1.6-.4-2.1-.8-.7-.4-1.1-.3-1.4.3-.2.4-.4.9-.7,1.3,0,0-.2,0-.4.2v-1.3c-1,.4-1.7.8-2.5,1.1-1.4.6-2.8,1.7-4.1,1.7-2,0-3.4,1.1-5,1.8-1.1.5-2.1,1.2-3.2,1.8-1,.5-2.1,1-3.1,1.5-.1,0-.1.2-.2.3-.3.4-.6.8-1,1.2-.6.6-1.3,1.2-1.9,1.8-.3.3-.5.7-.8.9-2,1.3-3.5,3.1-4.1,5.4-.3,1.2-.4,2.4-.9,3.5-1,2.2.3,5.9,2.6,6.9.8.4,1.7.9,2.2,1.6.5.8.8,1.4,2,1.2,1.7-.3,3.4-.3,5.2-.4,1,0,2.1-.2,3.1-.2.1,1.2.4,2.3-1.1,2.4,0,0,0,0-.1,0-.2.3-.4.5-.6.6.9.3,1.9.7,2.8,1,.1,0,.2,0,.3-.1,1-.4,1.7-.9,3-.5,1,.3,2.2-.3,3.2-.5,1.2-.3,2.4-.5,3.6.3.3.2.7.2,1,.1,1.2-.2,2.4-.5,3.7-.6,1.3-.1,2.7-.3,4-.1,2.1.2,4.3,3.3,4.1,5.1-.7.4-1.2.7-1.6,1.1,5.9.8,11.8,1.2,17.7,1.4,0,0,.1,0,.2,0,1.4-.4,2.8-.7,4.2-.9,1.4-.3,2.8-.6,4.2-.6,1.5,0,3,.2,4.3-.7.3-.2,1-.1,1.2.1.9,1,1.9.8,3,.7.3,0,.7,0,1,0,2.1.3,4.3.6,6.4,1,1.3.2,2.5.4,3.8.6.8.2,1.5.7,2.2.9,1.6.4,3.2.6,4.8.9.6.1,1.3.5,1.9.7,1.1.4,2.3,1.3,3.3,1.1,1.9-.2,3.3,0,4.4,1.6.1.2.3.4.5.5,2.2.5,3.6-.7,5.7-.8,2.5-.1,4.7-.5,6.8-2.1.4-.3.9-.7,1-1.3,0-.3,0-.6,0-1,0,0,0-.1,0-.2h0ZM201.2,240.3c-.3-.5-.4-1.1-.7-1.9.6.6,1,.8,1.3,1.2.2.2.2.5.3.8-.3,0-.8,0-.9,0h0ZM207.5,242.3c-.3-.9-1.8-1.1-.9-2.4.2-.2,1-.3,1.1-.2.5.8.7,1.6-.2,2.6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M124.4,233c.9,0,1.6,0,2-1,0-.2.2-.3.4-.4.4-.3,3.6-.1,4.1,0,.4.2,1,.3,1.1.2.3-.3.4-.8.4-1.3,0-.3-.3-.6-.3-.9,0-.3.1-.7.3-.9.1-.1.6,0,.8.1.5.3.7.5,1.4.2.7-.3,1.3.3,1.5,1.1.2,1.4.4,2.7.5,4.1,0,.2-.2.7-.4.7-.8,0-1.6,0-2.5,0s-.6,0-1,0c0,.4,0,.9.2,1.2.3.4.8.8,1.2,1,.3.1.8,0,1.1-.2.9-.5,1.7-1.2,2.6-1.7.2-.2.8-.2.9,0,.3.2.5.7.5,1,0,.8,0,1.6-.2,2.4-1.6.5-1.8,1.2-.6,2.3.3-.3.5-.7.9-1,.6.4.6.8.1,1.3-.7.6-.6,1.4,0,1.9.8.7,1,1.6,1.1,2.5.1.8.2,1.6,1.4,1.4,0,.9-.3,1.3-1.1,1.2-1-.2-1.8-.3-2.3,1-.2.5-1.1.7-1.7,1.1-.4.2-.7.4-1.1.6-.7.5-1.3,1.2-2,1.5-1.5.7-1.9,2.3-.6,3.8-2.4-.2-4.8-.4-7.2-.6-2.4-.2-4.7-.5-7-.8-4.1-.4-8.1-.9-12.2-1.3-2.8-.3-5.7-.6-8.5-.9s-5.7-.7-8.5-1c-3.1-.4-6.2-.7-9.3-1.1-1.3-.2-2.6-.4-3.8-.6.3-.7.6-1.4,1-2.2-2.1-1-2.3-1.8-.8-3,.8.3,1.5.6,2.3.9,0-.6,0-.9.1-1.3.3.1.5.2.8.4,0-.5-.1-.9-.1-1.3.2-.3.3-.6.5-.9-.1,0-.2,0-.3-.1,0,.3-.1.6-.2,1h-1.8v-.3c.4-.2.9-.3,1.4-.5-.2-.4-.4-.8-.6-1.2-.3.1-.5.2-.9.3,0-.5,0-.8,0-.9,1.7-.2,3.3-.4,4.6-.6.1-.7.2-1.3.3-1.8.2-.7.5-1.3.8-2,.2.3.4.5.6.7,1.1-1.4,1.9-1.5,3.1-.5,1.7-1.6,3.8-1.3,6-1.4.1-1.2.7-1.2,1.5-.5.2-.5.4-1,.7-1.6.6.3,1.1.5,1.6.8.6-.7,1.2-1.3,1.9-2,.4,0,.9,0,1.5.1-.2.4-.4.7-.6,1.1-.3,0-.6-.1-1-.2,0,.1-.1.2-.1.3.4.2.7.4,1.1.7,0,.4-.1.8-.1,1.2,0,.5.2.9.2,1.4,1.1-.3.9.8,1.4,1.2.3.3.6.7,1,.8.8.2,1.6.2,2.5.3,0-1.7,1.4-1.7,2.2-2.2.9.4,1.7.7,2.6,1,0,0-.1.3-.2.6,1.5.3,2.8,0,3.8-1.2.2.2.3.3.3.4,0,1.2.4,1.5,1.6,1.1.3-.1.9,0,1.1.1.7.7,1.3,1.6,2.2,2.6.7-.3,1.8-.4,2.4-1.1.6-.6.7-1.8,1.1-2.7.2-.5.6-1.1.9-1.5.1-.2.5-.3.6-.4.3-.9.6-1.8.9-2.6h0ZM100.1,240.5c-.8-1.1-1.5-2.1-2.3-3.3-1.6.4-.7,2-.7,2.8,0,1.2,1.3,1.3,2.2,1.7.3-.5.6-1,.8-1.2h0ZM88.7,236.5c0,0,0,.1,0,.2.2,0,.3.1.5.2,0,0,0-.2,0-.2-.2,0-.3-.1-.5-.2h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M131.1,220.7c-.4,0-1,.3-1.2.2-1-.7-2-.3-3.1-.2-1.5,0-3.1-.2-4.6-.3-.3,0-.7-.1-1,0-2.1,1.2-4,.6-5.8-.6-.9-.6-1.6-.6-2.3.3-.5-1-1.3-1.1-2.2-.7-1.3.5-2.6,1.1-4,1.5-1.1.3-2.3.2-3.4.3,0,0,0,0-.1,0-.1,0-.3.1-.4.2,0,0,0,0-.1.1-.1.2-.3.5-.5.7h-.3c-.3.2-.5.3-.8.4,0,0-.2,0-.2.1-.2.1-.3.2-.5.3-.3.2-.6.3-.9.5-2.6,1.2-5.2,2.6-7.9,3.6-1.8.7-3.6,1-5.5,1.4,1.1,0,2.3,0,3.4-.1.1-.2.3-.4.4-.4,1.8-.6,3.6-1.1,5.5-1.7.6-.2,1.1-.7,1.7-.8,1.3-.3,2.5-.9,3.9-.3.8.3,1.7,0,2.4.9.1.2.6.2.8.1,1.1-.6,1.7,0,2.5.7,0,0,0,0,0,0,.8,0,1.4.6,2.1.8.2,0,.4-.1.7-.2,1.1-.3,2.3-.3,3.4-.4.4,0,.9,0,1.4-.2,1.4-.5,2.8,0,3.3,1.1,0,0,.1.1.3.2.3-.2.5-.3.9-.6.1.3.2.5.3.8,1.3-.4,2.5-.3,3.4,1,.3.4,1,.9,1.4.9,1.1-.1,2.1-.6,3.2-.9-.6-1.5-.3-2.4,1.1-3.1,2-1,3.5-2.5,4.8-4.2.3-.4.7-.7,1.1-1.1-1-.1-2-.3-3-.4h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M267.7,219.6c-1.1.1-2.2.3-3.3.4,0,0,0,.2,0,.2.5,0,1,.2,1.7.3-.9.9-1.6,1.6-2.8,1.8-.7.1-1.4.4-1.9.9-2.1,2.1-4.3,1.7-6.6.5-.1,0-.4,0-.5,0-.4,0-.8-.2-1.2-.2-1.6,0-3.2.2-4.8.2-.2-.4-.4-.7-.5-1.1,0-.1-.2-.2-.2-.3-1.6-.8-4.1-.7-5,.4-.4-1.1-.8-2.1-1.2-3.2.2-.4.5-.9.7-1.3.2,0,.4,0,.6,0,5.2.4,10.5.8,15.7,1.1,3.1.2,6.2.2,9.3.3h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M-3.3,163.1c-.5-.3-1-.6-1.4-.9,0-.1.2-.2.3-.4.8.4,1.7.7,2.2.9,1.9-.1,3.6-.2,5.2-.4,1.6-.2,3.2-.5,4.7-.8,1.6-.3.8,2.4,3.1,1.4.3.8.6,1.7,1,2.7-.3.3-.8.7-1.4,1.2,1,0,1.8,0,3,.2,0,0,.2-.3.5-.6.2,0,.3,0,.5,0h0s-.6,1-.6,1c0,.3-.1.6-.2.8h-.4c-.4-.2-.8-.3-1.4-.5.2.7.4,1.2.5,1.6-.8,0-1.5,0-2.3,0,.4-.2.7-.3,1.1-.5-.1-.1-.3-.2-.4-.3-.3.3-.5.5-.8.8-.6,0-1.1,0-1.7,0,.2,0,.4-.1.6-.2,0,0-.2-.2-.2-.2-.2,0-.4.2-.5.3-1.2.6-2.4.6-3.8.3-1.7-.3-6.1-1.1-4.6-.9-.4-.3-.5-.4-.6-.5-.7-.5-1.4-.9-2.1-1.3.8-.2,1.6-.5,2.6-.8-1,0-2.8-1.6-2.7-2.2M7.4,167.6l.3.5v-.6c-.5,0-.9-.2-1.3-.3,0,0,0,.1,0,.2.4,0,.7.1,1.1.2ZM8.6,166.7c0-.2,0-.5.1-.7-1.8-1.1-3.9-.4-5.8-.6,0,.2,0,.4-.1.5,1.9.3,3.9.5,5.8.8h0ZM9,166.9c-.2.1-.3.2-.5.4.4.2.7.4,1.1.6,0,0,.2,0,.4-.1-.4-.3-.7-.6-1-.9h0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "newer"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "shado1",
    className: "cls-152",
    x: 3.9,
    y: 14.9,
    width: 265.5,
    height: 346.9
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-313"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M-26.3-82.1c-.2-1.7-.7-3.2-.4-4.9.2-1.5.5-3,.7-4.6v-.2c0-9.3,0-18.6,0-28,0-8.1,0-16.1.1-24.2v-8.4c.4,0,.7,0,1.1,0h0c.2,2.3.4,4.5.4,6.7,0,1.7-.2,3.5-.2,5.3s.1,4,.3,6c0,.3.4.5.7.8.7.6,0,6.2,0,7.3,0,2.6,0,5.1,0,7.7,0,5.1,0,10.2.1,15.3,0,1.6,0,3.3,0,5,0,1.9.6,7.7.6,8.9,0,5.5-.5,34.8-.5,37.2,0,3.6,0,7.3,0,10.9,0,4.6,0,9.2,0,13.9s0,1.8,0,2.7c0,2.1.2,4.2.4,6.4,0,.9,0,1.9.2,2.8,0,.5,0,1,0,1.4-.1,4.1-.3,8.1-.4,12.2,0,2.9,0,5.8,0,8.6,0,2.3.2,4.7.3,7,0,5.8,0,11.5,0,17.3-.7-.3-1.4-.6-2.2-.9-.4-.2-.8-.5-1.2-.7,0-30.8-.1-61.5-.2-92.3,0-1.1-.5-19.9-.7-21.8.2,4-.3,7.9,0,11.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M-9.2-166.1c-.6.2-3.5,0-4.1,0-2.1.3-3.3,0-5.4,0-1.4,0-2.9.3-4.3.2-1.4-.1-2.9.5-4.4.4-.3,0-3.5,0-6.2,0,0,1.4,0,3,0,4.6,0,6.6,0,13.1,0,19.7,0,18-.2,36-.2,54.1,0,.1.2,15.2.2,15.9,0-.3,0-4.3-.2-15.2.2,2.8,0,16.9.6,26-.4-.4-.8-.8-1.2-1.3-.7-.7-1.6-1.1-2.5-1.7-.2.9-.3,1.9-.5,2.8,0,.8.2,1.7.2,2.5,0,.3-.5.7-.9,1.1.7,1.6.9,3.4.6,5.3-1,.1-1.7-.2-2.1-1-.5-1-1.1-1.9-1.8-2.8-.3-.3-.8-.4-1.2-.6.8.8.9,1.8.9,2.8,0,4,0,7.9,0,11.9h0c.2.3.4.5.6.8.5.8.9,1.5,2,1.6.5,0,1,.6,1.3,1.1.2.3.2.9,0,1.2-.2.2-.8.3-1.2.2-.9,0-1.8-.3-2.7-.4,0,1.7.1,3.4.2,5.2,0,.5,0,1,0,1.5V-11.8c0,3,0,6,0,9.1,0,1.9-.2,3.8-.2,5.7,0,.5.1.9.2,1.4,0,.3,0,.5,0,.8,0,2.3,0,4.7,0,7,0,.3,0,.5,0,.8v.5c0,.5,0,1.1,0,1.6,0,.4,0,.8,0,1.2h0c.5.3,1,.7,1.5.9.5.2,1,.4,1.5.4,1.9,0,2.3.5,2.4,2.4,0,1,.4,2.1.5,3.1,0,.4,0,.9-.1,1.3-.1.4-.4.8-.8,1.4h2.1c0-.7,0-1.5.1-2.5.9,1.6.2,2.9,0,4.2,1.6.3,2.9.6,4.3,1,.4.1.7.5,1.1.7.4,0,.8,0,1.3,0,.7-.6,1.2-.1,1.8.3,0-27.1-.1-54.1-.2-81.2h0c0-1.5,0-37.3.1-38.8,0-.5-.2-.9-.2-1.4,0-18.3,0-36.7,0-55,0-.5-.2-4.8,0-5.2,1.6-.1,4.1-.3,4.4-.3,1-.2,19.3-3.5,26.2-4.8.3-1.1,2.6-8.4,2.9-9.6-5.6,0-10.9.8-16.4.8h0ZM-33.5-1.1v17.7h-.4V-1.1c0-.7,0-1.4,0-2.1,0-17.7,0-35.4,0-53.1,0-.5,0-.9.2-1.4,0,.2,0,.4,0,.6,0,18.4.2,36.8.3,55.3,0,.2,0,.4,0,.6h0ZM-26.8-51c0,0-.2,0-.3,0-.2-.3-.4-.7-.6-1,.4,0,.7.1,1,.1,0,.3,0,.6,0,.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M5.3.1c-.1-.7-1-3.4-1-4.2-.2-5.9,1.1-10.1,1-15.9,0-.1-.2-2.8-.8-2v-.6c-.4,0-.7,0-.7-.6,0-2.5-.2-5-.2-7.4,0-.6.3-1.2.4-1.9s.2-1.2-.6-1.6c-1.4-.5-1.4-.7-1.4-2.4,0-1.2,1.1-.9,1.7-1.2.2,0,.4,0,.6,0,0-9,0-17.9,0-26.9-2.4-.3-4.8-.5-7.2-.8-.3,0-.5-.5-.8-.8-.3-.4-.4-.8-.7-1.1-.6-.6-1.2-1.1-1.7-1.8-.4-.6-.8-.8-1.3-.3-.6.6-1.2.5-1.7,0-1-.9-1.8-1.9-2.8-2.9-.6-.6-.9-1.3-.7-2.1.4-1.6-.3-2.7-1.6-3.5-.4-.3-.6-.8-1-1.1-.7-.5-1.5-1-2.3-1.5-.4,1.8-.8,2.4-2,2.6,0,1.1-.8,2.1-.7,3.2.2.2,1.1.5,1.3.8.6,1.2,1.7,2.2,2.6,3.3,1.8,2.2,3.6,4.3,5.3,6.5,1.4,1.8,2.6,3.8,3.8,5.8.7,1.1,1.1,2.3,1.7,3.4.4.8.9,1.5,1.3,2.2.1.1.3.3.4.4,1.2,2.9,1.7,6,1.3,9.1,0,.5-.4,1.2-.6,1.2-.7,0-1.7,0-2.2-.4-.7-.7-1.1-1.4-2.1-.5-.7.6-2.1-.5-2.2-1.7-.2,0-.5,0-.7-.1-.6.4-1.6.4-1.3,1.8-1.3-1-.2-1.6-.2-2.3-.7.2-1.4.3-2.1.5-1.3,1.4-2.9,1.3-4.6.8,0,3.6-.2,7.1-.2,10.7,0,2.1,0,4.3,0,6.4,1.1-1.9,1.2-3.9,1.1-6,0-1.5-.3-3.1.4-4.6,0,2,.2,4.1.3,6.1.1,3.4,2.6,2.9.6,6.7-1.7,3.3-4.1,6.2-4.2,10.2-.1,2.1.4,4.1,1.2,6.1.4.9.8,1.9,1.2,2.8.8,1.8,1.6,3.5,2.4,5.3,1.8,3.8,4,8.1,8.1,9,3.9.9,7.6-1.8,10.8-4.3C4.1,3.2,5.6,1.8,5.3,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M38.7,361.4c.2,1.1-.2,1.9-1.2,2.4-2.5,1.2-5,2.4-7.5,3.6,0,0,.5,1.1.6,1.2.3.2.5.1.9.1.9,0,1.9-.2,2.8-.4.9-.3,1.5-1.1,2.3-1.6.8-.5,1.7-1,2.6-1.3.2,0,2.5-.9,2.6-.8-.7-1.3-2-2.2-3.1-3.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M119.1,416.8c-1.1-.6-2.1-1.3-3.4-2.1.2-.2.4-.4.6-.7l2.5.3c0,.1-.1.2-.2.3.3.2.5.5.8.7.9.4,1.7.8,2.6,1.2,0,.3,0,.5,0,.8-.1,0-.3,0-.4,0-.1,0-.2,0-.3-.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M8.9,387c-.2-.2-.4-.3-.6-.5-.3-.2-.6-.5-.9-.7,1.4-.4,2.8-.7,4.1-1.1.2-.3.4-.7.5-1,0-.1.2-.2.3-.3.3-.2.6-.4.9-.5.9.4,1.8,1,2.7,1.2,1.5.3,3,.4,4.5.6,0,.1,0,.3,0,.4-3.9,0-7.7,1.1-11.5,1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M17.1,371.2c0-.2,0-.3,0-.5,2.9-.8,5.8-1.5,8.7-2.3.2,0,.4-.3.5-.5,1.1.3,2.3.6,3.4.9-3.4.7-6.8,1.4-10.2,2.1-.8.2-1.7.2-2.5.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M4.3,375.4c.3,0,.6,0,.8,0,.7.7,1.5,1.3,2.2,2,0,.1-.2.2-.2.3l-2.8-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M13.2,383c-.3.2-.6.4-.9.5-.3-.6-.6-1.3-.9-1.9,0,0,0-.1.1-.2.6.5,1.2,1.1,1.8,1.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M9.6,379.8l-.8-.8h0l.8.8h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M12,383.8c-.2.3-.4.7-.5,1,0-.4-.3-1,.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M8.1,378.3c-.1,0-.2,0-.4,0,0,0,0,0,0-.1,0,0,.2.2.3.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M3.2,374.6c0,0,.2.1.3.2,0,0-.2-.1-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M8.4,378.5c0,0-.2-.2-.3-.3h0c0,0,.2.2.2.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M8.6,378.8c0,0-.2-.2-.3-.3h0c0,0,.2.2.3.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M8.6,378.8c0,0,.2.2.3.3h0c0,0-.2-.2-.2-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M9.7,379.8c0,0,.2.2.2.3h0c0,0-.2-.2-.3-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M9.9,380.1c0,0,.2.2.3.3h0c0,0-.2-.2-.3-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M10.2,380.3c0,0,.2.2.2.3h0c0,0-.2-.2-.3-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M10.4,380.6c0,0,.2.2.3.3h0c0,0-.2-.2-.2-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M10.7,380.9s0,0,.1.1c0,0,0,0,0,0,0,0,0,0,0-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M3.5,348.2c3.1-.1,6.2-.2,9.2-.3,3.1,0,6.2,0,9.3.3,2,.1,4,.6,6,.9,0,.1,0,.3,0,.4-.3,0-.6.1-.9,0-5.3-1.4-10.7-.9-16-.8-2.5,0-5,0-7.6,0v-.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M3.5,348.2v.6c-.6,0-1.3.5-1.7-.4.6,0,1.1-.1,1.6-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M35.3,385.4c-.1-.6,1.7-.4,1.9-.4.4,0,1.6,0,2,0,4.7,0,17.6.9,22.2.9-.3.3-25.9-.2-26.1-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M4.2,370.8c.5.8.9,1.6,1.5,2.6-.8.2-1.5.5-2.3.7.2-.7.4-1.5.6-2.2,0-.4.1-.7.2-1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M15.3,371c0,0,.2,0,.3-.1,0,0-.2,0-.3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M11.4,371.3c.1,0,.2,0,.3,0-.1,0-.2,0-.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M330-163c0,0,0-.1,0-.2-1-3.2-5.1-4-8.5-4.1-4-.2-8-.3-11.9-.3-3.6,0-7.2,0-10.9,0h-7.9c-28.8,0-57.6,0-86.4,1.4-1.7,0-3.5.2-5,1.1-2.1,1.3-2.6,4.3-2.8,6.5,1.1,1.2,3.1,1,4.2-.4.2-.2.5-.4.9-.4.7,0,1.4,0,2,0h.1c.4,0,.6,0,.8.2.3.2.4.6.4,1.1,0,.8-.6.8-1.2.8-1.3,0-2.7-.1-4,.7-.7.4-1.8.1-2.6.1-3.1,0-3.7.6-4.4,3.1-.2.8-.6,1.1-1.5,1.1-2.2,0-4.5.1-6.9.2,0,1.1,0,2,0,2.9,0,.4-.4.8-.7,1-.7.4-1.5.8-2.3,1-1.1.2-1.1.8-1.1,1.7,0,1.5,0,1.5-1.5,1.6-.4,0-.9,0-1.3.1-.4,0-.8.2-1.2.3,0,.2-.1.5-.2.7-.2,2.9-.4,5.7-.5,8.6,0,.8-.5,1.2-1.2,1.7-1.6.9-15.3,7.7-16.1,7-.7.6-1.2,1.4-1.9,1.6-1.2.4-2.5.6-3.7.6-2.9.1-5.8.1-8.7.2-.7,0-1.1.3-1.2,1,0,.5-.2,1-.2,1.5,0,1.7.4,2.1,2.1,2.2.7,0,1.7-.4,1.9.5.2,1.1-1,.7-1.5,1-.4.3-1,.3-1.5.5-.3.1-.5.4-.8.6-.3.2-.5.6-.9.7-.8.2-1.1.5-1.2,1.3,0,.7-.5.8-1,.8-1.1,0-2.3,0-3.5,0-1,0-1.4.5-1.4,1.4,0,1.2,0,2.3,0,3.5s0,1.6-1.5,1.6c-1.1,0-2.3,0-3.5,0-.8,0-1.3.2-1.5,1.1,0,.3-.5.7-.7.7s-.7-.3-1-.5c-.4-.2-.8-.7-1.2-.7-1,0-2.1-.4-3.2.7.5.1.8.1,1.1.3.4.2.8.3,1.1.6,0,0-.2.8-.4.8-.5,0-1.1,0-1.4-.2-1.3-1.2-1.7-1.1-2.6.6,0,.2-.3.4-.4.4-1.2.1-1.4.9-1.3,1.9,0,.9-.4,1.2-1.2,1.2-1.3,0-2.7.3-3.9-1-.2,1.7-.9,2.4-2.4,2.4-.2,0-.5.6-.6,1-.2.6-.2,1.6-.7,1.9-.8.5-1.8.7-2.7.9-.5.1-1.1.1-1.7,0-1.9-.4-3.3.6-4.9,1.3-.3.1-.5.6-.7.8-.4.4-.8.6-1.1,1-.3.4-.7.9-.7,1.3.1,3.5-.9,3-3.2,2.7-1.3-.2-2.4-.7-3.6,0-.2.1-.5-.1-.8-.2s-.5-.3-.8-.4c-.1.3-.4.7-.3,1,0,.8.3,1.5.5,2.3,0,.4.2.7.3,1.1-.4.2-.6.3-.9.5.7,1.7,1.4,3.5,2.1,5.2h0c0,.3,0,.5,0,.7,0,.2,0,.5,0,.7v1.9c0,0,0,.1,0,.2,0,.3,0,.7-.1,1-.2.9-.5,1.8-.8,3,.7.1,1.5.3,2.2.4,3,.5,4.8,3.1,4.9,6.3,0,.9-.1,1.8-.1,2.7s.1.9.2,1.4c1.8-.6,3.3-.1,4.7.5,2.2,1,3.1,2.9,3.4,5.2,0,.3.4.7.5,1,.9,0,1.7,0,2.6,0,1.6-.1,2.8.5,3.7,1.9.3.4.9.6,1.3.7,1.8.6,3.7.9,5.5,1.6,1.2.5,2.1,1.4,2.2,2.9,0,.4.2.7.3,1.1,2.2.2,2.9,1.2,2.6,3.6-.5,0-1,0-1.4,0-7-1.4-14-2.9-21-4.3-3.8-.7-7.6-1.2-11.4-1.8-.4,0-.7-.2-1.1-.2-.9,0-1.9,0-2.8-.1-3.3-.4-6.6-.8-9.9-1.2-3.1-.4-6.2-.9-9.3-1.4-1.3-.2-2.5-.3-3.8-.5-4-.8-8-1.5-12-2.5-2-.5-4-1.3-5.7-2.4-2.3-1.4-4.6-1.8-7.2-1.8-.6,0-1.1,0-1.7,0-2-.2-4-.2-6-.5-2.8-.4-5.6-.8-8.4-1.3-1.1-.2-2.1-.7-3.1-1-.1,0-.3-.2-.4-.3-.4-1.4-1.4-1.5-2.6-1.5-.4,0-.9-.1-1.2-.3-1.9-1.2-3.9-2.1-6.2-2.2,0,.7,0,1.5.1,2.3,0,0,0,.2,0,.3,0,.3-.2.7-.2,1,0,6.8.2,13.7.2,20.5,0,2.4-.2,4.8-.2,7.2,0,7,.1,13.9.2,20.9,0,1.7,0,3.4,0,5,0-.5.2-.9.2-1.4,0-3.9.3-14.9.2-16.4,0-4.4-.2-8.7-.2-13.1,0-.9.2-1.8.3-2.6h.4c0,.7,0,1.4.1,2,0,.5.4.9.5,1.3.2.6.5,1.2.7,1.8,0,0,.2,0,.2-.1.3-1.5,1.6-2.4,3.1-2,.2,0,.4.3.6.5.2.3.3.7.5.9,1.1.6,1.9,1.2,2.3,2.5,0,.2.6.4,1,.4.7.1,1.4.1,2,.3.3,0,.6.5.9.7.9.7,1.7,1.5,2.7,2,.3.2,1.1,0,1.3-.4.6-.9,1.4-.6,2.2-.5,1,.2,2,.3,3,.3.4,0,.9-.4,1-.7.5-1.1.8-1.3,2-.8.4.2.9.2,1.3.3.6,0,1-.2,1.1-.9,0-.3.4-.6.7-.9.3.3.7.6.8.9.3.9.8,1.2,1.7.9.8-.2,1.6-.5,2.5-.7.2,1.2.7,1.7,1.8,1.3.1-1.6.2-1.5,1.8-1.7.5,0,.9-.6,1.4-.9,0-.1,0-.2-.1-.3h2.3c.2,0,.5,0,.5,0,.5,1.2,1.5,1.4,2.6,1.3.2,0,.4.3.4.5s-.2.5-.4.5c-.4.2-.9.2-1.4.3v.3c.4,0,.9,0,1.3,0,1.7,0,3.3,0,5,0,.6,0,1.2.4,1.7.9.5.5,1.1.9,1.5.3,1-1.8,2.6-1,4-1.1,1.2,0,2.4.1,3.6.2.8,0,1.1-.3,1.1-1.1,0-1,.5-1.2,1.3-1.3,1.9,0,3.8-.2,5.7-.3.3,0,.7,0,1-.2,1.7-.5,2.5-.3,3.4,1.1,1,1.5,2.7,1.3,4.1,1.6.6.1.8-.5.9-1.2,0-1.1.1-2.2.2-3.3h7c0,.1,0,.2,0,.3-.9,0-1.7,0-2.5.1-.1,1.1-.3,2.1-.4,3.2,1.2.3,2.4.5,3.6.8q.2-1.9,2-1.9h5c0,.5,0,.8.1,1.2.3,1.1,1,1.3,1.9.7.2-.1.5-.3.7-.3,1.5,0,3.1,0,4.6.3,1.7.2,3.3.4,4.8-.8.2-.2.9-.2,1,0,.9,1.6,2.3,1.1,3.4.9.8.7,1.5,1.4,2.2,2,.7-.2,1.4-.4,2.3-.7v2.5c0,.2.1.3.3.7.5-.9.9-1.8,1.5-2.5.2-.3.7-.4,1-.5.8-.2,1.5-.4,2.3-.6.4,0,.8-.2,1.2-.2,1.8,0,3.7.3,5.4-.6.4-.2,1,.1,1.4.2.4,0,.8.3,1.2.3,1.5,0,2-.7,1.5-2.4.4.2,1,.2,1.3.5.5.7,1.2.7,1.7.5.4-.2.5-.9.7-1.3.1-.4,0-.8,0-1.4h6.4c-.2.4-.4.6-.4.8,0,.5.2,1.1.4,1.5.1.2.8.1,1.1,0,.9-.3,1.8-.5,2.6.3.7.7,1.3.6,2,0,.2-.2.6-.3,1-.5.2.4.4.7.4,1.1.1,1.1.8,1.8,1.9,1.9,1.6.2,2.9-.4,4.1-1.4-.5-.4-.9-.7-1.1-.9.2-.7.4-1.1.6-1.6-.3,0-.6-.2-.9-.2-2.9-.5-5.7-.9-8.6-1.4-1.3-.2-2.6-.4-3.9-.7-.3,0-.5-.3-.8-.5-.5,0-.9,0-1.3,0-3.3-.7-6.5-1.4-9.8-2.2-2.2-.5-4.4-.9-6.6-1.5-.8-.2-1.9-.5-2.1-1.1-.5-1.1,0-2.4.9-3.1,1-.8,2.2-1.5,3.6-1.1,4.1,1.3,8.3,2.6,12.4,3.8,2,.6,4,1.2,6,1.7,1.5.3,3,.6,4.5.8,4,.6,9.1,2.3,13,.6,3.1-1.4,6.3-2.7,9.4-4.1,3.1-1.4,6.4-2.8,8.5-5.5,1-1.2,1.7-2.7,2.6-3.9.8-1.1,2.6-3.7,3.5-4.4s3.3-1,3.4-2.4c0-.2.2-.4.3-.5.9-.5,1.8-.9,2.8-1.3.8-.3,1.8-.3,2.5-.7,1.1-.6,1.2-2.3,2.7-2.6,0,0,0-.3,0-.5.1-1,.5-1.6,1.6-1.9,1.7-.5,2.1-2.9.7-4.1-.5.2-1,.3-1.4.4-.7.2-1.4,0-1.5-.7,0-.4.4-1,.8-1.4.2-.2.7-.1,1.1-.1,0-.7.1-1.1.9-1.4.7-.3,1.3-.9,2-1.4.2-.9.5-1.9.8-2.8h-1.6c.3-1.2,1-1.8,1.8-2.1.8-.3,1.1-.7,1.1-1.6,0-.7.1-1.1,1-.7-.2.6-.3,1.3-.5,1.9.9-.5,1.9-1,2.8-1.6.6-1.8,2.1-2.3,3.7-2.6.4,0,.9.2,1.3.5,1,.6,2.4.1,2.9-1-.6-.2-1.2-.5-1.8-.7v-.4c.5-.2.9-.4,1.3-.5.9,0,1.4-.5,1.5-1.4.2-2.2,2.3-2.3,3.9-2,2.2.5,4.4.8,6.6.2.9-.3,2.1-.2,3,0,1.5.3,2.9,0,4-.7.8-.4,1.2-1.6,1.6-2.5.3-.8.6-.9,1.3-.9.3,0,.6,0,.9,0,1,0,1.6-.4,1.7-1.5,0-.2.2-.4.3-.7,1.3,1.8,1.3,1.8,2.5,1.3,0-.3,0-.7,0-1-.2-.5-.4-1-.6-1.7.3-.6.8-.8,1.4,0,0,0,.1,0,.2,0,.8-.5,1.5-.9,2.3-1.3.4-.2.9-.2,1.5-.3,0,.5,0,.8.1,1.1.1.4.4.7.6,1,.3-.3.7-.6.9-.9.1-.3,0-.8.2-1.4.5.5.9,1,1.4,1.6,0,0,.2,0,.2-.1-.1-.3-.2-.6-.4-1.2.5,0,1-.1,1.4,0,0,0,.1.5.2,1,.4-.4.8-.7,1.1-1.1,0-.1,0-.2,0-.3-.4,0-.9,0-1.3-.1-.3-.1-.6-.4-.8-.7.3-.2.7-.6,1-.5.6.1,1.2.5,1.7.8,1.1.7,1.5.5,2.4-.5.8-.8,1.4-1.5.3-2.5-.2-.2,0-.7-.1-1.1,1-.3,1.9-.5,2.2-1.8.1-.4,1.2-.6,1.8-.9.7-.3,1.3-.7,2.2-1.1.8.8,1.9,1.7,3.6.8-.9-.4,3.5-.4,2.6-.2-.2,0-.5.5-.5.8,0,.3.3.6.6.7.6.3,1.2.6,1.9.7.4,0,1-.1,1.2-.4.6-.9,1.4-.8,2.2-.7.5,0,1.1,0,1.6.1,0-.1,0-.2,0-.3-.9-.5-1.7-.9-2.6-1.4.8-.9,1.3-1.6,2-2.2.3-.3.9-.4,1.4-.4,1.1,0,1.7-.2,1.6-1.5,0-.6.2-1.2,1.3-1.5,0,.8,0,1.5,0,2.1,0,.2.3.5.5.7.2-.2.4-.3.5-.5.5-1,1.1-1.2,2-.5,0,0,.1.1.1.2,1.5,2,3.5,1.9,5.6,1.3.4-.1.8-.3,1.2-.4,0-2.5,36.8-15.8,38.2-15.6v-36.7c-.7,0-1.3,0-2-.1h.1ZM39.2-36.5c-.2,0-.5,0-.8,0,0-.1-.2-.3-.3-.4.2,0,.4-.2.6-.2s.4.2.5.3c0,0,0,.2-.1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M5.6,174.5c-.3,7.4-.5,14.8-.8,22.2,0,.4,0,.8-.3,1-.3.3-.7.2-1.1.2-6.9-.4-13.8,2.5-20.7,2.1,0-3.3.2-6.6.1-9.9,0-4.2-.3-8.3-.5-12.5,0-3.7,0-7.3,0-11,0-5.5,0-42.1,0-42.5,0-9,0-17.9,0-26.9,0-6-.2-11.9-.2-17.8,0-7.2-.2-14.4-.2-21.6,0-3.5,0-7,.1-10.6,0-3.1,0-6.2,0-9.3,0,.5.2.9.2,1.4,0,3.4,0,6.7,0,10.1,0,1.5.4,3,.6,4.5l.4-.3c.6.3,1.4.4,1.7.9.6.8,1.2.9,2.1.7.4,0,.8,0,1.1-.2,1.2-.3,2.2.6,3.3.7,1.7.1,2.7,1.4,3.7,2.5.6.6,1,1.1,1.9,1,1-.1,1.8.2,2.5,1,.5.6,1.1,1.1,1.7,1.6,1-.8,1-.8,2.1-.1.2.1.5.1.7.2,0,1.7.2,3.3.2,5,0,3.3,0,6.7,0,10,0,3,0,6,0,9.1,0,1,0,2,0,3,0,4.5,0,14,.1,14.1,0,.4,0,.9,0,1.3,0,11.1,0,22.2,0,33.3,0,5.6,0,11.2,0,16.8s-.1,5.6,0,8.4c0,2.1.9,9.7.8,11.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M74,134.5c-.3-.2-1.1-.2-1.1-.1-.3.9-1,2-.9,2.8l3.9-1.6c-.6-.3-1.3-.6-1.9-1.1h0ZM74.8,140.3c-1,0-2-.2-3.1-.2,0,0,0,0,0,0,.9.4,1.9.7,2.9,1,.1,0,.3,0,.8,0-.3-.3-.5-.6-.6-.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M219.8,110.5c2.1-1.4,4.5-2.3,7-2.6,1-.1,1.9-.1,2.9-.1.8,0,1.6.1,2.5.2,5.1,0,10-2.7,15.2-2.7.8,0,1.5.3,2.2.2,1.3-.3,2.5-.9,3.8-1.3.7-.2,1.4-.6,2.1-.5,1.7.3,3.1-.3,4.5-1.2.7-.5,1.5-.8,2.5-.5,1.2.4,2.2-.3,2.7-1.6.1-.3.5-.6.7-.8,1.5-1.3,3.3-1.3,5.1-1.3,1,0,2.1-.3,2.2-1.3.2-1.1.8-1.5,1.6-1.9,1.1-.6,2.1-1.2,3.2-1.8,1.5.9,1.5.8,3.2,0,.9-.4,1.9-.7,2.9-.9,2.4-.4,4.5-1.4,6.6-2.6.3-.2.6-.6.8-1,.5-1.3,1.6-2,2.6-2.9,0,3.8.1,7.7.1,11.5,0,2.5,0,17.8,0,18.3-.5.5-1,.9-1.5,1.3-1.5,1.1-3.1,2.1-4.5,3.2-1.2.9-2.3,1.9-3.2,3.1-1.5,2-3.1,3.8-5.2,5.2-.5.4-1.1.8-1.5,1.3-1.6,1.8-3.7,2.5-5.9,3.1-4.4,1.2-8.5,2.2-12.9,3-3.5.6-4,2.7-7.4,4-1.6.6-3.3,1.2-4.9,1.8,0,0-.5.1-1,.3-.4.2-.7.4-.9.8-.2.2-.2.5-.4.7-.2.3-.4.5-.6.7-.4.3-.7.6-1,1-1.5,1.4-3.2,2.9-5.2,3.6-1.1.4-2.2.5-3.3.7-1.3.3-2.5,1-3.8,1.2-.3,0-.6,0-.9.2-.2.1-.3.3-.5.5-1.8,2.5-4.8,3.6-6.4,6.2-.6.9-1,2-1.7,2.8-.7.8-1.8,1.4-2.8,1.1-.7-.2-1.2-.8-1.7-1.3-1.7-1.5-3.9-2-5.6-3.5-2.6-2.2-4.6-4.8-8.1-4.1-3.3.7-6.8.7-10,2-1.5.6-2.9,1.5-4.5,1.8-2,.3-4-.4-5.9-1.2-6-2.3-8.8,4.2-12.7,8.5-2.8,3.1-5.8,6.4-9.8,7.6-6.1,1.8-12.4-1.7-18.6-3-4.3-.9-8.7-.8-12.9-1.7-4.7-1.1-12.4.4-17.3.5-12.6.3-21.9-1-34.5-.7-4.2.1-8.7.1-12.1-2.4-3.5-2.5-4.9-7.1-5.2-11.5-.2-2.8,1.7-11.5-.8-13.3-1-.7-3.1-.2-4.3-.4-2.1-.4-4.1-1.3-5.8-2.6-2.8-2.2-4.9-5.1-7.1-7.8-2.8-3.3-6-6.2-8.5-9.6s-4.5-7.6-4.3-11.9c.2-3.8.9-5.5-1-8.7-1.5-2.7-2.9-5.3-4.1-8.1-1.2-2.9-2.8-6.5-4-9.4.2,0,1.3-.2,1.5-.2.2,0,.3,0,.6-.1.5,1.5,0,3.4,2.1,4.4.1-1,.2-1.9.4-2.9,1,0,.9.8,1.1,1.3.1.5,0,1.1.1,1.5.2.5.7,1.5,1,1.4,1.7-.1,1.9,1.2,2.2,2.2.5,1.6.8,3.4,1.1,5.1.1.5.3,1.1.5,1.6,1,3.5,2.4,6.6,5.3,9.1,1.6,1.4,3.2.8,4.8,1.3.3.1.8,0,1.1,0,.9.1,1.9.3,2.2,1.4,0,.3.4.4.7.7,0,.2.2.3.2.5,0,.2.1.4.2.6,1.2,1.6,2.1,3.3,2.5,5.3.3,1.6,1.4,2,2.9,1.4.6-.2,1.2-.4,1.8-.6.9,1.5,1.8,3,2.8,4.4.5.7,1.2,1.4,1.8,2l.2.3c0,0,.2.2.3.3.6.5,1.2,1,1.8,1.6,1.2,1.3,2.6,2.4,4.3,3.1-.4-.5-.8-.9-1.3-1.6,1-.1,1.7-.2,2.4-.2.4.4.7.3.8-.3.5.2,1,.2,1.4.5,1.6,1.3,3.3,2.6,4.4,4.4.2.3,2.3,2,3.1,1.7,0,0,.2,0,.2.1,1.1,1.9,2.9,2.7,4.8,3.6h.3c-1.7-1.3-1.4-4.2,0-5.7,2.8-3,7.8-2.7,11.4-4,2.7-1,5-2.7,7.7-3.7,8.6-3,18.6-2.7,27.5-4.4,2.5-.5,5.1-1.5,7.5-2.3,4-1.3,8-2.6,11.9-3.9,6.1-2.1,10.2-2.7,16.8-2.6,7.4,0,14.9.3,22.3.5,14.9.5,29.7,1.4,44.6,2.5-3.6-.5-7.2-.2-10.8-.7,6.7-1.8,13.5-2.8,20.4-3.1M47.4,117.4c0,0-.2,0-.2,0s0-.2,0-.2c0,0,.1,0,.2,0,0,0,0,.2-.1.2h0ZM74.6,141.1c-1-.3-2-.6-2.9-1,0,0,0,0,0,0-.4-.2-.6-1.5-1-2.4l1.2-.5c0-.8.6-1.9.9-2.8,0-.1.8,0,1.1.1.6.5,1.2.8,1.9,1.1l-3.9,1.6c0,.1,0,.2,0,.3.4,1.1,1.1,2.4,2.6,2.6,0,0,.1,0,.2.1.2.2.4.4.6.7-.5,0-.7.1-.8,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M295.1,120.1h0c-.1.1-.3.2-.5.2,0,.1-.2.2-.3.3,0,.5-.2.9-.2,1.4,0,1.8,0,3.6,0,5.4,0,.9,0,1.7,0,2.6-.1,1.4-.3,2.9-.5,4.3v4.3c.1,0,.1,0,.1,0-.6.3-1.3.5-1.9.9-1,.5-1.9,1.2-2.9,1.8,0-.1,0-.2,0-.3-.2,0-.3,0-.5,0l-.6-.4c-.7-1.6-3.1-2.6-4.9-2-.9.3-1.6.4-2.4-.3-.5-.5-1.1-.4-1.6,0-.7.6-1.4.8-2.2.3-1-.5-1.9,0-2.7.5-.7.4-1.5.7-2.3,1-.4.2-.9.3-1.3.5-1,.4-1.9.9-2.9,1.3-.1,0-.3,0-.5,0-1.1.2-2.3.2-3.4.5-.4,0-1,.1-1.3.3-.4.3-.2.7-.4,1.1,0,.1-.1.2-.2.3-1.6,1.6-3.8,2.4-6,3.1-.9.3-1.8.5-2.7.7-.3,0-1,0-1.2.3s-.1.5-.2.7c-.3.9-.7,2.4-1.8,2.5-.1-.2-.2-.3-.3-.4-.1-.2-.2-.4-.4-.5,0,.3,0,.6,0,.9-.1.4-.4.7-.7,1-1.9,2.1-5.4,4-7.9,5.2-2.2,1.1-3.6,1.4-5.5,3-1.4,1.1-2.8,2.3-4.4,3-.6.3-1.8.3-2.3.7-.4.3-1.6,2-2,2.4-2,1.7-4.2.3-6.1,2.2-1.2,1.3-3.1,2.5-5.1,1.1-1.7-1.2-3.3.9-5,1.2-1.5.2-9.2-.2-10.1-1,.8-1.2,8.2-4.7,9.2-5.8.8-.9,1.8-1.6,3.1-1.5.8,0,1.5,0,2.2,0,1-2.2,3-2.7,5-2.8.9,0,1-2.1,1.5-1.3.4-.4.7-.8,1.1-1.2,1.2.6.8-.3,1.2-.9.6-1.1,1.8-.8,2.5-1.8.9-1.5,2.2-2.5,3.7-3.6,1.4-1.1,2.9-2.1,4.4-3,.9-.5,1.8-1.1,2.6-1.8.4-.4.8-.9,1.3-1.2.7-.6,1.6-.9,2.5-1.2,1.4-.5,2.7-1,4.1-1.5.9-.3.9-.3,0,0v-.2c1.1-.1,2-.4,3-.9,2.4-1.2,3.1-2.9,5.5-4.1.8-.4,3.2-.5,4-1,.7-.3,1.3-.6,2-.8,1.1-.4,7.4-1.5,8.8-2.2,0,.3,3.1,0,4.6-.4,2.2-.6,4.3-1.3,5.9-3.1.5-.5,1-1,1.5-1.3,2.1-1.4,3.7-3.2,5.2-5.2.9-1.2,2-2.2,3.2-3.1,1.5-1.2,3-2.1,4.5-3.2.5-.4,1-.9,1.5-1.3,0,.1.1.2.1.3,0,.3,0,.7,0,1,0,1,0,1.9,0,2.9.2,0,.4,0,.6,0,0,.2,0,.3.1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M293.8,177c-.3-.7-.6-1.3-1-1.6-.1-.1-.3-.1-.4-.2-2.2-.7-1-4.8-4.4-3.6-.4.1-.9,0-1.3,0-1.3-.2-3.9-.9-4.4-1.5-1.1.7-2.1-2.8-2.2-3.1-1.6,0-1.9.7-1.9-.9,0-.6-1.2-1.2-1.8-1.6-.6-.4-1.6,0-2.3,0-.3,0-.7.1-.9,0-.5-.3-1-1-1.6-1.1h0c-2.5,0-5.1,0-7.6,0-1.3,0-2.6.2-3.8.5-.6.1-1.2.2-1.8.4s-.9.4-1.6.4c-.3,0-.5,0-.8,0-.1,0-.3.2-.4.2-.2.2-.5.3-.7.5-.4.3-.6.6-1,.8-.5.3-1,.5-1.4.8-.9.6-1.9,1.1-2.8,1.7-1.8,1.1-3.7,2.2-5.7,3.1-9.8,4.2-20.5,6.4-31.1,6.3-12.8,0-25.4-3.2-38.1-4.6-9.7-1.1-19.4-1.2-29.1-1.3-42-.3-84,0-125.9.7-2.8,0-5.7.1-8.5.7-6.5,1.5-11.9,5.9-16.6,10.6-6.3,6.2-11.9,13.1-16.7,20.5-5.5,8.5-5.8,13.3-4.2,23.5.4,2.5,1,5.2,2.7,7.1,2.4,2.6,6.2,3.1,9.7,3.3,12.3.6,24.6-.7,36.8-.3,14.3.4,28.5,3,42.8,4.2,23.2,1.9,46.6,0,69.7,2.2,20.2,1.8,40,6.5,60.2,8.1,19.1,1.5,38.3.1,57.4.4,12.4.2,24.9,1,36.9-2.1,2-.5,4.1-1.2,5.3-2.9,1-1.4,1.2-3.3,1.4-5.1,1.1-14.7,1.4-29.6.5-44.3-.2-3.4-1-17-3.1-22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M305.6,105.6c-1.1-.9,0-1.6.2-2.3,0-.4-.2-.8-.2-1.2,0-4.7,0-9.5,0-14.2,0-1.6.2-3.3.2-4.9,0-3.5-.2-7.1-.2-10.6,0-5.2,0-10.4,0-15.5,0-2.2,0-4.3,0-6.5v-.5c0-3.7-.1-7.4-.2-11.2-.1.6-.3,1.2-.3,1.8,0,1,0,1.9,0,2.9-.1,0-.2,0-.3,0-.1-.5-.2-1.1-.5-1.6,0-.2-.4-.4-.5-.6-.1.3-.3.5-.4.8s-.1.6-.2.9c-.2-.1-.4-.2-.6-.4-.1,17.1-.3,34.1-.4,51.2,0,0,0,0,0,0-.1-.8-.3-1.7-.3-2.5,0-3,0-6,0-8.9,0-3.1.2-6.2.2-9.4,0-1.2,0-2.4,0-3.4-.9.2-1.6.4-2.5.6.1-1,.2-1.7.2-2.5,0-1.6-.8-2.2-2.3-1.7-.6.2-1.2.6-1.9.8-.4.1-.9.2-1.3.3,0,5.4,0,10.8-.1,16.2,0,.5,0,1,0,1.6v.8c0,3.8.1,7.7.1,11.5,0,2.5,0,4.9,0,7.4,0,.9.1,6.3,0,8.4-.3,1.1-.3,2.2-.1,3.2.2,1.4.9,2.8.4,4.1-.3.7-.8,1.3-1.1,2.1-.2.7-.1,1.5,0,2.3.4,3,.9,6,1.3,9,.3,2.2.6,4.4.6,6.6,0,3.4-1,6.6-1.6,9.9-.6,3.2-.2,6.1-.1,9.3,0,2.2,0,4.5,0,6.7,0,3.5.2,7,.2,10.4,0,2,0,3.9.1,5.9v6c0,.4-.2,2.3-.2,2.9v1c0,5.3,0,10.6,0,15.9,1.8.1,3.6.3,5.4.4,0-2.8.1-5.7,0-8.5-.2-3.1-.1-6.3-1.1-9.4-.3-.9-.2-1.9-.4-2.8-.6-3.7,0-7.3,1.1-10.9-.9.7-1.8,1.3-2.7,2,0,0-.2,0-.2-.1.1-.4.2-.7.4-1,.3-.5.7-1,1.1-1.4,1.4-1.2,1.6-2.7,1.6-4.5,0-4.3.2-8.7.4-13,.1-3.3,1-7.3.1-10.6-.4-1.2-.9-2.4-1.3-3.7-.5-1.9-.4-4-.2-5.9.4-4.8,1.1-9.6,1-14.5,0-3.3-.6-6.7-1.8-9.8,1.4-.5,2.7-1,4.1-1.5,1.4-.6,2.9-1.2,4.3-1.8.7-1.9.5-3.8,0-5.7h0ZM302.2,98s0,0-.1,0v-1.7h.1v1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M294.2,67.1c0,5.4,0,10.8-.1,16.2,0,.5,0,1,0,1.6h-2c0,.5-.1,1.1-.1,1.4-.7.3-1.3.4-1.8.7-1,.5-1.9,1.3-3,1.7-1,.4-2.1.5-3.2.7-.3,0-.7.2-1,.2-2.3-.3-4.5.5-6.9-.6-1.5-.7-3.4-.5-5.1-.6-.2,0-.5.1-.7.3-1.2.7-2.5.9-3.8.7-.6-.1-1,0-1.5.4-.9.7-1.8,1.5-2.8,2-1.4.6-2.4,2-4.1,1.8,0,0-.1.1-.2.2-.7,1.3-2.1,1.3-3.3,1.7-.5.2-1.1.4-1.5.8-1.6,1.4-3.1,3-4.8,4.4-.7.6-1.6,1.5-2.3,1.4-1.5-.2-2.7.4-3.6,1.2-1.8,1.5-3.8,2.2-5.9,2.8-1.1.3-2.2.8-3.3-.2,0,0-.2,0-.5.1.1.4.3.8.5,1.4-.6,0-1.1.2-1.5.1-.9-.2-1,.2-.9.9-.3,0-.6-.2-.9-.3.2-1.5.5-2.3-1.1-2.7-1.4-.4-3-.5-4.4-.9-.6-.2-1.2-.4-1.8-.6-.8-.2-1.7-.3-2.6-.4-3.3-.3-6.6,0-9.9-.2-2.1-.1-4.2-.4-6.2-1.1-.9-.3-2-1.1-2.9-1.3-.8-.1-1.8.6-2.6.9-4,1.7-8,3.5-12.2,4.3-1.8.4-3.7.6-5.5,1.1-1.9.6-3.7,1.6-5.6,2.2-4,1.3-7.6.4-11.6.2-2.9-.1-4.3,1.3-7.3,1.2-2.3-.1-6-1.5-8.1-.6-1.1.4-2,2.7-3.4,3.4-10,4.9-20.8,8.2-31.8,9.6-4.9.6-9.9.9-14.5,2.5-4.2,1.5-8.4,4.1-12.8,3.8-4.5-.4-8.1-3.6-11.4-6.7-1.5-1.4-3.1-3.2-2.7-5.3.4-1.5,1.7-2.4,3.1-3.1,5.7-2.9,12.2-3.6,18.6-4.2,6.6-.7,13.1-1.3,19.7-2,5-.5,12,.4,16.6-2,.7-.4,1.4-.8,2.1-1.1.9-.3,1.9-.3,2.9-.4,3.2-.2,6.4-1,9.4-2.4,3.5-1.7,6.1-1.7,9.8-1.6.5,0,1-.4,1.4-.6,1.2-.6,2.4-1.1,3.6-1.7.4-.2.8-.5,1.2-.7.5-.3,1-.8,1.5-1,2-.7,4-1.3,6-1.8,2.3-.6,4.7-1.1,7.1-1.6.5-.1,1.1-.2,1.5-.4,1.3-.9,2.9-1,4.4-1.1,2.9-.3,5.7-.8,8.5-1.5,5.9-1.5,11.7-3.9,17-6.9,3.5-2,10.6-6.7,17.4-9.2-3.7,0-7.4,0-11.1,0-.2,0-.3-.1-.5-.2-.3,0-.7-.1-1-.2,0,0-.2,0-.2-.1-.3,0-.5,0-.8-.1-.5,0-1,0-1.5-.1.2-.2.4-.6.5-.5,1.3.1,2.4-.1,3.6-.5,1.1-.3,2.2-.6,3.3-.5,2.2.2,4.2-.7,6.3-1,.7-.1,1.3-.1,2-.3,1.1-.3,2.3-.5,3.4-.8,1.2-.3,2.4-.7,3.6-1.1,0-.2,0-.3-.1-.5-.3,0-.6,0-1,0-.4.1-.9.5-1.3.5-.9.1-1.8,0-2.7.2-1.1.3-1.6-.2-2-1.1-.2-.5-.2-1-.3-1.5h-1c.2-.3.4-.5.7-.6,2.5-1.1,4.9-2.1,7.4-3.1,4.5-1.8,8.9-3.8,13.7-4.8,5.7-1.3,11.4-2.7,17.1-4,.4,0,.7-.3,1.1-.4.8-.3,1.5-.5,2.3-.8-.1,1.4-1.1,1.7-2.3,2.1.4.2.7.3,1,.2.4-.1.7-.4,1.1-.5,1.8-.3,3.6-.6,5.4-.9.2,0,.5.2.8.3-.2.3-.3.6-.5.8-.2.2-.6.3-.8.5,1.9.5,3.7.9,5.5,1.4-.8.4-1.8.7-2.5,1.2-3,2.1-6.7,2.2-9.9,3.9-1.6.8-3.5,1-5.2,1.5-1.2.3-2.4.7-3.7,1.1-3.4.9-6.8,1.8-10.2,2.7-.5.1-1.1.5-1.3.9-.2.3,0,1.1.3,1.4.5.6.7,1.1.4,1.9-.1.4,0,.9,0,1.4,0,1.3.9,1.8,2.2,1.6,1.4-.3,2.8-.5,4.1-.4,1.5.1,2.9.6,4,1.7,1.8,1.8,1.4,1.8,3.2,0,.1-.1.2-.3.4-.4,1.5-1.5,3.2-2.6,5.3-2.8,1.1-.2,2.1-.3,3.1.7.7.7,1.6,1.2,2.6,1.9.1-3.2,1.6-5.4,3.8-7.1,1.5-1.1,2.3-2.6,2.9-4.3,0-.2.3-.4.5-.6.1.5,0,.8,0,1.2-.3,1.1,0,1.5,1.2,1.3.5-.1,1.1-.3,1.6-.4,1-.2,1.8,0,2.4.8.7,1.1,1.8,1,3.1,1.2-.8-.8-1.5-1.4-2.1-2-.1-.3-.2-.7-.4-1-.8-1.2-.5-3.1.6-3.9.2-.1.4-.2.6-.2,1.4,0,2.8.1,4.2.2,1.4.1,2.7-.9,2.7-2.4,0-1.5,0-2.9,0-4.4,0-1,.3-1.8,1.5-1.8.3,0,.5-.3.8-.5.3-.2.5-.6.9-.7,1.1-.5,1.7-1.6,1-2.5-.7-.9-.5-1.9-.6-2.9,0-.6-.2-1.3-.3-1.9,0-.2.1-.5.3-.6,2.2-1.4,1.4-3.6,1.5-5.6-.5,0-.8,0-1,.2-1.3.4-2.6.8-3.9,1.1-3.9.8-7.9,1.8-11.8,2.4-3.7.6-7.4.9-11.1,1.2-1.4.1-2.9,0-4.4,0-.8,0-1.5,0-2.3,0,0-.4.2-.7.3-1,1.2-.2,2.4-.3,3.6-.5.2,0,.3,0,.5,0,.2,0,.3,0,.5,0,.2,0,.4-.2.5-.3,1.2-.2,2.4-.4,3.6-.5,1.5-.2,3-.4,4.5-.6,2.3-.4,4.6-1,7-1.2,3.5-.2,6.5-1.5,9.5-3.2,1.5-.8,2.9-2.2,4.9-1.6,0,2.9,0,5.9.1,8.8,0,8.2.1,16.5.2,24.7,0,.6,0,1.1.1,1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M294,84.9v.8c-.9.9-2,1.6-2.6,2.9-.1.4-.4.8-.8,1-2,1.2-4.2,2.2-6.6,2.6-1,.2-2,.5-2.9.9-1.7.7-1.7.8-3.2,0-1.1.6-2.1,1.3-3.2,1.8-.8.4-1.4.8-1.6,1.9-.2,1-1.2,1.3-2.2,1.3-1.8,0-3.6,0-5.1,1.3-.3.2-.6.5-.7.8-.5,1.3-1.4,2-2.7,1.6-1-.3-1.8,0-2.5.5-1.4.9-2.8,1.5-4.5,1.2-.6-.1-1.4.3-2.1.5-1.3.4-2.5,1-3.8,1.3-.7.2-1.5-.2-2.2-.2-.9,0-1.8,0-2.6.2-6.7,1.7-12.3,4.2-18.5,7.2-7.3,3.6-16.3,5.4-24.3,7.1-6,1.2-12.1,2-18.3,1.6-2.5-.2-6.2-.1-8.2-1.6-1-.7-1.8-3.3-2.7-3.2-1.3.2-2.6.3-3.8.5-.3,0-.6,0-.8.3-1.1.9-2,.8-2.9-.3-.1-.2-.3-.4-.4-.6-1.2-2.6-3.5-4.1-5.9-5.5.6-1.4,1.6-1.9,3.1-1.8,2,.1,4,0,6,0,1.2,0,2.3-.4,3.2-1,.7-.4,1.3-1,2-1.3,1.5-.5,3.1-.9,4.7-1.3.7-.2,1.2-.3,1.3-1.2,1.3,0,2.4-.9,3.4-1.9.5-.2,1-.5,1.5-.7.7-.3,1.3-.6,2-.9.6-.3,1.2-.5,1.8-.8.4-.2.9,0,1.4,0,4,.3,7.8-.2,11.9-.7,1.8-.2,3.6-.4,5.4,0,.9.2,1.7.6,2.5,1,6.9,2.5,13.2-1.2,20.1-1.3,4.8,0,9.5.5,14.3-.1,4.1-.5,7.4-3.3,11.3-4.5s6.8-2,10.2-4.8c.5-.4.8-.5,1.5-.4,1.3.2,2.6,0,3.8-.7.2-.1.5-.3.7-.3,1.7.2,3.6,0,5.1.6,2.3,1.1,4.6.4,6.9.6.3,0,.6-.1,1-.2,1.1-.2,2.2-.3,3.2-.7,1.1-.4,2-1.1,3-1.7.5-.3,1-.4,1.8-.7,0-.3,0-.9.1-1.4h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M182.6,153.4c1.3-.1,2.6-.4,3.6-1.1.6-.4,1.3-1,2.1-1,1.4,0,2.3,1.4,3.7,1.6,2.1.3,3.4-2.5,5.5-3,.9-.2,1.9,0,2.8.1,2.4.2,4.8-.8,7-1.8,1.2-.5,2.5-1.1,3.6-1.8,1.6-1,3-2.4,4.7-3.3,4.6-2.3,10.2-.5,15-2.3,2.7-1,4.8-3.1,7.3-4.4,2.6-1.4,5.5-1.9,8.3-2.5,3.8-.7,7.6-1.5,11.5-2.2,4.4-.8,9.4-1.6,13.1,1.1-1.6,1.3-3.9.7-6,.7-5.3,0-9.2,4.8-13.8,7.6-3.5,2.2-7.6,3.3-11.4,5-5.1,2.2-9.7,5.4-14.1,8.8-1.9,1.5-4,3.9-6.2,4.7-.9.4-2,.2-3,.7-.4.2-2,2.1-2,2.1-.7,0-1.5,0-2.2,0-3.7-.3-2.8,4-4.1,5.7-2.3,3.1-5.1,2.1-8.2,1.7-3.4-.5-6.3.2-10,.5-1.2.1-2.5.2-3.7,0-1.3-.2-10.6,1.4-11.9.9-1.7-.6-12.1-5.4-12.1-3.5.5-3.1,2.4-6,5.1-7.6,1.2-.7,2.6-1.2,3.6-2.3.8-.9,1.1-2,1.9-2.9,2-2.5,6.1-1.6,9.7-1.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M304,159.7c-.9,2.8-.8,5.7-1,8.6,0,.3-.2.6-.3.8-.1,1-.3,2.1-.5,3.1-.2,1.4-.4,2.8-.6,4.5-.5-.5-.9-.8-1.3-1.1-.6.5-1.1,1-1.6,1.5-.9.7-1.8,1.3-2.7,2,0,0-.2,0-.2-.1.1-.4.2-.7.4-1,.3-.5.7-1,1.1-1.4,1.4-1.2,1.6-2.7,1.6-4.5,0-5.9.4-11.9.6-17.8,1.1.2,1.7-.4,1.7-1.5,0-.9.5-1.2,1.3-1.3,2.1-.3,2.2-.3,2.1,2,0,.8-.2,1.7-.2,2.5,0,.2,0,.6.1.7,1,.6.4,1.1,0,1.7-.2.4-.3.8-.4,1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M297,148.2c.6-.5,1.2-1.1,1.9-1.6,1.7-1.4,3.4-2.7,5.1-4.1.2-.2.4-.4.6-.6h0c.7-.4,1.4-.8,2-1.2.9-.5,1.7-.9,2.6-1.4-.2.5-.3,1.2-.7,1.6-.8,1-.1,1.3.7,1.5-3.7,3.1-7.4,6.2-11.1,9.3,0-.4,0-.7.1-1.1-.4-.3-.8-.7-1.2-1-.2-.1-.5,0-.8,0,.2-.5.5-.9.7-1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M297,148.2c-.2.5-.5.9-.7,1.4-1.6,2.5-3.5,4.7-5.8,6.6-.9.7-1.6,1.8-2.4,2.7-1.9,2.1-3.7,4.2-5.6,6.4-.7.8-1.4,1.7-2.1,2.5-.2.2-.4.3-.7.5-.7-.4-.5.2-.6.5,0,0,0,.2,0,.3-.2-.4-.4-.7-.5-1.1.9-.9,1.7-1.7,2.6-2.6,1.1-1.1,2.1-2.2,3.2-3.3.9-1,1.7-2.1,2.5-3.1.8-.9.8-1.2-.1-2.1-.1-.1-.2-.3-.2-.4.8-.9,1.7-1.8,2.5-2.7,1.5-1.3,2.8-2.7,4.4-3.8,1-.8,2.4-1.1,3.5-1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M288.1,158.9c.8-.9,1.5-2,2.4-2.7,2.3-1.9,4.2-4.1,5.8-6.6.3,0,.6-.1.8,0,.4.3.8.7,1.2,1,0,.3,0,.7-.1,1.1-.8.8-1.7,1.5-2.5,2.3s-1.3,1.4-1.9,2.2c-.5.7-1.1,1.2-2.1,1.2-.5,0-1.2.4-1.6.9-.6.7-1.1.9-2,.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M296.9,134.9c-.3,0-.6-.1-1-.2.2-1.1.7-1.7,1.5-2.2,2.6-1.6,5.5-1.8,8.4-2.3.6-.1,1.1-.9,1.9-.9s.7,0,1,0c-.8.6-1.5,1.2-2.3,1.8-2.5.9-5,1.8-7.4,2.8-.7.3-1.4.7-2.1,1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M309.8,155.6c0,.3.1.5.2.8-.3.5-.6,1-.8,1.6-.2.6-.2,1.2-.3,1.9-1.4-.4-2.8-.5-2.9-2.2.5-1.9,1.9-3.1,3.7-3.2,0,.4,0,.8.1,1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M299.2,208.7c0-2.8.1-5.7,0-8.5-.2-3.1-.1-6.3-1.1-9.4-.3-.9-.2-1.8-.4-2.8.4.4,1,.8,1.2,1.3.5,1.4.6,1.5,1.9.7.5-.3,1.3-.4,1.9-.3.3,0,.5.9.6,1.4.1.5,0,1.1,0,1.7,0,1.2.4,1.6,1.5,1.8.3,0,.7,0,1,0,0,4,0,8,0,12v2.6h-.5c-.2,0-.3,0-.5,0-1.9-.1-3.8-.3-5.6-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M294,127.4c.7-.7,1.4-1.6,2.2-2.2.6-.4,1.4-.6,2-1,.3-.2.7-.5.8-.8.3-.8.8-.9,1.6-1,1-.1,2-.5,3-.7,1.2-.2,2.4-.4,3.6-.5.3,0,.6.4.9.7,0,.1,0,.2-.1.3-.5,0-1-.2-1.4-.2-.5,0-1.2-.2-1.1.8l-.3,1.8c-.4.2-.9.3-1.3.5-2.6,1.3-5.2,2.5-7.8,3.8-.8.4-6.5,3.6-7.2,3.9,0-.9,5-4.6,5-5.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M294,129.9c.8-.3,1.5-.7,2.3-1.1,2.6-1.3,5.2-2.6,7.8-3.8.4-.2.9-.3,1.3-.5,0,.2.1.3.2.4-.5,1.3-1.3,2.1-2.7,2.4-2.9.6-5.4,2-7.8,3.6-.4.3-3,1.6-3.4,1.8,0-.5,2.2-2.3,2.3-2.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M294.3,119.6c0-1,0-1.9,0-2.9,0,1,0,1.9,0,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M295.1,120.1c0-.2,0-.3-.1-.5.4,0,.8,0,1.1,0,0,0,0,.2,0,.2-.4.1-.7.2-1.1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M302.9,3.1c0,.3-.1.6-.1.9v.2c.1.7.3,1.9.5,3V3.1h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M293.5-17.2c-4,.8-7.9,1.7-12.2,2.5.4.3.6.4.7.6,0,.2,0,.5,0,.7,0,.1-.4.2-.5.1-1.3-1.1-2.6-.6-4-.4-1.5.3-3,.6-4.5.8,0,.1-.2.2-.2.2.3.7-.7,1.7.4,2.2,1.4.6,2.9.7,4.1-.4.7-.6,1.4-.8,2.3-.8.7,0,1.4-.4,2.2-.6,0,.3,0,.5-.1.6-1.5,1-3.1,2-4.6,3-.4.2-.7.5-1.1.6-.6.3-1.2.5-1.9.6-2.4.4-4.8.8-7.3,1.2,1.6,1.2,1.8,2.4,1,3.9-.5.9-1.1.7-1.9.1-1.1.9-2.2,1.7-3,2.8-.5.7-1,1-1.6,1.2-1.2.3-2.8-1-3.2-2.2-.3-1-.9-1.9-1.5-2.7-.8-1.2,0-3.5,1.3-4,.3-.1.6-.2,1-.3,1.3,0,2.2-1,3-1.8.4-.4.4-1.6.2-2.2-.1-.4-1.1-.6-1.7-.6-1.1,0-2.2.3-3.2.4-.4,0-.9-.3-1.3-.5-.6-.4-.6-.8-.1-1.3,1.3-1.5,3-1.9,4.9-2.2,3-.4,5.9-1.2,8.9-1.7,5-1,10-1.9,15-2.9,1.6-.3,3.2-.8,4.8-1.3.4-.1.6-.5.9-.7-.2-.2-.4-.5-.6-.7-.2-.3-.4-.5-.7-.9,1-.7,2.5-.7,2.2-2.4,1.6.9.6,2.5,1.2,3.5.1,0,.2,0,.4,0,.2-.8.5-1.5.5-2.3,0-3.2,0-6.5,0-9.7,0-1.7.2-3.4.2-5.1,0-.8-.2-1.6-.2-2.4,0-1.6.2-3.2.2-4.8,0-1.4-.9-1.9-2.1-1.3,0,0,0,0-.1,0-2.4.5-4.5,2.1-7.1,2-1.6,0-3.1.1-4.7.3-.2,0-.4.2-.6.2-1.7.3-3.5.6-5.2.9-4,.8-8,1.6-12,2.4-.8.2-1.6.3-2.5.5-.9-.3-1.8-.5-2.9-.8.3-.7.5-1.5.8-2.3,0,0,.2,0,.2,0,.3,0,.5-.2.8-.2.9-.3,1.7-.7,2.6-.9,1.6-.3,3.2-.5,4.9-.7,5.6-.9,11.2-1.9,16.8-2.8,1.7-.3,3.4-.5,5.1-.8,2.1-.4,4.1-.9,6.2-1.3.1,0,.3,0,.4,0,0,.6,0,1.1.1,1.7h0c0,3.2,0,6.4-.1,9.6,0,1.6-.2,3.3-.2,4.9,0,4.3,0,8.5,0,12.8,0,1.8-.2,3.5-.3,5.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M294,20.8c0,0,0,.2-.1.3-4,.9-8.1,1.9-12.1,2.8-3.1.6-6.2,1.1-9.2,1.6,0-.1-.3-.3-.3-.4,0-1.7-.9-2.9-2.3-3.7,2.3-.6,4.7-1.2,7-1.8,4.2-1.1,8.5-2.4,12.7-3.5,1.3-.4,2.7-.5,4.1-.7.1,1.8.2,3.6.3,5.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M307.3,42.4c.2-.4.3-.9.5-1.3.2.1.6.3.6.3-.1.4-.3.8-.5,1.2-.2,0-.4-.1-.5-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M305.6,56.8c0-2.2,0-4.3,0-6.5.2.2.5.5.5.7,0,1.7,0,3.4,0,5.1,0,.2-.3.4-.5.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M286.9,142.9c.3-.7.7-1.4,1-2,.2,0,.4,0,.5,0,.1,0,.3,0,.5,0,0,.1,0,.2,0,.3-.7.6-1.4,1.2-2,1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M288.9,140.8c-.1,0-.3,0-.5,0,.1,0,.3,0,.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M294.6,120.3c0,0-.2.2-.3.3,0,0,.2-.2.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M306.4,190.4c-.2,1.4-.4,2.8-.5,4.1-.3,0-.7,0-1,0-1.1-.1-1.5-.6-1.5-1.8,0-.6,0-1.1,0-1.7-.1-.5-.3-1.3-.6-1.4-.6-.1-1.4,0-1.9.3-1.2.8-1.4.7-1.9-.7-.2-.5-.8-.9-1.2-1.3-.6-3.7,0-7.3,1.1-10.9.5-.5,1-1,1.6-1.5.4.3.7.6,1.3,1.1.2-1.6.4-3.1.6-4.5.1-1,.3-2.1.5-3.1,0,3-.1,6-.2,9,0,.4,0,.9,0,1.3,0,.2.3.3.5.5,1.4-.3,2-1.6,2.6-2.7,1.1-.2,1.3.9,1.8,1.4.7.5,1.4,1.1,2,1.6-.1.4-.2.8-.3,1.3-.3.3-.7.5-.9.9-1.5,2.4-1.7,5.2-1.9,8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M279.2,168.8c0-.3-.1-.9.6-.5-.2.2-.4.4-.6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M305.6,177.2c-.6,1.2-1.1,2.4-2.6,2.7,0-1.3.2-2.6.3-4,0-1.2.6-2.1,1.4-2.9s.8-.5,1.1-.4.5.7.5,1c0,1,.5,2.2-.7,3,0,0,0,.3,0,.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M307.6,165.2c0,.4-.2.8-.2,1.3,0,.6,0,1.3.1,1.9.1.9.3,1.8.4,2.7,0,.9-.8,1.3-2.4,1,.3-1.4.6-2.7.8-4.1.4-.9.9-1.8,1.3-2.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M307.6,165.2c0,0,0-.2,0-.2,0,0,0,.2,0,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M284.8,157.7c-1.1-.4-1.5-1.3-.8-2.2.7-1,.8-2.1,1-3.2.3-.3.6-.6.8-.9.4-.7.7-1.6,1.2-2.2,1.1-1.1,2.3-2.1,3.4-3,0-.8,0-1.5.1-2.2.5-.4,1-.8,1.5-1.1.4-.2,1-.2,1.3,0,.2.2.2.9,0,1.2-.2.5-.6.9-1,1.3-1.8,1.7-3.6,3.3-5.3,5-.2.2-.2.7,0,1,.2.4.5.8.8,1.1,0,.2-.2.4-.2.5-.1.2-.2.3-.3.5-.6.6-1.3,1.1-2,1.7-.9.7-1.4,1.4-.5,2.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M287.4,153.5c.1-.2.2-.3.3-.5.2-.2.3-.4.5-.5,1.4-1.6,2.7-3.3,4.2-4.8.6-.6,1.4-1,2.2-1.5.6,1.2-.3,1.8-1,2.4-1.4,1.4-2.9,2.7-4.3,4.1-.2.2,0,.7,0,1-.8.9-1.7,1.8-2.5,2.7-.2.2-.5.3-.7.5.1-.4.3-.8.4-1.1.3-.8.7-1.5,1-2.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M290.7,143.9c0,.7,0,1.4-.1,2.2-1.1.9-2.3,1.9-3.4,3-.6.6-.8,1.5-1.2,2.2-.2.4-.5.6-.8.9-.6-1.5-.3-2.9.8-4.2,1-.9,1.9-1.9,2.9-2.8.7-.4,1.4-.9,2-1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M288.7,145.3c-1,.9-1.9,1.9-2.9,2.8-1.9.3-2.1.2-2.7-1.5,0-.2-.1-.4,0-.6.2-.8,3-3,3.8-3-.6.6-1.2,1.3-1.8,1.9,0,0-.2.1-.3.2-.7.6-1,1.5-.4,2,.7.6,1.2,0,1.6-.5.7-1,1.7-1.2,2.8-1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M295.1,145.8c-.2.2-.4.3-.6.5.2-.2.4-.3.6-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M288.1,152.5c-.2.2-.3.4-.5.5,0-.2.2-.4.2-.5h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M295.8,145.3c-.1,0-.2.2-.3.2.1,0,.2-.2.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M304.6,141.9c-.2.2-.4.4-.6.6.2-.2.4-.4.6-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M302,98v-1.7h.1v1.7s0,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M293.5-17.2c-4,.8-7.9,1.7-12.2,2.5.4.3.6.4.7.6,0,.2,0,.5,0,.7,0,.1-.4.2-.5.1-1.3-1.1-2.6-.6-4-.4-1.5.3-3,.6-4.5.8,0,.1-.2.2-.2.2.3.7-.7,1.7.4,2.2,1.4.6,2.9.7,4.1-.4.7-.6,1.4-.8,2.3-.8.7,0,1.4-.4,2.2-.6,0,.3,0,.5-.1.6-1.5,1-3.1,2-4.6,3-.4.2-.7.5-1.1.6-.6.3-1.2.5-1.9.6-2.4.4-4.8.8-7.3,1.2,1.6,1.2,1.8,2.4,1,3.9-.5.9-1.1.7-1.9.1-1.1.9-2.2,1.7-3,2.8-.5.7-1,1-1.6,1.2-1.2.3-2.8-1-3.2-2.2-.3-1-.9-1.9-1.5-2.7-.8-1.2,0-3.5,1.3-4,.3-.1.6-.2,1-.3,1.3,0,2.2-1,3-1.8.4-.4.4-1.6.2-2.2-.1-.4-1.1-.6-1.7-.6-1.1,0-2.2.3-3.2.4-.4,0-.9-.3-1.3-.5-.6-.4-.6-.8-.1-1.3,1.3-1.5,3-1.9,4.9-2.2,3-.4,5.9-1.2,8.9-1.7,5-1,10-1.9,15-2.9,1.6-.3,3.2-.8,4.8-1.2.4-.1.6-.5.9-.7-.2-.2-.4-.5-.6-.7-.2-.3-.4-.5-.7-.9,1-.7,2.5-.7,2.2-2.4,1.6.9.6,2.5,1.2,3.5.1,0,.2,0,.4,0,.2-.8.5-1.5.5-2.3,0-3.2,0-6.5,0-9.7,0-1.7.2-3.4.2-5.1,0-.8-.2-1.6-.2-2.4,0-1.6.2-3.2.2-4.8,0-1.4-.9-1.9-2.1-1.3,0,0,0,0-.1,0-2.4.5-4.5,2.1-7.1,2-1.6,0-3.1.1-4.7.3-.2,0-.4.2-.6.2.4.1.8.3,1.2.4.5,0,1,0,1.3.1,0,1.3,0,2.6-.3,3.7-.4,1.7-.9,3.5-1.7,5-.4.7-1.8,1-2.7,1.4-.5.2-1.3-.2-1.4.7-.1.8-.2,1.7,1,1.9,0,0,.1.1.3.4-1.2.4-2.3.9-3.5,1.1-1.2.2-2.1.5-2.7,1.7,0,.2-.1.4-.3.4-1.8.9-1.3,2.5-1.3,3.9,0,1.7-1.2,3.1-2.8,3.3-1.8.2-3.6.6-5.4.8-1.1.1-1.7.8-2.3,1.7-1,1.5-2,2.9-3.1,4.2-.4.5-1,.5-1.2,0-2.5.7-4.9,1.4-7.3,2-2.3.6-4.6,1-7,1.4-2.4.4-4.9.8-7.3,1.2-.3,0-.6,0-.9.2.2.9.6,1.4,1.5,1.4,4,0,8.1,0,12.1-.6,3-.4,5.9-.8,8.7-1.9.1,0,.2,0,.6.1-1.1,2.6-1.1,5.1.5,7.5-1.4,2.4-4.6,2.2-6,4.4.6,1.5.5,1.4-.9,2-3,1.2-6,1.8-9.1,2.4-1.1.2-1,1.4-1,2.2,0,.9,0,1.7-1.2,2-.1,0-.3.2-.4.3,0,0-.1.2,0,.6.5-.2,1-.5,1.6-.7,2.2-.7,4-2.4,6.6-2.5,2,0,4-.7,5.9-1.7,1.5-.7,3.1-1.1,4.7-1.6.2,0,.5,0,.8,0,.4,0,.8.2,1.3.3-.2.4-.3.8-.5,1.2.7.3,1.6.5,2.4.9,1,.6,1,1.8.3,2.8-1.2,1.5-2.5,2.7-4.5,2.6-.4,0-.8.3-1.1.6-.9.9-1.6,1.8-2.7,3,.6.1,1,.3,1.5.3,1.3-.2,2.4.5,3.5,1,.5.2.6.7.1,1-.9.5-1.8.9-2.8,1.2-2,.6-4.1.9-6.1,1.6-2.3.9-4.5,2-6.8,3.1-.2,0-.2.3-.4.5.9.4,1.5,0,2.1-.4.5-.3,1-.5,1.5-.7.7-.3,1.4-.4,2.1-.7.2,0,.3-.2.5-.2,1.6,0,3-.5,4.3-1.6.2-.2.7,0,1.1-.1,1-.1,2-.3,3-.4.8-.1,1.5-.2,1.6.7-.6.8-1.2,1.5-1.7,2.1,1.2-.6,2.4-1.2,3.5-1.9,2.6-1.6,5.4-1.5,8.2-.7,1.4.4,2.8,1,4.1,1.6,2.3-.6,4.7-1.2,7-1.8,4.2-1.1,8.5-2.4,12.7-3.5,1.3-.4,2.7-.5,4.1-.7,0-10.9-.2-21.7-.2-32.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M257.6,20.5c-1.1.7-2.4,1.3-3.5,1.9-.2,0-.3.2-.5.3-.1.2-.2.5-.4.6-1.5.9-3,1.7-4.5,2.5-.5.8-1,1.6-1.5,2.3.1.2.3.5.5.7-1.1,1.4-2.9,1.6-4.4,2.1-3.6,1.1-7.3,2-10.9,3-2.7.7-5.4,1.5-8,2.2-.3,0-.6.3-.9.4-.5.2-1,.5-1.8.8-.2.5.4.5,1,.5,5.8.1,11.4-1.3,17-2.7,2.3-.6,4.6-1.3,6.9-2,.4-.1.8-.2,1.2-.3.1.2.2.3.2.4.1,1.8.9,3.1,2.9,3.2.4,0,.9,0,1.3,0,.4-.2.7-.3,1.1-.5.3,0,.7,0,1,0,.6-.3,1.1-.6,1.7-.8,3.6-1.1,7.2-2.2,10.8-3.3.8-.3,1.5-.7,2.4-.8,1.1-.3,1.9-.8,1.6-2,.6,0,1.3.1,1.6-.2.3-.4.3-1.1.4-1.6,0-.6,0-1.2,0-1.8,0-.1-.3-.3-.3-.4,0-1.7-.9-2.9-2.3-3.7-1.4-.5-2.7-1.2-4.1-1.6-2.8-.8-5.6-.9-8.2.7h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M299.9,24.7c0,.1.1.2.2.3-.1,0-.2.2-.3.1,0,0-.1-.2-.2-.2.1,0,.2-.1.3-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M302.1,32.3c0,0-.1,0-.2,0,0,0,0-.2,0-.2s.1,0,.2,0c0,0,0,.1,0,.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M279.1,148.7c.4.2,1.1.3,1.7.7.4.3.7,1.2.5,1.5-.3.6-1,1.3-1.6,1.4-.9.1-1.9-.2-2.8-.5-.8-.3-1.2-1-1-2,.2-1,.8-1.2,1.7-1.1.4,0,.8,0,1.6-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M287.4,153.5c-.4.8-.7,1.5-1,2.3-.2.4-.3.8-.4,1.1h0c-.2.2-.5.4-.8.6,0,0-.2,0-.3.1-.8-1.1-.4-1.8.5-2.5.7-.5,1.3-1.1,2-1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M285.1,157.6c.2-.2.5-.4.8-.6-.2.2-.5.4-.8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M309.8,179.7c-.1.2-.2.4-.4.5.1-.2.2-.4.4-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M280.7,64.1c.6.6,1.3,1.2,2.1,2-1.3-.2-2.4-.1-3.1-1.2-.6-.8-1.5-1-2.4-.8-.5.1-1.1.3-1.6.4-1.2.2-1.5-.1-1.2-1.3,0-.4.2-.7,0-1.2-.2.2-.4.4-.5.6-.6,1.7-1.4,3.1-2.9,4.3-2.2,1.7-3.7,3.9-3.8,7.1-1-.7-2-1.2-2.6-1.9-.9-1-2-.9-3.1-.7-2.1.3-3.8,1.4-5.3,2.9-.1.1-.2.2-.4.4-1.8,1.8-1.5,1.8-3.2,0-1.1-1.1-2.6-1.6-4-1.7-1.4-.1-2.8.2-4.1.4-1.2.2-2.1-.3-2.2-1.6,0-.5-.1-1,0-1.4.3-.8.1-1.3-.4-1.9-.3-.3-.5-1-.3-1.4.2-.4.8-.8,1.2-.9,3.4-.9,6.8-1.8,10.2-2.7,1.2-.3,2.5-.7,3.7-1.1,1.8-.5,3.7-.7,5.2-1.5,3.2-1.7,6.9-1.8,9.9-3.9.8-.5,1.7-.8,2.5-1.2.2,0,.5,0,.8,0,.2,0,.4-.2.5-.2.8-.3,1.5-.5,2.3-.8.2-.2.4-.3.5-.5.5-.2.9-.4,1.4-.5.4,0,.8,0,1.2,0,0,.4.1.8,0,1.1-.5.9-1,1.8-1.5,2.7-1.5,2.4-.8,5.7,1,6.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M275.3,55.8c-.2,0-.5,0-.8,0-1.8-.5-3.6-.9-5.5-1.4.2-.1.6-.2.8-.5.2-.2.4-.5.5-.8-.3-.1-.6-.3-.8-.3-1.8.3-3.6.5-5.4.9-.4,0-.8.4-1.1.5-.3,0-.7,0-1-.2,1.1-.4,2.1-.8,2.3-2.1.2,0,.5,0,.8,0,.3,0,.5,0,.8,0,6-1.2,11.8-3.3,17.5-5.6,2.4-.9,4.5-2.4,6.8-3.6.5-.3,1-.5,1.5-.7,0,.6.2,1.3.3,1.9,0,1-.1,2,.6,2.9.7.9,0,2-1,2.5-.3.1-.6.5-.9.7-.2.2-.5.5-.8.5-1.2,0-1.5.9-1.5,1.8,0,1.5,0,2.9,0,4.4,0,1.4-1.2,2.5-2.7,2.4-1.4-.1-2.8-.2-4.2-.2-.2,0-.4.1-.6.2-1.1.8-1.3,2.7-.6,3.9.2.3.3.7.4,1-1.8-.9-2.5-4.3-1-6.7.5-.9,1.1-1.8,1.5-2.7.1-.3,0-.7,0-1.1-.4,0-.8,0-1.2,0-.5.1-.9.4-1.4.5-.2.2-.4.3-.5.5-.8.3-1.5.5-2.3.8-.2,0-.4.2-.5.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M278.2,54.8c.2-.2.4-.3.5-.5-.2.2-.4.3-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M275.3,55.8l.5-.2-.5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M3.9,36.7c-.3,0-.7-.1-.8-.4-.2.2-.5.2-.8.2-.5-.1-.7-.6-.6-1.1.6-3.2-.5-6.7.6-9.8-.7-1.3-1.5-2.6-2.6-3.6-3-2.7-6.3-4.2-10.3-3.2-.4,0-.8,0-1.1,0-.1,0-.2,0-.3.1-.1,0-.3,0-.4,0l-6.2,2.2c0,.4-.3.9-.3,1.3.3,1.6-.3,2.9-1.3,4.1.1.3.3.7.4,1,0,0,.2,0,.2,0v-.8c1.4,2.1.7,4.8,2.4,7,.6-2,1.9-1.8,3.4-1.8,1.8,0,2.8,1.1,4.3,1.5s2.9,2.2,4.5,3c0,0,4.2,4.7,7.1,7.9-.3-1-.3-2.3,0-2.8.7-.9,1.4-1.8,1.9-2.9,0,0,0-.2,0-.2,0-.5,0-1,0-1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M-137.9,111.9c-.2,0-.5-.2-.5-.3,0-1.3,0-2.5,0-3.8.2,0,.3,0,.5,0,.1.6.2,1.1.3,1.7,0,.3,0,.5,0,.8,0,.5-.2,1.1-.3,1.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M-137.9,111.9c0-.5.2-1.1.3-1.6,0,.5-.2,1.1-.3,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M-138.8,108.1s0,0,0,0c0,0,0-.1,0-.2,0,0,0,0,0,0,0,0,0,.1,0,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M20.7,136.1c-1.4-.4-1.1,2.5-.9,2.3.5-.6.6-1.4.9-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M9.2,86.2c0,1.1,0,2.2,0,3.3v21.3c-.1.6-.1,1.2-.1,1.8,0,.5,0,1,0,1.5,0,7.9,0,15.8,0,23.7s0,12.2,0,18.3c0,2.9-.3,11.1,0,21.2,2.3.4,5.5-1.1,7.8-1,43.8.6,87.5,1.2,131.3.4,17.2-.3,34.6-.8,51.7,1.5,10.5,1.4,20.1.6,30.4-.7,6-.8,11.7-2.9,16.7-6.3,2.7-1.9,5.3-4.1,8.5-4.8-.1,0-.2-.3-.4-.7,1.4-.3,2.7-.6,4.1-1,4-1,8.1-1.2,12.3-1.2.4,0,.8.4,1.1.7.6.6,2.1.7,2.1.2,1.6-.3,4.3,4.5,4.6,4.9,1.6,1.8,4.2,2.6,6.2,4,.7.5,1.3,1,1.9,1.5.4.4.7.8,1.1,1.1.4.3.8.5,1.2.7,1,.6,2,1.5,2.7,2.4.8,1,.6,1.5.7,2.8,0,.7.3.9.9.8,0-2,0-4-.1-5.9,0-3.5-.2-7-.2-10.4,0-1.4,0-2.7,0-4.1s.6-3.4.1-4.4c-.9-2-4.8.8-6.2,1.1-.1,0-.2,0-.3,0,.6-.7.5-1.1-.3-1.9-.1-.1-.2-.3-.2-.4,0,0-.7.5-.7.5-.2.2-.5.4-.8.6,0,0-.2,0-.3.1-1.1-.4-1.5-1.3-.8-2.2.7-1,.8-2.1,1-3.2-.6-1.5-.3-2.9.8-4.2-1.9.3-2.1.2-2.7-1.5,0-.2-.1-.4,0-.6.2-.8,3-3,3.8-3h0c.3-.7,1.2-1.4,1.5-2.1-.5-1.8-3.6-3-5.5-2.4-.9.3-1.6.4-2.4-.3-.5-.5-1.1-.4-1.6,0-.7.6-1.4.8-2.2.3-1-.5-1.9,0-2.7.5-.7.4-1.5.7-2.3,1-.4.2-.9.3-1.3.5-1,.4-1.9.9-2.9,1.3-.1,0-.3,0-.5,0-3.3.5-8.5-.9-10.3,2.8-.3.6-.6,1.4-1.3,1.4-.2,0-.5-.2-.7-.3-2.4-1.1-4,1.8-4.7,4.1-1.2-1-1.4,0-3,1.1-1.5,1.1-4,2.1-5.1,3.7-.6.8-1,1.9-1.8,2.5-.9.7-2.2.8-3.3,1.3-2.3,1-3.6,4-6.1,4.1-3.1.2-2.3,1.9-4.3,3.4-1.8,1.4-4.4.9-6.2,2.8-1.2,1.3-3.1,2.5-5.1,1.1-1.7-1.2-3.4-.9-5.1-.6-5.7.9-13.2-1.1-19.2-1-7.1.2-14.2.6-21.3-.1-3.8-.4-7.5-1.2-11.2-1.6-6.1-.8-12.3-.8-18.5-.9-20.9,0-41.8.1-62.6.6-.6-.8-1.4-1.5-2.1-2-8.6-6.5-16.3-26.3-16.9-26.2-.4.1-.7.2-1.2.2.4-.9.7-1.6.3-2.7-.3-.6-.6-.9-1.1-1.3-.9-.5-1.7-1.1-2.5-1.7-1.9-1.7-3.9-3.4-6.3-4.5-1.6-.7-3.4-1.6-4.2-3-1.4-2.5-4.2-3-5.8-5-.4-.5-1.2-.7-1.8-.8-1.8-.4-3.1-1.7-4.5-2.6-2-1.3-2.5-3.5-3.9-5.1-1.1-1.3-1.6-2.6-1.9-4.2-.1-.4-.7-.7-1.1-1-.7-.5-1.4-.8-2-1.3-.8-.6-1.5-1.4-2.4-2.1-.7-.5-1.4-.9-2.2-1.3-1-.5-1.9-1-2.5-2.1-1.2-.3-1-1.2-1-2-.4-.3-1-.5-1.3-1-.5-.8-1.3-1.1-2.2-1.4-1-.3-.8-1.2-.9-1.9,0-1.5.8-6.6-.9-7.2-1.4-.5-6.9,3.4-8.3,4.1-.5.3-1.1.5-1.5,1-.7.7-.8,1.8-.9,2.8-.3,3.8-.2,7.7-.2,11.6.2,14.7.5,29.4.7,44,0,2.1,0,4.2,1,6,3.6-1.3,7.3-2.6,10.9-3.9M281.3,151c-.3.6-1,1.3-1.6,1.4-.9.1-1.9-.1-2.8-.5-.8-.3-1.2-1-1-2,.2-1,.8-1.2,1.7-1.1.4,0,.8,0,1.6-.1.4.2,1.1.3,1.7.7.4.3.7,1.2.5,1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M-24.8,238.3c-.6,1.2-8.6-2.1-9.8-.4,0-.6.9-15.8.9-16.3,0-5,.2-9.9.2-14.9,0-16.6-.2-33.1-.2-49.7,0-2.3,0-4.7,0-7,0-7,0-14.1,0-21.1.2-.4.3-30.4.2-31.4,0-3.8-.2-7.6-.2-11.4,0-3.6,0-7.2,0-10.8,0-9.7,0-19.4,0-29.1.2.1.4.3.6.4,1.2,1.3,2.4,2.7,3.8,3.8.9.7,2.2,1,3.3,1.5.1,7.9.2,15.8.3,23.7,0,10.1,0,20.1,0,30.2v2.2c0,4.8,0,9.6,0,14.4,0,.6,0,1.2,0,1.8,0,19.2,0,38.4.2,57.6,0,5,.2,9.9.2,14.9,0,2.8.3,5.6.2,8.4,0,1.2-.7,32.8.3,33.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M-17.8,38c0,3.1,0,6.2,0,9.3,0,3.5-.2,7-.1,10.6,0,7.2.2,14.4.2,21.6,0,6,.2,11.9.2,17.8,0,9,0,17.9,0,26.9,0,.4,0,.8,0,1.2,0,8.3,0,16.6,0,24.9v16.5c0,3.7,0,7.3,0,11,0-.9-.2-1.8-.2-2.8,0-2.9,0-5.8,0-8.7,0-.4,0-.9,0-1.3h-.3c0,.4,0,.7,0,1.1v28.7c0,.8.2,4.2.3,5.1-.4.6-.9,1.1-1.3,1.7-.4-.2-.8-.4-1.2-.7,0-.5.2-.9.2-1.4,0-6.7-.2-13.4-.2-20.1,0-.4,0-.9,0-1.3,0-11.9,0-23.8,0-35.7,0-3.8,0-7.7-.1-11.5,0-.3,0-.6,0-.9,0-7.4,0-14.8,0-22.3,0-3.7,0-7.5-.1-11.2,0-1.7,0-3.4,0-5.1,0-12.1,0-24.2,0-36.3,0-1-.2-1.8-1.2-2.3-.3-1-1.2-1.6-2-2.2-.3-.5-.6-1-.9-1.5-.2-.3-.4-.5-.6-.8,0,0-.1,0-.2,0-.4-.6-.9-1.2-1.5-1.9.4,0,.6,0,.8,0,1.1.6,2.1,1.1,3.2,1.7.8,1.6,1.5,3.1,2.2,4.7.1,0,.2,0,.4,0-.1-1-.2-2.1-.3-3.1v-.6c0-1.2.2-2.3.2-3.5,0-2.4,0-4.8,0-7.2,0-.7,0-1.3,0-2,1.1,0,2.3-.2,3.4-.3-.9.5-.5,1.4-.5,2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M-20.5,200.7c.4.2,2.1-2.1,2.6-1.8-.4,2.1,2.3,38.4.7,40.4-1-.4-8.3,0-8.2-1.2.2-2.8.2-38.6.2-41.4,0-5-.2-9.9-.2-14.9,0-19.2-.1-38.4-.2-57.6,0-.6,0-1.2,0-1.8.1-.3.4-.7.4-1,0-2,0-4.1,0-6.1.4.3.7.7.7,1.1.1,1.2.3,2.5.2,3.7,0,.9.3,1.3,1.2,1.1,0,.6,0,1.1,0,1.7,0,18.9.2,37.9.3,56.8,0,7.2.2,14.5.2,21.7v2.7c.2-.3.4-.5.6-.7.4-.9.9-1.7,1.3-2.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M12,6.6l-.5.5.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M51.3,61.8c0,0,0-.1-.1-.2l-.7,1.2-.4.7c0,.2-.1.4-.2.6,0,0,.4.3.5.3.4-.1.9-.3,1.1-.6,0,0,0,0,0,0,.3-.4.4-.9.5-1.4-.2-.2-.5-.3-.7-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M263.4-3.9c-1.8-.7-3.8-.8-5.8-.8-41.6-.3-83.1,0-124.7.8-27.7.5-55.4,1.3-83.1,2.3C36-1.1,22.2-.5,8.3.1,3.1.4-.8.6-5.8,2.3c-.9.3-8.6,2.4-8.5,3.5,2.9,15.8,6.5,31.2,10.3,46.8,1.3,5.2,2.5,10.3,4.7,15.2,1.9,4.1,5,8.4,9.4,8.8.5,0,1.1,0,1.5-.3.4-.3.4-.8.6-1.3,1.2-4.3,5.3-3.9,8.7-4.7,1.1-.3,1.6-1.1,1.3-2.2-.2-.9,0-1.8-.6-2.6,0,0,6.6-5.9,7.3-5,.2.2,3.6-.2,4.8.1,1.1.2,2.2.9,3.4,1s2.4,0,3.5,0c.8,0,1.5-.5,2.3-.7.9-.3,1.5-.2,2.1.7.6.8,2.3,1,3.7.5.3-.1,2.6-.5,2.6-.5,0,0,0-.1-.1-.2-.2,0-.4,0-.4-.1,0-.9.5.3.5.3,0,0,0,.1.1.2.2.2.5.3.7.5-.2.5-.3,1-.5,1.4,4.9,1,10.5,0,15.4-.7,8.9-1.1,17.9-2,26.8-2.8,2.7-.3,5.3-.5,8-.8,10.3-1,20.6-2,30.9-1,2.3.2,5.2.2,6.2-1.9,0,0,0-.2.1-.3.2,0,.4,0,.6-.2.2,0,.5-.2.6-.2,2.4,1.1,4.4-.4,6.5-1,.3,0,.6-.2.8-.4.6-1.1,1.7-1.4,2.9-1.6,2-.3,4-.8,6.1-.2.6.2,1.4-.2,2.1-.1.3,0,.6.3.9.5-.3.3-.6.6-.9.7-.6.1-1.3,0-1.9,0-.2,0-.4.3-.6.5.2.2.4.4.6.5.5,0,1,0,1.5,0,.6.1,1.1.4,1.7.6.3.1.6.4.9.4,1.5,0,3.1,0,4.6,0,1.2,0,2.5-.3,3.7-.2,1.9.1,3.6-.5,5.3-1.3.2,0,.3-.2.5-.2,1.3,0,1.5-.9,1.6-1.9.1-1.3,1.8-3.1,3.1-3.1.2,0,.6.4.7.7.2.6.3,1.1,1.1.9.7-.2,1-.4.9-1.2,0-.3.8-1,1.4-1.2.6-.2,1.4-.2,2,0,1.4.4,2.7-.2,4-.4.6-.1,1.2,0,1.9-.1.3,0,.8,0,1-.2,1-1.2,2.5-1.1,3.8-1.1,1.9,0,3.6-.3,5.4-.8.7-.2,1.5-.2,2.3-.2.2,0,.5.3.8.5-.3.3-.5.7-.8.8-.8.1-1.6,0-2.2.6-.7.8-.6,1.7-.4,2.5,0,.2.9.5,1.3.4,1.1-.5,2-.2,3.1,0,.8.2,1.6,0,2.4-.1,1.8-.3,3.5-.6,5.2-.9.9-.1,1.9,0,2.8-.3,1.5-.5,3-1,4.4-1.7,1.6-.9,3.4-.7,5.1-.9.6,0,1.2,0,2.1,0-.5.8-.6,1.6-1,1.8-.9.6-.9,1.2,0,2.2-.9.2-1.6.5-2.3.6-1.5.1-3,.1-4.4.3-.9,0-1.4.7-1.5,1.7,1.1-.6,2.3-.3,3.5-1,.9-.6,2.4-.4,3.5-.2,1.1.2,2.1.9,3.2,1.4.7.3,2.8-.3,3.3-1.2.5-.7.9-.9,1.7-.6,1.5.5,2.9.2,4.4-.1,1.2-.3,2.5-.4,3.8-.6,1.3-.2,2.7-.3,4-.7,2.5-.8,5-1.9,7.5-2.8,1.3-.5,2.8-.5,4.1-.9,1.2-.4,2.5-.9,3.6-1.6,1-.6.9-1.1-.1-1.7-.3-.2-.6-.3-.9-.5-.3-.1-.6-.2-.9-.5,1.3-.2,2.7-.6,3.9.1.8.5,1.4.2,2.1-.5-1-.2-1.9-.3-2.7-.4-.2,0-.4-.3-.6-.5-.8,0-1.5,0-2.3,0-.4.2-.9.4-1.3.5.2-1,.5-1.7,1.6-1.6,1.2-.2,2.4-.3,3.6-.5.2,0,.3,0,.5,0,.2,0,.3,0,.5,0,.2,0,.4-.2.5-.3,7.7-1.1,5.3-27.7,4.4-33.7-.5-3.3-1.4-6.8-4.1-8.6-.4-.2-.8-.4-1.1-.6h0ZM35.6,8.4c-.4-.4-.7-.7-1-1,.3-.2.6-.6.9-.6.4,0,.7.4,1,.6-.3.3-.5.5-1,.9h0ZM118.8,9.9c0-.1,0-.3,0-.4h1.5c0,.1,0,.2,0,.3-.5,0-1,0-1.5,0h0ZM130.9,9.4c1.3.1,2.5.2,3.7.3-2.6,1.6-3.1,1.5-3.7-.3ZM210.1,44.2c0,.1,0,.3,0,.4-.4,0-.9,0-1.3.1,0-.2,0-.3,0-.5h1.3ZM255.5,5.6c0,0,.2,0,.2.1,0,0,0,.1,0,.2,0,0-.2,0-.2-.1,0,0,0-.1,0-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M56.8,139.5c-2-4.7-4.6-8.3-9.7-10.6-1.6-.7-3.4-1.6-4.2-3-1.4-2.5-4.2-3-5.8-5-.4-.5-1.2-.7-1.8-.8-1.8-.4-3.1-1.7-4.5-2.6-2-1.3-2.5-3.5-3.9-5.1-1.1-1.3-1.6-2.6-1.9-4.2-.1-.4-.7-.7-1.1-1-.7-.5-1.4-.8-2-1.3-.8-.6-1.5-1.5-2.4-2.1-.7-.5-1.4-.9-2.2-1.3-1-.5-2-1-2.5-2.1.7-.7-5.5-6.1-6.3-6.3-1-.2-2,0-2.9-.1-3.1-.3-5.6-2.6-7.8-4.8-1-1-2-2-2.6-3.3-.7-1.5-.9-3.3-.9-5-.4-10.9.4-22.2,5.5-31.8,3,1,9,3.3,9.8,6.8.4,1.8-.2,3.8.2,5.7s1.2,3.6,2.4,5.1c1.4,1.8,2.7,3.6,4.1,5.4.1.3.3.5.4.8,1.4,2.1,3.1,4.1,3.5,6.7.2.2.3.3.5.5,0,.3,0,.5,0,.8,1.2,2.9,2.3,5.9,3.5,8.8,1.6,3.7,3.4,7.2,5.9,10.4.8,1,1.3,2.4,2.2,3.1,1.8,1.3,2.8,3.5,5,4.4,1.1.5,2.1,1.5,3.2,2.4,0,.6-.6.8-1.3.8-.7,0-1.6,0-1.6.8,0,.8.3,1.7.8,2.4.4.5,1.2,1,1.9.3,1-.8,1.4-.9,2.1.3,1,1.8,2.6,2.9,4.3,3.9.3.2.8.2.9.3,1.4,1.9,2.4,4,4,5.4,2.5,2.3,6.8,4.4,8.3,7.4,1.7,3.5,9.3,16.1,11.4,19,2.2,3.1,4.4,5.5,6.4,8.8.4.6.7,1.2,1.2,1.6,1.6,1.3,3.7,1.8,5.4,3.1,1.8,1.5,3.7,3.5,5.3,5.3,2.2,2.4,3.8,5.8,2.6,8.9-3,.9-6.3,0-9-1.7s-4.8-4.1-6.9-6.4c-2.7-3-4.7-6.2-7.1-9.3-1.1-1.5-3-2.3-4.4-3.5-4-3.5-5.3-11.1-7.2-15.9-.2-.6-.5-1.3-.8-1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M-17.8,38c0-.7-.4-1.6.5-2.1.4-.4.9-.8,1.3-1.2-.6-.5-1.2-1-1.8-1.4,0,0,0-.2,0-.3.2-1.5.3-2.9.5-4.4,0-.4,0-.9,0-1.3,1,.2,2.1.4,3.1.7,1.4.4,2.8.9,4.1,1.4.3,0,.7.2,1,.3,0,.4-.2,1.1,0,1.1,1,.5,2,1.1,3.1,1.4,3.4.8,10.9,1.8,11.1,2.2.3.7.4,1.6.6,2.4.1,1.2.3,2.3.4,3.5,0,1.2,0,2.4,0,3.6-.1,5.8-.4,11.6-.9,17.4,0,.1,0,.3,0,.4-.1.3-.5.4-.8.4-.6,0-.9-.7-1.5-.8-.2,0-1.3.5-1.2.6-.6-.5-1.2-1-1.7-1.6-.7-.8-1.5-1.1-2.5-1-.9.1-1.3-.3-1.9-1-1-1.1-1.9-2.3-3.7-2.5-1.1,0-2.1-1-3.3-.7-.4,0-.8,0-1.1.2-.9.2-1.5.1-2.1-.7-.3-.5-1.2-.6-1.7-.9l-.4.3c-.2-1.5-.5-3-.6-4.5,0-3.4,0-6.7,0-10.1,0-.5-.1-.9-.2-1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M-17.3,27.3c0,.4,0,.9,0,1.3-.8.9-1,3.3-.5,4.4,0,0,0,.2,0,.3-.8-.4-1.7-.9-2.5-1.3-.1-.3-.3-.5-.4-.7,0-.1,0-.3-.1-.4,0-.4.2-.9.2-1.3-.2-9.5-.3-19-.5-28.6,0-5.1-.2-10.2-.3-15.2.2-.2.4-.4.5-.6.2,0,.3-.2.5-.3.1.3.3.7.4,1,0,0,.2,0,.2,0v-.8c1.4,2.1.7,4.8,2.4,7,.6-2,1.9-1.8,3.4-1.8,1.8,0,2.8,1.1,4.3,1.5s2.9,2.2,4.5,3c.1,0,.3.1.3.2C-3.9-3.1-1.9-1.8-.8,0c.5.8.2,1.5-.8,1.6-.6,0-1.3,0-1.9,0-.7.2-1.6.3-2.1.8-1,1.1-2,.8-3.1.6-.9-.2-1.8-.4-2.9-.7,0,.7.4,1.4.2,1.7-1.1,1.8-.5,3.5,0,5.3.2.6,0,1.3-.2,1.9-.6,1.5,0,2.8.7,4,0,.1.2.3.4.3,1.7.2,1.7,1.6,2,2.8.3,1.3.9,2.3,2.1,3,1.3.8,2.4,1.9,3.5,2.9,1,.9,1.9,1.9,3.3,1.9,1.3,0,2.6,0,4.1,0,.1,1.8.2,3.7-.3,5.6-.1,0-.3-.1-.4-.2v-1.3c-4.4-.2-8.6-.5-12.8-.7-.3,0-.7-.2-1-.3.6-.3,1.3-.5,2.1-.8-.8-1.1-1.5-2.2-2.3-3.1-.7-.8-1.4-1.8-2.3-2.2-1.6-.6-1.8-1.8-1.8-3.2,0-5.4,0-10.8,0-16.2,0-1.5.3-2.7,1.4-3.8.3.2.6.3,1,.5.2-.7.4-1.4.6-2,.4-1.3-.2-2.3-1.5-2-1.2.2-2.1.2-2.7-1.1-.6,1,.4,2.4-1.1,3-.2-.6-.4-1.1-.6-1.7-.1,0-.2,0-.3,0,0,.3-.2.7,0,.9.9,1.8,1.1,3.7,1.1,5.6,0,4.8-.2,9.7-.3,14.5,0,1.3-.3,2.6-.4,3.8,0,1.9,0,3.7.1,5.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M37.1,40.1c-2,0-4,.3-5.9.1-2.2-.2-4.4-.6-6.7-.9-.3,0-.6,0-.9-.2-1.5-.8-3.1-.7-4.7-.9-1.6-.2-3.1-1.1-4.6-1.8-.5-.2-.9-.7-1.6-.1-.2.2-1.1.1-1.2-.1-.6-.7-1.1-.9-1.8-.2,0,0-.2-.2-.4-.3,0-.9.2-1.5,1-1.8.7.3,1.4.6,2.1,1,.5.3.9.3,1.1-.2.3-.8,1-.8,1.7-.8,3.3,0,6.6-.2,9.9-.3,2.2,0,4.3-.3,6.5-.2,2.5.1,5.1.5,7.6.7,1.9.2,3.7.2,5.6.3.7,0,1.4.2,2.1.4.9.3.9.8,0,1.4-.4.3-.9.7-1.4,1-.6,0-1.1,0-1.7,0-4.3,0-8.6-.2-12.9-.3-.7,0-1.4,0-1.9.8,1,1.3,2.4,1.9,4,2,1.2.1,2.5.2,3.7.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M-19.1-26.8c1.1-1.9,1.2-3.9,1.1-6,0-1.5-.3-3.1.4-4.6,0,2.1.2,4.1.3,6.1,0,1.9.2,2,1.9,2.7,2.5,1,3.4,3,2.8,5.8-2.1.7-4.1,1.4-6.2,2.2-.9-1-.8-2.2-.8-3.4.2-.9.3-1.9.5-2.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M1.8,30.3h0c.9,0,1.7.6,2.7.5.2,0,.4,0,.6,0,.2.1.3.4.4.7.3,1.4.4,2.7.4,4.1-.4.2-2-.6-2.4-.8-.7-.5-1-.7-1.9-.9s-1.7-.4-2.3-1c-.3-.3-.9-.4-1.4-.4-1.3-.1-2.6,0-3.9-.3-1.1-.2-2.1-.8-3.1-1.4-.1,0,0-.7,0-1.1,0,0,6.6.4,7.2.4,2.1.1,4.2.3,6.3.2,0,0,.1,0,.1,0,0,0,0,.1,0,.2,0,.7,0,1.4.4,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M4.5-22.6c-.4,0-.7,0-.7-.6,0-2.5-.2-5-.2-7.4,0-.6.3-1.2.4-1.9s.2-1.2-.6-1.6c-1.4-.5-1.4-.7-1.4-2.4,0-1.2,1.1-.9,1.7-1.2.2,0,.4,0,.6,0,.2,0,.3-.2.5-.3,0,3.2.3,6.3.2,9.5,0,2-.3,3.9-.5,5.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M4.4-4.7c.5,1.3.4,8.8,0,9.6-.6-.4-1.2-.8-1.8-1.3C1.8,3,1.4.4,2-.3c1-1.3,2.1-2.6,2.4-4.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M-19.6-24c0,1.2-.1,2.4.8,3.4,0,.4-.3.9-.3,1.3.3,1.6-.3,2.9-1.3,4.1-.2,0-.3.2-.5.3,0-2.1-.1-4.2-.2-6.2.1-.4.4-.7.4-1.1,0-1.5,0-3.1,0-4.6h.4v5.2c0,0,.2,0,.2,0,.1-.8.3-1.6.4-2.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M4.7,60.8h-.1c-.1-.3-.3-.6-.3-.9,0-6.9,0-13.7,0-20.6,0-.2.1-.5.2-.7,0,7.1.2,14.2.3,21.3,0,.3,0,.6,0,.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M3.2-13.9c.4-.3.8-.6,1.2-.8,0,2,0,4,0,6h-.3c0-.7,0-1.4,0-2-.1-.3-.3-.5-.4-.8l-.5-2.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M4.3-8.7h.3c.1,1.1.2,2.1.3,3.2-.1,0-.3,0-.4,0-.3-1,0-2.2-.1-3.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M9.2,81c.2.2.5.4.4.6-.1.7-.3,1.5-.5,2.2v-2.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M9,110.8v1.8-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M3.8-11.6c.1.3.3.5.4.8-.1-.3-.3-.5-.4-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M9.9,10.2v.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M4.3-21.6c0-.1.1-.2.1-.3,0,.1-.1.2-.1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M-12.2-22.8c.1,0,.2,0,.3-.1-.1,0-.2,0-.3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M-20.3,32c-.1-.3-.3-.5-.4-.7,0-.1,0-.3-.1-.4,0-.4.2-.9.2-1.3-.2-9.5-.3-19-.5-28.6,0-5.1-.2-10.2-.3-15.2,0-2.2-.3-4.4-.3-6.7,0-5.1,0-10.3,0-15.4,0-2-.4-4-.5-6,0-1.5,0-3.1,0-4.6s0-1,0-1.6c0-4.1,0-8.3,0-12.4.2.7.4,1.4.5,2.2.2,0,.3,0,.5,0,0-.8.1-1.6.2-2.4,0-1.1-.3-2.3-.3-3.4,0-1.3,0-2.5.1-3.8,0-2.5,0-5.1-.3-7.6,0-.7-1.8-1.3-1.8-.8.2,4.2.2,8.4,0,12.6-.2,4,0,7.9,0,11.9,0,3.6,0,7.3,0,10.9,0,4.6,0,9.2,0,13.9.2-.2.3-.4.7-.9.1,3.6.2,7,.4,10.4-.2-.1-.4-.3-.7-.4,0,.9,0,1.9.2,2.8.3,1.1.9,2.2,1,3.3.1,5,0,10,0,15,0,.5-.2.9-.2,1.4l.2.5c0,0-.1,0-.2,0,0-.2,0-.4,0-.5-.2,1.7-.4,3.3-.6,5.3,0-.6,0-1.1-.2-1.5,0-.4-.3-.8-.4-1.2.1,2.3.2,4.7.3,7,.1.3.3.7.3,1,0,1.4,0,2.8,0,4.3,0,3.6.2,7.2.3,10.8,0,.4.2.8.4,1.1-.1,0-.3,0-.5,0,.6.3,1.3.7,1.9,1h0ZM-22.5-29.2h0v-.8h.1v.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M-8.4,87.6c1.6,0,3.1.2,4.6-.5.2.5.5,1,.5,1.5.1,10.6.2,21.1.2,31.7,0,2-.3,4-.4,6,0,.3.2.6.2.9,0,.4,0,.8,0,1.4-1.1-1.9-2.5-3.2-4.6-3.6,0,.1-.1.3-.1.3,1.4,1.6,1.9,3.5,2,5.6,0,.5.4,1,.8,1.3.7.6,1.5,1.1,2.4,1.5,1.5.7,1.9,1.8,1.9,3.3,0,.6,0,1.1,0,1.7,0,1.1-.2,1.2-1.3.5-.2-.2-.3-.5-.5-.7h0c-.1-.1-.2-.3-.3-.4l-.2.4c-.1.1-.2.2-.3.3-.9-.4-1.8-.7-2.7-1.1-.7-.3-1.4-.5-2.1-.8,0-.6,0-1.2,0-1.8.5-.9.3-1.8-.4-2.4-1-.8-2.2-1.5-3.3-2.2-.2-.1-.3-.3-.4-.5-1-.9-2-1.7-3-2.6-.7-.5-1.2-1.5-2.3-1.2-.6-.5-1.1-.9-1.7-1.4-.9-.8-1.7-.4-2.4.3-.1,0-.2.1-.3.2h0c-.6.1-1.2.3-1.8.4,0,.2.2.4.2.6-.5,0-1.3.2-1.5,0-.4-.7-.6-1.6-.8-2.4-1.1.3-1.9,1-2.3,1.9-.3.8-.9,1.2-1.8,1.1-.5,0-1.1.2-1.6.3-.2-.3-.4-.5-.6-.8.5-.9,1.1-1.9,1.6-2.8.3.2.6.5.9.7.7-1.3.4-2.2-1-2.9.6-.4,1.2-.7,1.7-1.2.4-.3.6-.7,1-1.1h0c.1,0,2.5-1.4,3.6-2,.6,0,1.2-.2,1.8-.2.3,0,.7.2,1.1.3h0c.8.3,1.5.6,2.3.9.2,0,3.4,1.5,4.8,2.3,1.5.8,2.8,1.8,4.3,2.7.5.3.9.6,1.6.9,0-.5.1-.8.1-1.2.1-9.5.2-19,.3-28.6,0-2,0-4.1,0-6.1,0-.1,0-.2,0-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M-46.8,43.4c0-.7-.2-1.3-.1-2,0-.2.4-.4.7-.8.3,1,.6,1.8.9,2.5-.3.9-.8,1.1-1.4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M-41.4,44.2c0,.1,0,.2,0,.3-.3-.1-.7-.3-1-.4.3,0,.6,0,.8-.1,0,0,.2.1.2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M-23,121.1c-.9.2-1.2-.2-1.2-1.1,0-1.2,0-2.5-.2-3.7,0-.4-.3-.8-.7-1.1,0,2.1,0,4.1,0,6.1,0,.3-.3.7-.4,1,0-4.8,0-9.6,0-14.4,1.1-.3.4-1.2.6-1.8,0,0-.4-.2-.6-.3,0-10.1,0-20.1,0-30.2,0-7.9-.2-15.8-.3-23.7h0c1.1.6,3,.7,1.3,2.7.4.1.8.2.9.3.3.6.5,1,.7,1.4,0,.3,0,.7,0,1,0,10.2,0,20.4,0,30.5,0,2.5-.2,5.1-.2,7.6,0,1.7.1,3.4.2,5.2-.2.5-.7.9-.7,1.4,0,3.6,0,7.1,0,10.7,0,.7.4,1.5.6,2.2,0,2.1,0,4.1,0,6.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M-34.9,42.6c-.1-.6-.2-1.2-.4-1.8-.2-.7-.2-1.5.5-1.8.6-.2,1.5-.2,1.9.1,1.1.8,1.9,1.8,2.9,2.7.3.3.6.5.8.8.3.6.6,1.2.9,1.7-.3.3-.7.5-1,.8-.8.9-.8,1.8-.1,2.8.8,1,1.4.6,2.1-.1,0,0,.2,0,.2,0,.4.4.7,1.1,1.3.2,0,0,.1,0,.2,0,0,.2,0,.5.1.7-.2.9-.4,1.7-.5,2.6,0,.2,0,.4,0,.6h0c-1.1-.5-2.4-.8-3.3-1.5-1.4-1.1-2.5-2.5-3.8-3.8s-.4-.3-.6-.4c-.4-1.2-.8-2.4-1.2-3.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M-33.6,106.1c0-1.7.1-3.4.2-5.2,0-.2-.2,12.7-.2,5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M-25.6,105.8c.2.1.6.3.6.3-.2.6.5,1.5-.6,1.8v-2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M-41.4,127.4c0-.2-.2-.5-.2-.7,0-5.9,0-11.8,0-17.7,0,.2.2.4.2.6,0,6,0,11.9,0,17.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M-41.6,107.2v-6.9,6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M-41.4,133.9c0,0,0-.1,0-.2,0,0,0,0,0,0,0,0,0,.2,0,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M-22.9,100.7c0-1.7-.2-3.4-.2-5.2,0-2.5.2-5.1.2-7.6,0-10.2,0-20.4,0-30.5s0-.7,0-1c0-1.2.1-2.3.3-3.4,0-.1.4-.2.6-.4,1,.5,1.2,1.3,1.2,2.3,0,12.1,0,24.2,0,36.3,0,1.7,0,3.4,0,5.1,0,.3-.3.7-.3,1,0,10.8,0,21.5,0,32.3,0,.4.2.7.4,1.1,0,3.8.1,7.7.1,11.5,0,11.9,0,23.8,0,35.7,0,.4,0,.9,0,1.3-.2-.7-.3-1.5-.4-2.2-.2.2-.3.4-.3.6-.2,2.8-.4,5.6-.5,8.5,0,1.5-.4,3,.4,4.4.1.2,0,.7,0,1-.2.9-.5,1.7-.6,2.6,0,1.8.1,3.6.2,5.4,0,1.3,0,2.5,0,3.8-.2.2-.3.4-.6.7v-2.7c0-7.2-.2-14.5-.2-21.7-.1-18.9-.2-37.9-.3-56.8,0-.6,0-1.1,0-1.7,0-2.1,0-4.1,0-6.2,0-4.7,0-9.5,0-14.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M-26,36.1c0-1.6,0-3.2,0-4.7,0-.9.3-1.3,1.2-1.3.7.3,1.4.6,2.2.9.2,0,.3,0,.5,0,.6.3,1.3.7,1.9,1,.8.4,1.7.9,2.5,1.3.6.5,1.1.9,1.8,1.4-.4.4-.8.8-1.3,1.2-1.1,0-2.3.2-3.4.3-1.4,0-2.8,0-4.2,0-.3,0-.7,0-1.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M-20.7,38.2c0,2.4,0,4.8,0,7.2,0,1.2-.1,2.3-.2,3.5-.3-1.2-.6-2.3-1.7-3.1h-.3,0c0-.8-.2-1.6-.2-2.4,0-2.4,0-4.7,0-7.1.7,0,1.4.2,1.9.3.2.7.4,1.2.6,1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M-22.6,45.7c1.1.7,1.4,1.9,1.7,3.1v.6c-.3-.4-.7-.7-1-1.2-.3-.5-.7-.9-1.3-.4-1.1-.6-2.1-1.1-3.2-1.7-.1,0-.3,0-.8,0,.6.8,1,1.3,1.5,1.9-.6.8-.9.1-1.3-.2-.6-.7-1.3-1.3-1.9-2,.8-1.4,1.9-1.5,3.3-.7-.3-.8-.7-1.4-1.1-2-.2-.4-.4-.9-.6-1.3.4.3.9.5,1.3.8h0c.2.2.4.4.5.5.3.4.5.7.8,1.1.5.5,1.1,1,1.7,1.5h0,.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M-20.7,130.7c-.1-.4-.4-.7-.4-1.1,0-10.8,0-21.5,0-32.3,0-.3.2-.7.3-1,0,3.7.1,7.5.1,11.2,0,7.4,0,14.8,0,22.3s0,.6,0,.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M-22.1,52.5c-.2.1-.6.2-.6.4-.1,1.1-.2,2.3-.3,3.4-.2-.4-.4-.8-.7-1.4-.1,0-.5-.1-.9-.3,1.6-2-.3-2.1-1.3-2.7,0-.2,0-.4,0-.6.7.2,1.4.3,2,.5,0-.6-.1-1.1-.2-1.5.8.6,1.6,1.2,2,2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M-23.3,47.8c.6-.5.9,0,1.3.4.3.4.7.8,1,1.2.1,1,.2,2.1.3,3.1-.1,0-.2,0-.4,0-.8-1.6-1.5-3.1-2.2-4.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M-24.1,50.4c0,.5,0,.9.2,1.5-.6-.2-1.3-.3-2-.5.2-.9.4-1.7.5-2.6.1,0,.3,0,.4,0,.3.5.6,1,.9,1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M-20.7,38.2c-.2-.5-.4-1-.6-1.7-.5,0-1.2-.2-1.9-.3-.6,0-1.1,0-1.7-.1,1.4,0,2.8,0,4.2,0,0,.7,0,1.3,0,2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M-25,48.9c-.1,0-.3,0-.4,0,0-.2,0-.5-.1-.7.2.3.4.5.6.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M-35.7,95c.2.2.3.5.5.7-.2-.2-.3-.5-.5-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M-36.2,95c0-.1.1-.3.2-.4,0,.1.2.3.3.4-.2,0-.3,0-.5,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M68.1,36.9h4.4c0,.1,0,.2,0,.4-.5,0-1,.2-1.7.3.2.5.3,1,.5,1.8-2.5.2-4.8.5-7.2.7h-3.1c-8,0-16.1,0-24.1,0-1.2-.1-2.5-.2-3.7-.3-1.6-.1-2.9-.7-4-2,.4-.8,1.1-.9,1.9-.8,4.3,0,8.6.2,12.9.3.6,0,1.1,0,1.7,0h15.4c1,0,1.9,0,2.9,0,1.2,0,2.3-.2,3.5-.2h.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M35.6,8.4c-.4-.4-.7-.7-1-1,.3-.2.6-.6.9-.6.4,0,.7.4,1,.6-.3.3-.5.5-1,.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M292,41.5c-.1.1-.2.4-.3.6-.5.2-1,.4-1.5.7-2.3,1.2-4.5,2.7-6.8,3.6-5.7,2.2-11.5,4.3-17.5,5.6-.3,0-.5,0-.8,0-.2,0-.5,0-.8,0-.8.3-1.5.5-2.3.8-.4.1-.7.3-1.1.4-5.7,1.4-11.4,2.7-17.1,4-1.2.6-2.9.7-4.2,1.2-1.4.4-2.7.9-4.1,1.5-2.6,1-5.3,2-7.9,3.3-.8.4-1.6.8-2.2,1.5-.4.4-.6.9-.8,1.4-.9,1.9-.1,2.2,1.8,2.1,1.4,0,2.8-.4,4.3-.6.3,1.1-.5,2.2-1.5,2.6s-2.1.5-3.2.8c-.4.1-.7.3-.9.6-.1.3,0,.7,0,1,0,.9-.7,1.6-1.5,2.1-4.1,2.5-9.4,2.9-13.9,4.3-2.4.7-4.8.7-7.2,1.2-1.8.4-3.6.9-5.4,1.3-2.1.5-4.2,1-6.3,1.5-2,.5-4,1.3-6,1.8-2.5.6-5,1-7.5,1.5-2,.4-4,1-6.1,1.3-4.5.8-9.1,1.5-13.7,2.3-1.8.3-3.6.5-5.4.8-1.7.2-3,0-4.8-.3-.1,0-.2,0-.4,0-4.7,2.3-10.9,1.5-15.4,4.5-1.4.9-2.6,2.2-4.1,2.8-1.3.5-2.8.4-4.2.3-15.4-.9-31.1-.3-46.1,3.3-2.4.6-4.9,1.3-6.6,3.1-3.9,4.4,2.2,9,4.7,12.1,1.6,2,3.4,3.7,5.6,5.1.3,1.1.6,2.2.9,3.4h0c0,.1.4.2.4.3,0,.3-.4.7-.4,1v6.5c0,1.5-.1,3-.2,4.4,0,.3,0,.5,0,.7,0,.6,0,1.2-.1,1.9,0,0-.1,0-.2,0v-1.1c0-.6,0-1.1,0-1.7,0-1.2-.5-2-1.6-2.5-2-1-4.2-1.7-5.4-3.9,0,0-.1-.1-.2-.1-.9.3-2.9-1.4-3.1-1.7-1.1-1.8-2.8-3.1-4.4-4.4-.4-.3-.9-.3-1.4-.5-.2-.7-.6-.5-1.1-.4-1.6.4-3.1.6-4.5-.6-.1-.1-.4,0-.6,0-.2-1-.9-1.4-1.8-1.6,0,0-.2-.2-.2-.3,0,0-.2-.2-.3-.3-1.2-2.1-2.4-4.2-3.6-6.3-1-1.7-2.2-3.4-3.1-5.1-.5-1-.7-2.1-.8-3.3,0-1.2-1.3-2.4-2-3.6-.5.6-.5,1.3-.1,2.1-.1,0-.3,0-.4,0-1.3-.9-2.4-2.1-4.1-2.3-.2,0-.4-.2-.5-.3-1.1-.7-1.2-.7-2.2,0,1.9,1.3,3.9,2.6,4.5,5.2-.2-.2-.6-.4-.7-.7-.3-1.1-1.3-1.3-2.2-1.4-.4,0-.8,0-1.1,0-1.6-.5-3.2.1-4.8-1.3-2.9-2.5-4.3-5.6-5.3-9.1-.2-.5-.4-1.1-.5-1.6-.4-1.7-.6-3.5-1.1-5.1-.3-1-.6-2.3-2.2-2.2-.3,0-.8-.9-1-1.4-.2-.5,0-1.1-.1-1.5-.1-.5-.1-1.3-1.1-1.3-.1.9-.2,1.9-.4,2.9-2.1-1-1.6-2.9-2.1-4.4-.6.1-1.2.4-1.8.4-.1,0-.2,0-.3,0-.1,0-.1-.2-.2-.3-1.4-2.7-4.7-6.6-3.1-9.7,1.6-3.1,3.4-6.3,6.4-7.9,3.1-1.7,6.6-4.5,10-4.4,1.8.1,4.4,3.5,6.2,3.3,1.6-.2,3-1.1,4.6-.8,1.4.3,1.8,1.7,3,2.1.7.2,10.8.1,14.4-.3,10.1-1.1,20.1-3.2,30.4-2.9,3.9.1,7.9.6,11.8-.2,2.5-.5,4.9-1.5,7.3-2.3,7.7-2.4,15.9-2,23.9-1.6.8,0,1.7.1,2.3.5,0-.4.2-.7.3-1.1.2.1.5.2.6.4.4.9,1,1,1.8.6.2,0,.5-.2.6-.2,2.4,1.1,4.4-.4,6.5-1,.3,0,.6-.2.8-.4.6-1.1,1.7-1.4,2.9-1.6,2-.3,4-.8,6.1-.2.6.2,1.4-.2,2.1-.1.3,0,.6.3.9.5-.3.3-.6.6-.9.7-.6.1-1.3,0-1.9,0-.2,0-.4.3-.6.5.2.2.4.4.6.5.5,0,1,0,1.5,0,.6.1,1.1.4,1.7.6.3.1.6.4.9.4,1.5,0,3.1,0,4.6,0,1.2,0,2.5-.3,3.7-.2,1.9.1,3.6-.5,5.3-1.3.2,0,.3-.2.5-.2,1.3,0,1.5-.9,1.6-1.9.1-1.3,1.8-3.1,3.1-3.1.2,0,.6.4.7.7.2.6.3,1.1,1.1.9.7-.2,1-.4.9-1.2,0-.3.8-1,1.4-1.2.6-.2,1.4-.2,2,0,1.4.4,2.7-.2,4-.4.6-.1,1.2,0,1.9-.1.3,0,.8,0,1-.2,1-1.2,2.5-1.1,3.8-1.1,1.9,0,3.6-.3,5.4-.8.7-.2,1.5-.2,2.3-.2.2,0,.5.3.8.5-.3.3-.5.7-.8.8-.8.1-1.6,0-2.2.6-.7.8-.6,1.7-.4,2.5,0,.2.9.5,1.3.4,1.1-.5,2-.2,3.1,0,.8.2,1.6,0,2.4-.1,1.8-.3,3.5-.6,5.2-.9.9-.1,1.9,0,2.8-.3,1.5-.5,3-1,4.4-1.7,1.6-.9,3.4-.7,5.1-.9.6,0,1.2,0,2.1,0-.5.8-.6,1.6-1,1.8-.9.6-.9,1.2,0,2.2-.9.2-1.6.5-2.3.6-1.5.1-3,.1-4.4.3-.9,0-1.4.7-1.5,1.7,1.1-.6,2.3-.3,3.5-1,.9-.6,2.4-.4,3.5-.2,1.1.2,2.1.9,3.2,1.4.7.3,2.8-.3,3.3-1.2.5-.7.9-.9,1.7-.6,1.5.5,2.9.2,4.4-.1,1.2-.3,2.5-.4,3.8-.6,1.3-.2,2.7-.3,4-.7,2.5-.8,5-1.9,7.5-2.8,1.3-.5,2.8-.5,4.1-.9,1.2-.4,2.5-.9,3.6-1.6,1-.6.9-1.1-.1-1.7-.3-.2-.6-.3-.9-.5-.3-.1-.6-.2-.9-.5,1.3-.2,2.7-.6,3.9.1.8.5,1.4.2,2.1-.5-1-.2-1.9-.3-2.7-.4-.2,0-.4-.3-.6-.5,1.5,0,2.9,0,4.4,0,3.7-.3,7.4-.6,11.1-1.2,4-.6,7.9-1.5,11.8-2.4,1.3-.3,2.6-.8,3.9-1.1.3,0,.6-.1,1-.2,0,2.1.8,4.2-1.5,5.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M74.8,140.3c0,0-.1-.1-.2-.1-1.6-.2-2.3-1.5-2.6-2.6,0-.1,0-.2,0-.3l-1.2.5c.4.9.6,2.2,1,2.4,0,0,0,0,0,0,.9.4,1.9.7,2.9,1,.1,0,.3,0,.8,0-.3-.3-.5-.6-.6-.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M20.2,78.9c.2.2.3.3.5.5-.2-.2-.3-.3-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M-19.8-61.2c-.7,3.4-.5,6.8-.5,10.2,0,2.1,0,4.2,1,6.2.2-.2.3-.3.6-.5v1.3c0,3.6-.2,7.1-.2,10.7,0,2.1,0,4.3,0,6.4-.2.9-.3,1.9-.5,2.8-.1.8-.3,1.6-.4,2.3,0,0-.2,0-.2,0v-5.2h-.4c0,1.5,0,3.1,0,4.6,0,.4-.2.7-.4,1.1,0-.3,0-.6,0-.8,0-.2,0-.4,0-.7,0-.6,0-1.2,0-1.8,0-8.2.1-16.4.3-24.6,0-4.1.4-8.2.5-12.2h.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M-17.3,27.3c0-1.9-.2-3.7-.1-5.6,0-1.3.3-2.6.4-3.8.1-4.8.2-9.7.3-14.5,0-2-.2-3.9-1.1-5.6-.1-.2,0-.6,0-.9.1,0,.2,0,.3,0,.2.5.4,1.1.6,1.7,1.5-.6.4-2,1.1-3,.6,1.3,1.5,1.4,2.7,1.1,1.3-.3,2,.7,1.5,2-.2.6-.4,1.3-.6,2-.4-.2-.7-.4-1-.5-1.1,1.1-1.4,2.3-1.4,3.8,0,5.4,0,10.8,0,16.2,0,1.4.2,2.5,1.8,3.2.9.4,1.6,1.4,2.3,2.2.8,1,1.6,2.1,2.3,3.1-.8.3-1.4.6-2.1.8-1.4-.5-2.7-1-4.1-1.4-1-.3-2-.4-3.1-.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M-17.8,33c-.6-1.1-.3-3.5.5-4.4-.2,1.5-.3,2.9-.5,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M-20.3-61.2c-.2,4.1-.5,8.2-.5,12.2-.2,8.2-.2,16.4-.3,24.6,0,.6,0,1.2,0,1.8,0,.2,0,.4,0,.7,0,.3,0,.6,0,.8,0,2.1.1,4.2.2,6.2-.2.2-.4.4-.5.6,0-2.2-.3-4.4-.3-6.7,0-5.1,0-10.3,0-15.4,0-2-.4-4-.5-6,0-1.5,0-3.1,0-4.6s0-1,0-1.6c0-4.1,0-8.3,0-12.4.2.7.4,1.4.5,2.2.2,0,.3,0,.5,0,0-.8.1-1.6.2-2.4.2,0,.4,0,.5,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M-20.7,31.2c0-.1,0-.3-.1-.4,0,.1,0,.3.1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M-33.8-1.1c0-.7,0-1.4,0-2.1,0-17.7,0-35.4,0-53.1,0-.5,0-.9.2-1.4,0,.2,0,.4,0,.6,0,18.4.2,36.8.3,55.3,0,.2,0,.4,0,.6-.1,0-.2,0-.4,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M-33.8-1.1c.1,0,.2,0,.4,0v17.7h-.4V-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M-41.7,13.3c-1.2.7-2,.5-3-.8.4,0,.8,0,1.1,0,.5,0,.9-.3,1.4-.4,0,0,.1.4.2.7h.3v.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M-27.8,29.4c-.4-.1-.8-.2-1.3-.4.4,0,.8,0,1.3,0,0,0,0,.2,0,.2h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M-41.7,5c0-.3,0-.5,0-.8,0,.3,0,.5,0,.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M-41.7,12.8h-.3c0-.3.2-.5.2-.8,0,.3,0,.5,0,.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M-23.1,6.6c0-2.9-.1-5.8,0-8.6,0-4.1.2-8.1.4-12.2,0-.5,0-1,0-1.5.3,1.1.9,2.2,1,3.3.1,5,0,10,0,15,0,.5-.2.9-.2,1.4h0c-.2,1.7-.4,3.3-.6,5.3,0-.6,0-1.1-.2-1.5,0-.4-.3-.8-.4-1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M-22.7,30.9c0-5.8,0-11.5,0-17.3.1.3.3.7.3,1,0,1.4,0,2.8,0,4.3,0,3.6.2,7.2.3,10.8,0,.4.2.8.4,1.1-.1,0-.3,0-.5,0-.2,0-.3,0-.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M-22.8-18.5c-.1-2.1-.3-4.2-.4-6.4,0-.9,0-1.8,0-2.7.2-.2.3-.4.7-.9.1,3.6.2,7,.4,10.4-.2-.1-.4-.3-.7-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M-21.9,4l.2.5c0,0-.1,0-.2,0,0-.2,0-.4,0-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M-24.9,36.1c.6,0,1.1,0,1.7.1,0,2.4,0,4.7,0,7.1,0,.8.2,1.6.2,2.4-.6-.5-1.2-1-1.7-1.5-.3-.3-.6-.7-.8-1.1-.2-.2-.4-.4-.5-.5h0c0-.3,0-.7,0-1,0-.4,0-.9,0-1.3,0-.3,0-.5,0-.7v-2.4c0-.3,0-.5,0-.8,0,0,0-.2,0-.3.3,0,.7,0,1.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M-27.2,41.8c.2.4.4.9.6,1.3.4.6.8,1.2,1.1,2-1.4-.8-2.6-.8-3.3.7.6.7,1.3,1.3,1.9,2,0,0-.2,0-.2,0-.7.7-1.3,1.1-2.1.1-.7-.9-.7-1.9.1-2.8.3-.3.7-.5,1-.8-.3-.6-.6-1.2-.9-1.7-.3-.6-.6-1.2-.9-1.9.3-.4.7-.9,1.2-1.5,0,.4.2.6.2.9,0,.1.2.2.2.4h0c0,.8.2,1.2,1,1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M-29.6,29.4c-2.2,0-4.4,0-6.7,0-1.5,0-2.9.4-4.4.5-.2,0-.6.1-.7,0-.3-.2-.5-.6-.8-.9.3-.2.6-.6.9-.7,1.1,0,2.2,0,3.3,0,1.8,0,3.6.1,5.3.2,1,0,2,.2,3,.3,0,.2,0,.4,0,.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M-42.8,26.4c-.6.8-1.1.9-1.4,0-.4-.9-.6-1.8-.9-2.7.1,0,.2-.2.4-.2.5.3,1,.7,1.7,1.2h-1c0,0-.1.2-.2.2.5.5.9,1,1.5,1.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M-26.1,36.4c0,.3,0,.5,0,.8v1.8c0,.2,0,.4,0,.6-.2-.2-.5-.3-.7-.5-.3-.3-.5-.7-.8-1.2.4-.4.9-.9,1.5-1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M-27.3,41.8c-.8,0-1.1-.5-1-1.3l1,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M-26.1,40.3c0,.4,0,.9,0,1.3-.8-.4-.8-.8,0-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M-27.8,29.4c.3,0,.5,0,.8,0,0,0,0,.2,0,.2-.3,0-.5-.2-.8-.3h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M-28.3,40.5c0-.1-.2-.2-.2-.4,0,.1.2.2.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M-41.4,91.6c-1.5-.3-3-.7-4.5-1-.2,0-.5-.1-.7-.2-1.5-.8-2.9-1.6-4.4-2.4-.7-.4-.9-1-.4-1.7.2-.3.3-.6.5-.9.9-.2,2-.3,2.3-1.5,1,.9,2,1.7,3,2.6.2.1.3.4.4.5,1.1.7,2.3,1.4,3.3,2.2.7.6.9,1.5.4,2.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M-48.6,83.8c-.3,1.2-1.4,1.3-2.3,1.5.2-.7.4-1.4.5-2,0-.2-.3-.5-.5-.7,1.1-.2,1.6.7,2.3,1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M-22.9,100.7c0,4.7,0,9.5,0,14.2-.2-.7-.6-1.5-.6-2.2,0-3.6,0-7.1,0-10.7,0-.5.4-.9.7-1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M-22.6,45.7h-.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M-26,42.6l.5.5-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M56.8,120.9c-.6-.7-1.3-1.3-1.8-2-1-1.4-1.9-3-2.8-4.4-.2-.3-.4-.7-.6-1-.8-.9-1.2-2.1-2.6-2.4-1.6-.4-2.8-1.5-3.6-3,0-.2-.4-.2-.6-.4l-.3-.5c-.6-2.6-2.6-3.9-4.5-5.2,1-.6,1.1-.6,2.2,0,.2.1.3.3.5.4,1.7.2,2.8,1.4,4.1,2.3,0,0,.2,0,.4,0-.4-.9-.3-1.6.1-2.1.8,1.2,2,2.4,2,3.6,0,1.2.2,2.3.8,3.3.9,1.8,2.1,3.4,3.1,5.1,1.2,2.1,2.4,4.2,3.6,6.3h0ZM47.8,105.2c0,0,.2,0,.2,0,0,0,0-.1,0-.2,0,0-.2,0-.2.1,0,0,0,.1.1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M-21-22c0-.2,0-.4,0-.7,0,.2,0,.4,0,.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M-26,39v-1.8s0,1.8,0,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M145.2,9.2c-.2,0-.5,0-.6,0-.5-.3-.9-.6-1.3-.9.4-.3.8-.6,1.2-.9.3-.2.7-.5,1.1-.6.5-.1,1.1-.4,1.4-.2.4.3.6,1,.6,1.5,0,.3-.6.7-1,.9-.4.2-.9.2-1.4.2h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M110.8,12.7h1c0,.1,0,.2,0,.3-.3,0-.7,0-1,0,0-.1,0-.3,0-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M258.9,40.8c-.4.2-.9.4-1.3.5.2-1,.5-1.7,1.6-1.6l-.3,1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M262.8,39.2c.2,0,.3,0,.5,0-.2,0-.3,0-.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M263.8,39.2c.2,0,.4-.2.5-.2-.2,0-.4.2-.5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M261.8,20.9c.3.4.5.9.8,1.4-1.8,2.6-4.8,3.1-7.4,4.1-6.1,2.2-12.2,3.9-18.4,5.9-4.5,1.4-9,2.9-13.5,4.3-.5.2-1,.5-1.6.8-.9.5-1.7.9-3,1.6-.3,1.1.7,1,1.7,1.1,9.8.2,19.2-2.5,28.6-5.2,3.9-1.1,7.8-2.6,11.6-3.9.7-.2,1.4-.3,2-.5.2.4.4.6.4.8.2,3.6,1.5,6,4.8,6.2-1.9.6-3.6,1.4-5.7,1.2-2.4-.2-4.9.6-7.3,1.3-2.8.7-5.6,1.7-8.4,2.6-1.3.4-2.6.7-3.9,1-3.7.9-7.4,1.9-11,2.8-2.2.5-4.4.5-6.5,1.3-2.4.9-4.9.7-7.3,2.2-2.3,1.4-5.2,1.2-7.9,1.8-1.7.3-3.3.8-5,1.1-1.2.2-2.3.3-3.5.5,0-.2-.1-.4-.2-.7,2.1-1.8,4.2-3.5,6.3-5.3,0-.3-.2-.5-.2-.8-2.4.5-4.7,1.2-7.1,1.4-2.4.2-4.8,0-7.2-.4-1.1-.2-1.4-3.6-.4-4.6,1.3-1.2,2.6-2.1,4.5-1.7,1.5.3,3.2-.1,4.8-.3.6,0,1.3-.3,1.9-.3,5.4,0,10.5-2,15.5-3.9.6-.2,1.2-.9,1.7-1.5.8-.9,1.4-1.6,2.6-.6.3.2,1.1-.4,1.6-.7-.3-.5-.6-1.1-1-1.4-.4-.3-1-.3-1.4-.5v-.7c1.1-.3,2.2-.6,3.4-.8,1.8-.3,3.6-.4,5.3-.6,2.2-.3,4.3-.7,6.5-1.1.1,0,.3,0,.4-.2,1.5-3.6,4.8-2.2,7.1-3.4.2-.1.4-.3.6-.5-.5-.8-.9-1.5-1.6-2.8,3.4.3,6.3.4,9.1.8,2.2.4,4.3.6,6.4-.7.7-.4,1.4-.8,2.1-1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M261.3,13.9c-.4.8-.6,1.8-1.1,2.2-3.7,3.3-7.5,6.5-11.3,9.7-.1-1.4-.2-2.9-.5-5.2,4.2-2.2,8.5-4.4,12.8-6.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M134.6,9.7c-2.6,1.6-3.1,1.5-3.7-.3,1.3.1,2.5.2,3.7.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M208.8,44.2h1.3c0,.1,0,.3,0,.4-.4,0-.9,0-1.3.1,0-.2,0-.3,0-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M118.8,9.5h1.5c0,.1,0,.2,0,.3-.5,0-1,0-1.5,0,0-.1,0-.3,0-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M252,36.6l1.1-.5-1.1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M255.5,5.6c0,0,.2,0,.2.1,0,0,0,.1,0,.2,0,0-.2,0-.2-.1,0,0,0-.1,0-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M71.7,140c.9.4,3.1.1,2.8.1-1.5-.2-2.1-4.7-1.7-5.8,0,0,.8,0,1.1.1,1.6,1.2,3.5,1.7,5.3,2.3.8.3,1.5.5,1.7,1.5,0,.2.3.3.5.5v1.1c-.1.6-.2,1.2-.3,1.8,0,0,.1,0,.2,0,0-.2.1-.3.2-.5-.2,1.1-.4,2.2-.6,3.3-1.9-.7-3.8-1.3-5.6-2-1-.4-2-1.1-3-1.3-1.6-.2-1-1.4-.5-1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M255.9,36.6c.7-.2,1.4-.3,2.3-.6-.5,1.2-.8,1.3-2.2,1,0-.1,0-.3-.1-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M143.2,103.7c-4.4.7-8.5,1-13,2.4-16.3,5.2-34.3,1.7-50.6,6.9-3.1,1-6.2,2.3-9.5,2.1-.7,0-1.5-.2-2-.7-.6-.6-.8-1.6-.8-2.4-.1-4.5,2.7-9,6.8-10.8,2.3-1,4.8-1.2,7.2-1.4,9.1-.8,18.1-1.6,27.2-2.4,5-.4,10-.9,14.8-2.3,6.6-1.9,13.3-6.2,20.3-6.4,4.9-.1,8.7,2.2,14,1.3,4.6-.7,9.1-1.5,13.7-2.3,2-.4,4-.9,6.1-1.3,2.5-.5,5-.9,7.5-1.5,2-.5,4-1.2,6-1.8,2.9-.8,5.7-1.5,8.5-2.6,1.8-.7,3.8-1.2,5.7-1.6,1-.2,2.1-.2,3.1-.3.8-.1,1.5-.6,2.4-.8.8-.2,1.6-.2,2.4-.2,2.2,0,4.3,0,6.5,0,.6.7-.3,1.6-1.1,2-2.6,1.4-5.2,2.8-7.8,4.2-1.3.7-2.5,1.4-3.9,1.9-3,1.1-6.3.8-9.3,1.8-3.1,1-5.6,2.5-9,2.3-1.1.5-2.2.8-3.5.5,0,0-.2,0-.2,0-1.5,1-3.2.8-4.8.9-1.5.1-3,.2-4.4,1.1-.4.3-1,.3-1.5.4-2.4.5-4.7,1-7.1,1.6-2,.5-4,1.1-6,1.8-.6.2-1,.7-1.5,1-.4.3-.8.5-1.2.7-1.2.6-2.4,1.2-3.6,1.7-.5.2-1,.6-1.5.6-3-.1-6.1,2.6-9,3.1-.4,0-.7.1-1.1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M44.8,107.7c.2.1.6.2.6.4.8,1.5,1.9,2.6,3.6,3,1.4.3,1.8,1.6,2.6,2.4.2.3.4.6.6,1-.6.2-1.2.3-1.8.6-1.5.5-2.6.2-2.9-1.4-.4-2-1.3-3.7-2.5-5.3-.1-.2-.1-.4-.2-.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M-49.9,241.2c-6.8-.7-13.6-1.3-20.3-1.9.2.2.5.4.7.5.8.6,1.6,1.3,2.1,2.3.1.3,0,.6-.2.7,0,0,0,.6-.1.6,0,.4,0,.2,0,.6,0,3.5,0,7,.1,10.6,0,.9,0,1.1.1,2.3.6.6,2.1.6,2.9.9,1.7.7,3.5,1.2,5.3,1.6,3.6.8,7.3,1.1,11,1.7,4.4.7,8.8,1.7,13.2,2.4,9.7,1.6,19.7,1.9,29.4.9.4-2.8-1.2-5.5-1.8-8.3-.8-3.4,0-7.2-1.4-10.5-.2-.4-.4-.8-.8-1.1-.3-.2-.6-.3-1-.4-6.5-1.8-13.3-1.8-20-1.6-3.4,0-6.8.1-10.1,0-1.6,0-3.3-.2-4.9-.4-.8-.1-1.6-.2-2.4-.4-.6-.1-1.2-.5-1.8-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M-139.2,182.8c.3-.2.7-.4,1.1-.7.2.6.3,1.3.5,2-.2,3.9-.4,7.9-.6,11.8.2.7.4,1.5.6,2.2-.2,2.3-.5,4.6-.7,6.9,0,.9,0,1.8.3,2.7.4,2.2-2.1,1.8-3.5,1.8,0-4.3,0-8.5,0-12.8,0-1.6,0-3.1.2-4.6.2-1.4.5-2.9.5-4.3,0-.9,0-1.8,0-2.7.2-1.1.8-1.7,1.5-2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M-18.3,237.6c0-.8,0-42.1,0-42.9,0-9.6,0-19.1,0-28.7,0-.4,0-.7,0-1.1h.3c0,.4,0,.9,0,1.3,0,2.9,0,5.8,0,8.7,0,.9.2,1.8.2,2.8.2,4.2.4,8.3.5,12.5,0,1.4.4,44.5.1,46.8-.2,1.4-1.2.5-1.3.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M-41.4,175.8c0-.4-.2-.7-.3-1.1,0-5.1,0-10.1,0-15.1,0-.4.2-.8.3-1.1,0,2.8.1,5.7.1,8.5,0,2.5,0,5.1,0,7.6,0,.4-.2.8-.2,1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M-41.4,153.3c0-.3-.2-.6-.2-.9,0-4.5,0-9.1,0-13.6,0-.3.2-.6.2-.9,0,.3.2.6.2,1,0,4.6,0,9.2,0,13.7,0,.3-.1.6-.2.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M-41.4,155.6v-1.3,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M-21.9,203.3c0-1.3,0-2.5,0-3.8,0-1.8-.2-3.6-.2-5.4,0-.9.4-1.7.6-2.6,0-.3.2-.8,0-1-.8-1.4-.4-3-.4-4.4,0-2.8.3-5.6.5-8.5,0-.2,0-.4.3-.6.2.7.3,1.5.4,2.2,0,6.7.2,13.4.2,20.1,0,.5,0,.9-.2,1.4-.4.9-.9,1.7-1.3,2.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M-63.4,175.6c.4,0,.9,0,1.3,0-.4.5-.8.9-1.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M-70.3,186.4c.3,0,.6.2.8.3-.3,0-.6-.2-.8-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M-69,186.7l.5.3-.5-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M64.5,124.3c-.7,0-1.4.1-2.4.2.6.7.9,1.1,1.3,1.6-1.7-.7-3.1-1.8-4.3-3.1.2,0,.5,0,.6,0,1.4,1.2,2.9,1,4.5.6.5-.1.9-.4,1.1.4h0c-.3,0-.5.2-.8.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M59.1,123c-.6-.5-1.2-1-1.8-1.5.9.2,1.6.6,1.8,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M57.1,121.1c0,0-.2-.2-.3-.3,0,0,.2.2.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M57.3,121.4c0,0-.2-.2-.2-.3,0,0,.2.2.2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M64.5,124.3c.3,0,.5-.2.8-.3-.1.5-.4.7-.8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M-68,167c-.3,0-.5-.2-.8-.2.3,0,.5.2.8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M-68.3,175.7c-.6-.4-1.2-.8-1.8-1.2.7.3,1.5.3,1.8,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M-66.8,176.5c0,0-.1.2-.2.2,0-.1,0-.3-.1-.4.1,0,.2,0,.3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M303.2,3.1v4.2c-.2-1.1-.4-2.3-.5-3v-.2c0-.3,0-.6.1-.9h.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M-25.2,436.3h-23.6c-.2-.2-.5-.4-.7-.5-1.3-.3-2.6-.4-3.9-.7-3.8-.8-7.6-1.6-11.3-2.5-3.4-.8-6.8-1.8-10.2-2.8-1.4-.4-2.4-1.3-2.7-2.8,0-.3-.2-.7-.4-.9-1.9-1.7-3.7-3.4-5.7-4.9-1.1-.9-2.4-1.5-4-1.5-2.7,0-5.3-.3-8-.5-1.9-.2-4-.2-5.8-.8-5.3-1.9-10-4.7-13-9.8-.9-1.5-2.1-2.9-3.8-3.6-.3-.7-.7-1.3-.7-2,0-1.8.3-3.6,2.1-4.6.4-.2.6-.6.9-.9,1.4.7,2.7,1.3,4.1,2,.3.1.6.3.9.4,6.2,1.9,12.4,3.8,18.6,5.7,2.9,1,5.8,2.1,8.8,3.1,2,.6,4,1.1,6,1.7.1,0,.2,0,.3,0,0,0,4,1.6,5.9,2.3.3.2.5.3.8.5-.3,1.8-.6,3.7-.9,5.6-.2.9-.2,1.9-.4,3.2,2.1-.8,3.9-1.4,5.7-2.1.2,0,.5-.4.4-.5-.2-.9-.2-2-.6-2.8-.5-.9-.7-1.7-.3-2.7,2.3.3,4.5.7,6.8,1,.2,0,.5.1.7.2,0,0,0,0,.1,0,1.4.3,2.9.6,4.3,1,3.3.9,6.6,1.9,9.9,2.8-.1.2-.2.5-.4.7-1.1.9-2.2,1.7-3.3,2.6-.3.3-.4.8-.7,1.3.4.2.8.4,1.2.5,2.1.4,4.2.7,6.4,1,1.4.2,2.8,1,4.3.3.3.3.6.5,1,.8,1.3,1,2.8,1.8,3.9,3,1.5,1.6,2.9,3,5.2,3.3,1.4.2,3.1-.3,4.3,1-.9.4-1.8.8-2.7,1.2,0,0,0,.2,0,.3.7,0,1.4,0,2.2.1-.3.3-.6.5-.8.7-.4.2-.8.3-1.2.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M-116,397.5c-.3.3-.5.7-.9.9-1.8,1-2.2,2.7-2.1,4.6,0,.7.5,1.3.7,2-.5.7-1,1.5-1.5,2.2-1.4,1.7-2.5,3.5-1.3,5.9.1.3.2.6.2.9,0,2.5,1.8,3.7,3.6,4.6,1.2.6,2.5.8,3.8,1.3,4.1,1.7,8.2,3.5,12.4,5.1,1.3.5,2.8.8,4.2,1.2.7.2,1.5.4,2.1.8,1.8.9,3.3,2.2,5.5,2.4,1.4,0,2.8.3,4.2.5,3.1.5,6.2,1,9.3,1.5,2.8.5,5.6.9,8.4,1.4,4.5.9,9.1,1.8,13.6,2.7.5.1.9.5,1.3.8h-7.4c-.2-.2-.5-.4-.7-.5-2.6-.6-5.1-1.3-7.7-1.8-2.7-.5-5.4-.9-8.1-1.4,0,0-.2,0-.4,0,.2.2.5.3.7.4,0,0,0,.2,0,.3-3.7,0-7.5.1-11.2,0-3.7-.1-7.3-.5-11-.8,2.2.6,4.5,1.1,6.8,1.3,3.5.3,7,.4,10.4.6,1,0,1.9.8,2.1,1.8h-17.7c0-.1-.1-.4-.2-.4-2.6-.9-5.3-1.8-7.9-2.8-3-1.1-6-2.3-9-3.6-1.2-.5-3.4-2.1-3.3-2.2-.1,0-.8-.6-1.1-.7-.9-.5-1.9-.9-2.9-1.4-1.6-.9-3.2-1.7-4.8-2.7-.5-.3-3-1-3.5-1.4,0-6.7,1-12.9,1-19.7,1.2-.6,3.5-1.4,4.6-2,1.8-.6,3.5-1.2,5.3-1.7.9-.2,1.8-.3,2.7-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M-52.7,436.3c-.4-.3-.8-.7-1.3-.8-4.5-.9-9.1-1.9-13.6-2.7-2.8-.5-5.6-1-8.4-1.4-3.1-.5-6.2-1-9.3-1.5-1.4-.2-2.8-.5-4.2-.5-2.1-.1-3.7-1.5-5.5-2.4-.7-.3-1.4-.6-2.1-.8-1.4-.4-2.8-.7-4.2-1.2-4.1-1.7-8.2-3.4-12.4-5.1-1.2-.5-2.6-.7-3.8-1.3-1.8-1-3.6-2.1-3.6-4.6,0-.3-.1-.6-.2-.9-1.2-2.3,0-4.1,1.3-5.9.5-.7,1-1.5,1.5-2.2,1.7.7,2.9,2.1,3.8,3.6,3,5,7.7,7.9,13,9.8,1.8.6,3.8.6,5.8.8,2.7.2,5.3.4,8,.5,1.5,0,2.8.6,4,1.5,2,1.6,3.8,3.3,5.7,4.9.2.2.3.6.4.9.3,1.5,1.3,2.4,2.7,2.8,3.4,1,6.8,2,10.2,2.8,3.7.9,7.5,1.7,11.3,2.5,1.3.3,2.6.4,3.9.7.3,0,.5.3.7.5h-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M44.6,370h0s0,0,0,0c0,0,0,0,0,0ZM-54.5,379.3h0s0,0,0,0h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M27.4,346.1c.7.7,1.3,1.4,2,2.1,1.6,2.4,3.3,4.7,4.9,7.1,1.4,2.1,2.9,4.1,4.4,6.2.2,1.1-.2,1.9-1.2,2.4-2.5,1.2-5,2.4-7.5,3.6-2-.3-4.1-.6-6.1-.8-3.1-.3-6.1-.4-9.2-.8-2-.2-4-1-6.1-.9-6.7,0-13.5.4-20.2.6-.8,0-1.5.1-2.3.2-1,0-1.9-.2-2.9-.3-1.2,0-2.4,0-3.6,0-4.8-.3-9.7-.6-13.9-2.6,1.5-1.2,3.2-2.4,4.5-3.9,1-1.2,2.1-2.1,3.4-2.9.5-.3,1-.5,1.4-.9,1.4-1.3,3.1-2.1,5-2.5,4.9-1,9.8-2,14.6-2.9,2-.4,4-.5,6-.7.3,0,.6-.4,1-.6h.2c.4.9,1.1.3,1.7.4,2.5,0,5,0,7.6,0,5.4-.1,10.7-.7,16,.8.3,0,.6,0,.9,0,0-.1,0-.3,0-.4-2-.3-4-.8-6-.9-3.1-.2-6.2-.2-9.3-.3,2.2-1.1,4.6-1.1,7-1.3.5,0,1.1.2,1.6.3,2,.5,4.1,1.2,5.8-.7,0,0,.1,0,.2-.1h0ZM-6,356.2c0,.2,0,.3,0,.5.4,0,.9,0,1.3,0,1.5,0,3,.2,4.5.3,5.3.3,10.6.6,15.9,1,2,.2,3.9.6,5.9.9,0,.1,0,.3,0,.4-.6.2-1.3.3-1.9.5s-1.4.5-1.1,1.3c.1.3,1,.6,1.5.5.6,0,1.2-.4,1.7-.8.7-.5,1.3-1.2,2.1-2-1.3-.4-2.5-.9-3.8-1-4.2-.4-8.3-.5-12.5-.8-1.8-.1-3.6-.3-5.3-.4-2.7-.2-5.4-.3-8.1-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M-129.4,393.5c0-4.3.2-8.8.2-13.1,4.8,0,11.3,0,16.1.2,4.5.2,9.1.6,13.6.9.1,0,.2.1.3.2,0,0,.2,0,.2,0,1.7.5,3.4,1,5.1,1.5.1,0,.2,0,.3.1-.1,0-.2,0-.3-.1-1.1-.6-2.1-1.2-3.2-1.8-.6-.3-1.3-.5-1.9-.8-1.4-.3-2.8-.7-4.2-.8-2.7-.1-5.4,0-8-.1-4.5-.2-8.9-.6-13.3-1-.5,0-1-.4-1.4-.7-.6-.5-2.7-1.2-3.3-1.7v-6.4c.8,0,3.1.2,3.9.3,5.9,0,11.3,1.9,16.7,4.2.5.2,1,.2,1.5.3.8.4,1.7.7,2.5,1.1,1.1,1.1,2.3,2.2,3.7,2.8,0,0,.1-.1.2-.2-.2-.3-.3-.6-.5-.8.2-.2.5-.3.8-.5,1.7,1.4,3,3.3,5.1,4.2,2.5,1.2,5,2.3,7.5,3.5.9.4,1.7.9,2.6,1.4-1.4,2.2-2.8,1.4-4.3.4v.4c.5.5,1.1,1,1.7,1.5.2,0,.3.2.5.2,0,0,.1,0,.2,0,0,0,.2.1.3.2.4.2.8.4,1.3.6.3.2.6.4.9.5,2.5,1,4.9,2.1,7.4,3.1v3.3c0,0,.3.2.5.4-5.4.9-10.8,1.7-16.2,2.6-3,.5-5.9,1.1-8.9,1.6-1.5.5-2.8.2-4.2-.3-1.7-.5-3.3-1-5-1.5-2.5-1.1-5-2.1-7.4-3.2-.3-.1-.5-.4-.8-.6,2.4-.8,4.8-1.6,7.1-2.4v-.6c-.7,0-1.2,0-1.8.2-2.2.6-4.3,1.3-6.5,2-.3,0-.6.1-.9,0-2-.9-5.9-1-8-1.1h0ZM-113.9,386.2l-6.7-3.6c0,.2-.2.3-.2.5,1.9,1.5,4.1,2.6,6.4,3.4,3.2,1.1,6.4,2.2,9.7,3.3,1,.3,2.1.6,3.2.8.3,0,.6-.1.9-.2-4.5-1.4-8.9-2.8-13.3-4.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M-7,325.9c-.3.4-.6.8-1,1.1-.8.6-.7,1.3-.2,2,.1.1.2.2.4.4.4.5,1.2,1,.6,1.6-.4.5-1.3.7-2,.8-.6.1-1.3-.1-2-.2-2.1-1.3-4.4-1.7-6.8-2.1-2.2-.3-4.2.3-6.2,1.1-3.3.2-6.6.5-9.9.7,1.1-2.3.4-4.5-.8-6.7,2.4-.9,4.8-1.6,6.6-3.4,0-.2,0-.3-.2-.5-.4,0-.9.1-1.3.3-1,.4-2,1-3,1.4-1.1.4-2.3.5-3.5,0-.9-.4-1.8-.6-3-1,.8-.4,1.3-.8,1.8-1.1,1.9-.9,3.3-2.2,4.5-3.9.8-1.2.8-1.1,2.3-.6,2.2.7,4.5,1.3,6.7,1.8.4,0,.8-.2,1.2-.4,0-.1,0-.3,0-.4-1.1-.3-2.1-.6-3.2-.9-1.9-.6-3.8-1.2-5.7-1.9-.3,0-.5-.4-.6-.7,0-.2.3-.5.5-.6.2-.1.5-.2.7-.2,4.9-.3,9.8-.6,14.6.4.3,0,.6,0,.9,0,1.7-.4,3.4-.8,5.1-1.1,2.6-.4,5.1-.8,7.7-1.2,1.6-.3,3.1-.6,4.7-.9,1.1-.2,2.3-.3,3.4-.4.2.4.5.7.7,1.1,1.4,3,2.9,6,4.3,8.9,1.2,2.5,2.4,4.9,3.6,7.4-.4.2-.7.3-1,.4-2.2-.1-4.5-.2-6.7-.5-2.8-.3-5.6-.9-8.4-1.3-2.3-.3-4.6-.5-6.8-.8-2-.3-4.1-.6-6.1-1,.3.4.7.7,1.2.8,2.2.5,4.4,1,6.6,1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M-28.5,292.1c3.6-.9,7.2-1.7,10.7-2.8,3.8-1.3,7.6-2.9,11.3-4.4.4-.2.8-.5,1.2-.7.7,1.9,1.3,3.9,2.1,5.8,1.1,2.8,2.4,5.7,3.6,8.5-1-.3-1.8-.2-1.9,1.2,0,.2-.4.5-.7.6-.6.2-1.2.2-1.8.3-1.5,0-3,0-4.5,0-.8,0-1.5.2-2.3.2-3.3,0-6.7.1-10,0-2.9-.2-5.9-.5-8.8-1-1.7-.3-3.3-1.1-4.9-1.7s-3.2-1.2-4.8-1.9c-.6-.3-1.1-.7-1.7-1.1,0-.2,0-.3,0-.5,1.3-.3,2.7-.8,4-1,2.8-.4,5.6-.7,8.4-1.1,0,0,.1-.1.1-.2,0,0-.1-.1-.2-.2h0ZM-4.7,298.7c1.5-.3,2.4-1.2,3.1-2.2.4-.5,0-1-.6-1.1-.7,0-1.4,0-2-.3-.9-.3-1.7-.1-2.1.6-.3.4-.5,1.3-.2,1.6.4.6,1.2.8,1.9,1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M-3.9,300.5c.6,0,1.2-.1,1.8-.3.3,0,.7-.4.7-.6,0-1.4.8-1.4,1.9-1.2,1.5,3.1,2.9,6.2,4.4,9.3-2.7.7-5.3,1.2-8.1-.3-1.5-.8-3.4-.8-5.2-1.1-.4,0-1.3-.1-1.3,1.1,2.9.6,5.8,1.2,8.8,1.8h0c-.3.2-.5.3-.8.3-2.9-.2-5.8.3-8.6.8-.8.2-1.6.7-2.4,1.1-1.1.5-2.1.7-3.2,0-.7-.3-1.4-.6-2.2-.6-2.5,0-5,.1-7.5.1-2.5,0-4.9,0-7.5,0-.4-1.5-.9-2.9-1.4-4.6,1.4-.7,2.9-1.5,4.5-2,.8-.3,1.3-.8,1.5-1.5.4-1.1,1-1.4,2.1-1.4,4.5.1,9,.1,13.6.3,3.1.1,6.1-.3,9-1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M-121.9,362.7c.2-.3.5-.5.7-.8.5-.2,1.1-.6,1.5-.5,2.4.5,4.8,1.2,7.2,1.8,0,0,.1,0,.2,0,.2,0,.4.1.5.2.2,0,.3,0,.5,0-1.5,1.7-1.6,2-.5,4.1.1.2.2.5.2.7.4,1.2.7,2.5,1.1,3.7-2.4-.6-4.8-1.4-7.3-1.8-3.3-.5-8.2-.6-11.5-1,0-1.5,0-3,0-4.5,2-.3,5.7-.6,7.3-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M-98.8,381.6c0,0-.2,0-.2,0-.1,0-.2-.1-.3-.2-4.5-.3-9.1-.7-13.6-.9-4.8-.2-11.3-.2-16.1-.2,0-1.3,0-2.6,0-3.9.6.5,2.2.5,2.8,1,.4.3,1.4,1.3,1.9,1.3,4.4.4,8.9.8,13.3,1,2.7.2,5.4,0,8,.1,1.4,0,2.8.5,4.2.8v1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M-129.1,369.1c3.3.4,8.2.7,11.5,1.2,2.5.4,4.9,1.2,7.3,1.8.6.2,1.2.4,1.8.5.4,0,.9,0,1.3-.2,1.3-.5,2.6-1.3,3.9-1.4,2.6-.1,5.3.2,7.9.3,0,0,0,.2,0,.3-1.7,0-3.4,0-5.2.1-2.4.3-4.8.6-6.4,2.8-.5,0-1,0-1.5-.3-5.3-2.3-10.8-4.1-16.7-4.2-.8,0-3.1,0-3.9-.1v-.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M-34.5,332.4c-.3.5-.5,1.1-.8,1.5-1.2,1.2-2.4,2.3-3.8,3.6,1.4.7,2.8,1.7,4.3,2.1,4.3,1.1,8.6,1.9,12.9,2.9.7.2,1.4.3,2.2.4,0,0,0,.2,0,.3-.9,0-1.8.2-2.6,0-6.6-1.7-13.5-2.1-19.6-6.3.5-.1,1.1-.5,1.4-.3,1,.4,1.6,0,2.1-.7.8-1,1.5-2.1,2.2-3.2.2-.2.4-.4.6-.6,0,.2,0,.5.2.8.3-.2.6-.3.8-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M-112.2,392.9c-2.4.8-4.8,1.6-7.1,2.4-.2,0-.5.2-.7.3-.5,0-1-.1-1.5-.2-2,.9-5.7,2.6-7.7,3.6,0-.8,0-2.5,0-3.3,0-.8,0-1.6,0-2.5,2.1.1,6.1.5,8.1,1.4.2.1.6,0,.9,0,2.1-.6,4.3-1.3,6.5-2,.5-.2,1.1-.1,1.6-.2,0,.2,0,.4.1.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M-123.9,399.6c-1.2.6-3.6,1.9-4.8,2.5,0-.6-.4-1.3-.4-1.9.5-.3,2.6-1.2,3.1-1.4,1.9-1.3,3.7-2.5,6-2.7,1,.5,0,.7-.2.8-1.3.8-2.9,1.2-3.7,2.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M-129.2,364c0-1.5-.2-3.5-.2-5,1.6.6,5.2,1,6.2,2.6-.2.3-.3.7-.5.8-1.3.4-4.2,1.3-5.5,1.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M-95,353.9c-.3-.2-.7-.4-1-.6,0,0,0-.2,0-.2,1.6-.2,3.2-.5,4.8-.7,1.9-.2,3.8-.3,5.7-.5.2,0,.5-.2.7-.3,1.2.2,2.5.1,3.3,1.3-2.6,0-5.3,0-7.9,0-1.7,0-3.4.3-5,.5-.2,0-.4.4-.7.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M-112.4,363.2c-2.4-.6-4.8-1.3-7.2-1.8-.5,0-1,.3-1.5.5-.4-.6-.7-1.2-1.1-1.7,3.4-.2,6.5.7,9.5,2,0,.3.2.7.2,1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M-129.2,364c1.3-.3,4.2-1.2,5.5-1.6.2,0,.4-.5.5-.8.4.4.9.7,1.3,1.1-1.6,1.4-5.3,2.1-7.3,2.4v-1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M-129.3,399c2-.9,5.7-2.6,7.7-3.6.5,0,1,.1,1.5.2v.4c-2.3.2-4.2,1.5-6,2.7-.4.3-2.6,1.2-3.1,1.4,0-.5-.1-.8-.1-1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M-34.1,331.3c3.3-.2,6.6-.5,9.9-.7v.3c-1.6.3-3.2.7-4.8.9-1.8.2-3.6.2-5.4.3.1-.3.3-.5.4-.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M-66.8,413.9c-.4.9-.2,1.7.3,2.7.4.8.5,1.8.6,2.8,0,.2-.2.5-.4.5-1.8.7-3.6,1.3-5.7,2.1.2-1.3.2-2.2.4-3.2.3-1.9.6-3.7.9-5.6,1.3.2,2.6.5,3.9.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M-111.1,399.2c1.7.5,3.3.9,5,1.5,1.4.5,2.8.8,4.2.3.3.2.5.5.8.7.3.2.5.5.9.6,2.6,1,5.2,2,7.8,3,0,.1,0,.2,0,.4-6.2-1.9-12.4-3.8-18.6-5.7-.3-.1-.6-.3-.9-.4.3-.1.5-.2.8-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M-111.1,399.2c-.3.1-.5.2-.8.3-1.4-.7-2.7-1.3-4.1-2-.9.2-1.8.2-2.7.5-1.8.5-3.5,1.1-5.3,1.7.8-1.5,2.4-2,3.7-2.7.3-.2,1.2-.3.2-.8v-.4c.2,0,.5-.2.7-.3.3.2.5.5.8.6,2.5,1.1,5,2.2,7.4,3.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M-92.4,405.6c0-.1,0-.2,0-.4.9.3,1.8.5,2.6.8,1.8.5,3.5,1,5.3,1.5.3.2.6.3.9.5.3,0,.6,0,.9,0,1,.4,2,.9,3,1.3.7.3,1.4.6,2.2.9-2-.6-4-1-6-1.7-3-1-5.8-2.1-8.8-3.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M-66.8,413.9c-1.3-.2-2.6-.5-3.9-.7-.3-.2-.5-.3-.8-.5,2.4.4,4.7.8,7.1,1.2,1.4.3,2.9.6,4.3,1-2.3-.3-4.5-.7-6.8-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M-59.3,415.2h.1c0,0-.1,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M1.8,348.5h-.2c-1.9.1-3.9.2-5.8.4-1.9.2-3.8.5-5.6.8.1-.3.3-.6.5-.9-1.9-.5-3.7-.7-5.5-.1-2.1.7-4,.9-5.9-.5,0-.4.1-.8.2-1.2,2-1,3.8-2.5,6.2-2.6,2-.1,4-.2,6-.3,2.2-.2,4.5-.2,6.7-.6,5.2-.9,10.3-2.1,15.5-3.1,2.8-.6,5.7-1,8.5-1.4.2,0,.5,0,.6.2,1.7,2.2,3.4,4.5,4.4,7.1,0,0-.2,0-.2.1-1.8,1.9-3.8,1.2-5.8.7-.5-.1-1.1-.3-1.6-.3-2.4.2-4.8.2-7,1.3-3.1.1-6.2.2-9.2.3-.6,0-1.1.1-1.6.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M22.3,338.8c-2.9.5-5.7.9-8.5,1.4-5.2,1-10.3,2.2-15.5,3.1-2.2.4-4.5.4-6.7.6-2,.1-4,.2-6,.3-2.3.2-4.2,1.6-6.2,2.6-.4.2-.8.3-1.3.5,0-.2,0-.4,0-.6,1-.5,1.9-.9,2.9-1.4,1.3-.7,1.4-1.1.3-2.1,0,0-.1-.2-.3-.5.4,0,.8-.1,1.1-.1,2.7,0,5.5,0,8.2,0,4.8-.1,9.5-.5,14.2-1.5,3.9-.8,7.8-1.8,11.6-2.8,1.1-.3,2.3-.6,2.7-1.9.2-.5.2-1.1.3-1.6.8.7,1.5,1.5,2.2,2.3.4.5.6,1.1.9,1.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M-54.5,379.2c.5,1.1,1.5,1.4,2.6,1.6.8.1,1.5.2,1.8,1.1-2.6,0-5.1,0-7.7.2-3.7.3-7.4.7-11.1,1.1-3.9.4-7.9.7-11.8,1.3-2.2.4-4.3.5-6.2-.9-.4-.3-.9-.4-1.3-.5-4.2-1.2-7.8-3.4-11.1-6.2-.3-.3-.5-.6-1-1.1,3.1-.2,5.9-.3,8.6-.5,2.7-.1,5.4-.4,8-.4,2.8,0,5.6,0,8.4.2,1.7.2,3.4.9,5.1,1.3,5.5,1,11,1.9,16.6,1.5-.9.3-1.8.5-2.7.7-3,.7-5.9,1.4-8.9,2.1,0,0,0,.2,0,.3,1.2-.2,2.5-.3,3.7-.5,2.3-.4,4.5-.9,6.8-1.4h0ZM-69.4,382c0-.2,0-.3,0-.4-5.4.1-10.8.2-16.2.4,0,.1,0,.2,0,.3.3.2.6.5.8.5,5.2-.2,10.3-.5,15.5-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M-53.4,378c-5.6.3-11.1-.5-16.6-1.5-1.7-.3-3.4-1.1-5.1-1.3-2.8-.3-5.6-.3-8.4-.2-2.7,0-5.4.3-8,.4-2.8.2-5.5.3-8.6.5.5.5.8.8,1,1.1,3.3,2.8,6.9,5,11.1,6.2.5.1.9.3,1.3.5,1.9,1.4,3.9,1.2,6.2.9,3.9-.7,7.9-.9,11.8-1.3,3.7-.4,7.4-.9,11.1-1.1,2.6-.2,5.1-.1,7.7-.2,2.5.7,4.9,1.5,7.4,2.2,0,.2-.2.4-.2.5-.2,0-.5-.1-.8-.2-.2,0-.4-.1-.6-.2-.1,0-.3,0-.4,0-.2,0-.4-.1-.6-.2,0,0-.1,0-.2,0-.2,0-.4-.1-.6-.2-.5,0-.9-.2-1.4-.2-2.2-.2-4.5-.8-6.7-.7-7,.4-14,1.1-21,1.7-1.7.1-3.3.4-5,.4-2.2,0-3.6,1.6-5.1,2.9-.2,0-.4,0-.7.1.3.4.6.6.8.9,0,0-.2.3-.3.5-.4-.2-.8-.4-1.3-.6,0,0-.2-.1-.3-.2,0,0-.1,0-.2,0-.2,0-.3-.2-.5-.2-.6-.5-1.2-1-1.8-1.5v-.4c1.6,1,3.1,1.8,4.5-.4-.9-.5-1.7-1-2.6-1.4-2.5-1.2-5-2.4-7.5-3.5-2.1-.9-3.4-2.8-5.1-4.2-.8-1.8-.4-2.4,1.5-2.6,1-.1,2-.3,3.1-.5,0,0,0-.2.1-.3.6-.2,1.1-.3,1.7-.5.2,1,1,1,1.8,1,4.4,0,8.8-.1,13.2-.3,3-.1,5.7.7,8.6,1.2,4.7.8,9.4,1.5,14.1,2.1,1,.1,2.1-.3,3.1-.4.2,0,.3-.1.5-.2.5-.2,1.1-.5,1.6-.7-.3,1.3-1.5,1.4-2.3,1.9,0,0,0,.2,0,.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M-53.4,377.8c.8-.6,2.1-.7,2.3-1.9.4-.3.8-.7,1.4-1.1-1.2-.8-2.4-1.6-3.7-2.5,0-.1,0-.2,0-.4.4.1.8.2,1.1.4.8.4,1.6.8,2.4,1.2,1.5.7,3,.6,4.5,0,3.6-1.6,7.5-2.3,11.4-2.7,3.1-.3,6.3-.7,9.4-.7,3.6,0,7.1.6,10.7,1,4.2.6,8.4,1.3,12.6,2,1.6.3,3.2.7,4.9,1,0,.2-.2.3-.3.5-2.6-.4-5.2-.8-7.8-1.2-6.5-.9-13.1-2-19.6-2.6-2.6-.3-5.2,0-7.8.4-3.8.5-7.6,1.3-11.4,2-1.8.4-3.4,1.3-4.9,2.4-1.8,1.3-3.9,2.3-5.9,3.4,0,0-.2.1-.2.2h0c-2.3.4-4.5.9-6.8,1.3-1.2.2-2.5.3-3.7.5,0,0,0-.2,0-.3,3-.7,5.9-1.4,8.9-2.1.9-.2,1.8-.5,2.7-.7h0c.2,0,.4,0,.6,0h0c-.2-.1-.4-.2-.6-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M8.9,387c-2.4.8-4.8,1.5-6.8,3.1-1,.8-1.9,1.8-2.9,2.8,3.2,2.1,6.4,3.1,10.2,3.9.9.2,1.9.4,2.8.5,3.9.7,7.8,1.4,11.7,2.1-1.2.4-2.3.8-3.5,1.2-.4.2-.9.3-1.4.3-.6,0-1.1-.1-1.7-.3-2.5-.7-5.1-1.4-7.6-2.1-2.3-.6-4.6-1-6.8-2.1-1.9-1-3.7-2.1-5.5-3.2-.1-.3-.3-.6-.4-.9-.3-.2-.6-.3-.9-.5.1-.2.2-.4.3-.6.7.5,1.3.4,1.8-.3,2.2-3.1,5.4-4.2,8.9-5,.3.2.6.5.9.7.2.2.4.3.6.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M29.9,367.4c.2.5.5.9.8,1.4h-.9c-1.1-.3-2.3-.6-3.4-.9-.2,0-.4,0-.5,0-3-.8-6.1-1.1-9.2-1.1s-1.9-.2-2.8-.3c-3.1-.3-6.1-.8-9.1-.9-3.1-.1-6.2.2-9.3.3-.9,0-1.9,0-2.8.1-1.4,0-2.7,0-4.1,0,0-.2,0-.4,0-.6,6.7-.2,13.5-.5,20.2-.6,2,0,4,.7,6.1.9,3.1.3,6.1.5,9.2.8,2,.2,4.1.5,6.1.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M3.2,374.6c0-.2.2-.3.3-.5h0c.8-.3,1.5-.5,2.3-.8-.6-1-1.1-1.8-1.5-2.6-3.7-.9-7.4-1.8-11.1-2.6-1.9-.4-3.7-.9-5.6-1.3,0-.2,0-.3,0-.5h0c4.9.9,9.8,1.9,14.6,3,1.6.3,3,1.1,4.6,1.5,1.5.3,3,.3,4.6.5.1,0,.2,0,.3,0,1.2-.1,2.4-.2,3.6-.3,0,0,.2,0,.3-.1.5,0,1-.1,1.5-.2,0,.2,0,.3,0,.5-.5,0-1,.2-1.5.3,0,0-.2,0-.3,0-2.1.3-4.2.3-6.2.9-1.4.4-2.6,1.5-3.8,2.3-.1,0,0,.5,0,.7-.3,0-.6,0-.8,0-.3-.2-.6-.4-.8-.6,0,0-.2-.1-.3-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M-3.4,391.1c-.1.2-.2.4-.3.6-2.5-.7-5-1.6-7.6-2.2-1.7-.4-3.5-.5-5.3-.7-1.4-.2-2.8-.4-4.1-.5-2.5-.3-5-.6-7.5-.9-1.5-.2-2.9-.4-4.4-.6-1-.2-2.1-.3-3.1-.5-1.6-.3-3.1-.7-4.7-1.1-.9-.2-1.7-.4-2.6-.6,0-.2.2-.4.2-.5,4.7.8,9.3,1.6,13.9,2.4,4.5.7,8.9,1.2,13.4,1.9,3.8.6,7.6.9,11.2,2.3.3.1.5.3.8.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M-54.5,379.3c0,0,.2-.1.2-.2,0,0-.2.1-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M-12.4,366.4c0,.2,0,.3,0,.5-.3,0-.5,0-.8,0-.2,0-.4-.1-.5-.1-.4,0-.8,0-1.2,0-.3,0-.6-.1-.8-.2-2.6-.1-5.1-.2-7.7-.3-4.2-.1-8.2-1.1-12.2-2.4-1.6-.5-3.4-.6-5-1-2.2-.6-4.1.3-6.1,1.1-.7.3-1.4.3-2.1.5,0-.1,0-.2,0-.3.9-.6,1.9-1.2,2.8-1.9-.9-1.5-2.6-1.3-3.7-2,.2-.3.3-.6.5-.8,1.5.5,3,1.1,4.5,1.4,2.6.5,5.1.8,7.7,1,1.8.1,3.5-.8,4.8-2.1,1.2-1.2,2.4-2.3,3.6-3.5.2-.2.5-.6.5-.9-.1-1.8-.3-3.6-.5-5.3-2.5.1-5.1.2-7.7.4-4.4.4-8.7-.2-12.9-1.2-1.9-.5-3.8-1-5.7-1.4.2-.4.3-.8.5-1.3.8.2,1.8.1,2.4.5,2.8,1.7,5.9,2,9,2.3,6.4.7,12.7-.1,18.9-1.8.7-.2,1.5-.4,2.2-.6,0,.2,0,.4,0,.6-.2,0-.5.2-.7.3-.1,0-.2.1-.3.2-1.2.4-2.3.8-3.5,1.3-.3.1-.8.4-.8.6,0,1.4-.3,2.9.3,4.2,2.9-1,5.6-2.2,8.4-2.9,2.8-.7,5.8-1,8.7-1.4,1.9-.3,3.8-.6,5.6-.8,1.9-.2,3.9-.3,5.8-.4-.3.2-.6.5-1,.6-2,.3-4,.4-6,.7-4.9.9-9.8,1.8-14.6,2.9-1.8.4-3.6,1.2-5,2.5-.4.4-.9.6-1.4.9-1.3.8-2.4,1.7-3.4,2.9-1.3,1.5-3.1,2.6-4.5,3.9,4.3,2,9.1,2.3,13.9,2.6,1.2,0,2.4,0,3.6,0,1,0,1.9.2,2.9.3.5.2,1,.5,1.5.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M-6,356.2c2.7.1,5.4.2,8.1.4,1.8.1,3.6.3,5.3.4,4.2.3,8.4.5,12.5.8,1.3.1,2.5.6,3.8,1-.8.8-1.4,1.5-2.1,2-.5.4-1.1.7-1.7.8-.5,0-1.4-.2-1.5-.5-.3-.7.4-1.1,1.1-1.3s1.3-.4,1.9-.5c0-.1,0-.3,0-.4-2-.3-3.9-.7-5.9-.9-5.3-.4-10.6-.7-15.9-1-1.5,0-3-.2-4.5-.3-.4,0-.9,0-1.3,0,0-.2,0-.3,0-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M-12.4,366.4c-.5-.2-1-.5-1.5-.7.8,0,1.5-.1,2.3-.2,0,.2,0,.4,0,.6-.2.1-.5.2-.7.3h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M-16.8,365.4c-1.2,0-2.4,0-3.6,0,1.2,0,2.4,0,3.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M16.8,406.6c-.8,2.6-1.2,5.3-1.4,8,0,1.4,0,2.8.5,4.1.7,2,2.3,3.4,3.8,4.9,3.3,3.3,5.9,7.3,7.9,11.6.6,1.5,1.2,3.1.9,4.7-.4,1.9-2,3.3-3.8,4s-3.7.7-5.6.8c-7.8.2-15.6.3-23.4.3-7.6,0-15.1-.3-22.6-1.2-4.2-.6-8.4-1.4-12.3-2.9-5.4-2.1-10.1-5.5-15.4-8-4.7-2.1-9.7-3.5-14.2-5.9-4.7-2.5-8.8-6.3-11.8-10.7-1.5-2.2-2.5-4.6-3.6-7s-3-2.4-5.5-3.2c-.9-.3-1.8-.5-2.6-.8-2.6-1-5.2-2-7.8-3-.3-.1-.6-.4-.9-.6,1.2-.2,2.5-.5,3.8-.7,6.2-.9,12.4-2,18.6-2.7,4.3-.5,8.7-.5,13-.7,1.5.1,3.1.2,4.6.3,1.1,0,2.2.5,2.5,1.6.2.8.7,1.1,1.3,1.2,2,.3,4,.5,6,.7-2-.8-3.9-1.6-5.8-2.4.3,0,.6-.1.9-.2.3-.1.7-.2.9-.5.7-1,1.1-2.2,1.1-3.5,4.7,0,9.4-.2,14.1-.3.2,0,.3.2.4.2,2.6.3,5.2.6,7.8.7,4.8.3,9.6-.4,14.3-1.2,2.9-.5,5.7-.9,8.6-.4,0,0,0,0,0,.1-2.4,1.2-4.3,3-6,4.9-1.6,1.8-2.2,3.8-1.4,6.1.4,1.3,1.1,2.4,2.2,3.2-.2-1.8-.4-3.5-.5-5.2,0-1.3.3-2.5,1.4-3.3,1.9-1.3,3.9-2.5,5.8-3.7,1.8-.6,3.6-1.3,4.9-2.9,1.8,1.1,3.6,2.3,5.5,3.2,3.9,2,14.6,3.4,14.6,3.4-.1,0,4.6.2,4.3.2,0,0,0,0,0,0M-55,409.1h0s0,0,0,0c-2-1.2-4.3-1.1-6.4-1.6v.4c2.1.4,4.2.8,6.4,1.1ZM-24.4,406.8c0,0-.2-.1-.3-.2-4.4-1.3-8.7-2.6-13.1-3.8-.9-.3-1.9-.3-2.9-.4,0,.1,0,.2,0,.3.7.3,1.4.7,2.2.9,1.5.3,3,.4,4.5.7,1.2.3,2.4.8,3.7,1.1,2,.6,4.1,1.1,6.2,1.6.7.6,1.7.8,2.3.2.4-.4.2-1.4.3-2.2-1.5,0-1.9,1.1-2.6,1.7,0,0-.2,0-.2,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M13.3,327.2c1.6,0,1.8.2,2.2,1.8-3.6-.5-7.1-.9-10.7-1.4-3.4-.5-6.7-1-10.1-1.4-.6,0-1.2-.2-1.8-.3-2.2-.5-4.4-1-6.6-1.5-.4-.1-.8-.3-1.2-.8,2,.3,4,.7,6.1,1,2.3.3,4.6.5,6.8.8,2.8.4,5.6,1,8.4,1.3,2.2.3,4.5.3,6.7.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M-24.2,330.9v-.3c2-.7,4.1-1.4,6.2-1.1,2.4.3,4.7.8,6.8,2.1-1.2,0-2.3,0-3.5-.1-3.2-.5-6.3-.8-9.6-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M-6.7,340.4c-4.6-.5-9.3-.9-13.9-1.4,0-.1,0-.2,0-.3,4.7,0,9.4-.3,13.9,1.3,0,.1,0,.3,0,.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M-94,373.1c-.6.2-1.1.3-1.7.5,0-.6.1-1.3.2-1.9,0,0,0-.2,0-.3,0-1.3-.7-2.1-1.7-2.6-1-.6-2.2-1-3.3-1.4-1.2-.4-2.4-.7-3.5-1.1-2.4-.9-4.8-1.9-7.1-2.8-.2,0-.3,0-.5,0-.2,0-.4-.1-.5-.2,0,0-.2,0-.2,0,0-.3-.2-.7-.2-1,2.5.8,5,1.7,7.5,2.5.5.2.9.3,1.5.4,1.3-2.5,3.9-2.8,6-3.9,1.7-.9,3.5-1.5,5.2-2.2,0,0,.2.2.2.3,0-.5,0-1,0-1.5.1,0,.3,0,.4,0,1.4,0,2.9.2,4.2-.2,2.8-.7,5.5-.8,8.2,0,.2,0,.3.1.5.2,0,0,.1.1,0,0-1.7,0-3.7-.1-5.6,0-.9,0-1.8.6-2.7,1-1.7.8-3.4,1.8-5.5,1.3-.5-.1-1.2.2-1.7.5-2,1.1-3.9,2.3-5.8,3.5-.2.2-.4.5-.5.7-.3.3-.6.5-1,.8,3.3,1.3,6.5,2.7,9.7,4-1.4.8-1.7,2.2-2.2,3.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M-56.8,369.2c.8.6,1.5,1.1,2.3,1.7l-.2.4c-.3-.1-.6-.3-.9-.4-2.3-1.4-4.6-2.8-6.9-4.1-.5-.3-1.1-.4-1.7-.4-2.4,0-4.9,0-7.3,0-.1-.2-.3-.4-.4-.4-1.4,0-2.8,0-4.2.1-2.9,0-5.8,0-8.8,0,0,0-.2-.1-.3-.2-.8,0-1.7.1-2.5.1-.2,0-.3,0-.5,0h-.8c-.3,0-.5,0-.8,0-.1,0-.2,0-.3-.1h-.4c-.1,0-.2,0-.3,0-.6,0-1.2-.2-1.8-.2,0-.2,0-.3,0-.4,1,0,2,0,3,.1,0,0,.2,0,.3,0,1.6,0,3.2,0,4.7,0,4.8,0,9.7-.2,14.5-.3,1.3,0,2.6.2,3.8.3,1.2,0,2.5.4,2.6-1.6,1,.7,1.7,1.3,2.6,1.8.4.2.9.3,1.4.3,3.4,0,6.8,0,10.2,0,1.6,0,3.2.2,4.7.3,4.4.4,8.8.8,13.2,1.2-1.7.3-3.4.5-5.2,0-1.2-.4-2.6-.4-3.9-.5-3.9-.1-7.8-.2-11.7-.3-2,0-4.1,0-6.1,0-.2,0-.4.1-.7.2,0,1.5,1.2,1.7,2.1,2.3,0,0,0,.1.2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M-92.6,365.1c0,.2,0,.3,0,.4-2.7-.3-5.3-.6-8-.8.2-.2.4-.5.5-.7,1.3.3,2.6.6,3.9.8,1.2.2,2.3.2,3.5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M-91.7,357.8c-.1,0-.3,0-.4,0-1-1.3-1.9-2.6-2.9-3.9,1.1,1.3,2.2,2.6,3.3,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M-76.2,366c1.4,0,2.8-.1,4.2-.1.1,0,.3.3.4.4-1.5-.1-3.1-.2-4.6-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M-15.8,366.4l.8.2-.8-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M-88.3,366c.2,0,.3,0,.5,0-.2,0-.3,0-.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M-13.7,366.6c.2,0,.4.1.5.1-.2,0-.4-.1-.5-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M-52.7,376.5c-.2,0-.3.1-.5.2.2,0,.3-.1.5-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M-89.3,365.3c0,0-.2,0-.3,0,0,0,.2,0,.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M-90.9,365.8c.1,0,.2,0,.3,0-.1,0-.2,0-.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M-90.2,365.9c.1,0,.2,0,.3.1-.1,0-.2,0-.3-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M-89.1,366h.2-.1s-.1,0-.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M-85.3,365.8c0,0,.2.1.3.2,0,0-.2-.1-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M-56.8,369.2c0,0-.1,0-.2-.1,0,0,.1,0,.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M-53.4,371.9c0,.1,0,.2,0,.4,0-.1,0-.2,0-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M-54.2,394.9c0,1.3-.4,2.5-1.1,3.5-.2.3-.6.4-.9.5-.3.1-.6.1-.9.2-.9-.6-1.8-1.6-2.7-1.7-2.6-.4-5.3-.4-7.9-.6-.7-.1-1.3-.3-2-.3-2.3,0-4.7.2-7,.3-.2-.2-.4-.3-.5-.4v-3.3c.8.3,1.7.6,2.5.8,1.4.6,2.7,1.3,4.1,1.6,2.1.5,4.2.9,6.2-.2.6,0,1.1,0,1.7,0,2.9-.1,5.7-.3,8.6-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M-76.7,396.7c2.3-.1,4.7-.2,7-.3.7,0,1.3.2,2,.3.7.3,1.3.6,2,.9-4.3.2-8.7.2-13,.7-6.2.7-12.4,1.7-18.6,2.7-1.3.2-2.5.5-3.8.7-.3-.2-.5-.5-.8-.7,3-.5,5.9-1.1,8.9-1.6,5.4-.9,10.8-1.7,16.2-2.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M-95.8,373.8c-1,.2-2,.4-3.1.5-1.9.3-2.3.9-1.5,2.6-.2.2-.5.3-.8.5-.7-.5-1.4-1-2.1-1.5-.4-.2-.8-.2-1.3-.3-.8-.4-1.7-.7-2.5-1.1,1.6-2.2,4-2.5,6.4-2.8.2.7.5,1.5.6,2.1h4.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M-74.8,393.8c-.8-.3-1.7-.6-2.5-.8-2.5-1-4.9-2.1-7.4-3.1-.3-.1-.6-.3-.9-.5.1-.2.4-.4.3-.5-.2-.3-.5-.6-.8-.9.3,0,.5,0,.7-.1,2.4,1.3,4.9,2.6,7.3,3.9,1.2.6,2.6,1.2,3.8,1.7-.2.1-.4.3-.7.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M-113.9,386.2c4.4,1.4,8.8,2.8,13.3,4.2-.3,0-.7.3-.9.2-1.1-.2-2.2-.5-3.2-.8-3.2-1.1-6.5-2.2-9.7-3.3.2-.1.3-.2.5-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M-113.9,386.2c-.2.1-.3.2-.5.3-2.3-.9-4.5-1.9-6.4-3.4,0-.2.2-.3.2-.5,2.2,1.2,4.5,2.4,6.7,3.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M-98.8,381.6v-1c.6.3,1.3.5,1.9.8,1.1.6,2.1,1.2,3.2,1.8h0c-1.7-.5-3.4-1-5.1-1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M-104.5,375.7c.4.1.9.1,1.3.3.7.4,1.4,1,2.1,1.5.2.3.3.6.5.8,0,0-.1.1-.2.2-1.4-.7-2.6-1.7-3.7-2.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M-93.7,383.2c.1,0,.2,0,.3.1-.1,0-.2,0-.3-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M-87.8,388.3c.2,0,.3.2.5.2-.2,0-.3-.2-.5-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M-99.4,381.4c.1,0,.2.1.3.2-.1,0-.2-.1-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M-87.1,388.6c0,0,.2.1.3.2,0,0-.2-.1-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M-69.1,344c-.5,0-1,0-1.6,0,.5,0,1,0,1.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M-111.1,363.5c2.4.9,4.8,1.9,7.1,2.8,1.2.4,2.4.7,3.5,1.1,1.1.4,2.2.8,3.3,1.4,1,.5,1.8,1.4,1.7,2.6-2.6-.1-5.3-.4-7.9-.3-1.3,0-2.6.9-3.9,1.4-.4.1-.9.2-1.3.2-.6,0-1.2-.3-1.8-.5-.4-1.2-.7-2.5-1.1-3.7,0-.3-.1-.5-.2-.7-1-2.2-1-2.4.5-4.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M-112.2,363.2l.5.2-.5-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M-55,347.7c1.9.5,3.8,1,5.7,1.4,4.2,1.1,8.5,1.6,12.9,1.2,2.6-.2,5.2-.3,7.7-.4.2,1.7.3,3.5.5,5.3,0,.3-.2.7-.5.9-1.2,1.2-2.4,2.3-3.6,3.5-1.3,1.3-3,2.2-4.8,2.1-2.6-.2-5.2-.5-7.7-1-1.6-.3-3-.9-4.5-1.4-4-1.4-8-2.9-12-4.2-2.1-.7-4.3-.9-6.5-1.4.7-1.5,1.7-2.2,2.7-2.8,2.3-1.3,4.8-1.5,7.3-2.1,1-.2,1.9-.7,2.8-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M-55.7,344.6s0,0,0-.1c0,0,0,0,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M-95.8,373.8h-4.2c-.2-.6-.4-1.3-.6-2.1,1.7,0,3.4,0,5.2-.1,0,.6-.1,1.3-.2,1.9,0,0,0,.2-.1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M-7,411.6c-1.2.3-2.4.7-3.6,1-2.3-.3-4.7-.5-6.9-1-1.5-.3-3-1-4.4-1.5-.3-.3-.6-.5-.8-.8,0,0,0-.1,0-.2.9.3,1.7.7,2.6.9,1.6.4,3.2.7,4.7.9,1.9.3,3.8.4,5.7.5,1,0,1.9,0,2.7-.8.3-.3.8-.3,1.2-.5-.4.4-.8.9-1.2,1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M-10.1,413c.1,0,.2-.2.3-.2,1.6.3,3.3.7,4.9,1,.7.1,1.4.3,2.1.5v1c-.5.8-1.3,1-2.1.4-.3-.2-.5-.8-.8-1.4-1.3-.4-2.9-.9-4.5-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M-22.6,347.7c.2,0,.5-.2.7-.3.4-.2.8-.3,1.3-.5,0,.4-.1.8-.2,1.2,1.9,1.4,3.8,1.2,5.9.5,1.8-.6,3.6-.4,5.5.1-.2.4-.3.7-.5.9-2.9.5-5.8.7-8.7,1.4s-5.5,1.9-8.4,2.9c-.6-1.3-.4-2.8-.3-4.2,0-.2.5-.5.8-.6,1.2-.5,2.3-.9,3.5-1.3.1,0,.2-.1.3-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M-69.4,382c-5.2.3-10.3.5-15.5.7-.3,0-.6-.3-.8-.5,0-.1,0-.2,0-.3,5.4-.1,10.8-.2,16.2-.4,0,.2,0,.3,0,.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M-74.1,393.5c-1.3-.6-2.6-1.1-3.8-1.7-2.5-1.3-4.9-2.6-7.3-3.9,1.5-1.3,2.9-2.8,5.1-2.9,1.7,0,3.3-.3,5-.4,7-.6,14-1.3,21-1.7,2.2-.1,4.5.4,6.7.7.5,0,.9.2,1.4.2.2,0,.4.1.6.2,0,0,.1,0,.2,0,.2,0,.4.1.6.2.1,0,.3,0,.4,0,.2,0,.4.1.6.2.2,0,.5.1.8.2.9.2,1.8.4,2.6.6,1.6.4,3.1.7,4.7,1.1,1,.2,2.1.4,3.1.5,1.5.2,2.9.4,4.4.6,2.5.3,5,.6,7.5.9,1.4.2,2.8.4,4.1.5,1.8.2,3.6.3,5.3.7,2.6.6,5.1,1.4,7.6,2.2.3.2.6.3.9.5-.7,1.5-2.4,1.5-3.5,2.3,0,0-.4-.3-.7-.5-.6,0-1.2,0-1.8,0,0,0,0,0,0-.1.3-.1.5-.2.8-.4-1.8-.4-3.5-.7-5.3-.6-1.6,0-3.2.6-4.9.8-3.4.4-6.8.9-10.2,1.1-3.1.2-6.2,0-9.3-.2-.6,0-1.2-.3-1.8-.5,3-.6,6-1.2,9-1.8,0-.1,0-.3,0-.4-.8,0-1.5,0-2.3.1-1.5.1-3.2-.1-4.5.5-2.4,1-4.8,1.3-7.3,1.4-5.3.2-10.6.4-15.8.5-.6,0-1.3-.1-1.9-.2h-.3c-.2,0-.3,0-.4,0-1.9,0-3.7,0-5.6,0-1.8-.1-3.6,0-5.3-.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M-53.4,377.8c.2,0,.4,0,.6,0h0c-.2.1-.4.2-.6.2,0,0,0-.2,0-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M-45.5,384c-.2,0-.4-.1-.6-.2.2,0,.4.1.6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M-44.7,384.2c-.2,0-.4-.1-.6-.2.2,0,.4.1.6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M-43.7,384.5c-.2,0-.4-.1-.6-.2.2,0,.4.1.6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M-7,394.1c.2.2.6.5.7.5,1.2-.8,2.8-.8,3.5-2.3.1.3.3.6.4.9-1.3,1.6-3.1,2.3-4.9,2.9-.2-.8-.7-.2-1,0-.9.4-1.8.8-2.7,1.2,0-.1-.1-.3-.2-.4.6-.3,1.2-.6,1.8-1,.8-.5,1.6-1.1,2.3-1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M-12.3,366.3c.2-.1.5-.2.7-.3,1.4,0,2.7,0,4.1,0,.9,0,1.9,0,2.8-.1,3.1-.1,6.2-.4,9.3-.3,3.1.1,6.1.6,9.1.9.9.1,1.9.3,2.8.3,3.1,0,6.2.3,9.2,1.1.2,0,.3,0,.5,0-.2.2-.3.4-.5.5-2.9.8-5.8,1.5-8.7,2.3-.5,0-1,.1-1.5.2,0,0-.2,0-.3.1-1.2.1-2.4.2-3.6.3-.1,0-.2,0-.3,0-1.5-.2-3.1-.2-4.6-.5-1.6-.3-3-1.1-4.6-1.5-4.9-1.1-9.7-2-14.6-3.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M-4.7,365.8c-.9,0-1.9,0-2.8.1.9,0,1.9,0,2.8-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M-22.6,347.7l-.3.2.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M-7,394.1c-.8.6-1.5,1.1-2.3,1.7-.6.4-1.2.7-1.8,1,0,.1.1.3.2.4.9-.4,1.8-.8,2.7-1.2.3-.1.7-.7,1,0-1.9,1.2-3.9,2.4-5.8,3.7-1.1.8-1.4,2-1.4,3.3,0,1.7.3,3.4.5,5.2-1.1-.8-1.7-1.9-2.2-3.2-.8-2.3-.2-4.3,1.4-6.1,1.8-1.9,3.7-3.7,6-4.9.6,0,1.2,0,1.8,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M-60.6,394.6c5.3-.2,10.6-.3,15.8-.5,2.5-.1,4.9-.5,7.3-1.4,1.3-.6,3-.3,4.5-.5.8,0,1.5,0,2.3-.1,0,.1,0,.3,0,.4-3,.6-6,1.2-9,1.8-.2,0-.4.2-.6.2-4.7,0-9.4.2-14.1.3-2.9.1-5.7.3-8.6.4-.6,0-1.1,0-1.7,0,.3-.2.7-.3,1-.4.2-.1.4-.3.6-.4h.3c.6.7,1.2.5,1.9.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M-40.1,394.6c.2,0,.4-.2.6-.2.6.2,1.2.4,1.8.5,3.1.1,6.2.4,9.3.2,3.4-.2,6.8-.7,10.2-1.1,1.6-.2,3.3-.8,4.9-.8,1.8,0,3.5.2,5.3.6-.3.1-.5.2-.8.4-2.9-.5-5.8-.1-8.6.4-4.8.8-9.5,1.4-14.3,1.2-2.6-.2-5.2-.5-7.8-.7-.2,0-.3-.1-.4-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M-65.7,397.6c-.7-.3-1.3-.6-2-.9,2.7.2,5.3.2,7.9.6,1,.2,1.8,1.1,2.7,1.7,1.9.8,3.8,1.6,5.8,2.4-2-.2-4-.4-6-.7-.6,0-1.1-.4-1.3-1.2-.4-1.1-1.4-1.5-2.5-1.6-1.5-.1-3.1-.2-4.6-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M-24.2,407c-2.1-.5-4.1-1.1-6.2-1.6-1.2-.3-2.4-.9-3.7-1.1-1.5-.3-3-.4-4.5-.7-.8-.2-1.4-.6-2.2-.9,0-.1,0-.2,0-.3.9.1,1.9.1,2.9.4,4.4,1.2,8.7,2.5,13.1,3.8,0,0,.2.1.3.2,0,0,.2,0,.2,0v.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M-24.2,407v-.3c.8-.6,1.1-1.7,2.6-1.7,0,.8,0,1.8-.3,2.2-.6.6-1.6.4-2.3-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M3.8,409.8c-1.4,0-2.9,0-4.3.2-1,0-1.9.3-2.9.4-.4,0-.7-.1-1.1-.2,2.1-.3,4.3-.6,6.5-.9.8-.1,2.1.3,1.8.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M-55,409.1c-2.2-.4-4.3-.8-6.5-1.1v-.4c2.2.5,4.5.4,6.5,1.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M-24.4,406.8c0,0-.2-.1-.3-.2,0,0,.2.1.3.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "-55 409.1 -54.9 409.1 -55 409.1 -55 409.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M-63.4,394.8c-.3.2-.7.3-1,.4-2,1-4.2.7-6.2.2-1.4-.3-2.7-1.1-4.1-1.6.2-.1.4-.3.7-.4,1.7.9,3.5.8,5.3.9,1.9.1,3.7,0,5.6,0,0,.2-.1.3-.2.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M-60.6,394.6c-.7.3-1.3.5-1.9-.2.6,0,1.3.1,1.9.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M-63.4,394.8c0-.2.1-.3.2-.5.2,0,.3,0,.4,0-.2.1-.4.3-.6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M119,398.4c1.4.3,1.5-.5,2.8,0,1.6.6,54.7,11.4,77.4,13.8,11.1,1.5,25.8,6.1,37.7,7.6-11.9-1.5-23-6.8-34.2-8.3-22.8-2.4-67.3-10.6-67-10.2,1.4,2.2,5.6,3.6,7.9,3.2.5-.1,0,.8.5,1.3.8.8,2.3,1.6,3.9,1.3.7,0,1.5.6,2.2.9.4.2.8.3,1.2.3,2.4-.1,4.6.6,6.8,1.4.9.3,1.5.7,2.2,1.4.4.4,1.1.5,1.6.6,1.7.2,2.3,1,2.1,2.7,0,.5.2,1,.4,1.5.1.3.4.6.5.9-1.4.3-2.7.5-3.9.9-.6.2-1.2.7-.9,1.6.1.3,0,.8-.1,1.1-.4.9,0,1.5.6,2,.5.4,2.2,0,2.5-.4.4-.6,0-1-.4-1.4-.5-.4-1-.9-1.6-1.5,1.4-.8,2.3-.5,3.2.3.8.7,1.9,1.1,2.8,1.5.3.1.6,0,1.1.2-.3.3-.5.5-.6.7,0,.3-.2.7,0,.9,0,.2.5.3.8.2.7-.3,1.4,0,1.2.7-.1.5-.9.9-1.4,1.4,0,0-.2,0-.4-.1-2.2-.9-4.6-.4-6.9-.8-.2,0-.5.2-.8.2,1.2.3,2.4.6,3.6.8l2.8.5c.9.2,7.9,2.2,8.9,2.5,1.5.4,18.4,5.1,21.9,8.1h35.6c6.3,0,26,0,26.4,0h20.3c.6-.3,1.1-.7,1.8-.9,4.7-1.3,9.4-2.6,14.2-3.9.9-.2,1.8-.4,2.8-.6v-.5c-1.6-.3-3.3-.6-4.9-.8-4.4-.8-8.9-1.6-13.3-2.3-7.1-1.2-3.3-1-10.4-2.2-7.9-1.4-28-4.6-35.9-6.1-1.5-.3-9-2-11.9-2.6-5.4-1.2-.4-.6,4.5.2-36.1-8.1-66-13.3-109.9-19.8,2.5.6-1.2,1.1,2.1,1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M129.1,432.8h0v-4c0,.7,0,1.5-.7.7-3.3-4-6-7.9-6.6-12.4-1-.2-2-.2-3-.6-.3-.1-3-2-3.1-1.9.2-.2.4-.4.6-.7-.5-.3-1-.6-1.6-.7-3.9-1.1-7.7-2.3-11.6-3.3-9.6-2.6-19.4-4.4-29.2-6.2-1.7-.3-3.4-.7-5.1-1-2.1-.4-4.2-.8-6.4-1.2-3.8-.7-7.5-1.4-11.3-1.8-3.4-.3-6.9-.3-10.4-.3-4.2,0-8.3,0-12.5,0-1.6,0-3.3,0-4.9.3-1.4.3-2.6.7-3.9,1.2-2,.7-4.1,4.4-4.8,6.2-.5,1.2-.2,2.2-.5,3.3-.6,2.2-3.3,4.8-4.6,6.7-2.2,3.2-4.5,7.2-3.1,10.9.2.6.5,1.1,1,1.5.6.4,1.3.6,2,.7,24.3,4.1,48.7,8.2,73.3,8.9,2.5,0,5.1,0,7.2-1.1,2.2-1.2,3.6-3.4,5.2-5.2,1.9-2.2,3.6-3.1,6.4-4,4.7-1.6,7.3,0,11.6,1,5.2,1.1,10.5,1.8,15.7,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M203.8,434.8c-1.1-.3-2.3-.6-3.5-.9-2.8-.6-5.6-.9-8.4-1.3-1.4-.2-2.8-.5-4.1-.8-1.2-.3-2.1-.8-3.2-1.4-.3-.2-4.1-1.2-5.7-1.6-1-.3-8.2-1.2-7.3-.6-.3.3-.4.4-.4.4-2.2-.5-4.4-1-6.6-1.5,0,0,0-.2-.1-.2-.7-.2-1.3-.4-2-.6-.6-.1-1.2-.2-1.8-.3-.1,0-.2-.1-.3-.2-.7-.1-1.4-.2-2-.3-1.3,0-2.7,0-4-.3-7.9-1.4-15.5-4-23.4-5.9-3-.7-5.9-1.4-8.9-2-.1,0-.2,0-.3,0,.6,4.5,3.3,8.4,6.6,12.4.7.7.7,0,.7-.7v4c4.3,1,8.6,2,12.9,3,.4,0,.7.3,1,.5h2.3c2-.7,4.6-1.1,6.6-1.8.5-.2,11.4-2.5,12.4-2.6,1.2,0,.5.9-2.2,1.3.6.4-18.9,4-18.2,4.4,1,.7,22.3-.6,23.3.1,4.2,0,8.4-.3,12.6-.6,3.9-.3,7.9,0,11.8.1.4,0,.7,0,1,.2s.6.4.6.8c0,.2,0,.4,0,.5,0,.1.2.1.4.1,3.5.3,7,0,10.4-.4,1.5-.2,3-.3,4.4-.9-1-1.6-3-2.2-4.8-2.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M68.4,392.1c-.1,2.6-.4,3.9-1.6,6.4-.2.5-.4,1-.9,1.3-.4.3-.9.4-1.4.5-9.1,1.5-18.3,2.5-27.5,1.5-4.8-.5-9.4-1.6-14.1-2.6,0,0-.1,0-.2,0-8.2-1.8-16.2-1.3-23.6-6.1,1-1,1.8-2,2.9-2.8,2-1.6,4.5-2.3,6.8-3.1,3.8-.8,7.6-1.9,11.5-1.9,2,0,4,0,6,0,2.3,0,4.7-.2,7,0h.1c1.4.1,28.5-.7,28.5-.8,1.3.8,2.5,1.6,3.8,2.4.6.6,1.2,1.2,1.8,1.8.9,1.1.8,2.4.8,3.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M218.6,437c-10.2-2.5-45.4-10-58.2-12.6-2.8-.6-5.7-1.2-8.5-1.7-8-1.7-16-3.4-24-5-2-.4-3.9-.8-5.8-.9-.1,0-.2,0-.3,0-.4.3-.7.6-1.1.9,3.9.5,7.9,2,11,2.6,6.7,1.5,13.3,2.9,20,4.3,3.6.8,7.2,1.8,10.9,2.4,11.2,1.6,45,9.7,46.6,9.9,6.4.8,10.1.4,9.4.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M77.1,409.1c.3,0,.5-.2.8-.3-.3,0-.5.2-.8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M80.4,408.6v.5s0-.5,0-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M90.2,403.7c-2.6-1.4-5.2-2.7-7.8-4.1.3,0,.6,0,.9,0,1.1.1,2.2.3,3.3.4.7.3,1.4.5,2,.7l.2.2c.4.2.9.5,1.3.7,0,.7,0,1.3,0,2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M86.6,400.1c-1.1-.1-2.2-.3-3.3-.4-.3,0-.6,0-.9,0-.3-.1-.6-.3-1-.4.6,0,1.3,0,1.9,0,1.1.2,2.2.5,3.2.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M79.9,398.7c-.1,0-.2-.1-.3-.2.1,0,.2.1.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M88.9,401l-.2-.2.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M21.5,401.2l1.2-.4-1.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M11.7,411.9l.2-.3-.2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M67.1,402.3c-.1,0-.2-.1-.3-.2.1,0,.2.1.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M80,403.9c-.1,0-.2-.1-.3-.2.1,0,.2.1.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M3.5,410.4c0,0-.1.2-.2.3,0,0,.1-.2.2-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M96.5,407c3.4.5,6.6,1.6,10,2.7,1,.3,1.9.7,2.9,1,3.4,1,6.8,2,10.2,3,.9.2,1.8.2,3,.3-1.2.6-2.5-.1-3,1.4-.3-.2-.5-.5-.8-.7,0-.1.1-.2.2-.3l-2.5-.3c-.5-.3-1-.6-1.6-.7-3.9-1.1-7.7-2.3-11.6-3.3-2.6-.7-5.2-.7-7.9-1.4-3.2-.8-6.4-1.6-9.6-2.3-6.4-1.4-12.9-2.6-19.4-3.2-.9,0-5.9-1.1-6.6-1.6s3-.6,3.5-1.3c5.5-1,14.9,1.9,20.2,3.7,4.6,1.6,2.2.9,7,1.3.9,0,5.1,1.6,5.9,1.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M43.9,401.6c2.8,0,5.7,0,8.3-.9,1.3-.5,2.5-1.1,3.9-1.4.8-.2,1.7-.1,2.4-.5,1-.4,1.7-1.4,2.4-2.2,1.8-2.4,3.5-4.8,5.3-7.2.5-.7,1.4-1.6,2.2-1.3.5,1.7-1.9,3.5-2.6,5-.6,1.3-2,2.1-2.7,3.3-.3.5-.5,1-.8,1.5-.4.7-1.1,1.1-1.7,1.6-1.4,1-2.6,2.1-4.2,2.6-2,.6-4.4.6-6.5.9-7,.8-14.1.5-21-.5-2.4-.4-4.8-.7-7.1-1.2.4-.5.8-1,1.2-1.5,0-.1.2-.2.3-.3.1,0,.3,0,.4,0,3.4.2,7,.9,10.3,1.5,3.3.5,6.6.7,9.9.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M58.4,381.6c-.1,0-.3,0-.4-.1-2.4-2.3-4.7-4.6-7-6.9-1.8-1.7-2.9-4.1-4.9-5.6-.5,0-1,1.1-1.4,1h0c.4-.3.5-1.4,1.1-1.2.1,0,.3.1.4.2-1.1-1.1-.5-.2-1.6-1.2-.5-.5-1-1.2-1.5-1.8-.3-.4-.8-1.2-1.3-1.4-.1,0-.2,0-.4,0-1.8.3-3.6.7-5,2-.1.1-.3.3-.4.4-.2.1-.4.2-.6.3-.2.1-.3.3-.3.5-1.2.3-5,.9-5.3.9-3.4.7-6.8,1.4-10.2,2.1-.8.2-1.7.2-2.5.3-.5.1-1,.2-1.5.3,0,0-.2,0-.3,0-2.1.3-4.2.3-6.2.9-1.4.4-2.6,1.5-3.8,2.3-.1,0,0,.5-.1.7.7.7,1.5,1.3,2.2,2,0,.1-.2.2-.2.3-.9-.8-1.9-1.5-2.8-2.3-.3-.2-.5-.4-.8-.6,0,0-.2-.1-.3-.2h0c-2.6-.4-5.2-.8-7.8-1.2-6.5-.9-13.1-1.9-19.6-2.6-2.6-.3-5.2,0-7.8.5-3.8.5-7.6,1.3-11.4,2-1.8.4-3.4,1.3-4.9,2.4-1.8,1.3-3.9,2.3-5.9,3.4,0,0-.2.1-.2.2.5,1.1,1.5,1.4,2.6,1.6.8.1,1.5.2,1.8,1.1,2.5.7,4.9,1.5,7.4,2.2,4.7.8,9.3,1.6,13.9,2.4,4.4.7,8.9,1.2,13.4,1.9,3.8.6,7.6.9,11.2,2.3.3.1.5.3.8.5.7.5,1.3.4,1.8-.3,2.2-3.1,5.4-4.2,8.9-5,1.4-.3,2.8-.7,4.1-1,0-.4-.3-1,.5-1,0-.1.2-.2.3-.3-.3-.6-.6-1.3-.9-1.9,0,0,0-.1.1-.2.6.5,1.2,1.1,1.8,1.6.9.4,1.8,1,2.7,1.2,1.5.3,3,.4,4.5.6.5,0,1-.2,1.5-.2,3.1-.1,6.1-.1,9.2-.3,1.2,0,2.5-.5,3.7-.8-.2.3-.5.6-.7.9.9.3,1.8.7,2.8,1,.2,0,.4,0,.6,0,.4,0,.8,0,1.2,0h14c3.1-.5,6.1-1.1,9.2-.9,0-.1,0-.2,0-.3-1.2-.9-2.4-1.7-3.6-2.6h0ZM10.7,381s0,0,0-.1c0,0-.2-.2-.2-.3,0,0-.2-.2-.3-.3,0,0-.2-.2-.2-.3,0,0-.2-.2-.3-.2-.2-.3-.5-.5-.8-.8,0,0-.2-.2-.3-.3,0,0-.2-.2-.2-.3,0,0-.2-.2-.3-.3-.1,0-.2,0-.4,0,0,0,0-.1,0-.1,0,0,.2.2.3.2,0,0,.2.2.2.3,0,0,.2.2.3.3,0,0,.2.2.2.3.3.3.5.5.8.8,0,0,.2.2.2.3,0,0,.2.2.2.3,0,0,.2.2.2.3,0,0,.2.2.3.3,0,0,0,0,.1.1,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M46,369c-.5,0-1,1.1-1.4,1h0c.4-.3.5-1.4,1.1-1.2.1,0,.3.1.4.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M46,369c-.5,0-1,1.1-1.4,1h0c.4-.3.5-1.4,1.1-1.2.1,0,.3.1.4.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M20.4,385.1c0-.1,0-.3,0-.4.5,0,1-.2,1.5-.2,3.1-.1,6.1-.1,9.2-.3,1.2,0,2.5-.5,3.7-.8-.3.3-.5.6-.7.9.9.3,1.8.7,2.8,1,.3.3-1.9-.2-3.3-.3-2.4-.2-4.7,0-7.1,0-2,0-4,0-6,0h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M75.1,392.7c.8,1,1.8,1.8,2.7,2.7-.9-.9-1.9-1.7-2.7-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M168.6,423c-.2,0-.7,0-.8-.2-.1-.3,0-.6,0-.9,0-.2.3-.4.6-.7-.5,0-.9,0-1.1-.2-1-.5-2.1-.8-2.8-1.5-.9-.8-1.8-1.1-3.2-.3.6.5,1.1,1,1.6,1.5.5.4.8.8.4,1.4-.3.5-2,.8-2.5.4-.6-.5-1.1-1.1-.6-2,.1-.3.2-.8.1-1.1-.3-.9.2-1.4.9-1.6,1.2-.4,2.5-.6,3.9-.9-.2-.3-.4-.6-.5-.9-.2-.5-.5-1.1-.4-1.5.2-1.8-.3-2.5-2.1-2.7-.6,0-1.3-.2-1.6-.6-.6-.7-1.3-1.1-2.2-1.4-2.2-.8-4.4-1.5-6.8-1.4-.4,0-.8-.2-1.2-.3-.8-.3-1.5-1-2.2-.9-1.5.2-2.4-1.8-3.6-2.5-2.2-1.2-5.6-2.4-8-3.2-3.9-1.4-8.1-2.3-12.3-2.5-1.5,0-3.5.7-4.8.5-1.7-.2-2.4-1.6-3.8-2.4-1-.6-2.3-.6-3.4-.6-3.5,0-7.3.5-10.7,0-3.7-.6-7.4-2.1-11-3.1-7.1-2-14.7-4.7-22.1-4.8,0,1.8.1,3.6-.4,5.5-.5,1.5-2.6,3.3-2.5,5,.2,2.9,4.6,2.8,6.6,2.9,5.3.2,10,3.5,15.2,4.4,1.9.3,3.8.4,5.7.6,5.6.5,11.1,2.2,16.5,3.8,3.4,1,6.8,2,10.2,3,.9.2,1.8.2,3,.3-1.2.6-2.5-.1-3,1.4.9.4,1.7.8,2.6,1.2,1.9.4,3.8.7,5.8,1.1,8,1.7,16,3.4,24,5,2.8.6,5.7,1.2,8.5,1.7.3,0,.6-.3.8-.2,2.3.3,4.6-.1,6.9.8.1,0,.3.2.4.1.5-.4,1.3-.9,1.4-1.4.1-.7-.5-.9-1.2-.7h0ZM75.1,392.7c.8,1,1.8,1.8,2.7,2.7-.9-.9-1.9-1.7-2.7-2.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M59.5,384.9c-1.4-.9-5.4-.9-7-1.6-.6-.3,1.5-1.6,1-2s-.8-1-.6-1.6c1.9-.7,3.9.5,5.6,1.7,1.4,1.1,2.9,2.1,4.3,3.1.5.4,4.3,1.8,4.4,2.5-1.5.3-6.4-1.4-7.7-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M327.7,433.5c-2-.2-3.9-.3-5.8-.6-4.3-.7-8.6-1.5-12.9-2.2-6.4-1.1-12.8-2.2-19.2-3.3-2-.3-3.9-.8-5.9-1.1-3.4-.5-6.8-1-10.2-1.5-4.9-.8-9.7-1.6-14.5-2.4-2.2-.4-39.9-7.9-76.7-14.6-16.5-3.9-77.3-13.9-79.4-14.2-4.6-.6-9.1-1.5-13.7-2.4-5.2-1.1-10.4-2.4-15.7-3.4-2.6-.5-5.2-.7-7.8-1.1.6.6,1.2,1.2,1.8,1.8.3.2.6.3.9.5,1,.3,2,.6,3,.9,3,.9,5.9,1.7,9,2.4,3.7.8,7.4,1.6,11.1,2.3-.1,0-.2,0-.3,0l19.1,3.7c1.4.2,2.7.4,4.1.6,2.8.4,5.5.8,8.3,1.1,2.2.2,11.2,1.3,14.4,1.9,4.7,1.2,33.9,6.5,39.4,7.1,48.8,9.4,99.5,17.9,103.9,18.6,4.4.7,8.9,1.5,13.3,2.3,1.6.3,3.3.6,4.9.8,0,.2,0,.3,0,.5-.9.2-1.9.4-2.8.6-4.7,1.3-9.5,2.6-14.2,3.9-.6.2-1.2.6-1.8.9h6.9c1.6-.7,3.1-1.5,4.7-2,3-.9,6-1.8,9.1-2.4,1.7-.3,3.4-.3,5.2-.2,1.9.1,3.8.5,5.7.7,3.7.4,7.5.8,11.2,1.2,2.6.3,5.1.6,7.7.9.6,0,1.1.3,1.6.5v-1.3c-1.4,0-2.9-.1-4.3-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M-4.7,298.7c-.6-.4-1.4-.7-1.9-1.3-.2-.3,0-1.2.2-1.6.5-.7,1.3-.9,2.1-.6.6.2,1.3.2,2,.3.7,0,1.1.6.6,1.1-.8.9-1.6,1.9-3.1,2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M-36.7,237.8c-.3.7-4.5,0-4.6,0,0-.1-.2-5.5-.1-5.7v-.8c0-.6.2-2.4.2-2.7,0-6.4.2-12.7.3-19.1,0-4.4-.2-8.9-.2-13.3,0-3.1,0-11.1,0-12,0-2-.1-4-.2-6v-2.4c0-.4.2-.8.2-1.2,0-2.5,0-5.1,0-7.6,0-2.8,0-5.7-.1-8.5v-2.8c0-.4,0-.8,0-1.3v-1.1c0-.3.2-.6.2-.8,0-4.6,0-9.2,0-13.7,0-.3-.2-.6-.2-1,0-1.3,0-2.6,0-3.9,0,0,0-.2,0-.3,0-2.1,0-4.1,0-6.2,0-6,0-11.9,0-17.9,0-.2-.1-.4-.2-.6v-8.6c0-1.5.1-3.1.2-4.6,0-.8,0-1.6,0-2.4.7.3,1.4.5,2.1.8.9.3,1.8.7,2.7,1.1,0,.3.2.7.2,1,0,2.8.2,5.7.2,8.5s-.2,6.3-.2,9.4c0,4.9.2,9.7.2,14.6,0,2.7-.2,5.3-.2,8,0,14.8-.2,29.7-.2,44.5,0,10,.1,19.9.2,29.9,0,5.1-.5,21.5-.4,26.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M13.4,405.4c-.8.7-1.6,1.4-2.2,2.3-.6,1.1-.9,2.3-1.4,3.4-1.2,3.2-3.6,5.8-5.4,8.7s-3.1,6.6-1.8,9.8c.4,1.1,1.2,2.1,2.3,2.4.4-2.4.1-4.9-.6-7.2-.2-.7-.5-1.5-.3-2.2.2-.5.6-.9,1-1.3,3-2.7,5.9-5.8,6.9-9.6.3-1.2.5-2.6,1.2-3.6.4-.6.9-1,1.5-1.4,2-1.6,4.1-3.2,6.1-4.9.5-.4,1.1-.9,1.8-.9,1.1,0,2.3,1,3.3.5.5-.3-2.2-1.7-2.4-1.7-1.2-.2-2.4.3-3.4.7-2.5,1.2-4.6,3.1-6.7,4.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M15.5,413.7c-2.6-.6-5.5-1.6-6.1.7,23.5,4.3,47.2,8,71,11,4.2.5,10.1,2.2,14.2,1.5-.7-2.7-62.4-9.4-79-13.2h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-167"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M-7.4,361.1c-6.9.4-13.4,2.5-19.9,4.6-21.3,7-42.5,14.5-62.5,24.1-9.9,4.8-19.4,10.6-30.4,12.7-5,1-10.1,1.7-15.3,2.2,3.8,1,7.4,2.3,10.9,4,.4.2.8.5,1.1.8,1.6.4,3.3.9,4.9,1.3,13.5-2.2,27-4.8,40.6-6.7,7-1,14-2,21.1-3,4.8-.7,9.6-1.8,14.4-2.4,4.5-.6,8.5.4,12.9.3,14.5-.2,29-2,43.1-5.4,6.1-1.4,12.4-4.5,18.6-3.7,2.7.4,2.4,1.3,3-1.5s-.8-7.4-1.6-10c-2.6-7.9-8.8-9.4-15.8-12.2-8-3.2-16.4-5.5-25.1-5.1h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M178.8,111.7c-.3,2.2-.6,3.9-.7,4,0-.3.6-4,.7-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M179.7,89.6c0,0,0-.1,0-.2,0-.4,0-.7.1-.8.3.2,0,1,0,1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M181.2,94s0,0,0,.1h0c0-.1,0-.1,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M192.5,175.5h0q0,0,0,0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M208.5,173.8c.2-.3.4-.6.3-1,0-.4-.4-.7-.8-.8-.6-.3-1.5-.3-2-.4-1.5-.2-8.5.4-9.9,0-1.2-.3-8.4-2.9-8.8-3.1-3-1.9-5.9-3.8-9-5.5-1.9-1.1-4-1.8-6-2.6-.3-.2-.5-.4-.9-.6-4.2-2.1-14.4-4.8-14.7-4.8-.2,0-.4-.2-.6-.3-.3,0-.7,0-1,0-1.3-.3-2.6-.6-3.9-.8-2.7-.3-5.4-.4-8-.6-.5,0-1-.4-1.6-.5-.5-.1-1-.1-1.5-.2-.5,0-2.2-.7-2.6-.9-4.1-.5-7.8,1.9-11.7,3.3-4.6,1.6-10.1,2.1-12.9,6.1-.2.4-2.6-.2-4.1.4-.9.3-1.3,1.8-1.6,1.7-.1,0-.7,0-.9,0,0,0-.2.2-.2.2h0c-.2,1-.3,2.1-.8,2.9-.5,1-1.3,1.9-1.9,2.9-.2.3-.2.8-.3,1.1-.4.2-1,.4-1.4.8-1.4,1.5-1.6,2.8-3.8,2.4-1.6-.3-3.7-1.7-4.8-2.9-.4-.5-.8-1-1.2-1.4-1.4-1.3-3.5-1.3-5.3-1.3-1.7,0-4.1.2-5.6-.6-1.3-.6-1.6-2.3-2.8-2.8-.3-.1-.6-.1-.9-.1-2.5,0-5.1.3-7.5-.2-2.9-.6-5.7-1.5-8.5-2.3-1.5-.4-3-.8-4.5-1.1-4.9-1.1-10.6-2.2-15.7-2.2-2,0-4.1,0-6.1,0-.7,0-1.5,0-2.1.4-.2.2-.4.4-.6.7,1.2.6,1.9,1.8,1.9,3,.2.6.4,1.2.4,1.8,0,1.3-12.2,5.4-13.7,3.1-.9,0-1.7.2-1.8,1-.2,1.7,4.3,8.6,5.3,10,1.2,1.7,3.4,3,4.3,5,.6,1.4.5,3.4.6,4.9.4,5.6.8,10.6.5,16-.4,5.6,1.6,11.3,5.4,15.4,2.4,2.6,5.4,4.5,8.5,6.1,2.6,1.4,5.7,1.3,8.2,2.8,1.5.9,1.9,2.1,3.4,2.5,1.4.4,2.4,2.1,3.8,2.6,4.6,1.8,10.1-3.2,14.4-4,6.1-1.2,12.8-.8,19-1.2,12.7-.8,25.3-1.6,38-2.4,2.5-.2,5-.3,7.3-1.2,2.2-.8,4.1-2.2,6-3.6,4.1-3,10.1-6.2,12.9-10.7.9-1.5,1.2-3.1,1.5-4.8,0,0,0-.1,0-.2.2-1,.4-2,.9-2.9,1.3-2.8,3.3-5.2,5.8-6.8.9-.6,1.8-1.1,2.3-2,1,0,1.9-.6,2.8-.8.2,0,.3-.5.4-.8-.8-.3-.2-.7,0-.8.7-.3.9-1,1.8-1,3.6-.2,7.2.2,10.8-.2,2.3-.2,4.5-.8,6.8-.7,1.9.1,3.9.7,5.7,0,.9-.3,1.3-.7,2.3-.7h9.2c.4,0,.8,0,1-.3.3-.4,0-.9,0-1.3-.2-.7-.2-1.4-.2-2.1,0-2.2-.1-4.4-.2-6.6,0-.7,0-1.4,0-2,.1-1.1.4-2.1,1-3.1h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "77.1 188.3 65.8 187.2 71.4 190.8 77.1 188.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "78.1 191.9 69.8 193.4 76.5 195.1 78.1 191.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "121.5 181.5 130 177.9 127.2 182.9 121.5 181.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "123.8 185.4 130 183.6 126.9 187.2 123.8 185.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "89.9 183.9 55.8 176.7 67.4 185 85.5 186.3 93 207.1 97.1 228 89.5 230.4 91.7 232.6 102.7 230.4 98.7 208.5 113.4 207.1 117.8 229.6 126.2 229.9 126.2 226.4 121.2 226.1 116.8 202.4 115.6 182.4 127.8 176.8 134 165.1 110.9 181.5 112.5 202.4 98.1 203.9 89.9 183.9"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-132"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "158.4 205.6 158.4 205.6 158.4 205.6 158.4 205.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "158.4 205.6 158.4 205.6 158.4 205.6 158.4 205.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "158.4 205.6 158.4 205.6 158.4 205.6 158.4 205.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-286",
    points: "158.4 205.6 158.4 205.6 158.4 205.6 158.4 205.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-286",
    points: "158.4 205.6 158.4 205.6 158.4 205.6 158.4 205.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "158.4 205.6 158.4 205.6 158.4 205.6 158.4 205.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "158.4 205.6 158.4 205.6 158.4 205.6 158.4 205.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "158.4 205.6 158.4 205.6 158.4 205.6 158.4 205.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-245",
    points: "158.4 205.6 158.4 205.6 158.4 205.6 158.4 205.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "158.4 205.6 158.4 205.6 158.4 205.6 158.4 205.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "158.4 205.6 158.4 205.6 158.4 205.6 158.4 205.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "158.4 205.6 158.4 205.6 158.4 205.6 158.4 205.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-305",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-266",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-266",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-249",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-243",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-343",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-211",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-290",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "158.4 205.7 158.4 205.7 158.4 205.7 158.4 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-155",
    points: "158.4 205.8 158.4 205.8 158.4 205.8 158.4 205.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "158.4 205.8 158.4 205.8 158.4 205.8 158.4 205.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "158.4 205.8 158.4 205.8 158.4 205.8 158.4 205.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-137",
    points: "158.4 205.8 158.4 205.8 158.4 205.8 158.4 205.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-339",
    points: "158.4 205.8 158.4 205.8 158.4 205.8 158.4 205.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "158.4 205.8 158.4 205.8 158.4 205.8 158.4 205.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "158.4 205.8 158.4 205.8 158.4 205.8 158.4 205.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "158.4 205.8 158.4 205.8 158.4 205.8 158.4 205.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-187",
    points: "158.4 205.8 158.4 205.8 158.4 205.8 158.4 205.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "158.4 205.8 158.4 205.8 158.4 205.8 158.4 205.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-192",
    points: "158.4 205.8 158.4 205.8 158.4 205.8 158.4 205.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "158.4 205.8 158.4 205.8 158.4 205.8 158.4 205.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "158.4 205.8 158.4 205.8 158.4 205.8 158.4 205.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-240",
    points: "158.4 205.8 158.4 205.8 158.4 205.8 158.4 205.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-117",
    points: "158.4 205.8 158.4 205.8 158.4 205.8 158.4 205.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "158.4 205.8 158.4 205.8 158.4 205.8 158.4 205.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-173",
    points: "158.4 205.8 158.4 205.8 158.4 205.8 158.4 205.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-344",
    points: "158.4 205.8 158.4 205.8 158.4 205.8 158.4 205.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "158.4 205.8 158.4 205.8 158.4 205.8 158.4 205.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-318",
    points: "158.4 205.8 158.4 205.8 158.4 205.8 158.4 205.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "158.4 205.8 158.4 205.8 158.4 205.8 158.4 205.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-217",
    points: "158.4 205.8 158.4 205.8 158.4 205.8 158.4 205.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-284",
    points: "158.4 205.8 158.4 205.8 158.4 205.8 158.4 205.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-263",
    points: "158.4 205.8 158.4 205.8 158.4 205.8 158.4 205.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-253",
    points: "158.4 205.8 158.4 205.8 158.4 205.8 158.4 205.8"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-271"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 154.9,
    y: 199,
    width: 0,
    height: 0
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M154.9,199h0s0,0,0,0h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M304.7,270c-2-.1-4-.2-6-.3-2.5-.1-5-.1-7.5-.3-4.9-.3-9.7-.7-14.6-1.1-1.8-.1-3.6-.2-5.4-.3-4.3-.3-8.6-.5-13-.8-1.8-.1-3.6-.2-5.4-.3-4.2-.2-33.9-2.4-35-2.6-1.3-.3-2.8-.2-4.1-.4-4.2-.3-8.4-.7-12.5-1.1-.9,0-1.7-.1-2.7-.2,0,0,0,0,0,0-1,0-31.4-3-35.1-3.2-3.5-.3-7.1-.4-10.7-.7-3.5-.3-7-.9-10.5-1.3-3.2-.4-6.3-.7-9.5-1.2,0,0,0,0,0,0-2.4-.2-4.8-.4-7.2-.6-2.4-.2-4.7-.5-7-.8-4.1-.4-8.1-.9-12.2-1.3-2.8-.3-5.7-.6-8.5-.9s-5.7-.7-8.5-1c-3.1-.4-6.2-.7-9.3-1.1-1.3-.2-2.6-.4-3.8-.6-.6,0-1.2-.2-1.9-.3-.6-.2-1.2-.3-1.9-.5-1.1-.1-2.2-.2-3.2-.4-.5,0-1.1-.2-1.6-.2-1.5-.2-3.1-.4-4.6-.6-.5,0-.9-.2-1.4-.2-2.4-.4-4.8-.8-7.3-1.1-.5,0-.9,0-1.4,0-.2,0-.3-.1-.5-.2-.4,0-.9,0-1.4,0-.1,0-.2-.1-.3-.2-.8-.1-1.6-.2-2.4-.4-.2,0-.4-.2-.6-.2-.9-.1-1.8-.2-2.7-.4-.2,0-.4-.1-.5-.2-.2,0-.4,0-.5,0-.4,0-.7-.1-1.1-.2-5.1-.8-10.1-1.6-15.2-2.4-3.2-.5-16.2-4.6-19.5-5-1.6-.2-8.4,4.4-10.1,4.6,0,0,14.8-.4,14.7-.3,4.3.9,8.6,1.8,12.9,2.7,5.1,1.1,10.2,2.2,15.3,3.3,7.4,1.5,14.8,3,22.2,4.4,4.2.8,8.3,1.6,12.5,2.3,3.5.6,7.1.9,10.6,1.4,4,.5,7.9,1.2,11.9,1.7,5,.7,10,1.3,15.1,1.8,4.3.5,8.6.9,13,1.4,7.2.8,14.4,1.6,21.6,2.4,3.2.4,6.4.9,9.5,1.3,2.9.3,5.8.4,8.6.6,5.8.5,11.6,1.1,17.4,1.6,3.5.3,7,.6,10.6.9,4.6.4,9.3.8,13.9,1.2,3,.3,6,.4,9,.7,5,.4,9.9.9,14.9,1.3,3.2.3,6.4.4,9.7.6,6.8.4,13.7.9,20.5,1.3,5.2.3,10.5.6,15.7.9,8.8.4,17.6.8,26.5,1.2,3.8.2,29.8.7,33.6.8v-4.6c-3.7-.3-29.6-.9-33.4-1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M110.3,231.8c0,0,.3,0,.4-.2.5-1.2,1.4-1.1,2.5-1,.6,0,1.3-.5,2-.7.3-.1.6-.1.7-.2-.2,1.1-.4,2.1-.6,3,.1,0,.2,0,.4-.1.4.2.7.7,1,.7,1.2.1,2.4.3,3.6-.6.7-.6,1.7-.9,2.6-1,.5,0,1,.8,1.6,1.2.9,0,1.6,0,2-1,0-.2.2-.3.4-.4.4-.3,3.6-.1,4.1,0,.4.2,1,.3,1.1.2.3-.3.4-.8.4-1.3,0-.3-.3-.6-.3-.9,0-.3.1-.7.3-.9.1-.1.6,0,.8.1.5.3.7.5,1.4.2.7-.3,1.3.3,1.5,1.1.2,1.4.4,2.7.5,4.1,0,.2-.2.7-.4.7-.8,0-1.6,0-2.5,0s-.6,0-1,0c0,.4,0,.9.2,1.2.3.4.8.8,1.2,1,.3.1.8,0,1.1-.2.9-.5,1.7-1.2,2.6-1.7.2-.2.8-.2.9,0,.3.2.5.7.5,1,0,.8,0,1.6-.2,2.4-1.6.5-1.8,1.2-.6,2.3.3-.3.5-.7.9-1,.6.4.6.8.1,1.3-.7.6-.6,1.4,0,1.9.8.7,1,1.6,1.1,2.5.1.8.2,1.6,1.4,1.4,0,.9-.3,1.3-1.1,1.2-1-.2-1.8-.3-2.3,1-.2.5-1.1.7-1.7,1.1-.4.2-.7.4-1.1.6-.7.5-1.3,1.2-2,1.5-2.6,1.3-1.6,4.2.6,5.2,1.4.6,2.9.6,4.4.7,9,.4,17.8,2.8,26.8,3.8,9.4,1.1,18.9.6,28.2,1.3,13.8,1.1,27.4,4.6,41.1,4.3,2.3,0,4.7-.2,7-.7,4.1-.9,9.7-3,12.1-6.8,1.4-2.2,1.4-5.1,2.5-7.5,1-2.2,2.8-3.9,4-5.9,1.4-2.3,1.9-5,2.4-7.6.2-1.2.5-2.6,0-3.7-.8-1.5-2.5-1.9-3.7-2.9-1.7-1.4-2.1-3.6-2.7-5.6,0,0,0-.1,0-.2-.3-.1-.8-.2-.9-.4-.5-1.1-1.5-1.3-2.4-1.6-.5-.2-1.2,0-1.9.2.1-.3.2-.6.4-1.2-.6.1-1,.3-1.4.2-.5,0-1.3.4-1.6-.5-.2-.4-.4-.7-.5-1.1,0-.1-.2-.2-.2-.3-1.6-.8-4.1-.7-5,.4-.4-1.1-.8-2.1-1.2-3.2-.5-.4-.9-.8-1.4-1.3-.3-.3-3.1.5-3.6.5,0-2.7-.6-2.3-2.3-4.1-1.8-1.9-3.3-4-5.2-5.9-1.7-1.7-4.1-1.6-6.3-2.6-.9-1.3-1.8-2.9-2.9-4.4-.6-.9-1.5-1.2-2.5-1.2-1.4,0-2.8,0-4.1-.7-.7-.4-1.7-.1-2.6-.2-1.1.9-1.4.9-2.3-.1-.5-.6-1-1.3-1.6-2-.6-.8-1.2-1.6-1.9-2.4-1.7-.3-3.4-.7-5.1-.9-.9-.1-1.9.1-3,.2-.1,0-1.1-1-1.4-1.2-.5-.3-1-.4-1.6-.4s-1.2.2-1.8.4c-.5.3-.8.7-1.3.1-.2-.2-.3-.5-.6-.8-.4-.4-1-.4-1.3-.8-.2-.2-.3-.5-.5-.6-.4-.3-.9-.3-1.4-.3-.6,0-1.1,0-1.7.1-.7,0-1.3.1-2,.3-.5.1-1.1.6-1.6.5-1-.1-1.6-1.2-2.7-1.2-.4,0-.9.1-1.3.3-.9.3-1.6.6-2.6.6-1,0-1.9-.1-2.9,0-.4,0-.8.5-1.3.8-.1.3-.2.7-.4.8-1.4.2-2.6,1.2-4,.6-1.2-.4-2.2-.2-3.2.9-.8.8-2.2.9-3.3,1.3-1.2.5-2,1.7-3.3,2.1-1.5.4-1.6,1.4-2.5,2.4-.7.8-1.6,1.5-2.5,2.1-.1,0-.2.2-.3.2-.3.2-.7.5-1,.7-.4.3-.6.6-1.1.8l-1.1.3c-.5.4-1.1.8-1.5,1.3-.7.9-1.3,1.8-1.9,2.7-.6.8-1.2,1.6-1.8,2.4-.1.3-.2.6-.4.8-.5.9-1.1,1.8-1.6,2.7-.1.9-.2,1.8-.5,2.7,0,.3-.7.5-1.1.6-.5.1-1.1.1-1.7.2-.2,1-.4,1.9-.5,2.9-1,.1-1.9.2-2.8.3-.4.4-.8.7-1.1,1.1-.9,1.3-1.9,2.4-3.2,3.3-.8.6-3,1.3-3.3,2.3-.2.5,0,1.2-.3,1.6s-.5.2-.8.3-.5.3-.5.6c0-.1-1.2.2-1.3.1-.4,0-.9-.5-1.1-.9-.9-1.4-2-1.5-3.4-1,0-.3-.2-.5-.3-.8-.4.2-.6.4-.9.6-.1-.1-.2-.1-.3-.2-.5-1.1-1.8-1.6-3.3-1.1-.4.1-.9.1-1.4.2-1.1.1-2.3,0-3.4.4-1.7.5-1.7.6-1,2.3-.3.2-.7.5-1.2.9,1.1.4,2,.7,2.8,1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M209.6,238.6h0c0-.1-.4-.1-.4-.1h0c0,.1.4.1.4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M13.1,241.9c4.3.9,8.6,1.8,12.9,2.7,5.1,1.1,10.2,2.2,15.3,3.3,7.4,1.5,14.8,3,22.2,4.4,4.2.8,8.3,1.6,12.5,2.3,3.5.6,7.1.9,10.6,1.4,4,.5,7.9,1.2,11.9,1.7,5,.7,10,1.3,15.1,1.8,4.3.5,8.6.9,13,1.4,7.2.8,14.4,1.6,21.6,2.4,3.2.4,6.4.9,9.5,1.3,2.9.3,5.8.4,8.6.6,5.8.5,11.6,1.1,17.4,1.6,3.5.3,7,.6,10.6.9,4.6.4,9.3.8,13.9,1.2,3,.3,6,.4,9,.7,5,.4,9.9.9,14.9,1.3,3.2.3,6.4.4,9.7.6,6.8.4,13.7.9,20.5,1.3,5.2.3,10.5.6,15.7.9,8.8.4,17.6.8,26.5,1.2,3.8.2,29.5-.5,33.3-.4,0,6.4,2.6,15.5,2.6,21.8-2-.5-28.5-2.8-30.6-2.8-2.8,0-5.5,0-8.2-.7-2.7-.6-5.5-.6-8.2-.9-3.7-.4-7.5-.8-11.2-1.1-4.8-.4-9.5-.8-14.3-1.1-3.2-.2-6.4-.3-9.6-.6-4.1-.3-8.2-.2-12.2-1-2.9-.6-5.9-.5-8.8-.6-2.8-.1-5.6-.2-8.5-.3-1.9-.1-3.8-.3-5.7-.5-1.8-.2-3.5-.4-5.3-.5-2.5-.2-5-.2-7.5-.3-1.7,0-3.4-.2-5.1-.3-3.1-.3-6.3-.7-9.4-1-3-.3-6-.6-8.9-.9-3-.3-6.1-.7-9.2-1-2.2-.2-4.3-.2-6.5-.3-.9,0-1.8,0-2.8-.1-.9,0-1.7-.4-2.6-.4-1.9-.2-3.8-.2-5.6-.3-3.2-.3-6.3-.7-9.5-1-2.6-.3-5.2-.5-7.8-.9-2.7-.4-5.4-.9-8.2-1.3-2-.2-4.1-.2-6.2-.3-.5,0-1.1-.1-1.6-.2-2.4-.2-4.9-.5-7.3-.6-.6,0-1.1,0-1.7,0-1.2-.2-2.5-.6-3.8-.5-1.7.1-3.3-.2-4.9-.6-1.4-.3-2.8-.3-4.2-.5-1.8-.3-3.5-.7-5.3-.9-2.3-.3-4.7-.5-7-.6-2.9-.1-5.7-.2-8.6-.2-.9,0-1.6,0-2.4-.4-1.1-.5,61.2,10.3,60,10.8.5.4-71.5-10.1-78.3-11.2-3.3-.5-6.6-1.2-10-1.8-2.6-.4-5.3-.7-7.9-1.1-3.8-.7-7.5-1.5-11.3-2.1-5.8-1-11.6-1.8-17.3-2.7-7.9-1.3-15.8-2.9-23.5-5.1-5-1.4-10-2.8-14.9-4.6-2.5-.9-4.9-1.9-7.3-3-.9-.4-1.8-1-2.7-1.4-1.2-.4-2.3-.7-3.4-1.3-1.9-.9-3.5-2.2-5.4-3.2-1-.5-2-.8-2.9-1.4s-1.7-1.5-1.9-2.5c2.6-.2,5.1.4,7.7.3,2.7,0,5.4-.3,8.1-.6,5.3-.5,10.6-1.1,15.8-1.3,2.6,0,6.9-.3,9.4-.5,1.7-.2,2.1.9,3.7.6.1,0,.3,0,.4,0,2.4-.2,4.1-1.1,6.5-1.2,1,0,2.3-.3,3.2-.2.9.1,2.4,1.3,3.4,1.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M-42.4,245.6c4,2.2,7.8,4.6,11.9,6.6,7.7,3.7,15.8,6.2,24,8.4,7.7,2.2,15.6,3.8,23.5,5.1,5.8.9,11.6,1.8,17.3,2.7,3.8.6,7.5,1.5,11.3,2.1,2.6.5,5.3.7,7.9,1.1,3.3.5,6.6,1.3,10,1.8,6.8,1.1,20.8,3,21,3,.2,0,19,2.6,21.9,2.9.9.1,13.9,1.9,16.1,2.2.3,0,.5,0,.8.1.5,0,6.5.8,6.7.8l1.1.2c.2,0,3.2.4,3.5.4.2,0,1.1.2,1.3.2,0,0,.2,0,.3,0,.2,0,5.3.7,5.8.8,10,.9,19.9,1.9,29.9,2.8,4.7.4,9.5.8,14.2,1.2,7.5.7,14.9,1.4,22.4,2,6.7.6,13.3,1,20,1.5,8.3.6,16.5,1.2,24.8,1.8,8.8.6,17.6,1.3,26.4,1.9,5.9.4,11.8.8,17.7,1.1,6.2.4,36.9,1.4,43.1,1.8v4.1c-2.7,0-30-.7-32.8-.7-4.2-.1-8.4-.3-12.6-.6-4.7-.3-9.4-.7-14-1.1-3.9-.3-7.8-.6-11.8-.8-3.9-.2-7.8-.3-11.7-.6-5-.3-9.9-.7-14.8-1.1-4.1-.3-8.3-.5-12.4-.9-3.1-.3-6.2-.7-9.3-1-2.4-.2-4.9-.4-7.3-.6-3.1-.3-6.2-.7-9.3-1-2.3-.2-4.5-.4-6.8-.6-3.8-.3-7.5-.7-11.3-1.1-2.5-.2-5-.4-7.5-.6-3.6-.3-7.2-.7-10.8-1-2.3-.2-4.6-.4-6.9-.6-2.8-.3-5.5-.6-8.2-.9-2.2-.2-4.4-.5-6.6-.7-3.6-.4-7.3-.9-10.9-1.3-3.6-.4-7.3-.7-10.9-1.2-2-.2-3.9-.6-5.9-.9-4.1-.6-8.2-1.2-12.3-1.8-2.5-.4-5.1-.9-7.6-1.3-1.7-.3-3.4-.4-5.1-.6-3.7-.5-7.3-1.1-11-1.7-3.9-.6-7.8-1.2-11.6-1.9-4.5-.8-8.9-1.8-13.4-2.6-5.9-1.1-11.8-2.3-17.8-3.3-6.5-1.1-13.1-2-19.6-3.1-4.2-.7-8.4-1.6-12.6-2.4-2.7-.5-5.4-.9-8.1-1.4-2.3-.5-4.5-1.1-6.7-1.8-6.8-2.1-13.7-4-20.3-6.5-4.2-1.5-8.1-3.7-12-6-2.1-1.2-3.9-3-5.8-4.6-.7-.6-1.3-1.5-1.7-2.4,0-.1,0-.2-.2-.4.1,0,.2,0,.4,0,0,0,.1,0,.2,0,0,0,.2.2.3.2.2,0,.3.2.5.2l1,.5,1,.5c.2,0,.9.3.9.4l.5.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M340.5,298.2c-6.2-.4-36.9-1.4-43.1-1.8-5.9-.4-11.8-.7-17.7-1.1-8.8-.6-17.6-1.3-26.4-1.9-8.3-.6-16.5-1.2-24.8-1.8-6.7-.5-13.3-.9-20-1.5-7.5-.6-14.9-1.3-22.4-2-4.7-.4-9.5-.8-14.2-1.2-10-.9-19.9-1.9-29.9-2.8-.5,0-1.6-.3-1.7-.3-.2,0-9-1.1-9.1-1.1l-1.1-.2c-.3,0-64.2-8.4-64.7-8.8,1.1-.5,24.6.5,27.5.6,2.3.1,4.7.3,7,.6,1.8.2,3.5.6,5.3.9,1.4.2,2.8.2,4.2.5,1.6.4,3.2.7,4.9.6,1.2,0,2.5.4,3.8.5.6,0,1.1,0,1.7,0,2.4.2,4.9.4,7.3.6.5,0,1.1.1,1.6.2,2,.1,4.1,0,6.2.3,2.7.3,5.4.9,8.2,1.3,2.6.4,5.2.6,7.8.9,3.2.4,6.3.7,9.5,1,1.9.2,3.8.2,5.6.3.9,0,1.7.3,2.6.4.9,0,1.8,0,2.8.1,2.2,0,4.3.1,6.5.3,3.1.3,6.1.7,9.2,1,3,.3,6,.6,8.9.9,3.1.3,6.3.7,9.4,1,1.7.2,3.4.2,5.1.3,2.5.1,5,.2,7.5.3,1.8.1,3.5.4,5.3.5,1.9.2,3.8.4,5.7.5,2.8.1,5.6.2,8.5.3,2.9.1,5.9,0,8.8.6,4.1.8,8.2.7,12.2,1,3.2.2,6.4.3,9.6.6,4.8.3,9.5.7,14.3,1.1,3.7.3,7.5.7,11.2,1.1,2.8.3,5.6.3,8.2.9,2.8.7,5.5.8,8.2.7,2.1,0,28.6,1,30.6,1.6v3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M336.4,271.1c-3.7-.3-27.9-.8-31.6-1-2-.1-4-.2-6-.3-2.5-.1-5-.1-7.5-.3-4.9-.3-9.7-.7-14.6-1.1-1.8-.1-3.6-.2-5.4-.3-4.3-.3-8.6-.5-13-.8-1.8-.1-3.6-.2-5.4-.3-4.2-.2-8.4-.3-12.6-.6-1,0-2-.4-3-.6v-.3c1.8-.4,3.5-.8,5.4-1.3.6.8,1.5.9,2.5.6.2,0,.5-.1.6,0,1.5,1,3.1.8,4.7.6.8-.1,1.5-.1,2.3.2.7.3,1.6,0,2.4-.2,1.4-.4,2.5,0,3.7.6,1,.6,2,.9,2.8-.3.1-.2.4-.3.6-.3,1.5.2,2.2-.9,3.2-1.6.5-.4,1.2-.5,1.7-.9.6-.4,1-1,1.5-1.5.8-.4,1.6-.9,2.6-1.2,1.2-.3,1.9-1.2,2.8-1.9.2-.1.5-.1.7-.2.2,0,.5,0,.6,0,.4-.8.7-1.7,1.8-.6.9-.4,1.7-.9,2.6-1.3s.5-.3.8-.3c1.7-.3,3.3-.5,5-.8,1-.2,1.9-.6,3-.3.2,0,.7,0,.9-.3.8-1,1.9-.8,3-.8.4,0,1,0,1.3-.2,1.1-.9,2.2-.5,3.1,0,1,.4,1.5.3,2-.8.8,1,1.6,1.7,2.8,1.1,1.3,1.3,3,.2,4.4.8,1.4.5,2.6.3,4,0,1.2-.3,2.5.1,3.7.3.7,0,21,.2,21.6.4,0,5.3.9,10.8.9,16.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M335.3,208.6c0,1.5-.3,4.4-.3,5.9-.4,0-19.9-2.8-20.2-2.8-5.2-.5-10.3-.9-15.5-1.4-3-.3-6-.7-8.9-1-2.3-.2-4.6-.3-7-.5-2.5-.2-5-.4-7.5-.6-4.1-.3-8.1-.6-12.2-.9-3-.2-6-.5-9-.7-3.5-.2-7-.4-10.5-.6,0-.9-.1-1.7,0-2.6.1-1-1.3-1.9-.3-2.4,1,.1,3.8.2,4.8.3.4.2.8.5,1.2.5,3.5.3,7,.5,10.5.8,5.1.3,10.2.6,15.3,1,1.9.1,3.8.3,5.6.4l5.9.4c.2,0,.4,0,.5,0h.6c2.3.2,4.7.4,7,.6,1.6.1,3.2.3,4.8.4,2.9.3,5.8.6,8.8,1,1.8.2,3.6.4,5.4.5.5.1,20.5,1.5,21,1.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M77.1,253.9c-21.2-8-44.3-11.7-66.6-11.9-7,0-13.9,1.5-20.8,1.3-11.3-.3-22.2-3.2-33.6-2.5-.9,1.5-.7,3.6.7,4.4.3.2,1,.5,1.2.7.1.1.3.2.5.1,3.6-.1,2.6-.2,3.9-.3,6.4-.7,22.7,2.9,23.8,3.1,5,.9,9.8,2.6,14.8,3.6.5,0,1,0,1.6.1,27.1,2.5,54.6,13.8,81.6,6.1-1.8-2.5-4.5-3.7-7.1-4.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M120.1,268c.4-.1.9-.3,1.3-.4-.2-1.1.1-2.2,1.1-2.9,2.3-1.8,1.8,2.2,6.1-3-20.6-7.4-41.6-12.6-63.1-12.8-7,0-13.9,1.5-20.8,1.3-11.3-.3-22.2-3.2-33.6-2.5-.9,1.5,0,3.8,1.6,4.6,1.5.8,3.2.5,4.8.3,6.4-.7,13,.3,19,2.9,1.8.8,3.6,1.7,5.5,2.3,1.9.6,3.9.9,5.9,1.1,3.2,0,6.5.2,9.8.5,20.7,1.9,41.7,9,62.5,8.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-294",
    d: "M125.7,263.9c.4-.1.9-.3,1.3-.4-.2-1.1.1-2.2,1.1-2.9,1.1-.8,1.5,0,2.5-.2,1.9-.3,3.2-2.2,4.2-3.7-1.2,1.8-15-3.9-16.9-4.5-1.7-.5-6-2.6-7.7-2-1.9.6-1.7,3.5-1.6,5,.2,1.6.4,3.3.7,4.9.7,3.9,3.3,3.2,6.6,3.4,2.7.2,7.1,1.2,9.8.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M-37.8,280.6v-.4c-.1,0-.5-1.2-.5-1.2l-4-13.8c-.4.7,0,2.6,0,3.4,0,4.1,0,8.3,1.6,12.1.4,1,1,2,2,2.4,0,0,.1,0,.2,0,.2,0,.3-.2.3-.4.2-.7.3-1.3.5-2v-.2c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M9.3,334.2c-2.4,1.2-4.4.3-5.6-1.2-1.2-1.5-.9-3.1-.4-4.6.5-1.3,1.4-2.2,3-2.3,1.8-.1,3,.8,3.9,2.2.2.3.4.7.5,1.1,0,.4.1.8.2,1.2,0,.2-.1.5-.2.7-.5,1-.9,2-1.4,2.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M23.7,343h.8c1.4,0,2.2.5,2.5,1.6.3,1.1-.3,2.5-1.3,3.2-.8.5-1.6,1.3-2.5,1.6-1,.3-2.2.3-3.2.3-.1,0-.4-.7-.4-1.1,0-1,.3-2,.4-3.1.1-1.5,1.6-2.5,3.6-2.5h0ZM24.8,347.6c.1-.1.3-.3.4-.4-.1-.4-.1-1.1-.3-1.1-.8-.2-1.7-.3-2.6-.4,0,.2,0,.3,0,.4.8.5,1.7,1,2.5,1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M26.8,332.6c1.8,0,3.1,1.2,3.1,2.8s-1.2,2.9-2.9,2.9-3.1-1.2-3.1-2.9c0-1.8,1-2.8,2.9-2.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M43.6,319.8c.5.3,1.1.5,1.6.9,1.3,1,2.6,1.5,4.3,1.4.9,0,1.8.3,2.7.5,0,.1,0,.3,0,.4-2.5,1-5,1-7.1-.9-.7-.6-1-1.6-1.4-2.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M10.7,331.3c0-.2.1-.5.2-.7.4,0,.7.1,1.1.2,0,.1,0,.3,0,.4-.4,0-.9,0-1.3.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M20.4,287.2c-.3.4-.6.8-.8,1.3,0,.2,0,.3-.1.5-.3-.5-.6-1.1-1-1.3-1.2-.5-2.4-.8-3.6-1.1-.2,0-.6,0-.7.2,0,.3-.1.7,0,1,.4.8,1,1.6,1.6,2.6-.1,0-.4.4-.6.4-1-.3-3.2-2.2-3.1-2.6.5-1,.2-1.4-.7-1.9-.8-.4-1.6-.8-2.4-.1-.1.1-.3.2-.5.2-2.3.2-8.3-1.5-8.8-2.2-.2-.3-.5-.5-.8-.6-.7-.2-.8-.6-.7-1.2,2,.4,3.9.8,5.9,1.2,2.6.6,5.3,1.2,7.9,1.8,2.6.6,5.3,1.1,8,1.6.2,0,.4.2.6.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M27.1,288.5c-.2.7-.5,1.1-1.3,1-.4,0-.9.1-1.3.2-.4,0-1,0-1.1-.1-.6-1.1-1.6-1.2-2.7-1.1,0-.5,0-.9.1-1.3,2.1.4,4.1.9,6.2,1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M-6,281.2c-.4-.2-.7-.3-1.1-.5.4.2.7.3,1.1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M66.7,296.4c-.2,0-.4-.2-.6-.2.2,0,.4.2.6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M-3.9,282c-.2-.2-.4-.3-.6-.5.2.2.4.3.6.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-320",
    points: "210 239.5 210 239.5 210 239.5 210 239.5"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-179"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 205.8,
    y: 241.8,
    width: 2.7,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 205.8,
    y: 241.1,
    width: 2.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 205.8,
    y: 240.4,
    width: 2.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 205.8,
    y: 239.7,
    width: 2.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-330",
    x: 205.8,
    y: 239.6,
    width: 2.7,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 200.5,
    y: 240.4,
    width: 1.6,
    height: 0
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 200.5,
    y: 239.7,
    width: 1.6,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-330",
    x: 200.5,
    y: 239,
    width: 1.6,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-258",
    x: 200.5,
    y: 238.4,
    width: 1.6,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 143.1,
    y: 258.8,
    width: 117.1,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 143.1,
    y: 258.1,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-327",
    x: 143.1,
    y: 257.4,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-248",
    x: 143.1,
    y: 256.8,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 143.1,
    y: 256.1,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-325",
    x: 143.1,
    y: 255.4,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 143.1,
    y: 254.7,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-338",
    x: 143.1,
    y: 254,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 143.1,
    y: 253.3,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-334",
    x: 143.1,
    y: 252.7,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 143.1,
    y: 252,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 143.1,
    y: 251.3,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 143.1,
    y: 250.6,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 143.1,
    y: 249.9,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 143.1,
    y: 249.3,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 143.1,
    y: 248.6,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-337",
    x: 143.1,
    y: 247.9,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 143.1,
    y: 247.2,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-268",
    x: 143.1,
    y: 246.5,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 143.1,
    y: 245.8,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-226",
    x: 143.1,
    y: 245.2,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 143.1,
    y: 244.5,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 143.1,
    y: 243.8,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-323",
    x: 143.1,
    y: 243.1,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 143.1,
    y: 242.4,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 143.1,
    y: 241.8,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 143.1,
    y: 241.1,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 143.1,
    y: 240.4,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 143.1,
    y: 239.7,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-330",
    x: 143.1,
    y: 239,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-258",
    x: 143.1,
    y: 238.4,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 143.1,
    y: 237.7,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-236",
    x: 143.1,
    y: 237,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-231",
    x: 143.1,
    y: 236.3,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 143.1,
    y: 235.6,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-177",
    x: 143.1,
    y: 235,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 143.1,
    y: 234.3,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-298",
    x: 143.1,
    y: 233.6,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 143.1,
    y: 232.9,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 143.1,
    y: 232.2,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 143.1,
    y: 231.5,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 143.1,
    y: 230.9,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 143.1,
    y: 230.2,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-315",
    x: 143.1,
    y: 229.5,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 143.1,
    y: 228.8,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-278",
    x: 143.1,
    y: 228.1,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-257",
    x: 143.1,
    y: 227.5,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-256",
    x: 143.1,
    y: 226.8,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 143.1,
    y: 226.1,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 143.1,
    y: 225.4,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 143.1,
    y: 224.7,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 143.1,
    y: 224.1,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-262",
    x: 143.1,
    y: 223.4,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 143.1,
    y: 222.7,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 143.1,
    y: 222,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 143.1,
    y: 221.3,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 143.1,
    y: 220.7,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 143.1,
    y: 220,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 143.1,
    y: 219.3,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 143.1,
    y: 218.6,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-333",
    x: 143.1,
    y: 217.9,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 143.1,
    y: 217.2,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-242",
    x: 143.1,
    y: 216.6,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 143.1,
    y: 215.9,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 143.1,
    y: 215.2,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-295",
    x: 143.1,
    y: 214.5,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-300",
    x: 143.1,
    y: 213.8,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-335",
    x: 143.1,
    y: 213.2,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 143.1,
    y: 212.5,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-320",
    x: 143.1,
    y: 211.8,
    width: 117.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-320",
    x: 143.1,
    y: 211.6,
    width: 117.1,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M181.3,251.5c-.9,1-1.9,1.2-3.1.5-.2-.1-.4-.2-.6-.1-1.2.1-2.4.4-3.7.4-1.1,0-2.1-.6-3.2,0,0,0-.4-.2-.6-.4-.6-.7-1.1-.8-1.5-.1-1.4,0-2.3-1-3.8-.5-1.5.5-3.3.4-4.9.6-1.2.2-2.5.5-3.7.8-.2,0-.4.2-.6.2-.7,0-2.3-2.3-2.2-3,0-.2.2-.6.3-.6,1.1-.4,2.1-.8,3.2-1.2,1-.4,2.1-.7,3.1-1.1-1-.3-1.9-.6-2.8-1-.7.4-1.5.4-2.4,0-.7-.3-1.4-.3-1.6.8,0,.4-.6.9-.9.9-1.5-.1-2.6.3-3.2,1.8-.7-1.1-1.9-1.5-2.2-.9-.5.9-1.2.7-1.9,1-1,.4-1.9.9-2.8,1.2-1.2.4-1.8,1.3-1.5,2.5,0,.3-.2.6-.4,1-.3-.6-.5-1-.5-1.1-2.1,1.1-4.1,2.2-6.1,3.2,2.4.5,4.8.9,7.2,1.1,3.1.3,6.1.5,9.2.8,5.1.5,10.2,1.1,15.3,1.6,3.9.4,7.8.8,11.7,1.1,2.9.2,5.9.4,8.8.5.9,0,1.3-.3,1.7-1.2.4-.9,1.1-1.8,1.9-2.4,1.9-1.3,3.9-2.5,5.9-3.6,1.1-.6,2.3-1.2,3.5-1.6-5.9-.2-11.9-.6-17.7-1.4,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M154.9,199.1h0s0,0,0,0h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 88.7,
    y: 236.7,
    width: 0.6,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 88.7,
    y: 236.5,
    width: 0.6,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-298",
    x: 96.2,
    y: 241.6,
    width: 3.9,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 96.2,
    y: 241.2,
    width: 3.9,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 96.2,
    y: 240.8,
    width: 3.9,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 96.2,
    y: 240.3,
    width: 3.9,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 96.2,
    y: 240,
    width: 3.9,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 96.2,
    y: 239.6,
    width: 3.9,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-315",
    x: 96.2,
    y: 239.1,
    width: 3.9,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 96.2,
    y: 238.8,
    width: 3.9,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-278",
    x: 96.2,
    y: 238.3,
    width: 3.9,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-257",
    x: 96.2,
    y: 237.9,
    width: 3.9,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-256",
    x: 96.2,
    y: 237.5,
    width: 3.9,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 96.2,
    y: 237.1,
    width: 3.9,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 96.2,
    y: 237.1,
    width: 3.9,
    height: 0
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 75.1,
    y: 256,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-327",
    x: 75.1,
    y: 255.6,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-248",
    x: 75.1,
    y: 255.2,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 75.1,
    y: 254.8,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-325",
    x: 75.1,
    y: 254.4,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 75.1,
    y: 254,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-338",
    x: 75.1,
    y: 253.6,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 75.1,
    y: 253.2,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-334",
    x: 75.1,
    y: 252.8,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 75.1,
    y: 252.4,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 75.1,
    y: 252,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 75.1,
    y: 251.6,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 75.1,
    y: 251.2,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 75.1,
    y: 250.8,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 75.1,
    y: 250.4,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-337",
    x: 75.1,
    y: 250,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 75.1,
    y: 249.6,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-268",
    x: 75.1,
    y: 249.2,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 75.1,
    y: 248.8,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-226",
    x: 75.1,
    y: 248.4,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 75.1,
    y: 248,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 75.1,
    y: 247.6,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-323",
    x: 75.1,
    y: 247.2,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 75.1,
    y: 246.8,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 75.1,
    y: 246.4,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 75.1,
    y: 246,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 75.1,
    y: 245.6,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 75.1,
    y: 245.2,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-330",
    x: 75.1,
    y: 244.8,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-258",
    x: 75.1,
    y: 244.4,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 75.1,
    y: 244,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-236",
    x: 75.1,
    y: 243.6,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-231",
    x: 75.1,
    y: 243.2,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 75.1,
    y: 242.8,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-177",
    x: 75.1,
    y: 242.4,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 75.1,
    y: 242,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-298",
    x: 75.1,
    y: 241.6,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 75.1,
    y: 241.2,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 75.1,
    y: 240.8,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 75.1,
    y: 240.3,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 75.1,
    y: 240,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 75.1,
    y: 239.6,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-315",
    x: 75.1,
    y: 239.1,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 75.1,
    y: 238.8,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-278",
    x: 75.1,
    y: 238.3,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-257",
    x: 75.1,
    y: 237.9,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-256",
    x: 75.1,
    y: 237.5,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 75.1,
    y: 237.1,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 75.1,
    y: 236.7,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 75.1,
    y: 236.3,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 75.1,
    y: 235.9,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-262",
    x: 75.1,
    y: 235.5,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 75.1,
    y: 235.1,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 75.1,
    y: 234.7,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 75.1,
    y: 234.3,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 75.1,
    y: 233.9,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 75.1,
    y: 233.5,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 75.1,
    y: 233.1,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 75.1,
    y: 232.7,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-333",
    x: 75.1,
    y: 232.3,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 75.1,
    y: 231.9,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-242",
    x: 75.1,
    y: 231.5,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 75.1,
    y: 231.1,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 75.1,
    y: 230.7,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-295",
    x: 75.1,
    y: 230.3,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-300",
    x: 75.1,
    y: 229.9,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-335",
    x: 75.1,
    y: 229.5,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 75.1,
    y: 229.1,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-320",
    x: 75.1,
    y: 228.7,
    width: 66.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-320",
    x: 75.1,
    y: 228.7,
    width: 66.8,
    height: 0
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M242,186.3c-1.1-7.7-2.3-15.5-5.4-22.6-2.2-5-8.3-11.4-7-17.3,0,0,0,0,0-.1-.1-.4-.1-.9-.3-1.3-.3-.7-.4-2.7-1-3.1-.7-.4-2.8.1-3.7.5-.7.3-.6,1-.6,1.6,0,1.1.4,1.1-.5,1.7-1.5,1-4.1,1-5.7,1.4-3,.8-6.1.1-9.2-.2-.4,0-.8,0-1.1.2-.2.2-.2.4-.3.6-1.4,6-1.2,12.4-1.4,18.6,0,.6,0,1.2,0,1.7.1.7,0,5.5,0,8.7-.1,1.8,0,6,.1,7.8.2,1.4-.1,3-.3,4.4-.2,1.6-.4,3.1-.6,4.7-.1.7-.2,1.4-.4,2.1,0,.2-.5,1.6-.4,1.7.5.7,1,1.4,1.5,2,.7.9,1.3.6,2.2.5,0,0,.1,0,.2,0,1.4-.2,2.7,0,3.9.8.5.3,1,.7,1.6.7.5,0,1.1,0,1.7.1.3.1.5.4.8.6,1.4,1.4,2.3,3.1,3.5,4.7.4.6,1,1.1,1.7,1.3s1.5-.4,1.5-1.1c1.8-.5,3.9.9,4.1,2.8,3.1.3,5,4,8,4.7.9.2,1.9.2,2.8,0,1.1-.1,2.2-.3,3-1,.9-.7,1.4-1.7,1.8-2.7,1.4-3.8,1.4-8,0-11.8-.2-.7-.6-1.4-.6-2.1-.2-1.3.3-2.5.5-3.7.4-2.3,0-4.6-.3-6.8,0,0,0-.1,0-.2h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M240.8,192.1c0,.1.1.2.2.3,0-.2,0-.3,0-.5,0,0-.1,0-.1,0,0,0-.1.2,0,.2h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M241,191.9c0,.2,0,.3,0,.5,0-.1-.2-.2-.2-.3,0,0,0-.2,0-.2,0,0,.1,0,.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M214.9,191.7c-.5-1.7-1-3.5-1.4-5.3-.2-.7-2.6-14.8-2.3-21.3.1-3.1.6-5.5-.2-8.6-.7-2.8-1.8-5.9-.6-8.7l-2.3-1.1c-.2-.1-.5-.2-.7,0-.2.1-.3.4-.3.6-1.4,8.6-2.1,17.3-2.3,26.1,0,4.4,0,8.7.2,13.1,0,1.8.5,3.8.1,5.5-.4,1.6-1.6,2.9-1.6,4.7,0,3.7,2.8,4.6,5.7,5.2,1.5.3,3.2.7,4.1,2,.4.5.6,1.1,1.1,1.4.8.4,1.7,0,2.6.2.4.1.8.4,1,.7-.6-2.6-1.4-5.1-1.7-7.8-.7-2.1-1.2-4.3-1.4-6.5h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M43.2,245c.9,0,1-.4.5-1.1-.6.5-1.6.2-2-.7-.1.3-.3.6-.3.6-.4,0-.8-.1-1.1,0-1.6.2-1.7.1-2-1.9-.2.6-.3.9-.4,1.2-.3-.3-.6-.5-1-.8h0v-1.1c0,0-.1,0-.2,0-.1.4-.2.7-.3,1.1h0c0,0-.1,0-.2,0h0v-1.2h-1.5c0-3,3.3-4.4,5.3-3.2,0,.1,0,.2.1.3,0,0,.1,0,0,0,0-.1-.1-.2-.2-.3.1-.1.3-.4.4-.4.6.3,1.1.6,1.7.9,0-.4.1-.7.2-1.2.4.2.6.3.9.4.7.5,1.3,1.2,2.3.4.2-.2.8.3,1.3.4.3.1.7.2.9.2.3.6.6,1.2.9,1.8.3-.3.6-.6,1-1.2.3.4.6.9,1,1.6.3,0,.8.1,1.4.2.3-.3-.6-1.4.9-1.3.6,0,0-1.9-1.1-2.2.2,1.3-.8,1.3-1.6,1.5-.1-.3-.2-.5-.3-.8,0,0,.2,0,.3.1.1-.2.4-.4.4-.6.1-.7.4-1.1,1.2-1.1.8,0,1.6-.3,2.4-.4.7,0,1.5-.5,2.2.4.2.3,1,0,1.7,0,.2.9-.4,1.1-1.3,1.1,0-.1,0-.2-.1-.3,0,0,0,0,0,0,0,.1.1.2.2.3,0,1.2.6,1.3,1.5.6.2.3.5.6.7,1,.3-.4.3-1.4,0-3,1.5,1.5,3.1,3,4.7,4.7.1-.4.2-.9.4-1.4.1,0,.2,0,.3,0v2.3s.2.1.4.3c0,0,0,.2.2.7-1-.4-1.8-.8-2.6-1.1v1.5h2.5l.5.7c-.4.2-.9.4-1.4.7.5.3.9.5,1.3.7.1,0,.2,0,.3,0-.8-1.5.1-2.6.7-4,.5,0,1.3.2,1.6,0,.4-.3.3-1.1.5-1.8,1.1.2.4.9.3,1.4.3,0,.7.1,1.2.2-.4.3-.6.5-.9.7.4.3.7.6,1.2,1.1.2-1.2.3-2.2.4-3.3,1.8.5.2,1.7.9,2.5.2-.2.3-.4.6-.7.2.6.4,1.2.5,1.6.3-.1.6-.3.9-.4,0,.7,0,1.4,1,1.5.3-.7.5-1.4.6-1.7-.2-.6-.3-1-.4-1.4.3-.6.5-1.1.9-1.9.6-.4,2.3.7,2.2-1.4.3.2.6.5.8.5.5,0,1.3-.3,1.3-.4,0-.9.6-1.2,1.3-1.6,1.2-.6,1.5-1.9,2.1-3,.6-.8,1-1.4,2.1-1,.8.3,1.8.3,2.2-.8.1-.3.7-.3,1-.4.6-.2,1.2-.2,2.1-.4-.5-.6-.8-.9-1.1-1.3-.1-.2,0-.6,0-.8.1-.2.3-.4.4-.4,1.8-.6,3.6-1.1,5.5-1.7.6-.2,1.1-.7,1.7-.8,1.3-.3,2.5-.9,3.9-.3.8.3,1.7,0,2.4.9.1.2.6.2.8.1,1.1-.6,1.7,0,2.5.7-1.2,1.1-2.1,2.4-3.6,2.9-.8.3-1.3,1.2-2,1.8-.2.2-.6.3-.9.5-.5,0-1.1,0-1.5-.1-.6.7-1.2,1.3-1.9,2-.6-.3-1-.5-1.6-.8-.2.5-.4,1-.7,1.6-.8-.7-1.4-.7-1.5.5-2.1.1-4.3-.2-6,1.4-1.2-1-2.1-.8-3.1.5-.2-.2-.3-.4-.6-.7-.3.7-.6,1.4-.8,2-.2.5-.2,1.1-.3,1.8-1.4.2-2.9.4-4.6.6,0,.1,0,.4,0,.9.4-.1.6-.2.9-.3.2.4.4.8.6,1.2-.5.2-.9.4-1.4.5v.3h1.8c0,.4,0,.8.1,1.3-.3-.1-.5-.2-.8-.4,0,.4,0,.8-.1,1.3-.9-.3-1.6-.6-2.3-.9-1.4,1.2-1.2,2.1.8,3-.3.7-.6,1.5-1,2.2-.6,0-1.2-.2-1.9-.3.5-.2,1-.4,1.6-.6,0,0,0-.2,0-.3-.4-.1-.7-.2-1-.3.5-1.4-.4-1.1-.8-1.2-.7.8-1.1,1.4-1.6,1.9-1.1-.1-2.2-.2-3.2-.4-.5-.6-1.3-1.1-1.3-2,0-.2-.5-.3-.7-.5.1.8.3,1.6.4,2.3-1.5-.2-3.1-.4-4.6-.6v-2.1h-.4c-.3.3-.7.7-1.1,1.3.4,0,.8-.1.8-.1.2.6-.2.7-.6.7-2.4-.4-4.8-.8-7.3-1.1l.4-1.8-.4-.3c-.6.5-1.2,1-2,1.6-.3-.3-.6-.7-1-1.2-.6-.8-.7.1-1.2.7-.2-.4-.3-.6-.4-.9,0,0,0,0,0-.1,0,0,0,0,0,.1h-1c-.1.4-.2.7-.3,1-.2,0-.4-.2-.6-.2-.3-.4-.6-.8-.9-1.4-.3.2-.5.5-.8.7-.2-.5-.3-1-.6-1.7-.6.7-1.1,1.3-1.5,1.8-.4,0-.7-.1-1.1-.2h0ZM38.7,239.5c-.7-.2-1.4-.4-2.1-.6,0-.1-.1-.2-.2-.3,0,0-.1,0,0,0,0,.1.1.2.2.3.1.4.3.8.4,1.2.7-.2,1.2-.4,1.8-.6,0,0,0-.1,0-.2,0,0-.1,0-.1,0h0ZM54.1,237.9c.2.2.5.3.5.5,0,1.5,0,1.5,1.7,1.7.3.5.7,1,.8,1.5,0,1.1.7,1.3,1.4,1.3v-2.5c-.9-.1-1.5-.2-2.2-.3-1.1-.8-.4-2-.6-2.8-.4,0-.8,0-1.1,0-.2,0-.4.4-.5.6-.1,0-.2,0-.3.1,0,0,0,0,0,0,.1,0,.2-.1.3-.2h0ZM73,247.2c.6-.8.6-1.4,0-1.8v1.8ZM75.4,241.2c1.1,0,1.7-.2,1.7-.5-.4-.1-.8-.2-1.2-.3-.1.2-.3.4-.5.8ZM83.9,234.1c-.1,0-.3,0-.4.1.1.4.2.9.4,1.3.1,0,.2,0,.3,0-.1-.4-.2-.9-.3-1.3h0ZM81.7,237.8v-.4c-.2,0-.5,0-.8,0,0,0,0,.2,0,.3h.8ZM58.1,244.7c0-.6-.1-.9-.7-.7.2.2.4.4.7.7ZM74.2,245.5c0,.2.2.3.2.5.3-.2.5-.3.8-.5,0-.1-.1-.2-.2-.3l-.8.3h0ZM71,244.8c-.1,0-.2-.2-.3-.2,0,0-.2.2-.2.2,0,.1.2.2.3.3,0,0,.1-.2.2-.3h0ZM39,240.2c0,0-.1,0-.2,0v.5c.2,0,.3,0,.3,0,0-.2,0-.3-.1-.5h0ZM35.6,240.2c0,0-.2-.1-.2,0,0,0,0,.1-.1.2,0,0,.2.1.2,0,0,0,0-.1.1-.2h0ZM76.2,241.8c0,0-.2.1-.2.2,0,0,0,.1,0,.2,0,0,.2-.1.2-.2,0,0,0-.1-.1-.2ZM53.2,237.2c0,0,0,.2-.1.2,0,0,.2.1.2,0s0-.1.1-.2c0,0-.1,0-.2-.1h0ZM84.9,235.1h-.1v.4h.1v-.4ZM45,239.1s0,0,0,0c0,0,0,0-.1,0,0,0,0,0,0,.1,0,0,0,0,0,0h0ZM57.2,244.6h.1s0,0,0,0c0,0,0,0-.1,0h0ZM48.2,244.9s0,0,0,.1,0,0,0,0c0,0,0,0,0-.1s0,0,0,0ZM52.9,245s0,0,0,0c0,0,0,0,.1,0,0,0,0-.1,0-.2,0,0,0,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M122.8,231.8c-.9,0-1.9.4-2.6,1-1.1.9-2.3.7-3.6.6-.4,0-.7-.5-1-.7-.1,0-.2,0-.4.1.2-1,.4-2,.6-3-.1,0-.4,0-.7.2-.7.3-1.4.8-2,.7-1.1-.2-2-.3-2.5,1,0,0-.2.2-.4.2-.9-.3-1.8-.6-2.8-1,.6-.4.9-.7,1.2-.9-.6-1.4-.7-1.7.2-2-.6-.3-1.3-.7-2.1-.8-1.1,1.1-2.1,2.3-3.6,2.9-.8.3-1.3,1.2-2,1.8-.2.2-.6.3-.9.5-.2.4-.4.7-.6,1.1,0,.3,0,.5,0,.8,0,.4-.1.8-.1,1.2,0,.5.2.9.2,1.4,1.1-.3.9.8,1.4,1.2.3.3.6.7,1,.8.8.2,1.6.2,2.5.3,0-1.7,1.4-1.7,2.2-2.2.9.4,1.7.7,2.6,1,0,0-.1.3-.2.6,1.5.3,2.8,0,3.8-1.2.2.2.3.3.3.4,0,1.2.4,1.5,1.6,1.1.3-.1.9,0,1.1.1.7.7,1.3,1.6,2.2,2.6.7-.3,1.8-.4,2.4-1.1.6-.6.7-1.8,1.1-2.7.2-.5.6-1.1.9-1.5.1-.2.5-.3.6-.4.3-.9.6-1.8.9-2.6-.5-.4-1.1-1.2-1.6-1.2h0ZM114.1,233.8h-3.9c0,0,0-.3.1-.5-.5,0-1,.2-1.5.3,0-.2,0-.3,0-.5.6,0,1.2-.1,1.9-.2.4,0,.9-.1,1.3-.3,1.4-.6,2-.3,2.2,1.2,0,0,0,0,.1.1,0,0,0,0-.1-.1h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-158"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "121.7 230.5 134 228.8 134 230.5 121.7 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "120.4 230.5 134 228.6 134 228.8 121.7 230.5 120.4 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-292",
    points: "119 230.5 134 228.4 134 228.6 120.4 230.5 119 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "117.7 230.5 134 228.2 134 228.4 119 230.5 117.7 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-225",
    points: "116.4 230.5 134 228.1 134 228.2 117.7 230.5 116.4 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "115.1 230.5 134 227.9 134 228.1 116.4 230.5 115.1 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-340",
    points: "113.7 230.5 134 227.7 134 227.9 115.1 230.5 113.7 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-251",
    points: "112.4 230.5 134 227.5 134 227.7 113.7 230.5 112.4 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-341",
    points: "111.1 230.5 134 227.3 134 227.5 112.4 230.5 111.1 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "109.8 230.5 134 227.1 134 227.3 111.1 230.5 109.8 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "108.4 230.5 134 227 134 227.1 109.8 230.5 108.4 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "107.1 230.5 134 226.8 134 227 108.4 230.5 107.1 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "105.8 230.5 134 226.6 134 226.8 107.1 230.5 105.8 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-255",
    points: "104.5 230.5 134 226.4 134 226.6 105.8 230.5 104.5 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-162",
    points: "103.1 230.5 134 226.2 134 226.4 104.5 230.5 103.1 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-342",
    points: "101.8 230.5 134 226 134 226.2 103.1 230.5 101.8 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "100.5 230.5 134 225.9 134 226 101.8 230.5 100.5 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "99.2 230.5 134 225.7 134 225.9 100.5 230.5 99.2 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-312",
    points: "97.9 230.5 134 225.5 134 225.7 99.2 230.5 97.9 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-301",
    points: "96.5 230.5 134 225.3 134 225.5 97.9 230.5 96.5 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "95.2 230.5 134 225.1 134 225.3 96.5 230.5 95.2 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "93.9 230.5 134 224.9 134 225.1 95.2 230.5 93.9 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-316",
    points: "92.6 230.5 134 224.8 134 224.9 93.9 230.5 92.6 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-331",
    points: "91.2 230.5 134 224.6 134 224.8 92.6 230.5 91.2 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "89.9 230.5 134 224.4 134 224.6 91.2 230.5 89.9 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-302",
    points: "88.6 230.5 134 224.2 134 224.4 89.9 230.5 88.6 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "87.3 230.5 134 224 134 224.2 88.6 230.5 87.3 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-206",
    points: "86.1 230.5 134 223.8 134 224 87.3 230.5 86.1 230.5 86.1 230.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "86.1 230.3 134 223.7 134 223.8 86.1 230.5 86.1 230.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "86.1 230.1 134 223.5 134 223.7 86.1 230.3 86.1 230.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-156",
    points: "86.1 229.9 134 223.3 134 223.5 86.1 230.1 86.1 229.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-185",
    points: "86.1 229.7 134 223.1 134 223.3 86.1 229.9 86.1 229.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-195",
    points: "86.1 229.6 134 222.9 134 223.1 86.1 229.7 86.1 229.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "86.1 229.4 134 222.7 134 222.9 86.1 229.6 86.1 229.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "86.1 229.2 134 222.6 134 222.7 86.1 229.4 86.1 229.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "86.1 229 134 222.4 134 222.6 86.1 229.2 86.1 229"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-208",
    points: "86.1 228.8 134 222.2 134 222.4 86.1 229 86.1 228.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "86.1 228.6 134 222 134 222.2 86.1 228.8 86.1 228.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "86.1 228.5 134 221.8 134 222 86.1 228.6 86.1 228.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "86.1 228.3 134 221.6 134 221.8 86.1 228.5 86.1 228.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "86.1 228.1 134 221.5 134 221.6 86.1 228.3 86.1 228.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-104",
    points: "86.1 227.9 134 221.3 134 221.5 86.1 228.1 86.1 227.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-309",
    points: "86.1 227.7 134 221.1 134 221.3 86.1 227.9 86.1 227.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-244",
    points: "86.1 227.5 134 220.9 134 221.1 86.1 227.7 86.1 227.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-247",
    points: "86.1 227.4 134 220.7 134 220.9 86.1 227.5 86.1 227.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "86.1 227.2 134 220.5 134 220.7 86.1 227.4 86.1 227.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-142",
    points: "86.1 227 134 220.3 134 220.5 86.1 227.2 86.1 227"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "86.1 226.8 134 220.2 134 220.3 86.1 227 86.1 226.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-228",
    points: "86.1 226.6 134 220 134 220.2 86.1 226.8 86.1 226.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-248",
    points: "86.1 226.4 134 219.8 134 220 86.1 226.6 86.1 226.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-248",
    points: "134 219.8 86.1 226.4 86.1 218.9 134 218.9 134 219.8"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M278.2,224.8c-.6,0-1.2,0-1.9,0-.1-.4-.2-.9-.4-1.2-.2-.5-.6-.9-.9-1.3-.5-.8-1.2-1.2-2.2-1.4-2.6-.4-4.8.1-6.8,1.9-1.6,1.1-1.7,1.9-.2,2.7.4,1.3,1.2,2.6.8,4.1l-.3.5c-.1.2-.3.4-.4.6-.2.8-.7,1.1-1.5,1-.4,0-.9,0-1.3,0-.4,0-.7,0-1,0h-1.4c-.3,0-.5,0-.8.1,0,0-.2.1-.3.2h0c-.5.2-.9.4-1.3.5,0-.2,0-.3,0-.5l-.4-.7c0-.1,0-.3-.1-.4,0-1.5,0-3-1.5-3.9,0,0,0-.1,0-.2-.7-.8-1.5-1.7-2.2-2.5.1-.2.2-.5.4-.8.2,0,.4,0,.5,0,2.3,1.2,4.5,1.6,6.6-.5.5-.5,1.2-.8,1.9-.9,1.2-.2,1.9-.9,2.8-1.8-.7-.1-1.2-.2-1.7-.3,0,0,0-.2,0-.2,1.1-.1,2.2-.3,3.3-.4,1.6,0,3.1-.1,4.7,0,3.9.4,7.7.9,11.6,1.4-.9.9-1.3,1.9-1.5,3.2,0,.6.2,1.7-1,1.6-1.1-.3-2.2-.7-3.3-1h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-277",
    x: 241.3,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-292",
    x: 241.4,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 241.5,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-225",
    x: 241.6,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 241.8,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-340",
    x: 241.9,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-251",
    x: 242,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-341",
    x: 242.1,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 242.2,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 242.4,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 242.5,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 242.6,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-255",
    x: 242.7,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 242.8,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-342",
    x: 242.9,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 243.1,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 243.2,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-312",
    x: 243.3,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-301",
    x: 243.4,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 243.5,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 243.6,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-316",
    x: 243.8,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-331",
    x: 243.9,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 244,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-302",
    x: 244.1,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 244.2,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 244.4,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-259",
    x: 244.5,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-246",
    x: 244.6,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 244.7,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 244.8,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 244.9,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 245.1,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 245.2,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 245.3,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: 245.4,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 245.5,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 245.6,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 245.8,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 245.9,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 246,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-309",
    x: 246.1,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-244",
    x: 246.2,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-247",
    x: 246.4,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 246.5,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 246.6,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 246.7,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 246.8,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-248",
    x: 246.9,
    y: 218.2,
    width: 0.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-248",
    x: 247.1,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 247.5,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-276",
    x: 248,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 248.5,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-328",
    x: 249,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-247",
    x: 249.5,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 249.9,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 250.4,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 250.9,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 251.4,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-297",
    x: 251.9,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 252.3,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 252.8,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-321",
    x: 253.3,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-233",
    x: 253.8,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-279",
    x: 254.3,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 254.7,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 255.2,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-237",
    x: 255.7,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 256.2,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 256.7,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 257.1,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-311",
    x: 257.6,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-285",
    x: 258.1,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 258.6,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 259.1,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-283",
    x: 259.5,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 260,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 260.5,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 261,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 261.5,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-227",
    x: 261.9,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 262.4,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 262.9,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 263.4,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 263.9,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 264.3,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-287",
    x: 264.8,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 265.3,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-202",
    x: 265.8,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 266.3,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-299",
    x: 266.7,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 267.2,
    y: 218.2,
    width: 0.5,
    height: 7.2
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M216.2,259.6c-.5.5-1,1-1.3,1.5-.1.2,0,.8.2.9.9.4,1.7,0,2-1,.4-1.3,1.7-1.7,2.9-.9-.6,1-.9,2.1.3,2.9-.4,1.3-1,1.7-2.3,1.3-1.3-.3-2.8-.2-4.1-.4-4.2-.3-8.4-.7-12.5-1.1-.9,0-1.7-.1-2.7-.2.6-.5,1.2-.8,1.6-1.3,1-1.1,2.3-1.5,3.8-1.3.4,0,.6.6,1,.9.3.2.7.4,1.1.6,0-.4.2-.9.2-1.3,0-.6,0-1.2-.1-1.8.6,0,1.2-.3,1.8-.1,1.9.5,3.8.5,5.6-.1.9-.3,1.8.1,2.6,1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M205.3,191.3c.1-1.1.1-2.2.1-3.4,0-.9-.1-1.9-.2-2.8h0c-8,1.7-16.3,1.6-24.5,1.6-5.7,0-11.6-.7-17.1-2.1-1.1-.3-2.2-.6-3.2-1-1.5-.7-1.9-2.1-2.6-3.6-2-4.2-4-8.4-5.9-12.6.6,1.3.4,3.4.7,4.8.4,1.8.9,3.5,1.4,5.2.8,3,1.5,6,2.5,8.9.9,2.7,2.3,4.9,2.2,7.9,0,.4,0,.8-.2,1.1-.1.3-.3.6-.5.8-.4.5-.7.9-1.1,1.4,1-.7,2-1.2,3.1-1.6.4-.3.8-.5,1.3-.7,1.5-.5,3.2-.6,4.8-.8,2-.3,3.3-1.2,5-2.2.9-.5,3.1-1.5,3.7-.3.8-.4,1.6-.7,2.5-.7s1.6.2,2.3.7c0,0,0,0,0,0,.3.1,1,.2,1,0,0,0,4.9-1.4,6.8,1.3.5.7,1.2.9,1.9.4,2.1-1.3,3.9-1,5.3.7,1.1-.1,2-.3,2.9-.2.8,0,1.7.2,2.5.4h0c.4,0,.8.1,1.2.2.2,0,.4.1.6.2.2,0,.4,0,.5.1.5.7,1.7,1.7,1.8,2.6.2-.5.4-1.1.5-1.6.2-.5.3-1,.3-1.6s-.1-1,0-1.5c0-.6.2-1.1.2-1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M181.4,190.1c0-.1,0-.2,0-.3h0c0,0,0,0,0-.1,0,0,0,0,0,0,0,.2-.1.3-.2.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M248.3,223.7c1.6,0,3.2-.2,4.8-.2.4,0,.8.1,1.2.2-.1.3-.3.6-.4.8.8.9,1.5,1.7,2.2,2.5-.3-.1-.8-.2-.9-.4-.5-1.1-1.5-1.3-2.4-1.6-.5-.2-1.2,0-1.9.2.1-.3.2-.6.4-1.2-.6.1-1,.3-1.4.2-.5,0-1.3.4-1.6-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M50,245c.1.3.2.5.4.9.4-.6.5-1.5,1.2-.7.4.4.7.8,1,1.2.8-.6,1.4-1.1,2-1.6l.4.3-.4,1.8c-.5,0-.9,0-1.4,0-.2,0-.3-.1-.5-.2-.4,0-.9,0-1.4,0l-.3-.2c-.8-.1-1.6-.2-2.4-.4.1-.3.2-.7.3-1h1s0,0,0,0ZM54.2,245.7h-.1v.4h.1v-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M72.6,249.4c.5-.6.9-1.1,1.6-1.9.3,0,1.2-.2.8,1.2.3.1.7.2,1,.3,0,0,0,.2,0,.3-.5.2-1,.4-1.6.6-.6-.2-1.2-.3-1.9-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M236.4,217c1.2.4,2.3.8,3.5,1.2-1.2.2-2.4.3-3.7.5,0-.7.1-1.2.2-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M44.4,245.2c.4-.5.9-1.1,1.5-1.8.2.7.4,1.2.6,1.7.3-.3.5-.5.8-.7.3.5.6.9.9,1.4-.9-.1-1.8-.2-2.7-.4-.2,0-.4-.1-.5-.2-.2,0-.4,0-.5,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M256.2,227.2c1.5.9,1.5,2.4,1.5,3.9-.1,0-.3,0-.4-.2-.4-1.2-.8-2.5-1.2-3.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M67.8,248.8c-.1-.7-.3-1.5-.4-2.3.2.1.7.3.7.5,0,1,.8,1.4,1.3,2-.5,0-1.1-.2-1.6-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M61.8,248c.4,0,.8,0,.6-.7,0,0-.4,0-.8.1.4-.5.8-.9,1.1-1.4h.4v2.2l-1.4-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M258.3,232.7c.5-.2.9-.4,1.3-.5-.3.6-.5,1.3-.8,1.9-.1,0-.2,0-.3,0,0-.4-.1-.9-.2-1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M260.7,231.9c.5,0,.9,0,1.4,0-.5,0-.9,0-1.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M247.8,222.6c.2.4.4.7.5,1.1-.2-.4-.4-.7-.5-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M257.8,231.5l.4.7-.4-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M209.6,238.6h-.4c0-.1.4-.1.4-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M44.9,245.2c.2,0,.4.1.5.2-.2,0-.4-.1-.5-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M52.7,246.6c.2,0,.3.1.5.2-.2,0-.3-.1-.5-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M159.4,196.2c.1,0,.2-.1.3-.2-.1,0-.2.1-.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M247.5,222.3c0,.1.2.2.2.3,0-.1-.2-.2-.2-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M259.6,232.1c0,0,.2-.1.3-.2,0,0-.2.1-.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M210,239.5s0,0-.1,0c0,0,0,0,.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M51.1,246.3l.3.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M-15.3,242.7c-2.2.1-4.4.2-6.5.3-4.8.2-9.6,0-14.4,0-.6-.4-1.2-1-1.8-1-2.2-.2-4.4-.4-6.7-.6.2,0,.4,0,.6,0,3.8-.3,7.1,1.1,10.8,1.1,4.6,0,9.2,0,13.9.1,1.4,0,2.7,0,4.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M4.9,197.6c0,0-3.9-1.5-5.2-2.7,1.4.9,2.7,1.6,2.8,1.6.8.4,1.6.7,2.4,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M7.3,240.8c-4.2.6-7.7,1-7.7,1-1.3,0-2.7.2-4,.3-3,.2-6.1.4-9.1.5.4,0,.7,0,1.1-.1,1.5-.2,12.3-.9,19.8-1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M53.3,152.4c-1.6-.5-3.2-.9-4.9-1.3-.9-.2-1.7-.4-2.6-.6-1.3-.4-2.5-.8-3.8-1.3-2.2-.9-4.5-1.7-6.7-2.7-.8-.3-1.4-1-2.1-1.3-3.7-1.6-7.6-2.4-11.6-2.8-3.7-.4-7.4-.6-11.1-.8-1.1,0-2.2,0-3.3,0-3.7,1.4-7.4,2.9-10.8,5.2-3.4,2.3-7,4.4-10.2,6.9-2.9,2.2-5.5,4.8-8.3,7.3-.4.4-1,.6-1.6.9,0,.3-.1.7-.3,1-1.1,1.3-2.3,2.6-3.5,3.9-.3.3-.6.6-1,.9,0,.1-.2.2-.2.3,0,.1-.2.2-.3.3-2.1,2.3-4.3,4.5-6.3,6.8-5.9,6.8-12.6,14.6-15.3,23.4-2.7,8.7-6.4,17-9,25.8-.6,2-1,4.1-1.3,6.2.1,4.4.4,8.8.9,13.2.3,2.5.6,5.1.9,7.6,0,.5.3,2,.3,2.6.3,2.1.6,4.2.9,6.3.2,1.3.2,2.7.3,4,0,.2,0,1.1,0,1.8,0,0,0,.1,0,.3,1.4,3.8,2.7,7.7,3.9,11.6.3,1,.7,2,1,3,1.4,4.3,2.4,8.8,3.4,13.2.6,2.7,1.3,5.4,1.9,8.1.8,1.6,1.5,3.3,2.1,5,.8,2.3,1.3,4.5,1.6,6.9,0,.8.2,1.6.3,2.4,1.4,3,1.9,6.2,1.5,9.3l2.3,9.7c.2.8.4,1.6.5,2.5.2.1.4.3.7.4.9-1.1,1.7-2.3,2.5-3.4.3-.6.6-1.1.9-1.7-.8-5.6-1.5-11.2-2-16.8-.5-5.5-1-11-1.5-16.5-.1-1.2-.3-2.5-.4-3.7,0-.3,0-.5,0-.7,0-.1,0-.3,0-.5-.2-1-.4-2.1-.6-3.1-.9-2.3-1.7-4.6-2.4-6.9-1.6-4.8-2.7-9.5-3.4-14.5-1.4-4-2.9-8-4.6-12-2.1-5.1-.6-10.5,2.6-14.7.5-3-1.1-5.9-1.6-8.9-.4-2.4-.2-4.9,0-7.3,1.5-11.4,5.3-22.3,10-32.8,2.3-5.2,4.9-10.3,7.5-15.3,2.6-5.1,5.5-8.6,9.6-12.6,2.8-2.8,5.6-5.5,8.7-7.9,6.7-5.2,14.1-7.8,22.6-7.3.4,0,.7,0,1.1,0,.1,0,.2,0,.4,0,2.2.2,4.4.5,6.6.7.7.1,1.3.2,2,.3.3,0,.7,0,1,.1,0-.5.1-.9.3-1.6,2.1,0,4.3,0,6.5,0,2.1,0,4.2.2,6.3.5,5.2.8,10.3.8,15.5.8,1.3,0,2.5.4,3.8.6.5,0,1,0,1.5,0,0-.2,0-.3,0-.5-.4-.1-.8-.3-1.2-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M13.3,368c-4.2-4.7-8.4-9.6-11.8-14.9-.2-.4-.4-.8-.6-1.2-1.7-2.3-3.4-4.7-5.2-6.9-5.5-6.8-10-14.5-13.7-22.3-1.9-4-3.5-8-5.5-12-3.1-6-5.5-11.8-8.2-18-2.6-5.8-4.8-12-6.2-18.1-.7-2.8-1.3-5.9-2-8.7-.7-2.8-1.3-5.7-1.8-8.5-.3-.4-.7-.9-1-1.4-1.9-2.7-2.8-5.8-3.2-9-.5-.9-.9-1.9-1.2-3-2.1-.4-4.7-.4-5.8-.2,2.4,14.1,4.8,28.2,9.1,41.8,4.6,9.2,7.5,20.5,10.6,30.4,1.3,4,2.2,12.9,5.2,15.6,3.9,3.4,7.3,7.4,10.3,11.7,2.6,3.8,4.8,8.6,3.3,13-1.7,5-7.4,7.1-12.4,8.6-2.2.6-15.2,5.2-10.9,9.1,2.9,2.6,19.2-1.7,23.1-2.3,3.9-.6,6.1-.7,9.8.3,3.4,1,7,1.4,10.5,1.2,2.5-.1,7.2-2,10.1-2.4-.8-.7-1.6-1.9-2.3-2.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M134.6,283.1c.2,0,.4,0,.6.1-.2,0-.4,0-.6-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M331.4,213.1c-.1.7-2.1,1.2-17.6-.9-.5,0-1.1,0-1.6.1h-.5c-.1,0-.2-.2-.3-.2-1.2,0-2.3.2-3.5.3,0,0-.2.2-.3.3-.6.6-1.7.7-1.6,1.9-.9.4-.4,1-.3,1.6,0,.8,0,1.5,0,2.3-2.4-.8-4.8-.6-7.3-.3-.4,0-.7.1-1.1,0-2.8-.4-5.2.9-7.6,2.1-.7.3-1.4.7-2,1-.1,0-.4.2-.5,0-1.1-.8-2.2-.1-3.2,0-3.9-.5-7.7-1-11.6-1.4-1.5-.2-3.1,0-4.7,0-3.1-.1-6.2-.1-9.4-.3-5.2-.3-10.5-.7-15.7-1.1-.2-1.2,0-2.2.3-3.3.4-2,1.4-4.6,1.8-6.7,0-.4-.1-.8.1-1.1.2-.2.5-.3.8-.3,1.4,0,2.7,0,4.1,0,1.3,0,3.1,0,4.4.2,1,.2,1.3.3,2.4.3,2.7.1,5.4.4,8.1.5,1.6.1,3.3.2,4.9.3,4.5.3,9,.5,13.5.8.2,0,.3,0,.5-.1,2.3.2,4.6.3,7,.5,3,.3,6,.7,8.9,1,5.2.5,26.9,2.3,32,2.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M265.8,225.6c-1.4-.8-1.4-1.6.2-2.7.2.2.4.5.6.5.9,0,1.1.6,1.1,1.4,0,.2.1.4.2.6.5-.2.9-.4,1.3-.5.6,1.2,1.6,1.2,2.7,1,.8-.2,1.5-.4,2.3-.4,1.2-.1,1.6-.7,1.1-1.9-.1-.4-.2-.7-.3-1.1.3.4.7.8.9,1.3.2.4.3.8.4,1.2-.2.2-.3.6-.6.7-1.8.7-3.6,1.3-5.4,1.9,0-.6-.2-.9-.9-1.1-1.2-.2-2.5-.5-3.7-.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M265.8,225.6c1.2.3,2.4.6,3.7.8.7.1.9.4.9,1.1h0c-.2.2-.4.3-.5.5-1.1.6-2.1,1.2-3.2,1.7.4-1.5-.4-2.7-.8-4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M278.2,224.8c1.1.3,2.2.7,3.3,1-1.1-.3-2.2-.7-3.3-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M269.8,228c.2-.2.4-.3.5-.5-.2.2-.4.3-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M265.9,230.9c.1-.2.3-.4.4-.6-.1.2-.3.4-.4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M235.1,158.7c.3.8.5,1.7.9,2.5,1.3,2.6,1.5,4,2.7,6.6,1.7,3.7,3.1,8.9,3.9,12.9.9,4.6.9,9.6,1.3,14.2.2,2.2.6,7.6.5,8.5-.1,1.1.1,2.1,0,3.2,0,1.2-.6,2.5-1.1,3.6,0,.2-.2.3-.3.4,0,0-.2,0-.3,0-.5,0-.9-.2-1.4-.3-.4-1.8.5-3.7.5-5.6,0-.6,0-1.2-.1-1.7-.2-2.5.1-5,0-7.4s-.3-4.9-.4-7.3c-.3-7.7-1.8-15.6-4.8-22.7-1.2-3-3.4-6.3-4.7-9.2-.7-1.5-1.1-3.2-1.6-4.8-.4-1.3-.8-2.5-1.1-3.8-.3-1.2-.5-2.3-.5-3.5,0-.4,0-.8-.2-1.2,0-.2-.1-.4-.2-.5-.2-.2-.5-.1-.6-.3,0,0-.2-.7-.1-.7.2,0,.5,0,.7.2s.3.3.5.5c.7,1,.8,2.2,1.2,3.3.3.7.6,1.5.8,2.2s.8,1.7.9,2.5c.1.5.2,1,.3,1.6.4,1.1.6,2.2,1.1,3.2.6,1.2,1.4,2.3,2.1,3.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M244,206.9c.1-.3.2-.6.4-.8,3.5.2,7,.4,10.5.6,3,.2,6,.5,9,.7,4.1.3,8.1.6,12.2.9,2.5.2,5,.4,7.5.6-.2,0-.3.2-.5.1-4.5-.2-9-.5-13.5-.8-1.6,0-3.3-.2-4.9-.3-3.7-.2-7.5-.6-11.2-.6-1.1,0-7.3-.7-7.9.1-.1.2-1.1,3.3-1.2,3.3-.5,1.5-.5,2.6-1,4-.4,1.1-.8,2.4-.5,3.6-.2,0-.4,0-.6,0,.6-3.5,1.1-7,1.7-10.5,0-.3.2-.5.2-.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M266.1,203.5c3.9-3.8,9.2-4.1,12.6,0-.3.4-.6.8-.9,1.2-3.5-.3-7-.5-10.5-.8-.4,0-.8-.3-1.2-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M287.3,204.4c.2,0,.4,0,.5,0-.2,0-.4,0-.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M-8.9,297.5c1-2.3,3.8-3.6,5.8-3,2.4.7,4.5,3.4,4.3,5.9,0,.9-.6,1.7-1,2.5-.4-.5-.9-.9-1.3-1.4-.9-1.1-1.6-2.5-2.6-3.4-1.2-1.2-3.1-1.2-4.4-.3,0,0-.1,0-.2,0-.2-.1-.3-.2-.5-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M-8.2,297.8c1.3-.8,3.2-.8,4.4.3,1,1,1.7,2.3,2.6,3.4.4.5.9.9,1.3,1.4-.3.5-.6.9-.9,1.4-.6,0-1.2-.3-1.8-.2-1,0-1.8-.3-2.5-1-1.5-1.5-2.4-3.4-3.2-5.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M-8.2,297.8c.8,1.9,1.6,3.8,3.2,5.3.7.7,1.5,1,2.5,1,.6,0,1.2.2,1.8.2-1.1,1.4-2.6,1-3.9.7-2.9-.6-4.4-3.1-4.7-5.8,0-.2.1-.4.2-.6.2-.3.4-.5.6-.8,0,0,.1,0,.2,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M53.2,322l.4-.8c1.6-2.7.9-5.7-2.2-8.2,1.8-.1,3,1.8,3.4,3.8.3,1.6.6,3.5-1,4.9-.2.1-.4.2-.6.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M51.3,313.1c-1.8-.8-3.6-.8-5.4-.2.8-1.2,2.8-1.7,4.1-.9.5.3,1.5,0,1.3,1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M8,312.8c.6,0,1.1,0,1.6,0,.3,0,.5.4.8.6-.3.2-.6.5-.8.5-.6,0-1.3.2-1.5-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M71.9,310.3c.3,0,.6,0,.8,0,0,0,0,.3,0,.3-.3.1-.5.2-.8.3v-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M77,309.9c.3-.1.6-.2.8-.3,0,.1.1.2.2.4-.3.1-.6.3-.8.4,0-.1-.1-.3-.1-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M-8.4,297.8c-.2.3-.4.5-.6.8,0-.4,0-.7.1-1.1.2.1.3.2.5.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M54.4,323.6c0,0-.2,0-.2-.1,0,0,0-.1,0-.2,0,0,.2,0,.2.1,0,0,0,.1,0,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M13.8,309.1c0,0,0,.2-.1.2s-.1,0-.2,0c0,0,0-.2.1-.2s.1,0,.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M45.9,312.8l-.7.6.7-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M7.8,389.7c-.4,0-.9,0-1.3,0,.4,0,.9,0,1.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M24.8,347.6c-.8-.5-1.7-1-2.5-1.4,0-.2,0-.3,0-.4.9.1,1.7.2,2.6.4.2,0,.2.7.3,1.1-.1.1-.3.3-.4.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M168.7,251.7c-1.4,0-2.3-1-3.8-.5-1.5.5-3.3.4-4.9.6-1.2.2-2.5.5-3.7.8-.2,0-.4.2-.6.2-.7,0-2.3-2.3-2.2-3,0-.2.2-.6.3-.6,1.1-.4,2.1-.8,3.2-1.2,1.1-.4,2.3-.8,3.4-1.3,1-.4,1.7-.9,3-.5,1,.3,2.2-.3,3.2-.5,1.2-.3,2.4-.5,3.6.3.3.2.7.2,1,.1,1.2-.2,2.4-.5,3.7-.6,1.3-.1,2.7-.3,4-.1,2.1.2,4.3,3.3,4.1,5.1-.7.5-1.3.7-1.7,1.2-.9,1-1.9,1.2-3.1.5-.2-.1-.4-.2-.6-.1-1.2.1-2.4.4-3.7.4-1.1,0-2.1-.6-3.2,0,0,0-.4-.2-.6-.4-.6-.7-1.1-.8-1.5-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M204.9,236.5c0,1.7-.2,3.4-.2,5.1,0,.3.4.7.6,1-.7.3-.8.3-2.2-1.1,1-.9.9-1.7,0-2.7-.7-.7.3-2.3,1.3-2.3.2,0,.4,0,.5,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M207.5,242.3c-.3-.9-1.8-1.1-.9-2.4.2-.2,1-.3,1.1-.2.5.8.7,1.6-.2,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M200.5,238.4c.6.6,1,.8,1.3,1.2.2.2.2.5.3.8-.3,0-.8,0-.9,0-.3-.5-.4-1.1-.7-1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M101.9,222.4l-.8.3.8-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M102.7,221.5c-.1.2-.3.5-.5.7.1-.2.3-.5.5-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M101,222.8c-.2.1-.3.2-.5.3.2-.1.3-.2.5-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M103.2,221.2c-.1,0-.3.1-.4.2.1,0,.3-.1.4-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M100.1,240.5c-.2.3-.4.7-.8,1.2-.9-.4-2.3-.5-2.2-1.7,0-.9-.9-2.5.7-2.8.8,1.2,1.6,2.2,2.3,3.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M99.8,233.3c0,.3,0,.5,0,.8-.4-.2-.7-.4-1.1-.7,0-.1.1-.2.1-.3.3,0,.6.1,1,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M79.6,243.6c0-.3.1-.6.2-1,.1,0,.2,0,.3.1-.2.3-.3.6-.5.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M88.7,236.5c.2,0,.3.1.5.2,0,0,0,.1,0,.2-.2,0-.3-.1-.5-.2,0,0,0-.1,0-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M74.5,241.1c.1.4.2.7.4,1.4-.1.3-.4,1-.6,1.7-.9,0-.9-.8-1-1.5h0c0,0,0,0,0,0,0,0,0,0,0-.1.2-1.3.3-1.5,1.1-1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M40.3,235.6c.4.1.7.2,1.1.3,0,.1,0,.3-.1.4-.4-.1-.7-.2-1.1-.3,0-.1,0-.3.1-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M37.1,242.2c0,.3,0,.5,0,.8,0,0-.1,0-.2,0-.1-.3-.2-.6-.4-.9h0c.2,0,.3,0,.5,0h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M52.4,239.2c0,0-.2,0-.2,0,0,0,0-.1-.1-.2,0,0,.2,0,.2,0s0,.1.1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M36.3,242.2c0,.2,0,.4,0,.6,0,0-.1,0-.2,0,0-.2.1-.4.2-.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M73.4,242.6s0,0,0,.1c0,0,0,0,0,0h0q0-.1,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M56.2,240c.6.1,1.3.2,2.2.3v2.5c-.7,0-1.4-.2-1.4-1.3,0-.5-.5-1-.8-1.5h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M54,237.9c.2-.2.3-.6.5-.6.3-.1.7,0,1.1,0,.2.9-.5,2.1.6,2.8h0c-1.6-.1-1.6-.2-1.7-1.7,0-.2-.3-.3-.5-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M36.6,238.9c.7.2,1.4.4,2.1.6h0c-.6.3-1.1.5-1.8.7-.1-.4-.3-.8-.4-1.2h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M73,247.2v-1.8c.6.4.6,1,0,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M75.4,241.2c.2-.4.4-.6.5-.8.4.1.8.2,1.2.3,0,.3-.6.5-1.7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M83.9,234.1c.1.4.2.9.3,1.3-.1,0-.2,0-.3,0-.1-.4-.2-.9-.4-1.3.1,0,.3,0,.4-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M81.7,237.8h-.8c0-.2,0-.3,0-.3.3,0,.5,0,.8,0v.4s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M58.1,244.7c-.3-.2-.5-.4-.7-.7.6-.2.8,0,.7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M74.2,245.5l.8-.3c0,.1.1.2.2.3-.3.2-.5.3-.8.5,0-.2-.2-.3-.2-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M37.1,242.2h-.5c.1-.4.2-.7.3-1.1,0,0,.1,0,.2,0v1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M71,244.8c0,.1-.1.2-.2.3,0-.1-.2-.2-.3-.3,0,0,.1-.2.2-.2,0,0,.2.1.3.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M39,240.2c0,.2,0,.3.1.5,0,0-.2,0-.2,0v-.5s0,0,.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M35.6,240.2c0,0,0,.2-.1.2,0,0-.1,0-.2,0,0,0,0-.2.1-.2s.1,0,.2,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M76.2,241.8c0,0,.1.2.1.2,0,0-.1.1-.2.2,0,0,0-.1,0-.2,0,0,.1,0,.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M53.2,237.2c0,0,.1,0,.2.1,0,0,0,.2-.1.2,0,0-.1,0-.2,0,0,0,0-.2.1-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M84.9,235.1v.4h-.1v-.4h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M56.7,237.9c0-.1-.1-.2-.2-.3,0,0,0,0,0,0,0,.1,0,.2.1.3h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M40,237.9c0,.1.1.2.2.3,0,0,0,0,0,0,0-.1,0-.2-.1-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M54.1,237.9c-.1,0-.2.1-.3.2,0,0,0,0,0,0,.1,0,.2,0,.3-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M36.5,239c0-.1-.1-.2-.2-.3,0,0,0,0,0,0,0,.1.1.2.2.3h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M45,239.1s0,0,0,0c0,0,0,0,0-.1,0,0,0,0,.1,0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M57.2,244.6h0c0-.1,0,0,.1,0,0,0,0,0,0,.1h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M48.2,244.9s0,0,0,0c0,0,0,0,0,.1,0,0,0,0,0,0,0,0,0,0,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M52.9,245s0,0,.1,0c0,0,0,.1,0,.2,0,0,0,0-.1,0,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M38.7,239.5s.1,0,.1,0c0,0,0,.1,0,.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M50,244.9s0,0,0-.1c0,0,0,0,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M114.1,233.8h-3.9c0,0,0-.3.1-.5-.5,0-1,.2-1.5.3,0-.2,0-.3,0-.5.6,0,1.2-.1,1.9-.2.4,0,.9-.1,1.3-.3,1.4-.6,2-.3,2.2,1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M114.1,233.8s0,0,.1.1c0,0,0,0-.1-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M275,222.3c.1.4.2.8.3,1.1.5,1.2.1,1.8-1.1,1.9-.8,0-1.5.3-2.3.4-1.1.3-2,.2-2.7-1-.4.2-.8.3-1.3.5-.1-.3-.2-.5-.2-.6,0-.8-.2-1.3-1.1-1.4-.2,0-.4-.3-.6-.5,2-1.8,4.2-2.4,6.8-1.9.9.2,1.7.5,2.2,1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M54.2,245.7v.4h-.1v-.4h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M14.7,239.7c-.2,0-.5.1-.7.2-1,.2-3.5.6-6.7.9,2.4-.3,5-.7,7.4-1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M-34.4,185.8l-6.7,11.4c.6-1.1,1.2-2.3,1.7-3.5.2-.5.4-1,.7-1.4.2-.4.5-.7.8-1.1.9-1.2,1.6-2.4,2.3-3.7.2-.4.5-.9.8-1.2.1-.1.2-.2.4-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M7.1,198.4c.3.2.6.4.8.7-.5-.3-1.4-1.1-.8-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M-14.7,332.4l.3.3-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M88.2,166.6c-.2,0-.4,0-.5-.1-.4-.2-.8-.4-1.2-.6-.4-.2-.8-.4-1.1-.7-.1-.1-.2-.3-.4-.3-.2,0-.4,0-.5,0-.3,0-.7-.2-.9-.4,0,0-.1-.2-.2-.2-.1,0-.3-.1-.4-.2-.2,0-.3-.2-.4-.3-.5-.4-.9-.8-1.2-1.4s-.1-.4-.2-.6c0-.1-.3-.2-.4-.3-.9-.4-1.8-.6-2.6-1.1-1.5-.8-3.4-1-5.2-1.2-3.5-.2-7.1-.2-10.6-.3-.7,0-1.4-.2-2.1-.2-1.1,0-2.1,0-3.2,0-1,0-2.2,0-3-.4-1.8-.9-3.7-.7-5.6-1-2.5-.3-5-.5-7.4-.7-2.1-.2-4.2-.4-6.2-.6-.5,0-1-.1-1.5-.2-1.8-.2-3.5-.4-5.3-.7-2.6-.3-5.2-.7-7.8-1-1.1-.2-3.1.9-3.7,2,.5.1.9.2,1.3.3v.4c-.6,0-1.3,0-1.9,0-1.5.1-2.9,0-4.3,1-.7.5-1.8.7-2.8.7-1.6,0-3.3-.2-5,0-.9.1-2-.3-2.7.8-1.8.2-3.7.3-5.5.6-3.4.5-8.8,1.5-10.6,4.5-1.7,3-1.8,8.2-3.1,11.6-.4,1.1-1,2.3-1.7,3.3-1.5,2.1-3.8,3.4-6.2,4.2-2,.6-4.8.3-6.7,1.1-1.3.6-8.1,11.3-8.2,12.4-.3,0-.7,0-1,.2-1.8,1.2-3.7,2.4-5.5,3.6.2-.5.4-1,.7-1.3.7-.7,1.4-3,1.5-3.1,1.1-1.2,9.9-14,11-15.4.6-.7,1.1-1.6,1.6-2.4.9-.9,1.8-1.8,2.7-2.8.2-.2.3-.4.5-.5.4-.5.7-.9,1.1-1.4,2.1-2.3,4.2-4.6,6.3-6.8,2.8-2.8,5.6-5.5,8.7-7.9,6.7-5.2,14.1-7.8,22.6-7.3.4,0,.7,0,1.1,0,.1,0,.2,0,.4,0,2.2.2,4.4.5,6.6.7.7.1,1.3.2,2,.3.3,0,.7,0,1,.1.5.1,1.1.2,1.6.3.3,0,.6.1.9.2.4,0,.9,0,1.3,0,.4,0,2,.4,2.4.5.8.1,5.6.7,7.3.9.4,0,.9.1,1.4.2.4,0,.9,0,1.3,0,.9,0,4.1.4,4.6.4,1,0,3.7.2,4,.3,3.1.2,6.3.4,9.4.6,1.3.2,2.6.4,3.9.5,2.1.2,4.1.2,6.1.3,4,.3,8.1.7,12.1,1.1,1.4.1,2.8.3,4.2.5.5,1.1,1,2.3,1.5,3.4-.1,0-.3,0-.4,0l.5.9c.1,0,.2,0,.3,0-.1-.3-.3-.6-.4-.9.1,0,.3,0,.4,0,.4,0,.8.3,1.1.6,1.1.9,2.2,1.8,3.4,2.6.2.1.3.3.4.4.1.2.2.4.1.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M83.2,163.2c-.1,0-.2,0-.3,0l-.5-.9c.1,0,.3,0,.4,0,.1.3.3.6.4.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M23.1,153.4c-.3,0-.6-.1-.9-.2-.5-.1-1.1-.2-1.6-.3,0-.5-8.9-.5-8.8-1.1,2.1,0,11.9-1.1,15.5-.5,2.1,0,4.2.2,6.3.5,5.2.8,10.3.8,15.5.8,1.3,0,2.5.4,3.8.6.5,0,1,0,1.5,0,0-.2,0-.3,0-.5-.4-.1-.8-.3-1.2-.4-1.6-.5-3.2-.9-4.9-1.3-.9-.2-1.7-.4-2.6-.6-1.3-.4-2.5-.8-3.8-1.3-2.2-.9-4.5-1.7-6.7-2.7-.8-.3-1.4-1-2.1-1.3-3.7-1.6-7.6-2.4-11.6-2.8-3.7-.4-7.4-.6-11.1-.8-1.1,0-2.2,0-3.3,0,.6-.3,1.3-.5,1.9-.8,2.1.1,4.2.2,6.3.4,1.6.1,3.2.4,4.9.5,1.5.1,2.9.1,4.4.8,1.6.7,3.4.7,5.1.9,2.1.3,4,1.1,5.9,2.3,1.9,1.2,4.2,1.6,6.3,2.3h0c1.7,1.4,3.6,2.3,5.8,2.4.2,0,.5-.2.7-.2.2,0,.3,0,.5,0,.2.2.4.4.7.5,1.7.5,3.4,1,5.1,1.4,3,.7,6.1,1.4,9.1,2.2,1,.3,2.2-.1,3.1,1.4-.9,0-1.6.2-2.3.2-1.4-.1-2.8-.3-4.2-.5-1.3-.2-2.6-.4-3.9-.7-1.2-.3-3.1.1-3.7,1.2.5,0,1,0,1.4,0,.8,0,.7.4.4.9-3.1-.2-10.9-.6-14-.8-2.3-.4-4.9-.6-5.4-.7-.4,0-6.8-.9-7.3-.9-1.6-.2-4.7-.7-5.1-.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M19.6,152.8c-.7-.1-1.3-.2-2-.3.7.1,1.3.2,2,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M-28.8,168c0-.1.2-.2.3-.3,0,.1-.2.2-.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M-45.2,201.7c-.2.2-.3.4-.5.5.2-.2.3-.4.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M-50.2,193c.1-.1.2-.2.4-.3-.1.1-.2.2-.4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M-59.9,213.9c0,.1,0,.2,0,0-.1.2,0,0,0,0h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M11,151.7c-.1,0-.2,0-.4,0,.1,0,.2,0,.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M307.9,212.3c0,0-.2.2-.3.3,0,0,.2-.2.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M231.5,150.5c.1.5.2,1,.3,1.6-.1-.5-.2-1-.3-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M52.8,180c0-.1,0-.2.1-.3h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M54.8,183.4s-.1,0-.1-.1c0,0,0,0,0,0,.1,0,.1.1,0,.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M55.2,223.5c-.2-.1-.4-.2-.5-.3.2.1.4.2.5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M50.6,212c-.1,0-.2.2-.3.3.1,0,.2-.2.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M109,161.7s-.3-.6-.3-.9c0,.3.2.6.3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M132.5,154c-.9,0-1.8,0-2.8,0-1.2-.5-2.3-.9-3.5-1.4v-.3h.5c1.3-.1,2.6-.2,3.8-.4.3,0,.6-.2.8,0,.9.7,1.8.3,2.7.2,2.3-.4,4.7-.8,7-1.1,1.6-.3,3.1-.5,4.7-.7-2.4.6-4.7,1.3-7,1.9l-2.2.5c-.8.2-1.6.5-2.4.7-.1,0-.2,0-.3,0h0c-.5.2-.9.4-1.4.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M132.4,154c.5-.2.9-.4,1.4-.6-.5.2-.9.4-1.4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M133.8,153.5c.1,0,.2,0,.3,0-.1,0-.2,0-.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M128.1,170.5h0c0,0,.2,0,.3-.1,0,0-.2,0-.3.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M205,169.9c0,0,0-.1,0-.2-1.2,0-2.4,0-3.5,0-1.9,0-3.8,0-5.6-.6-.9-.3-1.5-.7-2.4-.9-1.6-.3-3.5-.3-4.5-1.9-1.1-1.6-2.5-3-4.2-4-.5-.3-1-.8-1.5-1.2-.3,0-.5-.2-.8-.3-.3-.2-.5-.4-.8-.5-.2,0-.4-.1-.6-.2-3.7-1.6-7.4-3.2-11.1-4.7-2.7-1.1-5.4-1.9-8.1-2.8-.2,0-.4-.3-.6-.5-.4,0-.7-.2-1.1-.3-.3,0-.5,0-.8,0-1-.3-2.1-.6-3.2-.9-1.4-.2-2.8-.4-4.1-.6-.3,0-.5-.2-.8-.2,0,0-.1,0-.1-.1-.4,0-.8,0-1.2,0-.4,0-.7,0-1,0-1.1,0-2.1.2-3.2.3-2.4.6-4.7,1.3-7,1.9.5,0,1.1,0,1.6.1.5,0,1,0,1.5.2.5.1,1,.5,1.6.5,2.7.2,5.4.3,8,.6,1.3.1,2.6.5,3.9.8.3,0,.7,0,1,0,.2,0,.4.2.6.3.3,0,10.6,2.8,14.7,4.8.3.2.6.4.9.6,2,.9,4.1,1.6,6,2.6,1.9,1,3.7,2.2,5.5,3.3.9.5,2,1,2.7,1.7.5.5,2,1.1,2.6,1.4.8.4,2.8.8,3.5,1.3,1.7,1.1,3.8,1.6,5.8,1.8.6,0,1.1,0,1.7,0,.4,0,.7,0,1.1-.1,1-.1,1.9-.3,2.9-.3.2,0,.3,0,.5,0v-1.9c.1,0,.1,0,.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M161.3,152.1c1.6.2,3.2.2,4.8.6,1.3.3,2.5,1.1,3.7,1.6.1,0,.3.2.4.1,1.9-.6,3.1,1.2,4.9,1.3.9,0,1.5,1.2,2.6.9,0,0,.2.6.3.9,1,.6,2.2,1.3,3.3,2,0,.1,0,.2,0,.4-3.7-1.6-7.4-3.2-11.1-4.7-2.7-1.1-5.4-1.9-8.1-2.8-.2,0-.4-.3-.6-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M181.7,160.3c.3.2.5.4.8.6-.3-.2-.5-.4-.8-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M157,154.6c-.2,0-.4-.2-.6-.3.2,0,.4.2.6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M160.2,151.8c.4,0,.7.2,1.1.3-.4,0-.7-.2-1.1-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M159.4,151.8c.3,0,.5,0,.8,0-.3,0-.5,0-.8,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M181.1,160c0-.1,0-.2,0-.4.2.2.4.4.5.6-.2,0-.4-.2-.6-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M182.5,160.8c.3,0,.5.2.8.3l-.8-.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M184.9,190.5h0c0-.1.1-.2.2-.3,0,.1-.1.2-.2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M183.9,189.5c0,.2-.1.3-.2.5,0-.1,0-.2,0-.3h0c0,0,0,0,0-.1,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M183.8,189.7h0c0,.1,0,.3,0,.4,0-.2.1-.3.2-.5,0,0,0,0,0,0,0,0,0,0,0,0h0ZM159,186c0,0,0-.1-.1-.2-.7-1.4-1.3-3.2-2.3-4.3,1.1,1.7,1.9,3.4,2.6,5.2l.5,2.6c0-.3,0-.6,0-.9h0c0-.3,0-.6,0-.8-.1-.6-.4-1.1-.6-1.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M185.1,190.2c0,.1-.1.2-.2.3,0,0,.1-.2.2-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M183.8,189.6s0,0,0,0h0c0,0,0,0,0,0h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M52,223c1-.2,5.4.2,10.5.4.4,0,.8,0,1.2,0-.8-.6-2.5-1.4-3.2-2-.9-.7-3-.8-3.8-1.6-2.8-.9-3.1-2.3-5.6-2.7-.4,0-.7-.1-1.1-.2-1.9-.3-3.9-.7-5.8-1-2-.3-4-.7-6-1-1-.2-2.1-.4-2.9-1-1.3-1.1-1.7-2.7-3.4-3.3.3-3.4-1.8-3.6-4.4-4.3-1.4-.4-7.8-2.9-8.9-1.7h0c-.4-.2-3.3-1.2-2.4-1.6-.1,0-.2-.1-.3-.2-.9.6-1.9,1.2-2.7,1.9-1.4,2.2-2.6,4.5-2.9,7,0,.6,0,1.2,0,1.9,0,.1,0,.2,0,.3,2.7,0,5.4.8,7.9,1.9,1,.5,2,1,2.9,1.7,1.5,0,1.9.4,2.8.9,1,.5,2.3.7,2.5,1.5,1.6.7,3.8,1.2,5.5,2.2,1.6.9,3.9,1.2,5.6,1.9,2.1.9,4.1,2,6.1,3,2,.9,4.4,1.4,6.3,2.4,1.3.7,1.8,1.8,2.3,3.1.2.4.9,3.7,1.1,3.7,1.9,0,3.8,0,5.8,0-2.1-3.1-4.2-6.3-6.1-9.6-1.1-1.8-1.5-3.4-.8-3.6h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-102",
    x1: -20.6,
    y1: 197.8,
    x2: -20.6,
    y2: 197.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M-32.7,195.8s0,0,.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M-37.7,196.9c0,0,0-.1-.1-.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M-2.6,186.2c-1.4-1.3-3.1-2.3-4.6-3.5-1.2-1.1-1.8-2.7-3.7-2.9h0c.1.4.2.8.1,1.3.6.4,1.2.7,1.7,1.1.6.5,1.1,1,1.3,1.6,1.4,1.2,2.8,2.5,4.3,3.6,3.8,3,7.4,6,10.3,9.9,0,0,.1.2.2.2,0-.4-.3-.8-.5-1.1-2.6-3.7-5.7-7.1-9-10.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M23.9,135.7c1.8-1,3.7-2,5.5-2.9.4-.2.8-.4,1.2-.6,1.2,0,2.5-.1,3.7,0,4,.7,7.9,1.4,11.9,2.2,2,.7,4,1.4,5.9,2.1.4.3.8.5,1.2.8,0,.3,0,.6.2.7,1.3.7,2.6,1.4,3.8,2.1,2.6,1.5,5.2,3,7.8,4.4.1.2.2.5.3.7,0,.2,0,.4-.1.6h0c-2.6-.7-5.3-1.3-7.8-2.3-2-.7-3.8-2-5.7-2.9-2.2-1-4.4-2-6.6-2.9-.6-.3-1.1-.6-1.6-.9-2.2-1.2-4.7-.9-7-1.5-.2,0-.6.2-1.1.5.6.3.9.4,1.2.6,2.7,1.1,5.4,2.1,8.1,3.2,1.6.6,3.2,1.3,4.9,1.9.7.3.9.7.8,1.4-2.1-.7-4.4-1.3-6.4-2.3-3.7-1.8-7.3-3.7-11.4-4.4-2.9-.5-5.7-1.6-8.7-.4,0,0,0,0-.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M23.9,135.7s.1,0,.1,0c3-1.2,5.8-.1,8.7.4,4,.8,7.7,2.7,11.4,4.4,2,1,4.3,1.5,6.4,2.3,2.5,1,5.1,2,7.6,2.9-1,0-2.1,0-3.1-.3-3.1-.8-6.1-1.7-9.2-2.5-1.9-.5-3.7-.9-5.6-1.3-4.2-.9-8.4-1.8-12.7-2.7-1.6-.3-3.3-.6-4.9-.8,0,0,0,.2,0,.3-.6,0-1.3,0-1.9,0,0,0-.2,0-.3,0-.5,0-1.1-.1-1.6-.2-.1,0-.3,0-.5,0,0,0-.1,0-.2,0,.8-.4,1.7-.7,2.5-1.1,1-.5,2-.9,3-1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M19,138.3c.5,0,1.1.1,1.6.2h.3c.6,0,1.3,0,1.9,0,.8.3,1.6.6,2.4.7,1.5.4,3.1.5,4.5,1,1.4.5,3.3,0,4,2.1,0,0,0,0,.1,0,1.7.5,3.4,1,5.1,1.5.5.2.9.5,1.4.8-1,0-2-.1-2.9-.1-.2,0-.5.1-.8.2,1.4.7,2.7,1,3.9,1.5.6.3,1.1.9,1.6,1.3-2.1-.7-4.5-1.2-6.3-2.3-1.9-1.2-3.8-2-5.9-2.3-1.7-.3-3.6-.3-5.1-.9-1.5-.6-2.9-.6-4.4-.8-1.6-.1-3.2-.4-4.9-.5-2.1-.2-4.2-.2-6.3-.4,2.9-1.4,5.9-2.1,9.1-2.4,0,0,.1,0,.2,0,.1,0,.3,0,.5,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M56.7,230.7c-1.4-1.6-3.2-2.8-5.2-3.6-.3-.1-.5-.2-.7-.4-.3,0-.5,0-.8,0-4.3-.9-9-3.2-12.2-6.3-.4-.4-.6-.8-.7-1.3-2.1-.7-4.1-1.5-6.1-2.5-.6-.3-1.1-.6-1.7-.7-.3,0-.6,0-.9-.2-3.7-.8-6.8-3-10.6-3.6-1.3-.2-2.6-.3-3.9-.3-1.1,0-2.8.6-3.9.4,0,0,1.5-.9,1.5-1,8.2-.4,13-3.1,19.3-8.3.8-.7,1.6-1.4,2.2-2.3,1.2-1.8,1.3-4.1,1.1-6.3-.5-.3-1-.8-1.2-1.5-.6-2-1.3-4-1.9-6-.4-.4-.6-1-.6-1.7h0c-1.9-5.6-4-11.1-6-16.6-.1-.4-.2-.7-.2-1.1-3.1-2.4-6.3-4.1-7.8-4.8-.2,0-3.1-4.1-5.3-4-3.3,0-6.7.3-10,.5-1.8.2-3.7.3-5.5.6-3.7.5-8.1,1-11,3.7-3.1,3-4.7,8.9-6,12.9-.2.6-.4,1.3-.8,1.8-.4.5-.9.8-1.3,1.1-3,1.9-6.2,3.6-8.9,5.8-2.9,2.3-5.9,5.4-7.5,8.7-.5,1.1-.6,2.4-1.4,3.3-1,1.3-3,1.8-4.3,2.7-1.5,1-2.7,2.4-4.2,3.4-5.9,4-9.4,10.4-10.8,17.5-.4,1.9-2.3,5-2.2,6.9,0,2,.5,3.5.9,5.5.2,1.2.6,2.5,1.1,3.6.2.5,1.4,1,1.6,1.6.7.6,1.4,1.3,2.2,1.7.8.5,2.4,2.2,3.2,2.2,6.5.4,5.7-.2,12.3.8,6.9,1,20.4,2.1,27.4,2.1,5,.7,10.1,1.5,15.1,2.2,8.6,1.2,17.3,2.3,26,2.6,4.4.2,8.8.6,13.2.5,2.3,0,4.8-.1,7-.8,2.9-.9,3.4-3.1,3.9-5.9.3-1.6.9-3.1,1.6-4.6.7-1.4,3.5-3,4.5-5,.6-1.2-.3-3.3-.5-3.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M126.5,142h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M17.8,158.9c-2.2,0-4.4-.2-6.6-.2-3.3,0-6.7.3-10,.5.6-1.1,1.8-.6,2.7-.7,1.6-.2,3.3,0,5,0,.9,0,2.1-.2,2.8-.7,1.4-1,2.8-.9,4.3-1,.6,0,1.3,0,1.9,0v-.4c-.4-.1-.9-.2-1.3-.3.6-1.1,2.6-2.2,3.7-2,2.6.4,5.2.7,7.8,1,1.8.2,3.5.4,5.3.7.5,0,1,.1,1.5.2,2.1.2,4.2.4,6.2.6,2.5.2,5,.5,7.4.8,1.9.2,3.8,0,5.6,1,.9.4,2,.3,3,.4,1.1,0,2.1,0,3.2,0,.7,0,1.4.2,2.1.2,3.5.1,7.1,0,10.6.3,1.8.1,3.7.3,5.2,1.2,1.5.8,3.6.8,4.3,2.8-1.2.5-2.4,1-3.6,1.5-.2.1-.5.2-.8.1-1.2-.3-2.4-.5-3.6-.8-.9-.2-1.8-.6-2.7-.7-2.8-.6-5.7-1.1-8.5-1.7-2.4-.5-4.7-1.1-7.2-1.1s-2-.2-3-.2v.3c1.8.4,3.6.7,5.4,1.2,1.1.3,2.1.8,3.2,1.2-5.6-1.4-11.3-2.3-17.1-2.4-1.8-.1-3.7-.3-5.5-.3-4.1.1-8.1-.2-12.1-.8-2.1,0-4.1-1.1-6.2-.3-.9,0-1.9-.2-2.8-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M90.2,169.3c-.7-.5-.9-.9-.3-1.6-.7-.5-1.4-1-2.1-1.5h0c-.4-.2-.8-.5-1.2-.7h0l-1.8-1.1c-.6-.4-1.1-.8-1.6-1.1-.3,0-.5,0-.8,0-1.2.5-2.4,1-3.6,1.5-.2.1-.5.2-.8.1-1.2-.3-2.4-.5-3.6-.8-.9-.2-1.8-.6-2.7-.7-2.8-.6-5.7-1.1-8.5-1.7-2.4-.5-4.7-1.1-7.2-1.1s-2-.2-3-.2c0,.1,0,.2,0,.3,1.8.4,3.6.7,5.4,1.2,1.1.3,2.1.8,3.2,1.2,3.3,1,6.7,2,10,3-.2.1-.3.2-.5.4h.1c0,0,.1,0,.2,0,1.1-.1,2.1,0,3.2,0,0,0,.2-.1.3-.2.5-.3,1.4-.3,2-.1.7.2,1.4.7,2.1,1.2,2.3,1.7,4.8,2.5,7.6,2.4,1.6,0,3.2.1,4.6,1.1.5.3,1.2.4,1.8.6-.9-.6-1.7-1.3-2.7-1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M34.1,154.9c.4,0,.9.1,1.4.2-.4,0-.9-.1-1.4-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M-16.1,164.1c-.3.1-.6.3-.9.4.3-.1.6-.3.9-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M22.2,153.2c.3,0,.6.1.9.2-.3,0-.6-.1-.9-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M-29.8,175.5c.2-.2.3-.4.5-.5-.2.2-.3.4-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M-17.5,164.7c-.1,0-.3.2-.4.2.1,0,.3-.2.4-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M62.9,151.5c2.2.6,4.3,1.3,6.5,1.9.4.1.9.4,1.3.5,0,.2,0,.3,0,.4-.6,0-1.3,0-1.9,0-2.2-.4-4.4-.8-6.6-1.3-2.4-.6-4.8-1.3-7.2-1.9-1.9-.5-3.9-.9-5.8-1.3-.2,0-.3,0-.5,0-.8-.3-1.6-.5-2.3-.8-1.4-.5-2.8-.9-4.1-1.4h0c-.5-.5-1-1.1-1.6-1.3-1.2-.5-2.6-.9-3.9-1.5.2,0,.5-.2.8-.2,1,0,2,0,2.9.1h.5c.5.3,1,.6,1.5.8,1.8.5,3.7.9,5.5,1.3h.8c.2.2.4.5.6.5,1,.3,2.1.5,3.1.9,2.4.8,4.9,1.6,7.4,2.4.2,0,.3,0,.5,0,.4.2.8.3,1.1.5,0,0,.1,0,.2,0,.1,0,.2.2.3.3h1.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M42.2,147.7c1.4.5,2.8.9,4.1,1.4.8.3,1.6.5,2.3.8-.2,0-.5.3-.7.2-2.2-.1-4.1-1.1-5.8-2.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M212.5,88.5c-.1-.1-.2-.3-.3-.4.1.1.2.3.3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M223.1,145.3c0,0,0-.1.1-.2,0,0,0,.1-.1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M223.1,145.3c0,0,0-.1.1-.2,0,0,0,.1-.1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M244.1,45c1.2.8,3.5,1.5,3.4,2.4,0,5.1-.7,10.2-1.1,15.3-.7,8.1-4,35.9-4.4,41.8-.2,3.2-.6,10-1.2,13.1s-16.7,2-22.2,2.6c-8.6.8-10.3.8-19,1.8-13.6,1.5-31.8,1.3-45.4,2.8-5.9.6-11.9,1.3-17.6.6-1.2-.1-2.1-1.1-2.1-2.2.1-11.9,4.7-23.2,5.4-34.9.6-10.9,1.2-22,1.8-32.9.2-3,5.7-5.5,21.6-6.4,12.6-.7,25.3-1.4,38-2.3,14-1,27.9-2.2,41.2-1.8,0,0,.2,0,.3,0,.1,0,.3,0,.5,0h.1c0,.1.5,0,.5,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M198.1,126.5h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M135.4,118.8c.9,3.2,0,6.1,7,5.9,20.5-.6,35.9-1.9,50.8-2.7,0,1.1,32.3-2.7,32.4-1.6-6.2.3-50.7,6.7-88.2,5.7-5.8-.2-5.5-4.5-5.2-6.4.3-2.1.5-4.2.7-6.3,0-1,1.7-13.3,1.7-13.6.3-1.8,4.7-46.6,5.8-47.2-1.3-7.8,16.3-6.4,21.1-6.4,23.6.2,47.3-.6,70.8-2.4,2.8-.2,5.7-.5,8.6.3,2.8.7,6.2,1,6.7,3.5-11.2-2.6-23.7-.5-35.2,0-21.2,1-67-.2-67.3,2.7-.8,8.8-9.7,61.6-9.7,61.6-.3,3-.4,5.3,0,7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M180.6,113.1c-.1,0-.3.3-.5.6,0-.3.3-.7.5-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M245.2,43.5c-.7-.1-1.5-.1-2.4-.2-14.1-.6-49.2,1.6-49.3,1.6-15.3.7-39.4.9-44.5,1.3-3,.2-3.7,2.1-5.4,3.5-1.3,1.1-8.1,55-8.4,60-.1,2.4-1.6,13.2-.8,14.7,1.3,2.4,9,1.3,11.4,1.4,11,.3,18.1-.2,22.4-.5,14.6-1,38.8-3.2,55.2-4.7,0-.4-.2-.8-.6-1-2,.1-4.9.4-6.8.5,0,0-5.4.3-7.2.4-4.3.3-8.7.6-13,.8-8.8.6-34.2,2.4-39.5,2.9-1.5.1-13.5.4-14.3.3-3.6-.3-4.8-1.2-4.6-3,.1-1.3.5-7.4.6-7.8.4-2.6,4.6-46,6.8-57.5.2-.9.4-1.9.9-2.8.3-.7.8-1.3,1.4-1.8,2.7-2.2,8.1-1.8,11.4-1.9,4.7-.1,9.4-.3,14.1-.6,9.2-.5,64.9-2.5,75-1.3,0-.3,0-1.9.2-1.6,0-.2-1.2-2.7-2.6-2.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M223.5,120.5c3.1-.3,11.2-.5,13.7-.8,1.6-.2,2.6-.9,3.2-1.3.4-.3.6-1,.5-1.2s-18,2.6-17.8,2.3c0,0-.1,0-.2,0,.4.3.5.6.6,1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M247.8,46.5h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M107.1,159.9c.3-1.7.6-3.4.9-5.1,0,0,.1,0,.2,0,1.6-.1,3.3-.1,4.9-.3,1.2-.1,6.4-1.2,7.5-1.3.4,0,.7,0,1.1,0,0,0,.2-.1.3-.2h0c.7,0,1.4,0,2.1,0,.2,0,.4-.2.6-.2.5,0,1,0,1.6,0,1.2.5,2.3.9,3.5,1.4-.6.5-1,1.2-1.7,1.5-.8.4-1.7.5-2.5.7-1.7.2-3.4.4-5.2.6-2,.2-10.8,2-12.2,2.5,0,0-.1.1-.2.2,0,0-.1.2-.1.3-.2.1-.4.2-.7.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M128.4,156.1c.4,1.2-.8,1.1-1.3,1.4-1.4.8-3.1.9-4.6,1.3-1.5.4-3,.4-4.4.7-1.1.2-2,1-3,1.6-.2.1-4.1,1.8-5,1.6-.5-.1-1.5-.4-1.7-.2,0,0,0,0-.1,0-.1,0-.2.2-.2.2,0,0,0,0,0,0,0,0,0,0,0,0-.2,0-.4,0-.7,0-.1,0-.2,0-.4,0-.2,0-.3,0-.5,0h0c0-.8.2-1.5.3-2.2,0-.2.1-.4.2-.6.2,0,.4-.2.7-.3,0,0,.1-.2.1-.3,0,0,.1-.2.2-.2,1.4-.5,10.2-2.3,12.2-2.5,1.7-.2,3.4-.3,5.2-.6.9-.1,1.8-.3,2.5-.7.7-.3,1.1-1,1.7-1.5.9,0,1.8,0,2.8,0-1.3.7-2.7,1.4-4,2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M123.3,153.2c-.4,0-5.8.3-6,.3-2.5.3-5,.5-7.5.9-.1,0-.3.3-.4.5,0,0-.1,0-.2,0,0-.5.2-1,.2-1.6,0,0,.1.2.2.3.8-.3,1.5-.7,2.3-.8,1.1-.2,2.2-.2,3.4-.2,1.5,0,3.1.1,4.6,0,1.5-.2,3-.5,4.4-1.1,1.2-.5,2.3-.8,3.6-.8s1.4-.7,2.1-.7c1,0,3.1-.3,3.1-.7,1.2-.6,6.8-.2,8.7-.5.6,0,1.3-.1,1.9-.3,1.6-.5,3.1-.5,4.6.2.6.3,1.5-.4,1.9.6-.5.1-.9.3-1.4.3-3.5.2-7,.3-10.5.6-1.3.1-2.6.6-3.9.8-1.9.3-3.8.6-5.7.9-.1,0-.2.3-.3.4h-.5c-1.4,0-2.9.2-4.3.2,0,0,0,.2-.1.4h0c-.1,0-.2.1-.3.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M114.9,176.6c-.2,0-.4.2-.5.3.2,0,.3-.2.5-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M127.1,171.7c-.2,0-.4.2-.5.3.2,0,.4-.2.5-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M120.3,174.7l-.5.3.5-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M92.8,171.2c-.9-.6-1.7-1.3-2.7-1.9-.7-.5-.9-.9-.3-1.6,0,0,0-.2.1-.3,2.4,1.4,4.8,2.9,7.2,4.3.1,0,.3.2.4.3.4.3,1,1.1,1.2.9.6-.2,1.1-.8,1.6-1.3,2.4-2.6,4.3-5.4,5.8-8.6-.2,1-.3,2-.8,2.9-.5,1-1.3,1.9-1.9,2.9-.2.3-.2.8-.3,1.1-.4.2-1,.4-1.4.8-.7.8-1.4,1.7-2,2.6-.6.8-1.3,1.3-2.2.8-1-.5-1.9-1.1-2.8-1.7-.2-.1-.4-.2-.5-.3h0c-.4-.2-.7-.3-1.1-.5h0c0,0-.5-.6-.5-.6h0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M93.4,171.8c.4.2.7.3,1.1.5-.4-.2-.7-.3-1.1-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M92.8,171.2l.5.6-.5-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M94.4,172.2c.2.1.4.2.5.3-.2-.1-.4-.2-.5-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M106.3,163c0-.1,0-.2,0-.3,0,0,.1,0,.2,0h0c0,.2-.2.3-.2.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M153.4,148.6c0-.5.2-1,.3-1.5,0,.5-.2,1-.3,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M153.4,149.4c0,0,0-.2,0-.2,0,0,.1,0,.2.1,0,0-.1,0-.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M215.7,149.3h1c0,0-1,0-1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M183.1,111.7c4.8-1.6,9.6-3.2,14.4-4.8-.5.4-.9.8-1.5,1-4.1,1.6-8.2,3.1-12.3,4.6-1,.4-3.1-.4-3.1-.4,0,0,.2,0,.3,0,.4,0,.7-.1,1-.2.1,0,.2,0,.3,0,.1,0,.2,0,.3,0,.2,0,.3,0,.5-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M207,145c.1,0,.2,0,.3,0,0,.2-.2.2-.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M148.9,149.9c.4,0,.7,0,1,0-.4,0-.7,0-1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M152.4,146.5v-.4s0,.4,0,.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,151.2c.2.5.4,1.1.6,1.6,2.5,5.3,1,12.2-3.5,15.9-.4.3-.9.7-1.4.6-.3,0-.5-.2-.7-.3-3.1-1.8-5.2-4.2-7.1-7.3-.6-1-1.2-2.2-1.9-3.1-.6-.8-1.4-1.5-2.2-2.1-5.5-4.3-12.4-6.1-18.4-9.6-.9-.6-1.3-1.2-2-2-.5-.6-1.3-.9-2-1.3-2-1.1-4-2.3-5.9-3.4-1.3-.7-2.6-1.4-3.8-2.1-.1,0-1.4-1.3-1.4-1.5.4,0,1.1-.1,1.5,0,.5.2,1,.6,1.3,0,.1-.3,0-.4,0-.8,0-.5,0-.8,0-1.3.1-2.1.2-4.2.2-6.3,0-2.7.6-5.6.5-8.3,0-.3.2-.6.3-.8.1-.3.3-.7.5-.8.2,0,4.8,4.2,6.7,6.1.6.6,1.1,1.1,1.7,1.7,2.1,2.2,4.3,4.5,6.4,6.7.9,1,1.9,1.8,3.1,3,.5-2,.9-3.6,1.3-5.3.4-1.5,1.5-2.1,3-1.6,2,.6,4,1.1,6.1,1.6,3.3.8,11.4,1.3,13.9,3.7.7.6.2,1.7.3,2.6.4,3.7.9,6.2,1.8,9.5.5,1.8.7,3.3,1.2,4.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M58.1,145.8c-2.5-1-5.1-2-7.6-2.9.1-.7,0-1.1-.8-1.4-1.6-.6-3.3-1.3-4.9-1.9-2.7-1.1-5.4-2.1-8.1-3.2-.3-.1-.6-.3-1.2-.6.6-.3.9-.6,1.1-.5,2.3.6,4.8.3,7,1.5.5.3,1.1.6,1.6.9,2.2,1,4.4,1.9,6.6,2.9,1.9.9,3.7,2.2,5.7,2.9,2.5.9,5.2,1.5,7.8,2.3,0,0,0,0,.1,0,0,0,0,0-.1,0,0-.2,0-.4.1-.6,1.3.7,2.6,1.4,3.9,2.1,1.6.7,3.2,1.3,4.8,2,.2.2.5.4.7.7-.6-.1-1.2-.1-1.7-.3-.4-.1-.8-.5-1.2-.6-3.1-.8-6.1-1.5-9.2-2.2-1.6-.4-3.1-.7-4.7-1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M58.1,145.8c1.6.4,3.1.7,4.7,1.1,3.1.7,6.1,1.4,9.2,2.2.4.1.8.5,1.2.6.6.2,1.1.2,1.7.3h0c.3.1.6.3.9.4,1.8.7,4.4,1.3,5.9,2.5.7.5,1.2,1.4,1.9,1.9.8.6,1.6,1.2,2.4,1.7,2.4,1.7,4.4,3.9,6.4,6,1.2,1.3,2.4,2.5,3.6,3.8.7.7,1.4,1.7,1.1,2.6.1-1.1-.9-1.9-1.9-2.5-2.4-1.3-4.8-2.6-6.9-4.3-2.4-1.8-4.4-4.1-6.9-5.9-2.9-2-6.3-2.5-9.7-3.3-2.3-.5-4.6-1.1-6.9-1.6-.6-.1-1.2,0-1.8,0h-1.1c-.1,0-.2-.2-.3-.3,0,0-.1,0-.2,0-.2-.5-.5-1-1.1-.5-.2,0-.3,0-.5,0-.8-.4-1.6-1-2.5-1.3-1.8-.7-3.8-1.1-5.5-2-1.1-.7-2-.8-3.1-.4h-.8c-.2-.3-.3-.7-.5-.7-2.2-.5-4.4-.9-6.6-1.4h-.5c-.5-.3-.9-.7-1.4-.8-1.7-.6-3.4-1-5.1-1.5,0,0-.1,0-.1,0-.6-2-2.6-1.6-4-2.1-1.4-.5-3-.6-4.5-1-.8-.2-1.6-.5-2.4-.7,0-.2,0-.3,0-.3,1.6.3,3.3.5,4.9.8,4.2.9,8.4,1.8,12.7,2.7,1.9.4,3.7.8,5.6,1.3,3.1.8,6.1,1.7,9.2,2.5,1,.2,2,.2,3.1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M19,138.3c-.1,0-.3,0-.5,0,.1,0,.3,0,.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M20.9,138.5h-.3c0,0,.2,0,.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M25.5,158.4c-.2,0-.4,0-.7.1.1,0,.3.1.4.2,0-.1.2-.2.3-.3h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "126.5 142 126.5 142 126.5 142 126.5 142"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M108.2,152.4c.4-1.2,1-1.4,2.4-.8-.8.3-1.6.6-2.4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M90,167.4c0,0,0,.2-.1.3-.7-.5-1.4-1-2.1-1.5.8.4,1.5.8,2.2,1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M106.1,150.7c.9,0,1.9,0,1.8,1.4-.6-.5-1.2-.9-1.8-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M106.6,162.6c0,0-.1,0-.2,0,.2-.7.4-1.4.5-2.1-.1.7-.2,1.4-.3,2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M86.6,165.5c-.6-.4-1.2-.7-1.8-1.1.6.4,1.2.7,1.8,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M87.8,166.2c-.4-.2-.8-.5-1.2-.7.4.2.8.5,1.2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M126.5,142s0,0,0,0h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M110.9,137.4c-.2.2-.4.3-.6.5h0c.2-.2.4-.4.6-.6h0q0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M111.2,137.1c-.1,0-.2.2-.3.3h0c0-.1.2-.2.3-.3h0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M48.6,146.9c1.1-.5,2-.3,3.1.4,1.6,1,3.6,1.3,5.5,2,.9.3,1.7.9,2.5,1.3-2.4-.8-4.9-1.6-7.4-2.4-1-.3-2.1-.6-3.1-.9-.2,0-.4-.3-.6-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M40.8,144.8c2.2.5,4.4.9,6.6,1.4.2,0,.3.5.5.7-1.8-.4-3.7-.8-5.5-1.3-.5-.1-1-.5-1.5-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M60.2,150.7c.6-.5.9,0,1.1.5-.4-.2-.8-.3-1.1-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M61.6,151.3c.1,0,.2.2.3.3-.1,0-.2-.2-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M221.6,146.6h.1c0,.1,0,.1,0,.1,0,0,0,0,0-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M25.5,158.4c-.2,0-.4,0-.7.1.1,0,.3.1.4.2,0-.1.2-.2.3-.3h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M147.8,149.3c-.5.1-.9.3-1.4.3-3.4.2-6.8.3-10.1.6-1.3.1-2.5.6-3.8.8-.9.2-1.9.3-2.9.5h0c-1.3.2-5.9.8-10.5,1.4,0,.2.2.3.2.5.5,0,.9-.2,1.4-.3.7,0,1.8-.1,3.3-.2.2,0,.4-.2.6-.2.5,0,1,0,1.6,0,0,0,.4-.2.9-.4,1.1-.1,2.3-.2,3.4-.3.3,0,.6-.2.8,0,.9.7,1.8.3,2.7.2,2.3-.4,4.6-.8,7-1.1,1.6-.3,3.1-.5,4.7-.7,1.1,0,2.1-.2,3.2-.3.3,0,.7,0,1,0,.4,0,.8,0,1.2,0-1.1-.2-2.2-.4-3.3-.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M60.5,110.9c-.4-.3-.8-.6-1.2-1h0c.4.3.8.7,1.2,1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M62.4,112.2c-.7-.4-1.3-.9-1.9-1.4.6.5,1.2.9,1.9,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M97.8,128.4c-1.6.1-3.4.2-4.9-.5-.6-.3-1.2-.7-1.8-1.2-.8-.6-1.3-1.3-2.2-1.8,2.6,1.6,5.4,2.4,8.3,2.9.2.2.3.4.5.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M112.1,130.5c.2-.3.4-.7.6-1-.2.3-.4.7-.6,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M110.6,131.9c.2-.1.4-.3.6-.4-.2.1-.4.3-.6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M141.3,142.6c-.3,0-.5-.2-.8-.3.3,0,.5.2.8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M114.6,134.4c0,0-.1.1-.2.2,0,0,.1-.1.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M114.1,134.7c0,0-.2.1-.3.2,0,0,.2-.1.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M113.6,134.9l-.3.3.3-.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "202.9 67.5 209.7 64.1 212.2 60.4 201.1 67.5 201.1 78.5 192.2 78.5 192.2 67.5 181.3 60.3 183.7 64.1 190.4 67.4 190.4 89.5 189.6 89.5 189.6 91.3 192.2 91.3 192.2 80.3 201.1 80.3 201.1 91.3 203.6 91.3 203.6 89.5 202.8 89.5 202.9 67.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "208.4 66.6 211.4 64.5 205.8 66.5 208.4 66.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "208.6 67.3 204.8 67.1 206.8 68 208.6 67.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "187.5 66.5 181.9 64.4 184.9 66.6 187.5 66.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "186.4 68 188.5 67.1 184.7 67.3 186.4 68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "202.9 67.5 209.7 64.1 212.2 60.4 201.1 67.5 201.1 78.5 192.2 78.5 192.2 67.5 181.3 60.3 183.7 64.1 190.4 67.4 190.4 89.5 189.6 89.5 189.6 91.3 192.2 91.3 192.2 80.3 201.1 80.3 201.1 91.3 203.6 91.3 203.6 89.5 202.8 89.5 202.9 67.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "208.4 66.6 211.4 64.5 205.8 66.5 208.4 66.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "208.6 67.3 204.8 67.1 206.8 68 208.6 67.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "187.5 66.5 181.9 64.4 184.9 66.6 187.5 66.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "186.4 68 188.5 67.1 184.7 67.3 186.4 68"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M195.4,95.6c-10.7,9.1-26.9,20.2-38.2,28.5.3,0,32-1.8,39.4-2.5,6.4-.6,25.6-1.9,28.8-2.1,5.7-.5,9.1-.8,11.3-1.1.7-.1,1.5-2.2,1.6-3.2,4-30.7,7-55.4,7.1-65.2-4.5,7-44.1,40.7-49.9,45.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M202,125c0-.2-.1-.4-.2-.6.2.1.3.5.2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M202.5,127.2c0-.2-.1-.4-.2-.5,0,.2.1.4.2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M203.2,128.9c-.1-.2-.3-.4-.4-.6.1.2.3.4.4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M196.9,96.5c0,0,.2-.2.3-.2,0,0-.2.2-.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M91.5,55.9c0,.3,0,.8-.2.8l.2.2c0-.3,0-.6,0-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,104.9h0c0,0,0,.1-.1.1-.1,0-.2,0-.4,0,0,0,.3-.1.5-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,114.3c0,.6,0,1.3,0,1.9-.3-1.2-.7-2.4-1-3.5v-1.2c0-2.1,0-4.2,0-6.3.1,0,.2,0,.3,0,.1.4.3.8.3,1.1.1,2.7.2,5.3.3,8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M54.9,75.6c0,0,.1-.2.2-.3,0,.1,0,.2-.2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M55.1,75c0,0,0,.2,0,.2,0,0,0-.1,0-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M16.3,65.5c.1-.2.2-.4.3-.6-.1.2-.2.4-.3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M53.2,117.5v6.8-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M53.1,129c0,.3,0,.5,0,.8,0-.3,0-.5,0-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M65.4,145.8s0,0,.1,0c0,0,0,0-.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M74.8,150.1c.3.1.6.3.9.4-.3-.1-.6-.3-.9-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M29,164.9c-.1.5-.2,1.1-.8,1.4-.8.2-1.6.3-2.6.5,0-.4.2-.7.2-1-.2,0-.5-.1-.7-.2,0,0,0-.4,0-.5.3-.1.6-.3.8-.2.5.1,1.1.3,1.6.5,0-.5,0-.8,0-1.1.6,0,1.2-.2,1.3.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M24.3,165.7c0,.2,0,.5-.1.7,0,0-.1,0-.2,0v-.7c.1,0,.2,0,.3,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M24.6,164.9s0,0,0,0c0,0,0,0,0-.1,0,0,0,0,.1,0,0,0,0,0,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M30.3,162.7c.2.1.3.2.5.3-.2-.1-.3-.2-.5-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M30.1,162.5l.3.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M31.7,163.6c0,0,.1.1.2.2,0,0-.1-.1-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M31.1,163.3c.1,0,.2.2.3.2-.1,0-.2-.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M30.9,163c0,0,.2.2.3.2,0,0-.2-.2-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M60.5,110.9c-.4-.3-.8-.6-1.2-1h0c.4.3.8.7,1.2,1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M62.4,112.2c-.7-.4-1.3-.9-1.9-1.4.6.5,1.2.9,1.9,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M97.8,128.4c-1.6.1-3.4.2-4.9-.5-.6-.3-1.2-.7-1.8-1.2-.8-.6-1.3-1.3-2.2-1.8,2.6,1.6,5.4,2.4,8.3,2.9.2.2.3.4.5.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M55.9,81.5c0,.1,0,.3-.1.4,0,0,0-.2-.1-.3,0,0,.1-.1.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M89.2,104.6c0,1,.9,1.3,1.6,1.7.4.2.6.7.9,1-.9-.3-1.8-.7-2.7-1-2-.8-3.8-2.1-4.9-4.1.8.4,1.7.7,2.5,1.1.6.5,1.1,1.1,1.7,1.6.6.6.7,0,.9-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-314",
    d: "M88.1,104.8c-.2.2-.3.5-.7.2-.4-.3-2.6-1.1-3.1-1.4,0-.1,1.9.2,1.9.2.7,0,1.4.1,2.1.2,0,.3-.2.6-.2.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M98.5,93.8c-.2,0-.4-.1-.5-.2.2,0,.4.1.5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M108.2,83.5s0,0,0,.1c0,0,0,0,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M106.9,96.5h1.9c-.6,0-1.3,0-1.9,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M57.2,227.6c-.4-.6-.6-1.6-.7-2.3,0-.2.2-2.1.4-2-.5-.3-1.2-.2-1.8-.2-3.2,0-6.4-.4-9.5-1-.7-.1-4.7-.6-4.8-1.6.5,4.3,2.5,3.9,7,5.8,1.6.7,4.9,2.3,6.2,3.2.8.6,1.9,1.5,2.5,2.4s0,1.4.9,1.8c.2,0-.4.6-.2.6s.4-.1.6-.2c.4-.1.7-.3,1.1-.4.5-.2,1.1-.4,1.6-.4.1,0,.3,0,.4-.1,0,0,0-.2,0-.2-.4-.5-.6-1.1-1-1.6-.2-.4-.6-.6-.9-1-.7-.8-1.2-1.7-1.8-2.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M95.7,155.2c0,2.5-.6,5-.8,7.4,0,.7,0,1.5.1,2.2.2.7.6,1.3.7,2,0,.4.1.7.2,1.1.3,1,1.3,1.8,2.3,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M55.1,75c0,0,0,.2,0,.2,0,0,0-.1,0-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M16,211.2c-.1,0-.2-.1-.3-.2-.1-.1-.2-.3-.3-.4,0,.6,0,.6.6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M24.8,169.3c-2,.3-3.9.8-5.9.9-1,0-2.1-.7-3.1-1.1.2-.3.5-.8.7-.8,1.6.5,1.7-.6,1.8-1.9-.9.4-1.6.7-2.4,1-.5-.8-1-1.6-1.5-2.4-1.7-.7-1.8-2.7-.5-4.4.5-.7.7-1.6,1.1-2.6.1.2.7.6.7,1,0,.6-.2,1.2-.3,1.8-.3.8-.7,1.5-.8,2.3-.2,1.3.5.9,1.2.6.1.2.3.4.4.5l1,.6c0-.2.1-.4.2-.6-.3,0-.7-.2-1-.2-.2-.3-.4-.5-.6-.8-.2-.8-.3-1.6-.5-2.4.4-.2.9-.3,1.3-.5-.1.7-.2,1.5-.3,2.3.6.2,1.7,1,1.3-.9,0-.2,0-.3,0-.5,0-.3,0-.5,0-.8,1.2-.7,2.9-1.1,3.3-2.1.5-1.2.9-2.3,1.8-3.1,1.3.7,2.9,1.1,3.7,2.1.7.9,3,2.6,4.1,2,0,0,1.5,2.6,2.8,3.4.5.3.9.8,1.4,1.2-.3.5-.6,1.1-.9,1.6-.4.3-3.6,2.9-9.2,3.7h0ZM23.6,161.6c0,.3.2.5.2.8.7-.1,1.5-.2,2.2-.3v-.9c-.9.1-1.7.3-2.4.4ZM22.5,161.7c0-.2.1-.4.2-.6-.7-.3-1.4-.6-2-.9,0,.2-.2.4-.3.6.7.3,1.4.7,2.1,1h0ZM23.1,163.5c0-.2.1-.4.1-.6-.6-.1-1.2-.3-1.9-.4,0,.2,0,.4-.1.6.6.2,1.2.3,1.8.5h0ZM19.2,163.5c.1.2.4.3.6.5,0-.2.2-.4.2-.6,0-.2-.8,0-.8,0h0ZM33.9,163.5c-.2,0-.3-.2-.5-.2,0,0-.2.3-.2.3.1.1.3.2.4.3,0-.1.1-.2.3-.4h0ZM31.2,164.7c-.1,0-.3.1-.3.2,0,0,0,.2.1.4l.5-.3c0,0-.2-.2-.2-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M109.3,230.7c1.1,0,2.1-.2,3-.8.5-.3,1.1-.7,1.7-.6.4.1.7.5,1.1.7.9.5,2.1,0,3.2.2.5,0,1,.5.8.9-.1.2-.4.3-.6.3-2,.4-4.2,0-6-1.1-.5-.3-1-.6-1.5-.4-.9.3-1.4,2-2.3,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M157.9,197.2c.2-.4.2-1.1.5-1.2,1.5-.7,1.8-2.2,1.9-3.5.2-1.2.1-2.6-.2-3.7-.9-2.9-1.8-5.8-3-8.5-2-4.3-3.4-8.9-5.3-13.3,1.1,2.4,2.7,4.4,4.1,6.6s1.9,4.7,3,7.1c.9,2.1,2.3,4,3,6.1.3.9.5,1.8.7,2.7.4,1.5,1.1,2.9,1.9,4.2-.4-.5-6,3.3-6.6,3.6h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M122.2,262.5c0,1.2-.4,2.4-1,3.4-3.3-.8-6.6-1.8-9.9-2.9-2.8-.9-5.6-2-8.2-3.5-1.7-1-3.3-2.1-5.1-2.8-3.3-1.4-8.4-2-11.9-1.2-.2,0-.4,0-.6.1-.4,0-.8.1-1.2.2-1,.1-2.1.2-3.1.4-1.4.3-3,.2-4.3.6-.3.1-.7.2-1,.3-1.8.5-3.8.2-5.6-.3-.8-.2-1.5-.5-2.3-.7-.6-.2-1.3-.3-1.9-.5-2.1-.6-4.2-1.1-6.2-1.8-.8-.3-3.8-1.5-4.5-1.8-.2-.1-.5-.2-.7-.3-.9-.3-1.8-1-2.6-1.4-.9-.3-1.8-.9-2.9-.8,0,0-.1,0-.1,0,0,0,0,0,0,0-.1-.6.3-1.2.6-1.6.5-.7.7-1.6,1-2.4.4-.9.7-1.8,1.1-2.8.8-2,1.5-4,2.2-5.9l1.9-1.9c2.8-1,5.6-2,8.4-2.7,4.2-1.1,8.6-1.9,12.8-2.8.5-.1,1-.4,1.4-.6.4,0,.9,0,1.3-.1,5.7-1.3,11.5-1.9,17.3-1.1,2.4.3,6,1.7,8,3.1,3.4,2.3,6.6,4.7,9.6,7.5,4.6,4.2,8.5,9,11.5,14.5.7,1.2,1.8,2.6,2.2,4,.5,1.8.5,1.1-.4,2.4-.5.8-1.2.6-1.4,1.7,0,0-.2.6-.2.9,0,.9-.5,1.7-1.4,1.8-1,.1-2.1-.1-3.1-.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M127,260.1c0-.2.2-.3.3-.4-.1-.2-.3-.5-.5-.6-3.5-3.3-6.9-5.9-10.6-8.9-4.7-3.8-9.5-8.5-14.6-11.9,3,2.6,5.2,5.3,8.2,7.9,1.1.9,2.1,1.9,3.2,2.8,2.7,2.4,5.5,4.8,8.1,7.3,1.7,1.6,3.4,3.4,5.6,4.3,0-.2.1-.4.2-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M119.6,261.8c1.2.6,1.9.9,3.2,1.2-6-4.6-11.8-8.5-18.2-12.5-1.6-1-3.4-2.2-5.2-2.6,0,.8.4,1.2,1.1,1.6,2.9,1.5,5,3.7,7.5,5.7,3.2,2.5,7.3,4.2,10.9,6.2.3.2.5.3.8.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M103.1,259c-3.4-2-6.7-4.6-10.6-4.9-1.7-.1-3.3.2-5,.5-2.8.5-5.5,1-8.3,1.6-1.7.3-3.4.6-5.2.7-2.1.1-4.3-.1-6.3-.7,4.8,2,10.2,2.5,15.3,1.5,1.5-.3,3-.8,4.6-1,4.2-.7,8.7,0,12.5,2,1.2.6,2.4,1.4,3.5,2.1,2.3,1.4,4.8,2.4,7.3,3.2,1.6.5,8.5,3.1,10.1,2-4.7-2.2-13.3-4.2-17.9-6.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M54.9,234.9c-.4.2-1,1.4-1.2,1.8-.7,1.7-1.5,3.4-2.2,5.2-.3.7-.6,1.4-.9,2.1,0,.3-.1.7-.3.9-.1.2-.4.2-.4.4-.3.5-.5,1-.8,1.5,0,.1-.1.2-.1.3,0,.2-.1.4-.1.6-.1.5-.4,1-.4,1.5,0,0,0,.1,0,.2,0,0,.1,0,.2,0h.7c-.1,0,1.9-3.6,2.3-4.6.8-1.8,1.6-3.7,2.2-5.6.4-1,.7-2.1,1.5-2.8.4-.5,1-.8,1.5-1.1,1.2-.7,2.3-1.5,3.5-2.2,0,0-3.2.5-5.4,1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M126.5,253.1c-3.1-3.6-13.1-13.9-16.4-16.9-.5,0-1.5-1.3-1.7-1.4-.3,0-.6-.2-.9-.3,1.4,1.5,17.7,17.9,17.9,18.2,1.3,1.2,2.6,2.9,3.5,4.5.3-.4-2-3.7-2.4-4.2h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M167,199.4c1.6-.5,3.3-.3,5-.4,2.3,0,4.5-.6,6.8-.7,2.3,0,4.7.5,6.2,2.2.6.7,1.1,1.6,1.9,2.1.6.4,1.2.5,1.9.6,1.8.4,3.6.7,5.4,1.1.9.2,2,1,1.5,1.7-2.6,0-5.2,0-7.9,0-.6,0-1.2,0-1.6-.4-.4-.4-.4-1-.8-1.3-.5-.4-1.2-.2-1.7-.5-.7-.3-1-1.1-1.5-1.6-1.5-1.4-3.9-.3-5.6.8-.5.3-1,.6-1.6.6-.5,0-1-.4-1.4-.6-2.6-1.3-5.3,1.2-8,2.2-1.8.7-3.9.8-5.7.3.7-2.3,2.5-1.1,4-2.2,1.4-1.1,1.1-3.2,3.3-3.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M24.9,214.6c.7.6,4.2,1.1,4.9,1.6,1,.7,2.1,1.2,3.3,1.6,3.4,1.3,8,2.3,11.3,3.6-2.8-2.1-6.2-4.7-7.5-8-.6-1.5-1.3-1.4-2-2.9-.5-1.2-1.4-4.9-2.7-5.2s-3.1,1.1-4.4,1.6c-1.6.7-9.7,2.7-11.4,3.2-1.3.4,5.6,2.1,8.4,4.5h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-329"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M143.3,210.5c0-.2.1-.4.2-.6h-1.1c-3.1,0-6.3,0-9.5,0-.7.4.2,1.5,1.1,1.7,2.4.5,4.8.8,7.2.9,0,0,.1-.2.2-.2.5-.5,1.1-1,1.7-1.4,0,0,.1-.1.1-.2h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M204.9,181.9c-.3,3.1-3,9.4-5.5,11.1-.7.5-1.7,1-2.4.5-.3-.2-.5-.5-.7-.8-1.6-1.7-4.1-.1-5.9.1-2.3.3-2.4-1.2-4.4-.8.4,1.8,1.8,3.3,3.6,2.7,1.1-.4,1.8-1.6,3-1.7,1.5,0,2,1.3,3.1,1.9,1.8.9,4.3-.9,5.9.3.8.6,2.4,2.3,2.4,3.2.6-3.2.8-6.7.9-10,0-.9,0-1.8.1-2.8v-1.1c-.1-.6,0-2.1-.2-2.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M54,217.1c-2.4-1.1-4.7-1.9-6.9-3.5-1.9-.8-8-6.9-9.1-9.7-1.7-4.2-3.1-8.6-5.1-12.6-.9-1.8-2.2-6.3-3.6-11.1-.6-.2-1.2-.5-1.7-.9-.6.7-1.3,1.2-2.2,1.5.2,5.4.4,10.7-.2,12.9-1.3,5.5-4.1,10.9-9,13.6-1.6.9-3.4,1.6-5.1,2.2-1,.3-2,.5-2.9.8,1.5.4,3,1,4.6,1.2,1.5.2,3.1.3,4.6.4,1-.3,2.1-.6,3-1,2.9-1.1,3.2-1.4,5.8.3,2.3,1.5,4.6,2.9,7,4.2,1.5.8,3,1.5,4.6,2,2.4.6,4.8.5,7.3.6,5.2.2,10.5,1.3,15.4,3.3-2.2-.9-4.3-3.2-6.6-4.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M30.6,190.4c1,8.3,3.9,16.3,8.3,23.3-.9.7-2.2-.2-2.9-1.1-3.2-4-5.4-8.8-6.6-13.9-.7-3-2.5-12.1.4-14.3.6,1.8.5,4,.7,5.9h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-308",
    cx: 229.1,
    cy: 56.2,
    rx: 1.7,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M224.8,56.4c0-.4-.3-.6-.7-.6s-.6.3-.6.7.3.6.7.6.6-.3.6-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M222.9,56.5c0-.7.5-1.4,1.2-1.4s1.3.5,1.4,1.2-.5,1.4-1.2,1.4-1.3-.5-1.4-1.2ZM223.1,56.5c0,.6.5,1.1,1.1,1s1-.6,1-1.2-.5-1.1-1.1-1-1,.6-1,1.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M206.8,95.3l-15.8-.6-12.1,3.8-9.3,7.1s1.6,2.6,3.9,2.7c1.7,0,4.5-1.6,7.3-3.9l10.3-2.5,13.7,1.1,2.1-7.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M175.1,101.3s.4.4.5,1.1c.1.7-.2,1.4-.8,1.7l-3.1,2-1-1.4,4.4-3.4h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M204.2,105.2l-15,2.7-8.5,5.4-4.1,6.5s3.2,4,7.6-2.5l8.4-3.6,11.5-.8v-7.7s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M179.4,115.5l.8.8c.4.4.5,1.1,0,1.5l-1.6,1.9-1.3-1.1,2-3.1h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M206.3,141.9s0,0,0,0c0,0,0,0,0,0,0,0-.1,0-.2-.1h.1s0,0,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M196.8,119.2c.8-.2,1.6-.2,2.1,0,.2,0,.4.3.5.5.1.3.3.6.2.9.3-.8-5,0-5.3,0-1.5.3-3.1.5-4.6.8,1.8-.5,3.6-1.1,5.3-1.7.5-.2,1.1-.4,1.8-.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-260"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M123.3,220.4c-.4,0-.8,0-1.1-.1-.3,0-.7-.1-1,0-.6.4-1.2.5-1.8.6l1.3,7.3c.8,0,1.4.4,2,1.2.2.3.4.5.7.7h1.4c.8-.2,1.6-.5,2.4-.7-.5-1.3-.4-2.2.6-2.8l-3.4-.2-1-6.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M103.4,221.1c0,0,0,0-.1,0-.1,0-.3.1-.4.2,0,0,0,0-.1.1-.1.2-.3.5-.5.7h-.3c-.3.2-.5.3-.8.4,0,0-.2,0-.2.1-.2.1-.3.2-.5.3-.2,0-.4.2-.6.3l.3,1.7c.3,0,.6,0,.9.2.8.3,1.7,0,2.4.9.1.2.6.2.8.1.4-.2.7-.3,1.1-.2l-.9-5c-.4,0-.8,0-1.3,0h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M313.1,238.5c-.4.1-1.1-.2-1.4-.5-.8-1-1.8-1.2-2.6-.2-.5.6-.9.9-1.7.7-.2,0-.5,0-.6,0-1.6,2-4.3,1.2-6.3,2.4-.8.5-1.7-.5-1.7-1.1,0-1.7-1.6-2.6-2-4,0-.2-.2-.4-.4-.6.5-.4-.1-2-.9-2.3,0,0,0-.2,0-.3,0-.4-.6-1.1-.9-1-1,.4-1.5-.2-1.5-.9-.1-1.7-1.6-1.9-2.6-2.5,0,0-.3,0-.3,0-1.4,1.6-3.8-3-6-1.7-.1,0-.2.2-.4.2s-.3-.1-.5-.2c-.7-.5-1.8,0-1.9.8-1.4-.1-6.5-.8-7.4.9-.2.3,0,.8-.3,1.1-.3.3-.7.1-1.1.1-.8,0-2,2-2.7,2.5-1.4,1-2.8,2-4.1,3,.2-.1-1-.3-1.3-.2-.4.2-.8,1-1.2,1.4-.7.7-3.1,1.7-2.6,3-1.7,1.1-2.5,3.4-1.9,5.3-.2.2-.5.2-.8.2-.4.8,0,1.7,0,2.6s-.2,2-1,2.1c-.5,1.2-.9,2.7,0,3.7,0-.1-2.2.2-2.4.2-.5,0-1.1.1-1.3.6,0,.2,0,.5-.1.7-.2.5-.8.6-1.2.7-1,.2-1.8,1.5-2.5,2.2-2.3,2.2-6.1,2.8-3.9,7.3.1,0,.2,0,.3,0,1.5,1,3.1.8,4.7.6.8-.1,1.5-.1,2.3.2.7.3,1.6,0,2.4-.2,1.4-.4,2.5,0,3.7.6,1,.6,2,.9,2.8-.3.1-.2.4-.3.6-.3,1.5.2,2.2-.9,3.2-1.6.5-.4,1.2-.5,1.7-.9.6-.4,1-1,1.5-1.5.8-.4,1.6-.9,2.6-1.2,1.2-.3,1.9-1.2,2.8-1.9.2-.1.5-.1.7-.2.2,0,.5,0,.6,0,.4-.8.7-1.7,1.8-.6.9-.4,1.7-.9,2.6-1.3s.5-.3.8-.3c1.7-.3,3.3-.5,5-.8,1-.2,1.9-.6,3-.3.2,0,.7,0,.9-.3.8-1,1.9-.8,3-.8.4,0,1,0,1.3-.2,1.1-.9,2.2-.5,3.1,0,1,.4,1.5.3,2-.8.8,1,1.6,1.7,2.8,1.1,1.3,1.3,3,.2,4.4.8,1.4.5,2.6.3,4,0,1.2-.3,2.5.1,3.7.3.7,0,19.2.6,19.9.7v-17.7c-1,.4-19.7.6-20.7.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M269.4,236.7c.8-.3,1.6-.4,2.3-.8.6-.4,1.1-1,1.6-1.5,1.4-1.2,3.5-1.6,5.2-.8.5,1.7,1.9,3.1,3.6,3.6-2.7-.3-5.8-.5-7.9,1.2-1.2,1-2.1,2.5-3.7,2.6-.8,0-1.6-.4-2.3,0-1.5.7-.8,3.4-2.2,4s-2.5,0-2.4,2.1c-2-3.6,2.3-9.2,5.7-10.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M55.8,119.9c0-1-.1-2-.2-3,0-.2,0-.5-.1-.7,0-.2-.2-.3-.3-.4-1.6-2.1-3.9-4.4-6.4-5.3.7,1.6,1.7,3,2.5,4.5.7,1.4,1.9,2.8,2.2,4.3s-.1,3.3-.2,4.8-.1,3.1-.2,4.7c0,.3,0,.5,0,.8,0,.6,0,1.3-.1,2,0,.5,0,.9,0,1.4-.2,1.1-.4,2.3-.6,3.4,0,.2,2.4,1.1,2.7,1.2,1.3.2.6-2.7.7-3.5.1-2.1.3-4.2.3-6.3,0-2.7,0-5.3,0-8h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M199.7,92.8l.2.2c3.9-1.7,9.2-.8,13.1-1.5-.1-.2-.2-.4-.3-.6l-17.4-12.1-13.4-.7-9.2,4.1c1.2,2.5,2.3,3.5,4.2,3.5,2.8,0,6.4-1.8,6.4-1.8l9.5,1.7c2.6,2.6,5.2,5.3,7.9,7.9.3.3.5.5.8.8.2.2.4.4.6.4.4,0,.7,0,1-.3,3.3-1.6,7.3-1.1,10.6-2.6-.7-.5-1.5-.9-2.3-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M227.2,128.7c-.8-5.5-2.1-10.9-3.3-16.3-.7-3.3-1.6-6.5-2.1-9.7-.2-.2-.4-.5-.5-.7-2.8-3.6-5.6-7.3-8.4-10.9-3.6,1.5-9,1.8-12.5,4.3h.1c0,0-.2.5.2,9,.1,2.9.3,5.8.6,8.6.1,1.2.6,2.7.2,3.8-.3,1.1-1.4,1.7-1.9,2.7-.4.8-.4,1.8,0,2.6.2.5.6.8.8,1.3.1.3.1.6.2.9.2,2.2-1,4.2-.4,6.3.9,3.1,2.8,5.8,4.6,8.4.7,1.1,1.6,2,2.2,3.1.7,1.2.6,2.4.8,3.8,0,.5,0,.9.3,1.3.5.7,1.4.8,2.2.8.9,0,1.8-.1,2.6-.2,1.5-.2,3-.3,4.4-.5,2.9-.3,5.6-1.2,8.4-1.5.5,0,1-.2,1.4-.6.3-.3.3-.8.3-1.3.1-5.2.4-10.1-.4-15.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M215.8,99.7c.1-.1.2-.3,0-.4l-2.6-3.8c0-.1-.3-.2-.4,0-.1.1-.2.3,0,.4l2.6,3.8c0,.1.3.2.4,0h0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M213.2,107.4s0,0,0,0c.1-.1.1-.3,0-.4l-2.2-2.6c-.4-.4-.9-.6-1.4-.5l-2.1.3c-.2,0-.3.2-.3.3,0,.2.2.3.3.3l2.1-.3c.3,0,.6,0,.9.3l2.2,2.6c.1.1.3.1.4,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M210.4,115.2h0c.1-.1.1-.3,0-.5l-1.7-1.9c-.4-.5-1.1-.7-1.7-.5l-2,.7c-.2,0-.2.2-.2.4s.2.2.4.2l2-.7c.4-.1.8,0,1,.3l1.7,1.9c.1.1.3.1.4,0h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "200.8 105.9 200.7 102.9 204.6 103.2 204.2 105.2 200.8 105.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M205.5,97.8l-5.7-2.8-3.6-5.7s7.3,5.8,9.3,8.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "204.4 114.7 201.4 115.1 201.2 113.1 204.1 113 204.4 114.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M179.3,79.3s.1.2.2.4c.5.9,0,2-.9,2.3l-4,1.5-1-1.8,5.6-2.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M226.4,128.8c0-.7-.2-1.5-.3-2.2h-.2c-5.6,3.7-11,1.5-11,1.5v.3c2.2,1.3,4.1,2.3,4.8,2.6,1.6.6,4.6,0,6.5-.6,0-.5,0-1,0-1.6h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M202.8,112.8l-10.5,1.2-6.6,3.4-2.1,2.7c-.5.6-.5,1.5,0,2.2l.3.4c.5.8,1.6,1,2.4.6l2-1.2,6.4-2.4,9.5-.2-1.4-6.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M185.9,120.3l.3.5c.2.4.2.7-.4,1.3,0,0-.7.9-.7.8-1.4-.6-1.4-2-1.4-2l.7-.9c.4-.5,1.2-.3,1.5.2h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M216.3,147.3c-2.7.6-4.3,1.2-7,.5-.3,0-2-.7-2.1-.9,0-.2-.1-.3-.1-.5,0-.9,0-1.8-.1-2.7,0-.6-.3-1.2-.7-1.7,0,0,0,0,0-.1-.7-.9-1.6-1.7-2.2-2.6-1-1.8-1.7-3.7-2.7-5.5-.4-.8-.8-1.6-1.1-2.4-.8-2,0-4.7-.5-6.8-.8-3.4-.2-4.4-.3-4.8-.1-1,1.3,4.1,1.2,5.7,0,1,.4,2.1.6,3.1.1.5.3.9.5,1.4.3.7.6,1.4.9,2.1,1.6,3.4,3.3,6.7,5.1,10,0,0,.1,1.7.2,2.6,0,.6,0,1.4.5,1.8.4.4,1,.5,1.6.5,2,.2,4.1.3,6.2.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M200.8,103.1c0-.2,0-.5,0-.7s0,0,0,0c0,0-.1,0-.1,0-2.1,0-4-.2-6.1-.3-1.3-.1-2.7-.3-4,0-2.7.6-5.5,1.3-8.2,2-.8.2-1.9.3-2.5,1-.2.3-.4.6-.7.8-.1.1-.2.2-.4.3-.1,0-.5.2-.6.3.1,0,.2,0,.4,0h.4c0-.1,0-.2.2-.2,0,0,.1,0,.2,0h0s0,0,0,0c.3-.1.6-.2.9-.3,0,0,.1,0,.2,0,.4-.2.9-.4,1.4-.5.4-.1.8-.2,1.3-.2,0,0,0,0,0,0l1.2-.4s0,0-.1,0c.6-.1,1.6-.3,1.8-.4.1,0,.3-.1.4-.2.8-.3,1.6-.2,2.4-.3.8,0,1.6-.2,2.4-.3,1.7-.2,3.5-.3,5.2,0,1.1,0,2.3.4,3.4.5,1.1,0,.9.2,1-.1,0-.1,0-.3,0-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M188,115.6c.6-.3.9-.6,1.6-.7.2,0,.4-.1.6-.2,1.1-.4,2.1-1,3.3-1.1.8,0,1.7-.2,2.5-.2,1.4-.1,2.7-.3,4.1-.2.2,0,.7,0,1,0,0,0,0,0,.2,0,0,0,0,.8,0,.9,0,.3,0,.2-.6.2-.2,0-.5,0-.7,0-.8,0-1.6,0-2.4,0-.9,0-1.7.4-2.6.5-2.5.3-4.9.9-7.2,1.9-1.8.7-3.5,1.6-5.2,2.6.5-.3,1.2-1.6,1.7-2,1.1-1,2.5-.9,3.8-1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M195.9,88.9c-.4-.7-1-1.3-1.5-1.9-.5-.5-.9-1.1-1.5-1.4-.6-.3-1.2-.3-1.9-.5-.1,0-.2,0-.3-.1-1.6-.2-3.1-.4-4.7-.6,1.2.4,2.7,1,3.6,1.3,1.2.5,2,.8,3,1.7,1.8,1.4,2.3,3.5,3.8,5.2,1.1,1.1,3.2,2.6,4.2,2.9-.6-.9-3.3-4.4-4.7-6.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-223",
    points: "95.9 128.5 99.9 120.8 101.5 127.3 95.9 128.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-230",
    points: "119.3 56.4 118.9 51.5 96.2 19.5 91.5 54.2 119.3 56.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-267",
    points: "96 44.2 24.1 53.5 24 50.2 96 19.5 96 44.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-190",
    points: "96 23 24.1 53.5 55 78.8 118.8 56.5 96 23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M101.1,126.3h0V56.6c-13.6-25-47.2,5.4-47.2,5.4l-8.5,74.5,55.6,24.6,6.1-1.5.2-16.9-6.2-16.3h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "99.1 84.1 104.5 106.2 111.7 117.3 106.4 126.2 81.7 131.6 60.5 119.2 61.3 87.8 82.3 85.9 89.4 74.2 94.8 82.8 99.1 84.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-223",
    points: "97.4 93 85.6 96.6 94.8 95.8 97.4 93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M82,74.6c1-1.4,2.9-3.9,3.2-4.2-.6-.3-5.4-1.5-6.9-1.4-6.2.3-9.8,3.1-9.8,3.1l.3,2.3,2.9,1.7c3.1-.4,7.3-2.1,10.4-1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M98.6,105.1c-.5.7-1.4.7-2.6.7-2.3,0-4.5.2-6.8.2-2.7,0-5.3.2-8,.3-1.2,0-2.4,0-3.6.1-1.2.2-2.8.9-4,.3-.2,0-.3-.3-.4-.4-1.5-2-2.1-4.5-2.6-6.9-.3-1.5-.9-2.9.9-2.6,2.2.3,4.4.7,6.6,1,3.4.5,6.8,1.1,10.2,1.6,3.3.5,6.6,1.3,9.9,1.2.4,1,.7,2,.7,3.1s-.1,1.2-.3,1.6h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-223",
    points: "71.2 92.4 67.2 92.7 67 96.5 65.2 91 71.2 92.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-223",
    points: "98.2 107.4 84.1 107.6 93.5 109.8 95.7 112.3 95.3 110 98.2 107.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M99.4,74.6s-.7-1.3-2-2.1c-1.9-1.1-4.6-1.7-4.6-1.7l1.9,4.5c.1,0,4.7,2.1,4.7,2.1,0,0,0-.5,0-3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M99.9,65.1s-9.5-8.9-35.9-.4c0,0,7-12,23-12.6,0,0,12.2,1.2,12.9,13.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M58.9,69.9c3.2-8.9,9.6-16.7,18.8-18.6,2.3-1,4.6-1.4,7.4-1.6,1.9-.1,3.7.1,5.3.7h.2c0-.1,4.7-23.3,4.7-23.3L27.1,55.9l27,22.2,2.4-1.8c.4-2.2,1.2-4.4,2.4-6.3h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M50.3,39.1c-.6,0-1.1,0-1.7.1-.2,0-.4,0-.7.2-.8.2-1.6.4-2.4.6-1.2.3-2.5.6-3.7.9-.7.4-1.3.7-1.9,1.1-.2.2-.5.3-.7.5-.1,0-.3.2-.4.3,0,0,0,0,0,0h0c0,.1-.1.2-.2.2,0,0,0,.2,0,.3.5-.1,1-.1,1.1.6,1.1-.3,2.2-.7,3.3-1.1s2.1-.5,3.2-.9c2.3-1,4.4-2.5,6.8-3.2-.8-.2-1.6.3-2.5.4h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M104.5,56.4c-.1-.2-.2-.3-.3-.5,0,.2.2.3.3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M101.4,51h0c.2.4.5.8.7,1.1-.2-.4-.4-.7-.7-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M72.4,65.3c.2,0,.4-.2.5-.2,0,0-.1,0-.1,0-.1,0-.2.1-.4.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M40.4,62.4c-.2-.1-.6-.2-.9-.3h0c.3.2.6.3.9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M39.2,45.7h0c0-1.5.3-1.7.3-1.8h0c-.2-1.5-1-1.3-1.5,0,0,0,0,.4,0,.8,0,.4,0,.9-.1,1.5-.3,3.5-.9,9.9-1.1,11.1,0,1.4,0,2.5-.1,3.6-.1,3.6-.2,5.5-.2,8.1.5-.1,1-.2,1.5-.1.5.3.9.5,1.2.8.1-2.5.3-5.1.3-7.6h0c0-1.2-.1-11.4-.3-16.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M41.2,72.1c0,.5.2,1,.2,1.5,0-.5,0-1-.2-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M36.5,69c-.4.1-.9.3-1.2.5-4.2,2.4-.9,8-.9,8.5.3,2.3-2,11.7-2.9,14.3-2.9,7.9-4.6,6.2-7.4,10.6-4,6.4-.3,9.8-.3,10.6s-4.3,6.2-1.6,5.8c1.4-1.9,2.7-.9,3.5-3.3,1.1,3.7-3.7,3.2-3.1,5.8,4.9-1.4,5.4-6,5.6-.6,3.1,1.3.4-4.9,3.4-2.2,2.1-1.3,1.4-5.1,1.6-5.8.5-1.6,2.6-1.4,4.7-11.5,3.5-16.3.1-21.8.3-23,0,0-.1,0-.2,0-.7,0-1-1-1.6-1.1.8,0,1.5-.3,2.1-.8s1-1.1,1.4-1.8c.6-.9,1.2-1.9,1.2-3-.3-.8-.9-1.6-2-2.4-.4-.3-.8-.5-1.2-.8-.4,0-1,0-1.5.1h0ZM27.1,118c0,.1-.2.2-.3.2.4-.8.5-1.7.3-2.6-.1-.5-.3-1-.5-1.5.7,1.2,1.1,2.6.4,3.9ZM27.8,102.7c-2.1,2-3.4,4.9-3.4,7.8-.3-1-.2-2.1-.1-3.1.1-1.3.2-2.6.9-3.7.4-.7,1-1.2,1.6-1.7.4-.3,1.8-1.9,2.1-1.4.4.7-.8,1.7-1.2,2.1h0ZM32.3,113.2c-5.8,3.7.8-1.2,2.2-7,.3,2.6-1.3,4.7-2.2,7ZM36.5,96.3c.4-1.3.8-2.7,1-4.1.2-1.2.2-2.5.2-3.8,0-.9-.5-6.1,0-6.3,1-.3.6,4.7.7,5.3,0,.2,0,1.8,0,2.1,0,.2,0,.3,0,.5-.2,1.6-.5,3.1-.9,4.6-.6,2-1.4,4-2.2,5.8l1.2-4.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M32.3,113.2c.9-2.3,2.5-4.4,2.2-7-1.5,5.9-8,10.8-2.2,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M26.9,102c-.6.5-1.2,1.1-1.6,1.7-.7,1.1-.8,2.4-.9,3.7,0,1-.2,2.1.1,3.1,0-2.9,1.2-5.8,3.4-7.8.4-.4,1.6-1.4,1.2-2.1-.4-.6-1.7,1-2.1,1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M27.2,115.6c.2.9.1,1.8-.3,2.6.1,0,.2,0,.3-.2.7-1.4.3-2.7-.4-3.9.2.5.4,1,.5,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M38.5,76.9c-.6.5-1.3.8-2.1.8.5,0,.9,1.1,1.6,1.1,0,0,.1,0,.2,0,.5-.3,1.2-1.3,1.5-1.6.6-.6,1.1-1.2,1.4-1.9.2-.5.2-1,.2-1.6,0-.5-.1-1-.2-1.5h0c0,0,0,0,0,0,0,1.1-.6,2.1-1.2,3-.4.6-.8,1.3-1.4,1.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M37.5,94.6c.4-1.5.7-3,.9-4.6,0-.2,0-.3,0-.5,0-.3,0-1.9,0-2.1,0-.7.3-5.6-.7-5.3-.6.2,0,5.4,0,6.3,0,1.3,0,2.5-.2,3.8-.2,1.4-.6,2.7-1,4.1l-1.2,4.2c.8-1.9,1.6-3.8,2.2-5.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M37.4,43.2s0,.1-.1.2c-.4.8,0,2,0,2.9,0,1.2-.1,2.4-.2,3.5-.1,2.4-.2,4.7-.3,7.1-.1,4.7.3,9.5-.3,14.2.6-4.6,1.1-9.3,1.7-13.9.4-3.4.8-6.8.9-10.2,0-.8,0-1.5-.2-2.2-.1-.4-.5-.7-.4-1.1.1-.6,1.2-1,1.7-1.3.8-.5,1.9-1.4,2.7-1.6-.6.2-1.3.4-1.9.6-.4.1-1.1.5-1.6.8-.6.3-1.2.6-1.7,1,0,0-.2.1-.2.2h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M158.5,146.3c-1.1-.5-19.3-4.7-13.5-3.6-.8-.2-1.5-.6-2.2-1-3-1.9-6.1-3.7-9.1-5.6l1.8-.2c-.4,0-.7-.1-1.1-.2-3.7-.4-7.8,0-11.5.3-3.5.3-7.1.5-10.6.9-.6,0-1.1.1-1.6.2-.3.2-.6.4-.8.5-.7.2-1.6.4-2.3.8-.3,0-.5,0-.8.2-.3.1-.7.4-.8.7,0,0,0,.2,0,.2,0,.3,0,.6.1.9,0,0,0,.1.1.2.7,1.1,1.3,2.4,1.2,3.7,0,.4-.1.9-.3,1.3-.1,1.8-.6,3.6-1.2,5.3-.3,1.5-3.2,9.1-4.3,11.3-1.1,2.3-2.4,4.4-4,6.1-.4.6-1,1.2-1.2,1.8-.3,1,.6,1.1,1.5,1.6.2,0,.3.2.5.3.4.3,1,1.1,1.3.9.6-.2,1.2-.8,1.7-1.3,3.7-3.9,6.3-8.9,9.2-13.4.5-.8,1.1-1.7,1.8-2.3,1.5-1.4,3.7-1.8,5.7-2.2,1.9-.4,3.8-.7,5.6-1.1,7.3-1.4,14.6-2.9,22-3.9,2.1-.3,3.8-.3,5.6.8,1.8,1,3.5.7,5.6,1.2,1.1.2,2.2.6,3.3,1.2,0-.9.4-1.8.4-2.7,0-1.3-1-2.3-2.1-2.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M128.3,142h0s0,0,0,0h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M141.9,141.1c-1.4-1.1-2.5-1.9-3.5-2.7l-2.4-1.8c-2.3-.3-4.7-.2-7.2,0-.3,0-.6,0-.9,0,.9.7,1.8,1.4,2.7,2.2.4.4.8.8,1.2,1.3h.1c.6.3,1.2.6,1.8.8,1.5.7,3,1.4,4.4,2.1,1.5-.6,3-1.1,4.5-1.3-.2-.2-.4-.3-.6-.5,0,0-.2,0-.3,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M82.2,157.1c.2.2.4.3.6.5,3.6,2.6,7.4,5.2,11.1,7.8.9.6,1.7,1.2,2.3,2,.5.6.8,1.3,1.1,2,.4,1,1.7,2.7.9,3.6-2.4-1.1-4.7-3-6.9-4.4-1.6-1.1-3.2-2.1-4.8-3.3-1.1-.9-2.2-1.9-3.5-2.6-1-.6-2.1-1-3.2-1.4-2.7-1-5.4-2-8.1-2.9-2.2-.8-4.4-.8-6.7-.9-2-.2-4.1-.2-6.1-.3-1.3-.1-2.6-.3-3.9-.5.2-.5.3-.9-.4-.9-.4,0-.9,0-1.4,0,.6-1.1,2.4-1.6,3.7-1.2,1.3.3,2.6.5,3.9.7,1.4.2,2.8.4,4.2.5.7,0,1.4,0,2.3-.2-.9-1.5-2.1-1.1-3.1-1.4-3-.8-6.1-1.4-9.1-2.2-1.7-.4-3.4-.9-5.1-1.4-.2,0-.4-.3-.7-.5,1.9.4,3.9.8,5.8,1.3,2.4.6,4.8,1.4,7.2,1.9,2.2.5,4.4.9,6.6,1.3.6.1,1.3,0,1.9,0,0-.2,0-.3,0-.4-.4-.2-.9-.4-1.3-.5-2.1-.6-4.3-1.3-6.5-1.9.6,0,1.2-.1,1.8,0,2.3.5,4.6,1.1,6.9,1.6,2.2.5,4.5.9,6.7,1.6,1.1.3,2.2,1.1,3.2,1.7.3.2.5.4.7.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M146.6,142.3c1.6.2,3.2.4,4.8.7,1,.1,2.1.2,3.1.5.8.2,1.5.7,2.2,1.1v.6c-3.8-.8-7.5-.9-11.3-.6-2.5.2-4.9.7-7.2,1.6-1,.4-2,.5-3.1.7-4,.9-7.9,2.1-12,2.3-.8,0-1.6,0-2.4,0,3.5-1.5,7-3,10.9-3.7.3,0,.5-.2.8-.3,1.4-.4,2.7-.7,4.1-1.1.6-.2,1.2-.4,1.8-.6,2.4-.9,4.9-1.4,7.6-1.1h0c.2,0,.5.1.8.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M107.2,145.9c.9-1.7,1.7-3.5,2.2-5.3,0-.2.1-.5,0-.6-.1-.1-.3,0-.5,0-.6,0-1.1-.4-1.6-.7s-1.1-.5-1.6-.3c.2.6,0,1.5.2,2.1.1.4.2.8.5,1.1.1.2.3.3.3.5,0,.2,0,.3,0,.5,0,.7,0,1.4-.1,2.1,0,.2,0,.5,0,.7s.3.1.5,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M106.5,156.1c-.6,1.1-1.3,2.1-2,3.2-1.2,2-2.5,4.1-2.6,6.4,2.4-3.6,4.9-7.3,7.4-10.9,1.5-2.2,3-4.5,5-6.4,1.9-1.8,4.2-3.3,6.9-3.7-3.1,0-5.2-1.3-7.7,1.2-2.8,2.8-4.8,6.9-6.9,10.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M107.3,117.3c0-.2-.1-.5-.2-.7-.6-1.6-1.2-3.1-1.8-4.7-.4-.8-.7-1.6-1-2.5-.3-.6-.4-2.4-.8-2.9,1.4,2.1,6.3,10.1,7,10.9-2.3,3.4-2.8,4.7-4.6,7.3.4-2.2,1.5-7.2,1.5-7.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M94.8,82.8l-5.4-8.7-1.4,2.3,8.9,16.5c.5,0-2-10.1-2-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M96.6,58c0-.5,0-1.2-.3-1.6,1.2,1.2,1.2,1.3,2.1,2.8.2.4,1,2.5,1.2,2.9.4.9.5,2,.4,3-.6-.7-2.8-1.6-4.2-2.3.2-1.8.7-3.7.8-4.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M307.7,301.6c-4.2-.1-8.4-.3-12.6-.6-4.7-.3-9.4-.7-14-1.1-3.9-.3-7.8-.6-11.8-.8-3.9-.2-7.8-.3-11.7-.6-5-.3-9.9-.7-14.8-1.1-4.1-.3-8.3-.5-12.4-.9-3.1-.3-6.2-.7-9.3-1-2.4-.2-4.9-.4-7.3-.6-3.1-.3-6.2-.7-9.3-1-2.3-.2-4.5-.4-6.8-.6-3.8-.3-7.5-.7-11.3-1.1-2.5-.2-5-.4-7.5-.6-3.6-.3-7.2-.7-10.8-1-2.3-.2-4.6-.4-6.9-.6-2.8-.3-5.5-.6-8.2-.9-2.2-.2-4.4-.5-6.6-.7-3.6-.4-7.3-.9-10.9-1.3-3.6-.4-7.3-.7-10.9-1.2-2-.2-3.9-.6-5.9-.9-4.1-.6-8.2-1.2-12.3-1.8-2.5-.4-5.1-.9-7.6-1.3-1.7-.3-3.4-.4-5.1-.6-3.7-.5-7.3-1.1-11-1.7-3.9-.6-7.8-1.2-11.6-1.9-4.5-.8-8.9-1.8-13.4-2.6-5.9-1.1-11.8-2.3-17.8-3.3-6.5-1.1-13.1-2-19.6-3.1-4.2-.7-8.4-1.6-12.6-2.4-2.7-.5-5.4-.9-8.1-1.4-2.3-.5-4.5-1.1-6.7-1.8-6.8-2.1-13.7-4-20.3-6.5-4.2-1.5-8.1-3.7-12-6-2.1-1.2-3.9-3-5.8-4.6-.4-.3-.7-.9-1.1-1.5-.1,0-.3,0-.4,0,.2.8.4,1.8.6,2.5,1,4.8,1.9,9.6,3,14.4.2,1.2.8,2.3,1.2,3.4.5.3,1.1.5,1.5.9,2.8,2.5,5.8,4.5,9.3,5.9,4.5,1.9,8.9,4.1,13.4,5.7,3.5,1.3,7.3,2.1,10.9,3.1l1.1.5c.5.1,1.1.2,1.6.3.2.2.4.3.6.5.6.1,1.2.2,1.9.3,2,.4,3.9.8,5.9,1.2,2.6.6,5.3,1.2,7.9,1.8,2.6.6,5.3,1.1,8,1.6.2,0,.4.2.6.3h.5c2.1.5,4.1.9,6.2,1.4,1.2.2,5.5,1,5.7,1.1.7.1,2.7.6,3,.8.5,0,2.1.2,2.4.3.2,0,11.5,2.2,12.4,2.4.2,0,1.1.2,1.4.3,1,.2,8.3,1.7,8.9,1.9,0,0,5.1.8,5.4.9.2,0,.4.2.6.2.6.1,23.3,5,25.9,5.6,1.6.4,3.2.6,4.9.8,2.5.4,4.9.8,7.4,1.2,2.7.4,5.5.6,8.2,1,2.5.3,5,.8,7.5,1.2,2.2.3,4.5.6,6.7,1,2.9.4,5.8.8,8.7,1.2,2.7.4,5.4.7,8.1,1,2.4.3,4.9.6,7.3.9,3.5.4,6.9.8,10.4,1.2,4.1.5,8.3,1.2,12.4,1.7,3,.4,6.1.7,9.1,1.2,3.7.5,7.4,1.1,11.1,1.6,1.1.2,2.1.2,3.2.3,1.9.3,25.4,3.2,29.1,3.7,3.9.5,7.8.9,11.7,1.4,4.8.7,9.6,1.5,14.4,2.1,4.1.5,8.3.6,12.4.9,2.2.2,4.4.4,6.6.7,3.6.5,7.1,1.1,10.7,1.5,2.8.3,5.6.4,8.4.6,4.4.3,8.7.6,13.1.8,3.9.2,32.4,0,36.4.2v-26.7c-2.7,0-30,.2-32.8,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M304.1,328c-4.4-.2-237.8-31.7-238-31.8-.3,0-.5,0-.8,0-.2,0-44.8-9-45-9-.3.4-27.1-6.3-27.5-6.5-3.6-1-7.4-1.8-10.9-3.1-4.6-1.7-8.9-3.8-13.4-5.7-3.4-1.4-6.5-3.4-9.3-5.9-.4-.3-.9-.6-1.4-.8,0,0,0,0,0,0l4,13.8c0,0,0-.2,0-.3.6.5.7.6.3,1.5v.4c1.4.8,2.7,1.6,3.9,2.5.7.5,1.2,1.3,1.6,2.1.8,1.6,1.5,3.3,2.2,4.9.1.3.4.6.4.8-.2,1.7.9,3,1.2,4.5.4,1.7,1.4,3.2,1.9,4.8.4,1.3,1.2,2.5,1.6,3.9.9,2.7,1.6,5.6,2.5,8.3.4,1.3,1.2,2.5,1.8,3.7.5,1,1.1,1.9,1.6,2.9.9,1.8,1.4,3.9,2.7,5.2,1.5,1.6,1,3.4,1.1,5.1,0,1.2.9,1.2,1.4,1.7.3.3,1,.4,1.1.8.4,1,.7,2.1,1.1,3.2-.1,0-.3.2-.5.3-.3-.4-.7-.8-1-1.2-.4-.5-.8-.9-1.2-1.4.4.9.9,1.8,1.3,2.7.2.4,2,2.9,2.7,3.7.4.5,20.6,27.5,21.4,28.9.6,1.1,1.4,1.9,2.3,2.7,1.1,1.1,2.2,2.2,3.3,3.3.5.5.9,1.1,1.4,1.6.9.9,1.7,1.9,2.6,2.8,2.4,2.4,4.9,4.8,7.4,7.2,0,0,.3,0,.4.1,1.3.9,2.5,1.8,3.8,2.7,1.3.8,2.7,1.7,4,2.5,2.7.4,5.5.6,8.2,1.2,5.5,1.1,11,2.5,16.5,3.6,4.8.9,9.5,1.8,14.4,2.5,3.6.5,12.3,2.9,14.1,3.3.2,0,.4,0,.5.1,47.3,7.1,74.9,12.6,115.4,20.8,3.2.5,6.5,1,7.1,1.2,4.8.9,9.6,1.9,14.5,2.8,4.1.8,8.3,1.4,12.4,2.1,5.1.8,10.2,1.7,15.3,2.5,3.6.6,7.1,1,10.7,1.6,2.1.3,4.1.8,6.2,1.2,6.7,1.2,13.5,2.3,20.2,3.4,4.5.8,9,1.6,13.6,2.3,2,.3,4.1.5,6.1.6,1.5.1,25.2-.5,26.7-.4v-112.2c-3.9,0-30,.5-33.9.4h0ZM13.6,309.1c0,0,.1,0,.2,0,0,0,0,.2-.1.2s-.1,0-.2,0c0,0,0-.2.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M201.6,393.9c-.1-.1-.2-.2-.3-.3,0,0,.2-.2.2-.2,0,0,.2.1.3.2,0,0-.1.2-.2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M103.9,333.5c0,.2-.1.4-.1.6,0-.2.1-.4.1-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M177.7,380.5c-.1,0-.2,0-.3-.1.1,0,.2,0,.3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M120,363.9s0,0-.1,0c0,0,.1,0,.2,0,0,0,0,0-.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M23.1,374.7c-.6-4.8-2.7-9.9-4.8-14.2-4-8.4-10-15.4-15.8-22.6-4.5-5.5-6.1-12.3-10.3-17.5-5.4-6.8-11.3-10-15.2-18.4-3.3-7.1-5.5-14.9-10.3-21.2-.9-1.2-1.9-2.4-2.5-3.8,0-.1,0-.2,0-.3-1.6-1.3-3.1-2.6-4.6-3.9,1.1,4,2.3,7.9,3.7,11.5.9,2.4,2,4.8,3,7.1,1.6,3.5,8.7,18.5,9.7,21.2,3.9,10.7,9.3,20.8,16.1,30,6.7,9.1,14.3,20,17.5,25.5,1,1.7,2,3.4,3,5.1,2,3.2,4.2,6.2,7.1,8.4,1.8,1.3,3.7,2.5,5.7,3.4-2.9-3.6-1.7-6.3-2.2-10.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M-50.8,306.5c.3-5.4.7-10.8,1-16.2,3.6,8.8,5.2,18.3,4.8,27.8-.2,3.9,0,17.3-5.3,9.1-4-6.1-.9-14-.4-20.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M27.1,184.8c0,0-.2.2-.3.3-.2.2-.4.3-.6.5-3.5,3.2-7,6.4-11.1,8.8-4.9,2.8-10.4,3.1-15.6,4.9-6,2-12.2,2.9-18.2,5-2.4.8-7,2.1-8.6,4.3-2.6,3.4,3.7,2.7,5.5,2.5,6.9-1,13.9-.9,20.9-.8,2.4,0,4.3.4,6.6,1,2.2.6,4-.2,6.2-1,5-1.6,8.6-3.8,11.9-6.8.5-.9,1-1.9,1.5-2.9,1.6-3.4,2.6-7,3.3-10.7-.6-1.7-1.2-3.3-1.7-5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M47.5,223.5c-.3.7-2,.2-2.7.6l-15-5.9c-4.4-2.7-6.5-3-9-4.5-.2-.3-3.5-.8-4-1-8.3-1.3-16.7-2.4-25.1-3.3-3.2-.3-6.5-.7-9.7-.5-1,0-1.9.2-2.9.3-1.6.1-3.2.4-4.7.7-1,.2-2,.3-3.1.5,0-.8-.2-1.7-.7-2.5,6.3-.9,12.7-1.2,19-1,5.3.1,10.7.6,16,1.3,1.3.2,9.2,1,16.2,3.2h0c.4,0,.7.2,1.1.3,3.4,1.4,12.7,5.7,16,7.4,2.4,1.2,6.1,3.6,8.6,4.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M58.8,230.3c-.9-1.7-3-2.8-4.7-3.7-2.5-1.5-4.5-2.4-7.3-3.2-.2,0-.3-.1-.5-.2-.3.8-13.6-4.5-14.2-4,3,1.5,18.8,9,21.4,10.9.9.6,1.7,1.4,2.3,2.3.2.3.5,1.4.7,1.6.2.2,1.9,0,2.9-.5.5-.2-.4-2.7-.6-3.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M28.7,191c-.7-2.4-1.5-4.7-2.3-7,.7,3.6,1.5,7.2,1.5,10.9s-.9,7.5-3.1,10.4c-.9,1.2-2.5,4.6-4.3,5.7,1.5.3,6.9,2.3,11.5,4.4.2-8.4-1-16.4-3.3-24.4h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M-19.2,287.2c1.3,0,4.3,1.2,5,2.3.2.3-.3.4-.3.4-2.7-.5-4.7,2.7-6.8,4.4-2.2-1.1-3.3-3.9-2.4-6.2.3,0,.7,0,1,0,.5,0,3.1-.8,3.4-1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M-16.3,283.6c0,.1-.5,1.1-.6,1.3-.2.3-2.1,2.3-2.2,2.4-.4.2-2.9,1-3.4,1.1-1-1.5-1.6.5-1.3-3.3,1.5-2.6,6.1-3.9,7.6-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M-12.7,286.4c.5,1.7.7,2.3.2,4.3,0,.2-.5.3-.5.4-.4.2-.4.3-.8,0-.6-.5-.5-.8-.7-1.1,0,0,.5,0,.3-.4-.7-1.1-3.6-2.3-5-2.3.1,0,2-2.1,2.2-2.4,0,1.5,1,.1,2.9,1,.3.1-1.1,1,1.4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M-23.6,288.2c-.9,2.3.2,5.1,2.4,6.2,3.3,1.6,6.1,0,7.4-3.4.4.3.4.2.8,0,0,.1.5.3-.4,1.7-4.1,6.5-12.7,2-12.5-5.3.5-.8.7.5,2.3.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M-12.7,286.4c-2.5.4-1.1-.5-1.4-.6-1.9-.9-2.9.5-2.9-1,0-.1.5-1.1.6-1.3,0-.1-.1-.7.5-1,1.8.8,2.6,2,3.2,3.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-336",
    d: "M-14.5,289.9c.2.2,0,.6.7,1.1-1.4,3.3-4.1,5-7.4,3.4,2-1.7,4.1-5,6.8-4.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M69.2,208.7c-.4,1.3-1.6,2.6-2.6,3.1-.5-.1-.5.2-.5.2-.2,0-1.5-.3-1.6-.3-1.2-.8-2.7-4.1-1.8-6,.1-.5.2.6.5,2.1,0,.1-.2,1.4.6,2.6,0,0,.3.3.4.4.2.5.6.4.9.5,1.4.4,2.8,0,3-1.9l-.2-1.2c-.3-.5-1.4-.3-2.1-.3.5-.4.8-1.6.6-2.2-.1-.5-.4-.7-.4-.7-.8-3.3,4.5,1.2,3.1,3.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M66.1,212c-1.2.2-.8,0-1.6-.3,0,0,1.4.3,1.6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M66.6,211.8c-.2.1-.2.1-.5.2,0,0,0-.3.5-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M68,208c-.9.7-1,0-1,0-.4,0-1.1.8-1.4,1.1-.7.5-1.7,1-1.7,1.2-.8-1.2-.6-2.4-.6-2.6.1,0,.3,0,.5,0,1.2.5,1.3,0,2.2,0s1.7-.1,2.1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-324",
    d: "M68,208l.2,1.2c-1.4-1.5-1.9,1.4-3,1.9-.3,0-.7,0-.9-.5.2-.8,1.7-.8,1.2-1.6.4-.2,1-1,1.4-1.1,0,0,.1.8,1,0h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M69.2,208.7c1.5-2.7-3.9-7.2-3.1-3.9l-2.4,2.9c-.1,0-.3,0-.5,0-.2-1.5-.4-2.5-.5-2.1-.9,2,.6,5.3,1.8,6-5.8-3,.2-13.8,4.9-5.5,0,1.3.2,1.5-.2,2.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M65.9,207.7c-.9,0-1,.5-2.2,0l2.4-2.9s.3.2.4.7c.1.6-.1,1.8-.6,2.2h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-336",
    d: "M68.2,209.2c-.3,1.9-1.6,2.3-3,1.9,1.2-.5,1.6-3.4,3-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M65.5,209c.4.9-1,.9-1.2,1.6-.1-.1-.4-.3-.4-.4,0-.2.9-.8,1.7-1.2h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M-34,148.6c.9,0,1.2,1.5,1.4,2.4-.5.6-1.4,2.6-1.8,2.9-.7.4-1.5,0-1.7.1-1.8.8-2.9,2.3-4.9,2.6,0,0-.2,0-.4-.5.4-1,0-2.9.3-3.7.2-.4,5.5-5.4,7.1-3.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M-34,148.6c-1.6-1.5-6.9,3.5-7.1,3.9l-1.1-.8c0-.8-.6-1.3-.5-2.1,1.9-3.8,6.1-4.8,9-1.3l-.2.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M-42.2,151.6c0,.4-.6,1.8.8,4.4.2.4.4.5.4.5,1.2,1.6,1,.8,1.3,1,.1,0-.5.2.9.8,3,1.1,4,0,5.7-2.6.1-.2.6.9,1-1.5.6,2.2-3.2,6-5.3,6.1-3.6.2-8-5.4-5.3-10.7,0,.8.5,1.3.5,2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M-32.2,154.2c-.4,2.4-.9,1.3-1,1.5-.2,0-.2-.1-.2-.2-.2-1.1-1-1-1-1.7.4-.2,1.3-2.2,1.8-2.9,0,.2,1,.4.4,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M-33.4,155.5c-.1,0-.4-.2-.4-.3-2.1-2.4-4.2,1-5.9,2.3-.3-.2-.1.6-1.3-1,2-.3,3.1-1.8,4.9-2.6.2-.1,1,.3,1.7-.1,0,.7.8.6,1,1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M-41.2,152.4c-.3.8.1,2.7-.3,3.7-1.4-2.6-.8-4-.8-4.4l1.1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M-33.4,155.5c0,.1,0,.3.2.2-1.7,2.5-2.6,3.7-5.7,2.6,2,.3,2.5-2.5,5-3.1,0,0,.3.2.4.3h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M-61.4,119.8c-1.1,0-1.4,1.5-1.7,2.4.6.6,1.6,2.6,2.1,2.8.9.4,1.8,0,2.1,0,2.1.8,3.4,2.3,5.8,2.6,0,0,.2,0,.5-.5-.5-1,0-2.9-.3-3.7-.2-.4-6.5-5.3-8.4-3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M-61.4,119.8c1.9-1.5,8.3,3.4,8.4,3.7l1.3-.8c0-.8.8-1.3.7-2.1-2.2-3.8-7.2-4.7-10.7-1.2l.3.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M-51.6,122.8c0,.4.7,1.8-1,4.4-.3.4-.5.5-.5.5-1.4,1.7-1.2.8-1.6,1-.1,0,.6.2-1,.8-3.6,1.2-4.8,0-6.7-2.5-.2-.2-.7.9-1.2-1.5-.7,2.2,3.7,5.9,6.3,6,4.3.1,9.6-5.5,6.4-10.8,0,.8-.6,1.3-.7,2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M-63.7,125.5c.5,2.4,1.1,1.3,1.2,1.5.3,0,.2-.1.2-.3.3-1.1,1.2-1,1.2-1.7-.5-.2-1.5-2.2-2.1-2.8,0,.2-1.2.5-.6,3.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M-62.3,126.8c.1,0,.5-.3.5-.3,2.5-2.4,5,.9,7,2.3.3-.2.1.6,1.6-1-2.3-.3-3.6-1.7-5.8-2.6-.2,0-1.2.3-2.1,0,0,.7-.9.6-1.2,1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M-52.9,123.6c.4.8-.2,2.7.3,3.7,1.8-2.6,1-4.1,1-4.4l-1.3.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M-62.3,126.8c0,.1,0,.3-.2.3,2,2.5,3.1,3.7,6.7,2.5-2.4.4-3-2.5-5.9-3,0,0-.4.2-.5.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M-82.7,269.4c.2,2.8.1,2.7-.7,1.9-.7-.7,0-.6-1.5-1-2.8-.7-4.1,2.3-1.6,3.4-.8.9-2.9-2.3-2.6-4.3.3-1.9,2-2.4,3.6-2.5,1.7-.1,2.2.9,2.8,2.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M-89.1,269.5c-.3,2,1.8,5.2,2.6,4.3.3,0,.3.2.7.1,0,0-.2.3.7,0v.7c-5.2,1.4-7.8-7.7-4-5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-84.9,270.4c1.4.4.8.3,1.5,1-.2,1,0,1.7-1.7,2.5-.9.4-.6,0-.7,0-1.2-1.2-1.4-3.6.9-3.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-319",
    d: "M-82.7,269.4c-.6-1.5-1.1-2.5-2.8-2.4l-.8-2c.6-.3,3.5,1.1,3.7,4.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M-84.9,270.4c-2.3,0-2.1,2.4-.9,3.6-.4,0-.5,0-.7-.1-2.5-1.2-1.2-4.2,1.6-3.4h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M-9.3,219.9c-.6-.8-.7-.9-1.6-1.4-2-1.3-3.6-1.6-5.9-.9-.3,0,.3.4,0,.5-4.7,1.7-3.1,1.3-3.7,4.3,0,.2-.6-.3-.7,0,0,0,.5.6.5.6,0,.1-.4,1.2-.4,2.5,0,.2,0,.3,0,.5h-.7c-1.2-.3-.8-1.9-1.1-3,1.4-4.4,4.6-7,9.4-6.3,1,.1,4.6,2.1,3.9,3.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M-10.9,218.5c.8.6.9.6,1.6,1.4.1.1.2.3.3.4-9.5-.9-7.4,5.4-11.9,5.7,0-.2,0-.3,0-.5,2.6,0,2.8-3.5,3-3.7.2-.2.4.3.6,0,2.5-3.1,2.6-3,6.6-3.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M-10.9,218.5c-3.9.4-4.1.3-6.6,3.4-.2.2-.4-.3-.6,0-.2.2-.4,3.8-3,3.7,0-1.2.4-2.4.4-2.5,0,0-.5-.6-.5-.6,0-.4.6.2.7,0,.6-3-1-2.6,3.7-4.3.3-.1-.3-.4,0-.5,2.3-.7,4-.4,5.9.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M-9.1,220.3c.4.6.7,1.1.9,1.7-1.4-.3-1.2,2.9-2.1,3.5,0,0,.1-.1-.2,0-.7.3-2.5.2-3.5.7-1.7.9-1.4,1.9-1.5,2-1.5.4-1.2,1.5-1.3,1.6-.4.3-2.6.4-2.5,1-1.4-1.2-2.5-2.8-2.4-4.8h.7c4.5-.4,2.4-6.7,11.9-5.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M-21.6,226.1c0,2,1,3.6,2.4,4.8,1.7,1.4,1.8.9,2.4,1.1,0,0,.2.4,1.7.5,1.7,0,3.6-.5,4.6-2,.3.6,1,0,1.6.3-5.2,7.4-17,2.3-13.8-7.7.3,1.1-.1,2.7,1.1,3.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M-8.1,222.1c.7,2.3.8,4.1.6,6.2-.1,0-.3,0-.4,0-.2-.7-1.2-.9-1.9-.7,0-.8,0-1.3-.3-2.1.9-.6.7-3.9,2.1-3.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M-8,228.3c.1,0,.3,0,.4,0-.3.9-.8,1.7-1.3,2.5-.6-.3-1.3.4-1.6-.3.2-.3.6-1.9.6-2.4.7.2,1.1.5,1.9.2h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M-10.5,225.6c-.6,2.2-2.9,5.2-4.6,6.8-1.5,0-1.6-.5-1.7-.5,1.6-2.5,1.1-2.6,1.4-3.6,0-.1-.3-1.2,1.5-2,1-.5,2.8-.4,3.5-.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M-10.2,225.6c.3.8.2,1.3.3,2.1,0,.2,0,.3,0,.5,0,.5-.4,2.1-.6,2.4-1,1.5-2.9,2-4.6,2,1.7-1.7,4-4.6,4.6-6.8.3-.1.2,0,.2,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M-15.4,228.3c-.2,1.1.2,1.2-1.4,3.6-.6-.2-.7.3-2.4-1.1-.1-.6,2.1-.7,2.5-1,.1,0-.2-1.2,1.3-1.6h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M-8,228.3c-.8.3-1.2,0-1.9-.2,0-.1,0-.3,0-.5.7-.2,1.7,0,1.9.7Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M312,284.7c-1.3,0-4.3.9-5,1.9-.2.3.3.4.2.4,2.6-.3,4.4,3,6.3,4.8,2.2-.9,3.5-3.5,2.8-5.8-.3,0-.7,0-1,0-.5,0-2.9-1-3.3-1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M309.5,280.9c0,.2.4,1.1.5,1.3.2.3,1.9,2.4,2,2.5.3.3,2.8,1.2,3.3,1.3,1.1-1.4,1.6.6,1.5-3.2-1.3-2.6-5.7-4.2-7.3-1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M305.7,283.4c-.6,1.6-.8,2.2-.5,4.2,0,.2.5.4.5.4.4.2.4.3.8,0,.6-.5.5-.8.8-1,0,0-.5,0-.2-.4.7-1,3.7-1.9,5-1.9-.1-.1-1.8-2.2-2-2.5-.1,1.5-1,0-2.9.8-.3.1,1,1-1.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M316.2,285.9c.8,2.3-.5,5-2.8,5.8-3.4,1.3-5.9-.5-7-3.8-.4.3-.4.2-.8,0,0,.1-.5.2.2,1.6,3.5,6.6,12.2,2.8,12.5-4.3-.4-.8-.7.5-2.2.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M305.7,283.4c2.4.5,1.1-.4,1.4-.5,1.9-.7,2.8.7,2.9-.8,0-.1-.4-1.1-.5-1.3,0-.1.2-.7-.4-1-1.8.6-2.7,1.7-3.4,3.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-336",
    d: "M307.2,286.9c-.2.2-.1.5-.8,1,1.1,3.3,3.6,5.1,7,3.8-1.8-1.8-3.6-5.1-6.3-4.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M300.4,391.2c.5,1.7,2.1,3.6,3.8,4.3.9-.1.7.2.8.3.3,0,2.4-.2,2.5-.3,2-.9,4.6-5.1,3.5-7.7-.1-.6-.4.7-1,2.7,0,.2.2,1.8-1.2,3.3-.1.1-.6.4-.8.5-.4.6-1,.4-1.5.5-2.2.3-4.3-.3-4.5-2.8l.5-1.5c.6-.6,2.2-.3,3.3-.3-.8-.5-1-2.1-.8-2.9.2-.7.7-.8.8-.9,1.6-4.2-7.2,1.1-5.3,4.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M304.9,395.7c1.9.4,1.3.2,2.5-.3-.1,0-2.2.3-2.5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M304.2,395.5c.4.2.4.2.8.3,0,0,.1-.4-.8-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M302.4,390.4c1.3,1,1.5,0,1.6,0,.7.2,1.6,1.2,2.1,1.5,1.1.7,2.6,1.5,2.5,1.8,1.4-1.5,1.2-3.1,1.2-3.3-.2,0-.5,0-.8,0-2,.5-2-.2-3.5-.3-1,0-2.7-.3-3.3.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-324",
    d: "M302.4,390.4l-.5,1.5c2.3-1.8,2.8,2,4.5,2.8.5,0,1.1.1,1.5-.5-.2-1-2.5-1.2-1.8-2.3-.6-.3-1.5-1.4-2.1-1.5,0,0-.3,1-1.6,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M300.4,391.2c-2-3.7,6.9-9,5.3-4.8l3.5,4.1c.2,0,.5,0,.8,0,.6-1.9.9-3.3,1-2.7,1.1,2.6-1.5,6.8-3.5,7.7,9.4-3.3,1.2-18.1-7-7.7-.3,1.7-.4,2,0,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M305.7,390.1c1.5,0,1.5.8,3.5.3l-3.5-4.1c0,0-.5.2-.8.9-.3.8,0,2.4.8,2.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-336",
    d: "M301.9,391.9c.2,2.5,2.3,3.1,4.5,2.8-1.8-.8-2.2-4.6-4.5-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M306.2,391.9c-.8,1.1,1.5,1.3,1.8,2.3.2-.1.6-.4.8-.5,0-.3-1.4-1.1-2.5-1.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M292.3,199.9c.5,1.5,1.9,3.1,3.3,3.7.8-.1.6.2.6.2.3,0,2.1-.2,2.2-.2,1.7-.8,4-4.4,3-6.7,0-.6-.4.6-.9,2.3,0,.2.1,1.6-1.1,2.9-.1.1-.5.3-.6.4-.3.5-.9.4-1.3.4-1.9.3-3.7-.3-3.9-2.4l.4-1.3c.5-.5,2-.3,2.8-.2-.6-.5-.9-1.8-.6-2.5.2-.6.6-.7.6-.8,1.4-3.7-6.3.9-4.6,4.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M296.2,203.8c1.6.4,1.1.2,2.2-.2-.1,0-1.9.3-2.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M295.5,203.6c.3.1.3.1.6.2,0,0,.1-.3-.6-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M294,199.2c1.2.8,1.3,0,1.4,0,.6.1,1.4,1,1.9,1.3,1,.6,2.2,1.3,2.2,1.5,1.2-1.3,1-2.7,1.1-2.9-.2,0-.5,0-.6,0-1.8.4-1.8-.1-3-.2-.9,0-2.3-.3-2.8.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-324",
    d: "M294,199.2l-.4,1.3c2-1.5,2.4,1.7,3.9,2.4.5,0,1,0,1.3-.4-.2-.9-2.2-1-1.5-2-.5-.3-1.3-1.2-1.9-1.3,0,0-.2.8-1.4,0h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M292.3,199.9c-1.7-3.2,6-7.9,4.6-4.2,1,1.2,2,2.3,3,3.5.2,0,.5,0,.6,0,.5-1.7.8-2.9.9-2.3,1,2.3-1.3,5.9-3,6.7,8.2-2.9,1-15.7-6.1-6.7-.3,1.5-.4,1.7,0,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M296.8,199c1.3,0,1.3.7,3,.2-1-1.2-2-2.3-3-3.5-1.5-1.8-.4.2-.6.8-.2.7,0,2.1.6,2.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-336",
    d: "M293.6,200.5c.2,2.1,2,2.7,3.9,2.4-1.5-.7-1.9-4-3.9-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M297.3,200.5c-.7,1,1.3,1.1,1.5,2,.2-.1.6-.3.6-.4,0-.3-1.2-.9-2.2-1.5h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M308.2,248.4c-1-.2-1.4,1.5-1.8,2.5.5.7,1.3,3,1.8,3.3.8.5,1.7.1,1.9.3,1.9,1.1,3,2.8,5.1,3.3,0,0,.2,0,.5-.5-.4-1.1.3-3.2,0-4.1-.1-.5-5.6-6.3-7.5-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M308.2,248.4c1.9-1.5,7.4,4.4,7.5,4.8l1.2-.8c.1-.8.8-1.4.8-2.3-1.8-4.4-6.3-5.8-9.8-2.2l.2.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M317,252.4c0,.4.5,2.1-1.2,4.8-.3.4-.5.5-.5.5-1.4,1.7-1.2.8-1.5,1-.1,0,.5.3-1,.8-3.4,1-4.4-.4-6-3.3-.1-.2-.7.9-1-1.8-.8,2.4,3,6.8,5.4,7.1,3.9.5,9.2-5.2,6.6-11.4,0,.9-.6,1.4-.8,2.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M305.7,254.4c.3,2.7.9,1.5,1,1.8.3,0,.2-.1.2-.3.3-1.2,1.2-1,1.2-1.8-.4-.3-1.2-2.5-1.8-3.3,0,.2-1.1.4-.8,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M307,255.9c.1,0,.5-.2.5-.3,2.5-2.4,4.5,1.4,6.3,3,.3-.2,0,.7,1.5-1-2.1-.5-3.2-2.2-5.1-3.3-.2-.1-1.1.2-1.9-.3,0,.8-.9.6-1.2,1.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M315.7,253.2c.3.9-.4,2.9,0,4.1,1.8-2.7,1.2-4.4,1.2-4.8l-1.2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M307,255.9c0,.1,0,.3-.2.3,1.6,2.9,2.6,4.3,6,3.3-2.2.2-2.6-2.9-5.3-3.8,0,0-.4.2-.5.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M10.7,228.9c1.4-.2-1.7,3-2.2,3.3,0,.5,0,.8.2,1.3,1.4,3.9.1-.7,4.1-.5,2.2,1.5,1.3,1.9,1.4,2,0,0,.1.4.2.8.3.6,0,1.4,1.5-.3-.7-.4-1.9-2.1-1.5-2.8-1.6-.3-3-2.4-2.8-4.1-.5,0-.5,0-1,.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M15.2,232.7c-.2,0-.5,0-.8,0-.4.7.8,2.4,1.5,2.8,1.1-1.3,1.6-2.4,1.5-4.1-.4,1.3-1.1,1.2-2.2,1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M11.5,233.7c-2.4.8-1.5,2.7,1.8,2.5.3-1.2-.4-2.7-1.8-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M11.5,233.7c1.4-.2,2,1.4,1.8,2.5.7,0,.8.2,1.2-.5-.1-.4-.2-.7-.2-.8-.7-1.4-1.2-1.8-2.8-1.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M8.7,233.5c-.3-.4-.3-.8-.2-1.3.1-1.3,1.1-2.7,2.2-3.3.5-.3.5-.2,1-.3,2.4-.3,2.9,1.8,3.5,4.1,1.2,0,1.8,0,2.2-1.3-.4-6.8-10.6-3.7-9.3,1.9,0,.2.5.1.5.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M11.7,228.7c-.3,1.7,1.1,3.7,2.8,4.1.2,0,.5,0,.8,0-.6-2.3-1.1-4.4-3.5-4.1h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M10.7,228.9c-1.1.6-2.1,2-2.2,3.3.5-.3,3.7-3.5,2.2-3.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M247.2,281.4c.2,2.9.2,2.8,1,1.9.6-.8,0-.6,1.5-1.2,2.9-1.1,4.8,1.8,2.2,3.3,1,.8,2.9-2.7,2.2-4.7-.6-1.9-2.5-2.2-4.3-2.1-1.9.1-2.3,1.2-2.8,2.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M254.3,280.7c.6,2-1.3,5.6-2.2,4.7-.3,0-.3.2-.8.2,0,0,.2.3-.8,0v.7c6,.8,7.5-8.9,3.8-5.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.8,282.1c-1.5.6-.9.4-1.5,1.2.4,1,.2,1.8,2.2,2.4,1,.3.7,0,.8,0,1.2-1.4,1-3.9-1.5-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-319",
    d: "M247.2,281.4c.5-1.6.9-2.7,2.8-2.8l.6-2.1c-.7-.3-3.6,1.6-3.4,5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M249.8,282.1c2.5-.4,2.7,2.2,1.5,3.5.5,0,.5-.2.8-.2,2.5-1.5.7-4.4-2.2-3.3h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M277.2,265.2c.6-1,.7-1,1.5-1.8,2-1.7,3.8-2.3,6.4-1.8.3,0-.3.4,0,.5,5.4,1.2,3.6,1,4.6,4.2,0,.3.6-.4.8,0,0,0-.5.7-.5.8,0,.1.6,1.3.8,2.7,0,.2,0,.3,0,.5h.8c1.3-.6.6-2.3.8-3.5-2.1-4.6-6-7-11.1-5.6-1.1.3-4.7,2.9-3.9,4.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M278.7,263.5c-.9.7-.9.8-1.5,1.8,0,.2-.2.3-.2.5,10.3-2.3,8.8,4.8,13.8,4.6,0-.2,0-.3,0-.5-2.8.4-3.5-3.5-3.8-3.7-.2-.2-.4.3-.6.1-3.1-3.1-3.3-2.9-7.6-2.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M278.7,263.5c4.4-.1,4.5-.3,7.6,2.8.2.2.4-.4.6-.1.2.2,1,4.1,3.8,3.7-.1-1.4-.7-2.5-.8-2.7,0,0,.5-.7.5-.8-.1-.4-.7.3-.8,0-1-3.2.8-2.9-4.6-4.2-.3,0,.3-.4,0-.5-2.6-.5-4.4,0-6.4,1.8h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M276.9,265.7c-.3.7-.6,1.2-.8,2,1.5-.6,1.7,3,2.8,3.5,0,0-.1-.1.2,0,.8.2,2.7-.2,3.9.3,2,.7,1.8,1.9,1.9,2,1.6.2,1.5,1.4,1.6,1.5.5.3,2.9,0,2.9.8,1.4-1.5,2.3-3.4,2-5.6h-.8c-5,.3-3.5-6.9-13.8-4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M291.5,270.3c.3,2.2-.6,4.1-2,5.6-1.6,1.7-1.9,1.3-2.5,1.5,0,0-.1.5-1.8.8-1.8.3-4,0-5.3-1.5-.2.7-1.1,0-1.8.5,6.7,7.3,18.9.2,14-10.4-.2,1.2.5,3-.8,3.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M276.2,267.8c-.5,2.6-.3,4.6.2,6.8.2,0,.4,0,.5,0,.1-.8,1.2-1.2,2-1-.1-.9-.2-1.4,0-2.3-1-.5-1.3-4.1-2.8-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M276.9,274.6c-.1,0-.3,0-.5,0,.4.9,1.1,1.8,1.8,2.5.6-.4,1.5.2,1.8-.5-.3-.3-.9-2-1-2.5-.7.4-1.1.7-2,.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M279.2,271.3c1,2.4,3.9,5.2,6,6.8,1.6-.3,1.7-.7,1.8-.8-2.1-2.5-1.6-2.7-2-3.8,0-.2.1-1.3-1.9-2-1.2-.4-3.1,0-3.9-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M278.9,271.3c-.2.9-.1,1.4,0,2.3,0,.2,0,.4,0,.5.1.6.7,2.2,1,2.5,1.3,1.5,3.4,1.8,5.3,1.5-2.1-1.6-5-4.5-6-6.8-.4-.1-.2,0-.2,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M284.9,273.6c.4,1.1,0,1.3,2,3.8.6-.3.9.2,2.5-1.5,0-.7-2.4-.5-2.9-.8-.1,0,0-1.3-1.6-1.5h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M276.9,274.6c.9.2,1.3-.1,2-.5,0-.2,0-.3,0-.5-.8-.1-1.9.2-2,1Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M298.4,237.1c5.5-1.4,9.9,7.2,12.3,3.4-.1-1,0-1.4,0-1.5-3.7,0-5.8-4.6-10.4-4.5-1.1.7-1.4,1.5-1.9,2.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M300.2,234.4c4.6,0,6.7,4.5,10.4,4.5-1.4-4.7-5.9-7.3-10.4-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M301,248c1.5,1,2.9,1.5,4.5,2.3.4,0,.7.1,1.5-.4-.8-.8-.3-3.5-1.7-3.7-.2,0-4.6,1.5-4.3,1.9h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M298.4,237.1c0,0-.3,1.4-.4,1.9,1.4-.4,1.6-1.5,3.3.2-4.3,4.6-1.6,6.2-1.5,6.8,0,.5-2.8-.7,1.1,2.1-.3-.4,4-1.9,4.3-1.9,1.4.3.9,3,1.7,3.7,2.3-1.4,4.3-5.1,4.5-7.7,0,0-.7-1.6-.7-1.7-2.4,3.8-6.8-4.8-12.3-3.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M298,238.9c-1.7,7.7.6,9.1,7.2,12,.3,0,.1-.7.2-.7-1.6-.7-3-1.2-4.5-2.3-3.9-2.7-1-1.5-1.1-2.1-.1-.6-2.8-2.1,1.5-6.8-1.7-1.6-1.9-.6-3.3-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M303,241.6c-6.6-1.1-1.4,8,1.7,2.8l-1.7-2.8Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M242.7,252.1c-2.9,8.7,3.9,11.7,8.7,8.3,2.5-1.8,4.6-8.3,1.3-9,.5,1.7.3,2.8-.4,4.5-.6,1.4-2,2.6-3.3,3.4-.1,0-.6,1.5-3.2,1.1-3.8-2.2-1.3-2.1-.9-2.6,1.6-2.5,3.2-3.1,3-6.8-.2-3.5-3.7-.2-5.2,1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M242.7,252.1c1.5-1.3,5-4.7,5.2-1.1,2.8.1,3.2,3,4.5,4.9.7-1.7.8-2.8.4-4.5-1.2-4.6-8.7-3.3-10,.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M247.9,251c.3,3.7-1.4,4.2-3,6.8,1.4.5,2.7,1,4.1,1.5,1.3-.8,2.8-2,3.3-3.4-1.2-1.9-1.7-4.7-4.5-4.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M244.9,257.7c-.3.5-2.9.4.9,2.6,2.5.4,3-1,3.2-1.1-1.4-.5-2.7-1-4.1-1.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M215,299.2c1.4,1.8,2.1,3.7,4.8,3.4,1.4-1.6,1.3-1.6.7-3.7-1.7.9-4.1,0-4.5-1.9-1.6,0-1,1.3-1.1,2.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M219.9,302.6c-2.8.4-3.4-1.6-4.8-3.4-.6,3.8,1.7,7,4.8,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M216.2,296.9c.3,1.9,2.8,2.8,4.5,1.9-.7-2.5-2.7-3.7-4.5-1.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M164,218.8c3.8,4,10.2,3.3,9.3,10.7l-1.7.9c3.8-5.7-6.2-10.2-5.8-4.5.8-.7,2.5-2.2,3.3-1.1,6.2,4.1-2.7,9.1-3.3,1.1-.6.5-.2,1.1-.6,1.1-.1,0-.1-1.9-1.7-1.9,3.2,9.3,14.8,9,13-3-2.7,2.3-4-1.6-6.1-2.6-1.8-.8-4.1.2-5.4-1.9-.5.4-.8.5-1.1,1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M165.1,217.7c1.2,2,3.6,1.1,5.4,1.9,2.2,1,3.4,4.9,6.1,2.6-1-6.7-6.3-9.3-11.5-4.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M163.6,225.2c1.5,0,1.5,1.9,1.7,1.9.3,0,0-.6.6-1.1-.5-5.7,9.5-1.2,5.8,4.5l1.7-.9c1-7.4-5.5-6.7-9.3-10.7-1.5,2.7-1.4,3.2-.4,6.4h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M161.4,212.4c.1.4.2.7.4,1.1,3.3-.9,2.3.9,4.5,1.5l-.4-3.4c-1.5-.1-4.6-1.9-4.5.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M161.8,213.5c.3.9.2,5.6,4.5,1.5-2.2-.6-1.1-2.4-4.5-1.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M165.8,225.9c.7,8,9.6,3,3.3-1.1l1.1,2.8c-3.4,2.8-5.5-1.6-1.1-2.8-.9-1.1-2.5.4-3.3,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M169.2,224.8c-4.4,1.3-2.3,5.6,1.1,2.8l-1.1-2.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M262,140.9c-5.2-2.3-10.9,5.5-12.6,1.3.3-1,.2-1.4.2-1.5,3.7.6,6.5-3.6,11-2.7,1,.9,1.1,1.7,1.4,2.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M260.6,138c-4.5-.8-7.3,3.3-11,2.7,2.2-4.4,7-6.2,11-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M257.6,151.2c-1.6.8-3.1,1-4.8,1.5-.4-.2-.7,0-1.4-.6.9-.6.9-3.4,2.3-3.4.2,0,4.3,2.2,3.9,2.6h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M262,140.9c0,0,0,1.4,0,1.9-1.3-.7-1.4-1.7-3.3-.4,3.5,5.3.6,6.3.4,6.9-.2.5,2.9-.2-1.4,1.8.4-.4-3.7-2.6-3.9-2.6-1.4,0-1.4,2.8-2.3,3.4-2-1.8-3.4-5.7-3.1-8.3,0,0,1-1.5,1-1.5,1.7,4.2,7.5-3.6,12.6-1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M262,142.8c.4,7.8-2.1,8.8-9.1,10.6-.3,0,0-.8,0-.8,1.7-.5,3.2-.7,4.8-1.5,4.3-2,1.3-1.3,1.4-1.8.2-.6,3.1-1.6-.4-6.9,2-1.3,2-.3,3.3.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M256.7,144.6c6.8,0,.1,8.1-2.1,2.5l2.1-2.5Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M191.8,187.7c1.4,9.1-5.8,10.9-10,6.7-2.2-2.2-3.1-9,.2-9.1-.8,1.6-.8,2.7-.4,4.5.4,1.5,1.6,2.9,2.8,3.9.1.1.4,1.6,2.9,1.6,4.1-1.6,1.6-1.9,1.4-2.4-1.2-2.7-2.7-3.6-1.8-7.2.8-3.4,3.6.5,5,2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M191.8,187.7c-1.3-1.5-4.1-5.4-5-2-2.8-.3-3.7,2.4-5.2,4.1-.4-1.8-.4-2.9.4-4.5,2-4.3,9.1-1.8,9.8,2.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M186.8,185.7c-.9,3.6.7,4.4,1.8,7.2-1.4.3-2.9.5-4.3.8-1.2-1-2.4-2.4-2.8-3.9,1.5-1.6,2.5-4.4,5.2-4.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M188.6,192.9c.2.6,2.8.9-1.4,2.4-2.5,0-2.8-1.5-2.9-1.6,1.4-.3,2.9-.5,4.3-.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M231.6,185.6c-1.7,1.6-2.6,3.3-5.3,2.5-1.1-1.8-1-1.8-.1-3.8,1.5,1.2,4.1.7,4.7-1.1,1.5.3.7,1.4.7,2.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M226.3,188.2c2.7.8,3.6-1,5.3-2.5,0,3.8-2.8,6.6-5.3,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M230.8,183.2c-.6,1.8-3.2,2.3-4.7,1.1,1.1-2.3,3.2-3.2,4.7-1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M281.3,176.5c-4.4,3.3-10.6,1.5-10.9,9l1.5,1.2c-2.8-6.3,7.8-9.1,6.4-3.5-.7-.8-2.1-2.6-3.1-1.7-6.8,3,1.2,9.4,3.1,1.7.5.6,0,1.1.4,1.2.1,0,.5-1.8,2-1.6-4.6,8.6-16.1,6.4-12.3-5.1,2.3,2.7,4.2-1,6.5-1.6,1.9-.5,4.1.8,5.6-.9.4.5.7.6.9,1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M280.4,175.2c-1.6,1.8-3.8.5-5.6.9-2.3.6-4.2,4.3-6.5,1.6,2.1-6.5,7.7-8.2,12.1-2.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M280.6,182.9c-1.5-.3-1.8,1.6-2,1.6-.3-.1.2-.6-.4-1.2,1.4-5.6-9.2-2.8-6.4,3.5l-1.5-1.2c.3-7.5,6.5-5.7,10.9-9,1.1,3,.9,3.4-.7,6.4h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M284.9,170.7c-.2.4-.3.7-.5,1.1-3.1-1.5-2.4.5-4.6.7l.9-3.3c1.5.2,4.8-1.1,4.3,1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M284.3,171.7c-.5.8-1.1,5.5-4.6.7,2.2-.3,1.5-2.2,4.6-.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M278.3,183.3c-2,7.7-9.9,1.4-3.1-1.7l-1.6,2.6c2.9,3.3,5.7-.6,1.6-2.6,1-.9,2.4.9,3.1,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M275.2,181.6c4.1,2,1.4,5.9-1.6,2.6l1.6-2.6Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M247.5,45.7c-.1-.5-.3-.6-.5-1-.3-.4-1.3-1-1.8-1.1-.1,1.2.3,2.4.1,3.6,0,.6.1.4.1.9h2.4c0-.9-.1-1.7-.3-2.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M245.5,48.1h0c.3.4,0,1.3-.1,1.8-1,8-7.5,58.4-8.7,68.4,1,0,2.2-.4,3.2-.7.5-.2,1-.2,1.1-.4.7-7.9,7.4-61.4,6.9-69.2h-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M-11.2,168.9c1.4-.2,3.4,0,3.6,1.4v.2c.1,0,.3,0,.4.2,2.6,1.2,5.7,1.2,8.5,1.4.3,0,.5,0,.8.1,8.3.2,21.3-.8,26.1-2.6-1.3,0-17.7.9-18.9.7-3.7-.5-7.3-1.8-11-2.3-4.1-.5-8.4-.8-12.7-1.7.5.7,1.7,2.7,3.2,2.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M36.5,161.1l-.6-2c-.6-.5-3.4-2.6-4-3.1-1.3-1.2-2.9,0-4.3-.3-.6-.1-2.1-.8-2.3-.9-1.7-.7-3.5-1.3-5.2-2.1-1.1-.5-2-1-3.1,0-.3.3-.9.2-1.5,0,.3-.3.7-.6.9-.8-1.9-.2-3.9-.4-5.9-.5-3.1-.2-4,.5-4.5,3.3-.7,0-1.3-.2-2-.3-.8,0-1.6-.2-2.5-.2-.3,0-.5.2-.8.2-.6,0-1.2,0-1.9,0-1.2,2.3-3.6,2.4-6,0,0,.6.1,1,.2,1.7-.8-.2-1.5-.5-2.2-.7,0,.1.1.2.2.3-1.1.5-2.3,1.1-3.4,1.6-.7,1.3-1.4,2.6-2.1,3.8,0,0-.3,0-.5,0-.2.2-.4.5-.5.7-1.5,2.9-1,3.7,1.8,4.8,2.7,1,5.4,1.1,8.1,1,2,0,3.9.3,5.8,1.2.8.2,1.5.3,2.5.6-.1-.2,12.8,1.3,20.4.3,5.4-.6,9.4-2.1,11.8-3.1,1.4-.6,2.2-2.1,2-3.6-.1-.7-.2-1.4-.4-2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M26.3,156c-.2-.3-4.1-2.1-5.8-2.8-1.1-.5-2-1-3.1,0-.3.3-.9.2-1.4,0,.3-.3-3-1.1-4.9-1.3-3-.2-3.9.5-4.4,3.3-.7,0-1.3-.2-1.9-.3-.8,0-1.6-.2-2.4-.2-.3,0-.5.2-.8.2-.6,0-1.2,0-1.9,0-1.2,2.3-5.8,1-5.7,1.6-.8-.2-1.5-.4-2.2-.7,0,.1.1.2.2.3-1.1.5-2.2,1.1-3.4,1.6,1.1-2.1,3-2.9,4.8-4,.8-.5,1.5-1.1,2.2-1.5,1.2-.6,2.4-1.4,3.6-1.6,5-.7,9.9-1.3,14.9-1.9,1.1.1,2.3.3,3.4.4.2.1.5.2.8.3,3.6,1.4,7.2,2.8,10.8,4.2.1,0,.2.2.3.3h0c.2.1.4.3.6.4h0c.1.1.2.2.3.3h0c.1.1.3.2.4.3,0,0,.2,0,.2.1,0,.1.2.2.3.3l.4.4c-.2,1.1-.8,1.7-1.9,1.5-.7-.2-1.4-.3-2.1-.4,0-1.3-.9-1.1-1.6-1h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-257",
    points: "10 167.9 10 167.8 10 167.9 10 167.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-256",
    points: "9.4 167.9 9.8 166.9 10 166.9 10 167.8 10 167.9 9.4 167.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "8.7 167.9 9.1 166.9 9.8 166.9 9.4 167.9 8.7 167.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-220",
    points: "9.1 166.9 8.7 167.9 8.5 167.9 8.5 166.9 9.1 166.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-220",
    points: "8.6 166.7 8.7 166.3 8.7 166.7 8.6 166.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "7.9 166.7 8.6 164.9 8.7 164.9 8.7 166.3 8.6 166.7 7.9 166.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "7.2 166.7 8 164.9 8.6 164.9 7.9 166.7 7.2 166.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-262",
    points: "6.6 166.7 7.3 164.9 8 164.9 7.2 166.7 6.6 166.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-210",
    points: "5.9 166.7 6.7 164.9 7.3 164.9 6.6 166.7 5.9 166.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "5.3 166.7 6 164.9 6.7 164.9 5.9 166.7 5.3 166.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "4.6 166.7 5.4 164.9 6 164.9 5.3 166.7 4.6 166.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "4 166.7 4.7 164.9 5.4 164.9 4.6 166.7 4 166.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-144",
    points: "3.3 166.7 4.1 164.9 4.7 164.9 4 166.7 3.3 166.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "2.8 166.5 3.4 164.9 4.1 164.9 3.3 166.7 2.8 166.7 2.8 166.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "3.4 164.9 2.8 166.5 2.8 164.9 3.4 164.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "7.3 168.1 7.7 167.2 7.8 167.2 7.8 168.1 7.3 168.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "6.7 168.1 7 167.2 7.7 167.2 7.3 168.1 6.7 168.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-262",
    points: "7 167.2 6.7 168.1 6.4 168.1 6.4 167.2 7 167.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "14.4 169.9 14.4 169.9 14.4 169.9 14.4 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "13.8 169.9 14.4 168.3 14.4 169.9 14.4 169.9 13.8 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "13.1 169.9 14.4 166.7 14.4 168.3 13.8 169.9 13.1 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "12.4 169.9 14.4 165.1 14.4 166.7 13.1 169.9 12.4 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-163",
    points: "11.8 169.9 14.4 163.5 14.4 165.1 12.4 169.9 11.8 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-315",
    points: "11.1 169.9 14.4 161.9 14.4 163.5 11.8 169.9 11.1 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "10.5 169.9 14 161.2 14.4 161.2 14.4 161.9 11.1 169.9 10.5 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-278",
    points: "9.8 169.9 13.4 161.2 14 161.2 10.5 169.9 9.8 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-257",
    points: "9.2 169.9 12.7 161.2 13.4 161.2 9.8 169.9 9.2 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-256",
    points: "8.5 169.9 12.1 161.2 12.7 161.2 9.2 169.9 8.5 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "7.9 169.9 11.4 161.2 12.1 161.2 8.5 169.9 7.9 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-220",
    points: "7.2 169.9 10.8 161.2 11.4 161.2 7.9 169.9 7.2 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "6.6 169.9 10.1 161.2 10.8 161.2 7.2 169.9 6.6 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "5.9 169.9 9.5 161.2 10.1 161.2 6.6 169.9 5.9 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-262",
    points: "5.3 169.9 8.8 161.2 9.5 161.2 5.9 169.9 5.3 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-210",
    points: "4.6 169.9 8.2 161.2 8.8 161.2 5.3 169.9 4.6 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "4 169.9 7.5 161.2 8.2 161.2 4.6 169.9 4 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "3.3 169.9 6.9 161.2 7.5 161.2 4 169.9 3.3 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "2.7 169.9 6.2 161.2 6.9 161.2 3.3 169.9 2.7 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-144",
    points: "2 169.9 5.6 161.2 6.2 161.2 2.7 169.9 2 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "1.3 169.9 4.9 161.2 5.6 161.2 2 169.9 1.3 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: ".7 169.9 4.2 161.2 4.9 161.2 1.3 169.9 .7 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-333",
    points: "0 169.9 3.6 161.2 4.2 161.2 .7 169.9 0 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "-.6 169.9 2.9 161.2 3.6 161.2 0 169.9 -.6 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-242",
    points: "-1.3 169.9 2.3 161.2 2.9 161.2 -.6 169.9 -1.3 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-218",
    points: "-1.9 169.9 1.6 161.2 2.3 161.2 -1.3 169.9 -1.9 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "-2.6 169.9 1 161.2 1.6 161.2 -1.9 169.9 -2.6 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-295",
    points: "-3.2 169.9 .3 161.2 1 161.2 -2.6 169.9 -3.2 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-300",
    points: "-3.9 169.9 -.3 161.2 .3 161.2 -3.2 169.9 -3.9 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-335",
    points: "-3.9 169.9 -4.4 169.7 -1 161.2 -.3 161.2 -3.9 169.9 -3.9 169.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "-4.4 169.7 -4.7 169.6 -4.7 168.7 -1.6 161.2 -1 161.2 -4.4 169.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-320",
    points: "-4.7 167.1 -2.3 161.2 -1.6 161.2 -4.7 168.7 -4.7 167.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-320",
    points: "-2.3 161.2 -4.7 167.1 -4.7 161.2 -2.3 161.2"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M29.4,163.9c-1.4-.6-2.9,0-4.3.5-1.8.7-3.5,1.4-5.3,2.1-.5-.5-1.3-.7-2-.4-.7.4,0,1.6.8,1.8s1.6-.3,2.5-.3c.8,0,1.5.5,2.3.5s1.5-1.1.8-1.6c1.8,0,3.7-.2,5.5-.4-.6-.8-1.2-1.6-1.8-2.4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-260"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M18.9,152.4c-1.4-.3-2.9,0-4.3-.4-.3,0-.6-.1-.8-.2-1.9.2-3.8.3-5.7.5-1.1,2.1-4.3,2.4-6.3,2.4-3,0-5.4,1.1-8.3,1.2h-.4c-1.2,1.1-.7,2.2,3.5,3.1,7.4,1.6,16.5-.6,23.4-3.1.5-.2.9-.3,1.3-.7.5-.6.5-1.4.2-2.1-.8-.3-1.7-.6-2.6-.8h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M-16.1,244.6c1.9,0,3.9.1,5.8.3-2.9-.9-11.4-2.8-14.3-3-6.5-.5-13.1-.2-19.6-.5-5.6-.3-9.9.3-13.9-4.7-6-7.4-3.2-12.2-.4-19.8,3.3-9.2,10.6-14.1,17.5-20.1-.3,0-.6,0-.8.2-1.8,1.2-3.7,2.4-5.5,3.6-5,3.3-8.7,7.8-12,12.7,0,.1-.2.2-.3.3.2.1-.9,1.8-1.4,2.5-.3.4-.6.9-.8,1.4-.2.4-.2.5-.6,1.3,0,.1-.2.6-.2.7-.4,1.4-1.1,2.7-1.6,4.1-1.4,4-1.4,8.3-.2,12.4.8,2.8,2.4,4.8,5,6.2,1.4.8,2.9,1.5,4.5,1.8,9.8,1.9,37.2.6,38.7.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.2,55.8l-.7-.7h0c0,0,0,.2,0,.2,0-.7-2.1-4-12.2-15.9-.6-.7-1-1.2-1.2-1.4-.4-.5-1-1.2-1.6-1.9-3.8-4.4-10.2-11.7-6.7-16.3l.4-.5.4.4c5.5,5.7,10.3,12.5,15,19,1.7,2.4,3.4,4.8,5.1,7.1h0c1,1.3,2.1,2.9,2.6,4.7.6,2,.1,4.1-1.1,5.4h0ZM96.3,20.8c-2.2,4.1,3.5,10.6,7,14.6.6.7,1.2,1.4,1.6,1.9.2.2.6.7,1.2,1.4,8.2,9.7,11.2,13.8,12.1,15.6.5-1,.6-2.3.2-3.6-.5-1.6-1.5-3.1-2.5-4.3h0c-1.7-2.3-3.5-4.8-5.1-7.1-4.5-6.3-9.2-12.9-14.5-18.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8,123.8h-.6s.1-5.7.1-5.7c-1.2,2.3-3.2,4.2-5.6,5.1l-1.4.5,2.7-4.4c-1.2.8-2.5,1.4-3.9,1.7l-1.5.4,1-1.2c2.2-2.5,2.3-5.9,2.4-9.2,0-1.1,0-2.2.2-3.3.4-3.5,2.5-6,4.5-8.5.8-.9,1.6-1.9,2.2-2.9,1.8-2.6,3.1-5.7,4.1-10.1.2-.7.3-1.4.4-2.1.2-.9.4-1.9.6-2.8.5-1.7.5-3.2,0-4.6,0-.2-.2-.5-.3-.7-.2-.6-.5-1.2-.5-1.9-.2-1.6.6-2.5,1.3-3.5.3-.4.6-.8.8-1.3.4-.9.4-2.2.4-3.4,0-.6,0-1.2,0-1.7.4-4.3.5-7.8.6-11v-.7c0-2.3,0-4.6.7-6.9.9-2.7,3.1-5,6-6.3s6.1-1.3,8.6,0l1.1.5-1.1.4c-1,.4-2.1.8-3.2,1.1-2.3.8-4.7,1.6-6.4,2.8-2.2,1.6-1.4,4.5-1.4,5.1,0,5.2.3,12.9,0,17.2-.1,1.4-.7,2.1.1,3.1.6.7,1.2,1.4,1.6,2.4.1.3.2.7.1,1.1,0,1.1-.4,2.2-.9,3.2-.2.3-.3.5-.5.7-.4.5-.7.9-.8,1.6-.2.9-.2,1.9-.3,2.9,0,.3,0,.6,0,.9-.1,2.2,0,4.5,0,6.7.2,3.6.3,7.4-.4,11-.6,3-1.5,6-2.7,8.8-.4,1-.8,2-1.1,3.1-.6,1.7-1.2,3.5-2.1,5.2-.5,1.1-1.2,2.5-2.5,3.2l-.3-.5v.9c-.2,1.5-.9,3.2-2.3,3.2h0ZM27.4,114h1s-.2,8.6-.2,8.6c.5-.4.8-1.5.8-2.1l1-11.3h1c0,0-.9,10-.9,10,.8-.6,1.3-1.5,1.8-2.6.8-1.7,1.4-3.4,2-5.1.4-1,.7-2.1,1.1-3.1,1.1-2.8,2-5.7,2.6-8.7.8-3.5.6-7.1.4-10.7-.1-2.2-.2-4.5,0-6.8,0-.3,0-.6,0-.9,0-1,0-2.1.3-3.1.2-.9.6-1.4,1-2,.1-.2.3-.4.4-.6.5-.8.8-1.7.8-2.6,0-.3,0-.6-.1-.8-.3-.8-.8-1.4-1.4-2-.9-1-.5-2-.4-3.8.3-4.3,0-9.9,0-15.2,0-.5,0-2.5,0-3,0-2.6-.8-3,1.9-4.9,1.8-1.3,4.3-2.1,6.7-2.9.6-.2,1.3-.4,1.9-.6-2.1-.6-4.4-.4-6.6.5-2.6,1.1-4.6,3.2-5.4,5.7-.7,2.1-.7,4.3-.7,6.5v.7c0,3.3.7,5.9.3,10.2,0,.5,0,2.5,0,3,0,1.3-.8,2.2-1.4,3.3-.3.5-.6,1-.9,1.4-.6.8-1.2,1.6-1.1,2.8,0,.5.3,1.1.5,1.6.1.3.2.5.3.7.5,1.6.6,3.3,0,5.2-.2.9-.4,1.8-.6,2.8-.1.7-.3,1.4-.4,2.1-1.1,4.6-2.4,7.8-4.3,10.5-.7,1-1.5,2-2.3,2.9-2,2.5-4,4.8-4.3,7.9-.1,1-.1,2.1-.2,3.2,0,3-.2,6.1-1.7,8.6,1.8-.7,3.4-1.9,4.6-3.4l1.4-2.2.9.5c-.4.8-.9,1.6-1.4,2.3l-2.9,4.7c2.5-1.6,4.3-4.4,4.5-7.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3,73.4l-.7.4c2.5,4.7,4.6,9.6,6.3,14.7.1.4.2.7.3,1,.5,1.5.1,2.7-1.2,3.5,0,0-.2.1-.2.2-1.1.7-2.4,1.1-3.7,1.6-1.2.4-2.5.9-3.6,1.5l.4.7c1-.6,2.3-1,3.4-1.4,1.3-.5,2.7-.9,3.9-1.7l.2-.2c2.3-1.5,2.4-1.8,1.5-4.4-.1-.3-.2-.6-.3-1-1.6-4.8-3.7-9.8-6.4-14.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8,97.4c1,0,2.4.4,3.6.7.5.2,1,.3,1.5.4,6.2,1.5,12.6,2.3,18.9,2.4.3,0,.8,0,.9.2,1.1.1,1.1.6.9.7l.3,1.6-.2,2.6c-.1,0-.4.1-.9.2-3.8,0-7.7.1-11.6.1s-5.6,0-8.4,0c-1.4,0-2.7-.1-3.5-.8-.8-.7-3-6.1-2.9-7,0-.5.2-.9,1.3-.9M71.8,96.4c-1.2,0-2.1.4-2.3,1.8-.2,1.2,2.3,7.1,3.2,7.9,1.1,1,2.7,1.1,4.2,1.1,2.8,0,5.6,0,8.4,0s7.7,0,11.6-.1c.8,0,1.8-.6,2-1.3-.2-1.4,0-4,0-6.1-1,0-2.5.2-3,.2-6.3-.2-12.6-1-18.7-2.4-1.6-.4-3.7-1.2-5.3-1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8,19.9l-.4-.9c-15.2,6.7-30.4,13.5-45.5,20.5l.4.9c15-6.9,30.4-13.8,45.5-20.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,25.5l-.4-.9c-9.2,3.8-18.5,7.6-27.7,11.4s-18.5,7.6-27.7,11.4l.4.9,27.7-11.4,27.7-11.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9,54.3h1v-4.4c2-.8,4-1.5,6-2.3s4-1.6,6-2.3l-.4-.9c-2,.8-4.1,1.6-6,2.3-2,.8-4,1.6-6,2.3l-.6.2v5.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.1,47.9h-1v.3h1v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9,52.7l.3,1c4.3-1.3,8.5-2.8,12.6-4.5l-.4-.9c-4.1,1.7-8.3,3.2-12.6,4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.8,148.6c-1.5,0-3-.3-3.9-1.5-.7-.9-.8-2.1-.8-3.2,0-.7,0-1.4-.2-2-.5-1.4-1.4-2.4-2.4-3.5-.7-.7-1.4-1.4-1.9-2.3-1.6-2.5-1.8-5.2-2-7.7-.1-2.1-.2-4.1-1.1-6-.2-.5-.5-1-.3-1.6h0c-2.9-.8-6.1-.4-8.7,1.2-.3.2-.5.3-.8.5-.8.5-1.5,1-2.4,1.3-1.3.4-3.1,0-3.7-1.3-.3-.6-.3-1.3,0-2-.8.6-1.6,1.1-2.6,1.3s-2.1-.2-2.8-.9c-.6-.5-.8-1.2-.7-1.9,0-.6.4-1.1.6-1.5,3.1-4.9,6.3-7.7,11-9.7,1.3-.6,2.8-.9,4.2-1.3,1.6-.4,3.3-.8,4.7-1.5l.4-.2c.5-.3.9-.5,1.3-.8-1.8-1.4-5.8-1-7.9-.8-3.8.4-6.9,1.6-10.1,2.8-1.4.5-2.8,1.1-4.3,1.5-3.7,1.2-6,1.3-7,.2-.6-.6-.7-1.6-.2-2.8,1.3-3.7,10.2-7.1,13.1-8.2,3.7-1.4,7.5-1.8,11.1-2.2,1.6-.2,3.2-.3,4.9-.6-5-6.7-9.8-9.7-14.7-9.1-1,.1-2,.5-3,.9-1.4.5-2.8,1.1-4.3,1-2,0-4.1-1.5-4.1-3.6,0-1.6,1.2-3,3.6-4.1,1.9-.9,4.5-1.9,7.2-2,1.8,0,3.6.3,5.3.7,2.4.5,4.7,1,6.9.4h.2c0,0,.2,0,.2,0,1.2.8,2.3,1.5,3.4,2.2,1.1.7,2.3,1.4,3.5,2.2,6.4,4.4,13.5,9.5,17.7,16.8,3.2,5.5,4.4,11.8,5.5,18.7,1,5.9,1.9,11.9,2.7,17.8.5,3.5.6,7.3-1.9,9.6-1.4,1.2-3.2,1.6-5,1.9-3.2.5-6.4.8-9.6,1-.3,0-.6,0-1,0h0ZM199.1,121.2c0,.2,0,.5.2.8,1,2.2,1.1,4.3,1.2,6.4.2,2.5.3,4.9,1.8,7.2.5.8,1.1,1.4,1.8,2.1,1,1.1,2.1,2.2,2.6,3.9.2.7.3,1.5.3,2.2,0,1,0,2,.6,2.7.8,1.1,2.5,1.1,4,1,3.2-.2,6.4-.5,9.5-1,1.6-.3,3.3-.6,4.5-1.6,2.2-1.9,2-5.4,1.6-8.7-.8-5.9-1.7-11.9-2.7-17.8-1.1-6.9-2.3-13-5.4-18.4-4.1-7.1-11.2-12.1-17.4-16.5-1.2-.8-2.3-1.5-3.4-2.2-1.1-.6-2.1-1.3-3.3-2.1-2.4.6-4.8,0-7.2-.4-1.7-.4-3.4-.7-5.1-.7-2.5,0-5,1-6.8,1.9-2,.9-3,2-3,3.1,0,1.5,1.6,2.5,3.1,2.5,1.4,0,2.6-.5,3.9-1,1-.4,2.1-.8,3.2-1,5.4-.7,10.7,2.6,16.1,10.1l.5.7h-.8c-2,.5-3.9.7-5.8.9-3.7.4-7.2.7-10.8,2.2-7.6,2.9-11.8,5.5-12.5,7.6-.3.8-.3,1.4,0,1.8.3.3,1.5.9,6-.5,1.5-.5,2.9-1,4.3-1.5,3.3-1.2,6.5-2.4,10.4-2.8,2.7-.3,7.1-.8,9.1,1.4l.3.3-.2.3c-.5.7-1.2,1.1-1.9,1.4l-.4.2c-1.5.8-3.2,1.2-5,1.6-1.4.3-2.8.7-4.1,1.2-4.5,1.9-7.5,4.6-10.5,9.3-.2.3-.4.7-.5,1.1,0,.5.2.9.4,1.1.5.5,1.3.7,1.9.6,1.2-.2,2.2-1.1,3.2-2l.2-.2c5.7-5,11.9-7.1,17.1-5.6l2.9.8-4.1.2v-.3c-5.6-1.1-11.1,2.3-14,4.6l.2.2c-1,.9-2.1,2.3-1.6,3.4.4.8,1.6,1.1,2.5.8.8-.2,1.4-.7,2.2-1.2.3-.2.6-.4.9-.5,3-1.8,6.8-2.2,10.1-1h.1c.4,0,.7.2.8.6l.4,1.1-1.1-.5c0,0-.2,0-.3-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.1,173.5c-.6,0-1.3-.2-1.9-.7-1.1-.8-1.8-2.1-1.8-3.4-.1-2.1.9-3.9,1.9-5.7v-.2c2.6-4.6,4.7-9.4,6.3-14.3.7-2.2,1.5-4.7,1.4-7.2-.1-2.8-1.3-5.3-2.5-7.9-.9-1.9-1.8-3.9-2.3-6l1-.2c.5,2,1.4,3.9,2.2,5.8,1.2,2.6,2.4,5.3,2.6,8.3.1,2.7-.7,5.3-1.4,7.6-1.7,5-3.8,9.8-6.3,14.4v.2c-1,1.7-1.9,3.4-1.8,5.2,0,1,.6,2.1,1.4,2.7.4.3.9.6,1.6.4,2.8-5.5,6.4-12.3,12.5-15.8,3.2-1.8,6.7-2.6,10.2-3.3l12.9-2.8c3.5-.8,7-1.5,10.7-1.7,7.5-.4,14.9,1.9,22.5,4.5,5,1.7,9.5,3.3,13.4,6.2,1.2.9,2.4,2,3.6,3,2.1,1.9,4.1,3.7,6.6,4.8,3.7,1.7,8.1,1.5,12,1.3v1c-3.9.2-8.4.4-12.4-1.4-2.6-1.2-4.8-3.1-6.9-4.9-1.1-1-2.3-2-3.5-2.9-3.7-2.7-8.1-4.4-13.1-6-7.5-2.5-14.8-4.8-22.1-4.4-3.5.2-7.1.9-10.5,1.7l-12.9,2.8c-3.4.7-6.9,1.5-9.9,3.2-5.9,3.4-9.4,10.2-12.2,15.6v.2c-.1,0-.3,0-.3,0-.2,0-.5.1-.7.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.2,194.2c-.1,0-.3,0-.4,0-1.6-.3-2.5-1.8-3.1-3.4l-9.1-22.5.9-.4,9.1,22.5c.5,1.3,1.2,2.6,2.3,2.8.6,0,1.2-.2,1.9-.4h.1c4.6-1.9,9.8-2.4,14.6-1.4l-.2,1c-4.7-.9-9.7-.4-14.1,1.3h-.1c-.6.3-1.3.6-2,.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.6,200.2c-.2,0-.4-.1-.5-.3-.2-.3-.2-.7-.1-1,0-.1,0-.2,0-.3-1.3-5.5-.9-11.1-.6-16.6l2.3-34.1c0-.5.4-.6.5-.6.2,0,.5,0,.6.4.1.3,0,.7-.1.9l-2.2,33.4c-.4,5.4-.7,11,.5,16.3,0,.2,0,.3,0,.5,0,0,0,0,.1,0l.3.6c0,.2-.2.6-.6.7,0,0-.1,0-.1,0h0ZM204.5,199.2c-.1,0-.2,0-.2.1,0,0,0,.3.2.5.2.2.5,0,.5,0l-.5-.6h0ZM205.9,148c0,0-.1.1-.1.2,0,0,.1.2.3.2l-.2-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.3,219.2l-1-.3c5.3-17.7,5.1-35.3-.7-49.6-1.1-2.7-2.5-5.5-3.8-8.2-3-6.1-6.1-12.4-6.6-19.3h1c.4,6.6,3.5,12.9,6.5,18.9,1.3,2.7,2.7,5.4,3.8,8.2,5.9,14.5,6.1,32.4.7,50.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9,175l-12.3-9.4c-1.9-1.5-3.9-3-6.1-4-2.5-1.1-5.4-1.4-8.1-1.8l-13.6-1.7c-5.4-.7-10.9-1.4-16.4-1.4h-.9c-2.1,0-4.3,0-6.4-.6-1.6-.5-3.1-1.3-4.5-2.1-.9-.5-1.8-1-2.8-1.4-6.5-2.9-13.3-2.9-20.4-2.9h-.2c-.3,0-.7,0-.9,0-.2,0-.5.2-.7.4l-.2.2c-1.2.8-4.6,1.6-6.3.5-.6-.3-1.2-1-1-2.3.4-3.9,3.9-6.5,7-7.7,2-.8,4.2-1.1,6.2-1.5,1.3-.2,2.6-.5,3.9-.8,2.8-.7,5.5-1.9,8.1-3,1.6-.7,3.3-1.4,4.9-2,5.5-2,10.2-2.3,14.1-.7,1.8.7,3.4,1.9,4.9,3,.7.5,1.4,1,2.1,1.5,2.4,1.6,5.1,2.7,7.4,3.6,1.6.7,3.3,1.3,4.9,1.9,2.3.9,4.7,1.8,7.1,2.8,10.6,4.6,20.3,11.7,27.9,20.5,1.2,1.3,1.5,3.5,1.8,5.4.1.8.2,1.6.4,2.2l.4,1.4h0ZM7.1,148.7h.3c7.2,0,14,0,20.8,3,1,.4,1.9,1,2.8,1.5,1.4.8,2.8,1.6,4.3,2,1.9.6,4.1.6,6.1.6h1c5.5,0,11.1.7,16.5,1.4l13.6,1.7c2.8.3,5.7.7,8.3,1.8,2.4,1,4.4,2.6,6.4,4.1l10.1,7.8c0-.3-.1-.7-.2-1-.3-1.9-.6-3.8-1.5-4.9-7.5-8.7-17-15.7-27.5-20.2-2.3-1-4.7-1.9-7-2.8-1.6-.6-3.3-1.2-4.9-1.9-2.3-.9-5-2.1-7.5-3.7-.7-.5-1.4-1-2.1-1.5-1.5-1.1-3-2.2-4.7-2.9-3.6-1.5-8.1-1.2-13.3.7-1.6.6-3.3,1.3-4.9,2-2.6,1.2-5.4,2.4-8.2,3.1-1.3.3-2.7.6-4,.8-2,.4-4.1.7-6.1,1.5-2.8,1.1-6,3.4-6.3,6.9,0,.6.1,1.1.6,1.4,1.3.8,4.2.2,5.3-.5l.2-.2c.3-.2.6-.4.9-.5.4-.1.8-.1,1.2-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.5,151c-3-3.7-7.1-6.3-11.6-7.4-.8-.2-1.7-.4-2.5-.5-1.5-.3-3.1-.6-4.6-1.1-1.5-.6-2.9-1.5-4.2-2.3-.7-.4-1.4-.9-2.1-1.3-9.9-5.6-22.2-2.6-30.8.8l-.4-.9c8.8-3.5,21.4-6.5,31.6-.8.7.4,1.5.9,2.1,1.3,1.3.8,2.6,1.7,4,2.2,1.4.5,2.9.8,4.4,1.1.8.2,1.7.3,2.6.5,4.8,1.2,9.1,3.9,12.2,7.8l-.8.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9,211c-.4,0-.7,0-1-.1-1.7-.3-3.4-.8-5.1-1.3-1.6-.5-3.4-1-5-1.3-2.8-.5-6.7-.8-9.8,1.2l-.5-.8c3.4-2.2,7.6-1.9,10.5-1.4,1.8.3,3.5.8,5.1,1.3,1.6.5,3.3,1,5,1.3.5,0,1,.2,1.4,0,.5-.2.8-.6,1.2-1.1,3-4,5.5-7.6,6.1-11.9.6-4.5-1.1-9.1-2.6-13.1l.9-.4c1.6,4.1,3.3,8.8,2.7,13.6-.6,4.6-3.3,8.5-6.3,12.4-.4.5-.9,1.2-1.7,1.5-.3,0-.6.1-.8.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.6,257.9l-2.4-3.1c-5.3-6.8-11.3-13.1-17.9-18.8-.4-.4-.6-.3-.6-.3,0,0,.1-.1.1-.2,0,0,0,0-.2,0-.1,0-.2,0-.2,0l.7.7c-.2.2-.5.3-.7.2-.4-.1-.6-.5-.6-.8,0-.4.1-.7.4-.8.7-.4,1.5.2,1.7.4,5.6,4.8,10.7,10.1,15.4,15.7-3.4-6.7-7.4-12.1-12.2-16.2-6.6-5.6-14.7-8.5-22.2-8-4.5.3-8.9,1.8-13.1,3.2-4.3,1.5-8.8,3-13.4,3.3-.3,0-.6,0-.9,0-1.7,0-3.5.2-4.9,1.1-1.1.8-1.9,2-2.6,3.3-2,3.7-3.9,7.5-5.6,11.4h.2c-.1.7-.5,1.4-1.1,1.8l-1.4.9.7-1.6c1.9-4.4,4-8.9,6.4-13.1.8-1.4,1.6-2.8,2.9-3.7,1.6-1.1,3.5-1.2,5.4-1.3.3,0,.6,0,.9,0,4.5-.3,8.9-1.8,13.2-3.2,4.3-1.5,8.7-3,13.3-3.3,7.8-.5,16.1,2.4,22.9,8.2,5.7,4.9,10.5,11.7,14.2,20.2l1.5,3.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.1,264.4c-1.2,0-2.3-.7-3.4-1.3l-22.4-14.4h3.2c0,.1,0,.9,0,.9l19.7,12.7c1.1.7,2.3,1.4,3.5,1.1.6-.2,1-.7,1.2-1.1.4-.8.4-1.7.1-2.5-.5-1.4-1.7-2.5-3-3.6-6.1-5.1-12.6-9.9-19.2-14.3-.6-.4-.9-1-.7-1.5.1-.3.5-.5.8-.4.3,0,.7.4.6.8,0,0,0,.2-.1.3,6.6,4.4,13.1,9.2,19.2,14.3,1.4,1.2,2.8,2.4,3.4,4.1.4,1.1.3,2.3-.2,3.3-.4.8-1,1.3-1.8,1.6-.3.1-.6.2-1,.2h0ZM103.9,240.2c-.1,0-.3.2-.4.4,0,0,0,.2.1.3,0,0,.2,0,.3,0v-.6s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.3,251.7l-.6-.8c4.1-3.1,9.9-2.7,14.1-2.4,13.5.9,27.2,1.5,40.7,1.7.6,0,1.8,0,2.4.8l-.7.7c-.4-.4-1-.4-1.7-.4-13.5-.2-27.2-.8-40.8-1.7-5.3-.4-9.9-.4-13.4,2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5,233.6l-.9-.5c.7-1.4,0-3.2-.9-4.2-1.1-1.3-2.7-2-4.1-2.7-11.8-5.7-23.9-10.9-36-15.7l.4-.9c12.2,4.8,24.3,10.1,36.1,15.7,1.4.7,3.2,1.5,4.4,2.9,1.2,1.3,1.9,3.5,1,5.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.3,266.7c-.6,0-1.2,0-1.8-.2-4.8-.8-9.4-2.4-13.7-4.7-.9-.5-1.9-1-2.8-1.6-3.6-2.1-7.4-4.3-11.5-4.2-2.3,0-4.6.8-6.8,1.5-2.8.9-5.8,1.9-8.8,1.4-1.8-.3-3.5-1.1-5.2-1.9l-.7-.4c-6.1-2.9-12.6-4.8-19.3-5.5v-1c6.9.7,13.5,2.6,19.7,5.6l.7.4c1.6.8,3.2,1.6,4.9,1.8,2.8.4,5.5-.4,8.3-1.4,2.3-.8,4.6-1.5,7-1.6,4.4,0,8.3,2.2,12,4.3.9.5,1.9,1.1,2.8,1.6,4.2,2.2,8.7,3.8,13.4,4.6,1.7.3,3.8.3,4.6-1.1,0,0,.1-.2.1-.3.2-.5.6-1.1,1.3-1.2v1c0,0-.2.4-.4.7,0,.1-.1.2-.2.3-.7,1.2-2,1.8-3.8,1.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.9,260.8c-.2,0-.5-.1-.6-.4s0-.8.3-1c.3-.2.5-.1.8-.1h.1c0,0,.2,0,.4-.2.2-.3.4-.8.3-1.2-.1-1.1-.7-2.1-1.6-2.7l.6-.8c1.1.8,1.9,2,2,3.4,0,.7-.1,1.5-.5,2-.3.3-.7.5-1.1.5s-.2,0-.2,0c0,0-.2,0-.2,0,0,0,.2-.1.1-.3,0-.2-.3-.2-.5-.2l.4.9c0,0-.2,0-.2,0h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.2 53.7 23.8 52.9 34.8 62.3 34.2 63.1 23.2 53.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6,77c-.1-.2-.3-.4-.4-.6l.2-.2c-3.4-3.1-7.8-6.7-12.4-9.9-.1.5,0,1.3-.3,1.7,1.6,1.8,3.7,3.1,5.8,4.4,2.3,1.4,3.9,2.9,5.5,5-1.8,18.9-3.6,36-7,55.6l2,2c3.4-19.7,4.9-38.8,6.8-57.8v-.2s0-.2,0-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.1,99.5c-1-.9-1.7-2-2.4-3.2l.9-.5c.6,1.1,1.3,2.1,2.2,3l-.7.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.8,107c-1.2-1.1-2.8-1.9-4.4-2.4l.3-1c1.7.5,3.4,1.4,4.7,2.6l-.7.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.2 112.3 206.8 111.6 210 114.5 209.3 115.2 206.2 112.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6,132.4h0c-1.4,0-2.6-1.2-3.8-2-2.9-1.9-5.9-3.8-9.2-5.2-2.5-1.1-5.2-1.9-7.5-3.5-.4-.3-.8-.6-1-1-.2-.5-.2-1-.1-1.6.4-5.1,0-10.3,0-15.4,0-5.6.3-11.2-.2-16.8.6,0,1.2.1,1.8.3-.4,9.7-.8,17.9-.6,27.6,0,.9,0,2.9,0,5.1s1.4,1.3,2.4,1.9l11.1,5.9c1.8,1,3.6,2.2,5.5,3s3.1.2,5.2-.3c3.9-.9,7.7-1.6,11.6-2.2,1.1-.2,8.4-.4,8.9-1.3.9-1.7,1.9-3.4,2.8-5.1s1.8-3.4,2.8-5.1c-.8-1.5-1.9-2.7-3-4-1.7-2-3.4-4-4.2-6.7l-3.1-16.3v-7.1l1,10.1,3.1,13c.7,2.5,2.3,4.3,3.9,6.3,1.2,1.4,2.4,2.8,3.3,4.4v.3c.1,0,0,.3,0,.3-1,1.7-1.9,3.6-2.9,5.4-.9,1.8-1.9,3.6-2.9,5.4v.2c-.1,0-.4,0-.4,0-6.3,0-13.3,1.9-19.4,3.2-1.4.3-3.5,1.3-5,1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8,66.7l-.4-.3c-3.5-2.7-8.3-4.3-13.8-4.5-5-.2-10,.6-14.9,1.3-1.2.2-2.2.5-3.2.7-1.1.3-2.1.6-3.4.8l-1.4.2.9-1.1c3.4-3.9,7.5-8.3,12.7-10.9,5.6-2.8,11.9-3,16.4-.4,3.5,2,5.9,5.5,8,8.9.8,1.3.3,3.4-.6,4.8l-.3.5h0ZM83.7,60.8c.6,0,1.2,0,1.9,0,5.5.3,10.3,1.8,13.9,4.4.5-1.1.8-2.4.3-3.2-2.1-3.4-4.4-6.7-7.6-8.6-4.2-2.5-10.1-2.3-15.4.4-4.5,2.3-8.2,6-11.4,9.6.6-.1,1.2-.3,1.8-.5,1.1-.3,2.1-.6,3.4-.8,4.3-.7,8.8-1.4,13.2-1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M172.7,191.3c-.1.1-.3-.1-.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.1,127.4c-2.9,0-5.9-.3-8.3-1.6-3.8-2.2-3.3-7.1-3-9.7l6.2-60.2c.4-3.5,1.1-7.3,4.2-8.8,1.2-.6,2.6-.7,3.9-.7l93.1-4c3.6-.2,6,.5,7.5,2.1,1.5,1.6,2,4.1,1.6,7.8-.7,7.6-1.5,15.2-2.4,22.7-1.1,9.9-2.3,19.9-3.6,29.7-.3,2.4-.6,4.7-1,7.1,0,.4,0,1.1-.1,1.8-.1,2.8-.3,5-1.1,5.9-1.4,1.5-5.8,1.7-9.7,1.8-1.7,0-3.3.1-4.2.3l-.2-1c1-.2,2.6-.2,4.4-.3,3.3-.1,7.9-.2,9-1.5.6-.7.7-3.5.8-5.2,0-.8,0-1.5.1-1.9.3-2.4.6-4.7,1-7.1,1.3-9.8,2.5-19.8,3.6-29.7.8-7.5,1.6-15.1,2.4-22.6.3-3.4-.1-5.6-1.4-7-1.2-1.3-3.5-1.9-6.7-1.8l-93.1,4c-1.2,0-2.4.1-3.5.6-2.6,1.3-3.3,4.7-3.6,8l-6.2,60.2c-.3,3.3-.5,7,2.5,8.8,3,1.7,7.5,1.5,11.1,1.4.5,0,1,0,1.5,0,15.6-.5,33.7-1.2,51.4-3.3v1c-17.6,2.1-35.8,2.8-51.4,3.3-.5,0-.9,0-1.4,0-1.1,0-2.2,0-3.4,0h0Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 1.4,
    y: 3.7,
    width: 260.5,
    height: 350.7
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M235.5,317.5s-.2.5-.2.5c0,.5.3.8.5,1.3,1.7-.3,2.6,3.8,5.8,3.8-1-.8.9-.2.8-2.2-.2-3.3-4.2-4.2-6.8-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M228.7,322.6c.1,0,.5.5.5.5.9-1,1.8-1.9,2.8-2.8.7-.6.7-.7,1.5-1.3.9-.6.6-.6,1.8-1,0,0,.2-.5.2-.5-1.4-2.7-6.2,1.2-6.8,5.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M236,332.2c-.5-.6-.8-.2-1.2-1,0,0,0-.2,0-.3-1.7-.5-3.9-2.5-4-4.3-1.2-.8-1-2.4-1.5-3.5,0,0-.4-.5-.5-.5-.6,4.2,3,9.3,7.3,9.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M235.7,319.3c1.3,3.4,2.4,4.8,6,3.8h-.2c-3.2,0-4-4.1-5.8-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M232,320.3c-.5,1.2,0,2.3-.2,3.5.7-.7,1.8-.3,2.8-.3-.3-.5-1.2-3.9-1-4.6-.8.5-.9.7-1.5,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M229.2,323.1c.5,1.2.3,2.7,1.5,3.5,0-1.4.7-1.9.8-2,.1-1,.2-.7.2-.8.2-1.2-.2-2.4.2-3.5-1,.9-1.9,1.8-2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M233.5,319c-.2.6.7,4.1,1,4.6.6,1,5.6,1.9,6.9,1.5,1.1-.3,1.1-.9,1.9-1.5,0-.8,1-1.4-.5-1-.2,0-.3.3-1,.5-3.6,1-4.7-.4-6-3.8-.2-.4-.4-.8-.5-1.3-1.1.4-.9.4-1.8,1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-322",
    d: "M242.7,322.6c1.5-.4.5.2.5,1,.2,4.5-3.8,9.4-8.5,7.6.5.8.8.4,1.2,1,10.6.9,7.9-14,7-12.3l-.2,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M231.7,323.9s-.1-.3-.2.8c1.5,2,2.2,4.2,3.3,6.3,0,0,0,.2,0,.3,4.7,1.8,8.7-3.1,8.5-7.6-.7.6-.8,1.2-1.9,1.5-1.3.4-6.3-.5-6.9-1.5-1,0-2-.5-2.8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M230.7,326.6c.1,1.8,2.3,3.8,4,4.3-1-2.1-1.7-4.4-3.3-6.3,0,.1-.8.6-.8,2Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfPacedImage);
export default __webpack_public_path__ + "static/media/Self-paced-image.a1be4013a1dde33a2dce76a2a616e2bf.svg";
export { ForwardRef as ReactComponent };